(function (factory) {
  typeof define === 'function' && define.amd ? define('index', factory) :
  factory();
}((function () { 'use strict';

  const KEY_ENTER = 13;
  const KEY_BACKSPACE = 8;
  const KEY_DELETE = 46;
  const KEY_LEFT_ARROW = 37;
  const KEY_UP_ARROW = 38;
  const KEY_RIGHT_ARROW = 39;
  const KEY_DOWN_ARROW = 40;
  
  const KLAVIYO_PUBLIC_KEY = 'VV2vHd';
  const KLAVIYO_LIST_ID = 'XqEi7e';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  
  function _generateRandomID() {
    let id = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
    return id;
  }
  
  async function _generateLineGroupID(alreadyUsedIDs = [], checkCart = true) {

    let id = _generateRandomID();

    // First check if on the cart page
    const itemList = document.querySelector('.Cart__ItemList');
    if (itemList) {
      // Get Items from Cart Item List DOM element
      const itemsWithLineGroup = itemList.querySelectorAll('[data-line-group]');
      itemsWithLineGroup.forEach((item) => {
        const lineGroupValue = item.getAttribute('data-line-group');
        alreadyUsedIDs.push(lineGroupValue);
      });

    } else {

      if (checkCart) {
        // Ajax call to cart
        const response = await fetch(`${window.routes.cartUrl}.json`, {
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const content = await response.json();
        content.items.forEach(function(item) {
          if(item.properties?._line_group) {
            alreadyUsedIDs.push(item.properties._line_group);
          }
        });
      } 
    }

    while(alreadyUsedIDs.includes(id)) {
      id = _generateRandomID();
    }

    return id;
  }
  
  //Checks that string contains characters that are allowed for monogramming.
  function _validMonoCharacterCheck(testString){
    var regex = new RegExp("^[a-zA-Z0-9.]+$");
    if (!regex.test(testString)) {
        return false;
    }
    return true;
  }

  function _validEmailAddress(email) {
    email = email.trim();
    if (!email) {
      return false;
    }
    var emailPattern = new RegExp('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$');
    return emailPattern.test(email);
  }

  function checkPrivateSale(checkOnly = false) {

    if (!window.theme.customStrikethroughEnabled) {
      return false;
    }

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function showPrivateSaleBadges() {
      const privateSaleBadges = document.querySelectorAll('.Product__BadgeWrapperCustom');
      // If we see custom badge elements, we know the setting is on, flip the prices
      if (privateSaleBadges.length) {
        let anyCustomVisible = false;
        privateSaleBadges.forEach(element => {
          // Variant-aware PDP badges: only reveal when the currently selected variant is on sale.
          if (element.hasAttribute('data-variant-sale-badge') && element.getAttribute('data-on-sale') !== 'true') {
            element.classList.add('d-none');
            return;
          }
          element.classList.remove('d-none');
          anyCustomVisible = true;
        });
        // Only hide the default badges when a custom sale badge is actually shown.
        // Otherwise (variant-aware wrapper is hidden because the selected variant
        // is not on sale) the default badge should remain visible as the fallback.
        const defaultBadges = document.querySelectorAll('.Product__BadgeWrapper:not(.Product__BadgeWrapperCustom)');
        defaultBadges.forEach(element => {
          if (anyCustomVisible) {
            element.classList.add('d-none');
          } else {
            element.classList.remove('d-none');
          }
        });
      }
    }

    function showPrivateSalePrices() {
      const strikethroughPrices = document.querySelectorAll('.ProductItem__CustomStrikethroughPrice');
      // If we see custom strikethrough elements, we know the setting is on, flip the prices
      if (strikethroughPrices.length) {
        strikethroughPrices.forEach(element => {
          element.classList.remove('d-none');
        });
        // Hide the default prices
        const defaultPrices = document.querySelectorAll('.ProductItem__DefaultPrice');
        defaultPrices.forEach(element => {
          element.classList.add('d-none');
        });
      }
    }

    const norm = v => (v || '').trim();
    const cookieName = 'cuy_csp';
    const urlParam = 'privatesale';
    let showPrivateSalePricing= false;

    if (!window.theme.customStrikethroughCodeRequired) {
      showPrivateSalePricing = true;
    } else {

      let codeValue = urlParam;
      if (window?.theme?.customStrikethroughCode) {
        codeValue = norm(window.theme.customStrikethroughCode);
      }

      // Check if the cookie exists
      const privateSaleCookie = getCookie(cookieName);
      if (privateSaleCookie && privateSaleCookie == codeValue) {
        showPrivateSalePricing = true;
      } else {
        // If no cookie, check URL parameter
        const urlParams = new URLSearchParams(window.location.search);
        const privateSaleValue = urlParams.get(urlParam);
        if (privateSaleValue && privateSaleValue == codeValue) {
          // Set a cookie that expires in 30 days
          const days = 30;
          const maxAge = days * 24 * 60 * 60;
          document.cookie = `${cookieName}=${privateSaleValue}; Max-Age=${maxAge}; Path=/`;
          showPrivateSalePricing = true;
        }
      }
    }

    if (checkOnly) {
      return showPrivateSalePricing;
    }

    if (showPrivateSalePricing) {
      showPrivateSaleBadges();
      showPrivateSalePrices();
      return;
    }
  }

  var Responsive = /*#__PURE__*/function () {
    function Responsive() {
      var _this = this;

      _classCallCheck(this, Responsive);

      this.currentBreakpoint = Responsive.getCurrentBreakpoint();
      window.addEventListener('resize', function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();

        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }

        document.dispatchEvent(new CustomEvent('breakpoint:changed', {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint
          }
        }));
        _this.currentBreakpoint = newBreakpoint;
      });
    }

    _createClass(Responsive, null, [{
      key: "matchesBreakpoint",
      value: function matchesBreakpoint(breakpoint) {
        switch (breakpoint) {
          case 'phone':
            return window.matchMedia('screen and (max-width: 640px)').matches;

          case 'tablet':
            return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

          case 'tablet-and-up':
            return window.matchMedia('screen and (min-width: 641px)').matches;

          case 'pocket':
            return window.matchMedia('screen and (max-width: 1007px)').matches;

          case 'lap':
            return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

          case 'lap-and-up':
            return window.matchMedia('screen and (min-width: 1008px)').matches;

          case 'desk':
            return window.matchMedia('screen and (min-width: 1280px)').matches;

          case 'widescreen':
            return window.matchMedia('screen and (min-width: 1600px)').matches;

          case 'supports-hover':
            return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }
      }
    }, {
      key: "getCurrentBreakpoint",
      value: function getCurrentBreakpoint() {
        if (window.matchMedia('screen and (max-width: 640px)').matches) {
          return 'phone';
        }

        if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
          return 'tablet';
        }

        if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
          return 'lap';
        }

        if (window.matchMedia('screen and (min-width: 1280px)').matches) {
          return 'desk';
        }
      }
    }]);

    return Responsive;
  }();

  var Carousel = /*#__PURE__*/function () {
    function Carousel(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck(this, Carousel);

      this.element = element;
      this.initialConfig = Object.assign(JSON.parse(element.getAttribute('data-flickity-config')), overrideSettings);
      this.options = options;

      this._attachListeners();

      this._build();
    }

    _createClass(Carousel, [{
      key: "destroy",
      value: function destroy() {
        this.flickityInstance.destroy();

        if (this.initialConfig['breakpoints'] !== undefined) {
          document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
        }
      }
    }, {
      key: "getFlickityInstance",
      value: function getFlickityInstance() {
        return this.flickityInstance;
      }
    }, {
      key: "selectCell",
      value: function selectCell(index) {
        var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        if (shouldPause) {
          this.flickityInstance.pausePlayer();
        }

        this.flickityInstance.select(index, false, !shouldAnimate);
      }
    }, {
      key: "next",
      value: function next() {
        this.flickityInstance.next();
      }
    }, {
      key: "previous",
      value: function previous() {
        this.flickityInstance.previous();
      }
    }, {
      key: "pausePlayer",
      value: function pausePlayer() {
        this.flickityInstance.pausePlayer();
      }
    }, {
      key: "unpausePlayer",
      value: function unpausePlayer() {
        this.flickityInstance.unpausePlayer();
      }
    }, {
      key: "resize",
      value: function resize() {
        this.flickityInstance.resize();
      }
    }, {
      key: "getSelectedIndex",
      value: function getSelectedIndex() {
        return this.flickityInstance.selectedIndex;
      }
    }, {
      key: "getSelectedCell",
      value: function getSelectedCell() {
        return this.flickityInstance.selectedCell.element;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        if (this.initialConfig['breakpoints'] !== undefined) {
          this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
          document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
        }
      }
      /**
       * Create the carousel instance
       */

    }, {
      key: "_build",
      value: function _build() {
        var _this = this;

        var config = this._processConfig();

        this.flickityInstance = new Flickity(this.element, config);

        this._validateDraggable();

        this.selectedIndex = this.flickityInstance.selectedIndex;
        this.flickityInstance.on('resize', this._validateDraggable.bind(this));

        if (this.options['onSelect']) {
          this.flickityInstance.on('select', function () {
            // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
            // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
            if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
              _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);

              _this.selectedIndex = _this.flickityInstance.selectedIndex;
            }
          });
        }

        if (this.options['onSettle']) {
          this.flickityInstance.on('settle', function (index) {
            _this.options['onSettle'](index, _this.flickityInstance.selectedCell.element);
          });
        }

        if (this.options['onClick']) {
          this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
            _this.options['onClick'](cell, index);
          });
        }
      }
      /**
       * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
       * if the displayed elements equals to the amount of elements
       */
    }, {
      key: "_validateDraggable",
      value: function _validateDraggable() {
        var isActive = this.flickityInstance.isActive || false;

        if (!isActive || !this.flickityInstance.options['draggable']) {
          return; // Not draggable, so nothing to do
        }

        if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
          this.flickityInstance.unbindDrag();
        } else {
          this.flickityInstance.bindDrag();
        }
      }
      /**
       * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
       */

    }, {
      key: "_processConfig",
      value: function _processConfig() {
        var config = Object.assign({}, this.initialConfig);
        delete config['breakpoints'];

        if (this.initialConfig['breakpoints'] === undefined) {
          return config; // No change, we simply return the config as it is
        }

        var breakpoints = this.initialConfig['breakpoints'];
        breakpoints.forEach(function (breakpoint) {
          if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
            config = Object.assign(config, breakpoint['settings']);
          }
        });
        return config;
      }
      /**
       * Verify if the breakpoint has changed, and optionally update the carousel
       */

    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged() {
        // The breakpoint may have changed, so we delete the carousel and rebuild it
        this.flickityInstance.destroy();

        this._build();
      }
    }]);

    return Carousel;
  }();

  var Animation = /*#__PURE__*/function () {
    function Animation() {
      _classCallCheck(this, Animation);
    }

    _createClass(Animation, null, [{
      key: "slideUp",
      value:
      /**
       * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
       * force an animation
       */
      function slideUp(element) {
        element.style.height = "".concat(element.scrollHeight, "px"); // Force previous height to allow CSS transition

        element.offsetHeight; // Force redraw

        element.style.height = 0;
      }
      /**
       * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
       * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
       */

    }, {
      key: "slideDown",
      value: function slideDown(element) {
        if (element.style.height === 'auto') {
          return;
        } // To do the animation we temporarily hide it, check the height, and transition to it


        element.style.height = "".concat(element.firstElementChild.scrollHeight, "px");

        var transitionEnded = function transitionEnded(event) {
          if (event.propertyName === 'height') {
            element.style.height = 'auto'; // Allows the content to grow normally

            element.removeEventListener('transitionend', transitionEnded);
          }
        };

        element.addEventListener('transitionend', transitionEnded);
      }
    }]);

    return Animation;
  }();

  /**
   * Various DOM helper
   */
  var Dom = /*#__PURE__*/function () {
    function Dom() {
      _classCallCheck(this, Dom);
    }

    _createClass(Dom, null, [{
      key: "getSiblings",
      value:
      /**
       * Get all the previous and next siblings, optionally filtered by a selector
       */
      function getSiblings(element, filter) {
        var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var siblings = [];
        var currentElement = element; // Do the previous first

        while (currentElement = currentElement.previousElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }

        if (includeSelf) {
          siblings.push(element);
        } // Then the next side


        currentElement = element;

        while (currentElement = currentElement.nextElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }

        return siblings;
      }
      /**
       * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
       * we need to normalize it
       */

    }, {
      key: "nodeListToArray",
      value: function nodeListToArray(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
          if (!filter || nodeList[i].matches(filter)) {
            items.push(nodeList[i]);
          }
        }

        return items;
      }
      /**
       * Calculate an element width with its margin
       */

    }, {
      key: "outerWidthWithMargin",
      value: function outerWidthWithMargin(element) {
        var width = element.offsetWidth,
            style = getComputedStyle(element);
        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
      }
      /**
       * Calculate an element height with its margin
       */

    }, {
      key: "outerHeightWithMargin",
      value: function outerHeightWithMargin(element) {
        var height = element.offsetHeight,
            style = getComputedStyle(element);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
      }
    }]);

    return Dom;
  }();

  var Collapsible = /*#__PURE__*/function () {
    function Collapsible() {
      _classCallCheck(this, Collapsible);

      this.domDelegate = new domDelegate.Delegate(document.body);

      this._attachListeners();
    }

    _createClass(Collapsible, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.domDelegate.on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
      }
      /**
       * Toggle a given collapsible
       */

    }, {
      key: "_toggleCollapsible",
      value: function _toggleCollapsible(event, target) {
        var _this = this;

        // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
        var parentCollapsible = target.closest('.Collapsible');

        if (parentCollapsible.classList.contains('Collapsible--autoExpand') && Responsive.matchesBreakpoint('tablet-and-up')) {
          return;
        }

        var isOpen = target.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          this._close(parentCollapsible, target);
        } else {
          this._open(parentCollapsible, target);
        } // We make sure to close any siblings collapsible as well


        Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
          return _this._close(collapsibleToClose);
        });
        event.preventDefault();
      }
      /**
       * Open a given collapsible
       */

    }, {
      key: "_open",
      value: function _open(collapsible) {
        var toggleButton = collapsible.querySelector('.Collapsible__Button'),
            collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

        if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
          return; // It's already open
        }

        toggleButton.setAttribute('aria-expanded', 'true');
        collapsibleInner.style.overflow = 'visible';
        Animation.slideDown(collapsibleInner);
        setTimeout(function () {
          collapsible.style.overflow = 'visible';
        }, 350);
      }
      /**
       * Close a given collapsible
       */

    }, {
      key: "_close",
      value: function _close(collapsible) {
        var toggleButton = collapsible.querySelector('.Collapsible__Button'),
            collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

        if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
          return; // It's already closed
        }

        toggleButton.setAttribute('aria-expanded', 'false');
        collapsibleInner.style.overflow = 'hidden';
        collapsible.style.overflow = 'hidden';
        Animation.slideUp(collapsibleInner);
      }
    }]);

    return Collapsible;
  }();

  var Accessibility = /*#__PURE__*/function () {
    function Accessibility() {
      _classCallCheck(this, Accessibility);
    }

    _createClass(Accessibility, null, [{
      key: "trapFocus",
      value:
      /**
       * Traps the focus in a particular container
       */
      function trapFocus(container, namespace) {
        this.listeners = this.listeners || {}; // We check if there is an element with the attribute "autofocus"

        var elementToFocus = container.querySelector('[autofocus]') || container;
        container.setAttribute('tabindex', '-1');
        elementToFocus.focus();

        this.listeners[namespace] = function (event) {
          if (container !== event.target && !container.contains(event.target)) {
            container.focus();
          }
        };

        document.addEventListener('focusin', this.listeners[namespace]);
      }
      /**
       * Removes the trap of focus in a particular container
       */

    }, {
      key: "removeTrapFocus",
      value: function removeTrapFocus(container, namespace) {
        if (container) {
          container.removeAttribute('tabindex');
        }

        if (this.listeners && this.listeners[namespace]) {
          document.removeEventListener('focusin', this.listeners[namespace]);
        }
      }
      /**
       * Reset any previous trap focus
       */

    }, {
      key: "clearTrapFocus",
      value: function clearTrapFocus() {
        for (var key in this.listeners) {
          if (this.listeners.hasOwnProperty(key)) {
            document.removeEventListener('focusin', this.listeners[key]);
          }
        }

        this.listeners = {};
      }
    }]);

    return Accessibility;
  }();

  var Drawer = /*#__PURE__*/function () {
    function Drawer(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Drawer);

      if (!element) {
        return;
      }

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateBody = new domDelegate.Delegate(document.body);

      this.onOpen = options['onOpen'] || function () {};

      this.onClose = options['onClose'] || function () {};

      this.isOpen = false;
      this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      this._attachListeners();
    }

    _createClass(Drawer, [{
      key: "destroy",
      value: function destroy() {
        if (this.delegateBody) {
          this.delegateBody.off('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
          this.delegateBody.off('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
        }
        window.removeEventListener('resize', this._calculateMaxHeightListener);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open(event) {
        if (this.isOpen) {
          return;
        } 

        // Make sure that the search is closed whenever a drawer is opened
        this.element.dispatchEvent(new CustomEvent('search:close', {
          bubbles: true
        }));

        if (this.element.id == 'sidebar-cart') {
          this.element.dispatchEvent(new CustomEvent('cart:open', {
            bubbles: true
          }));
        }

        if (event) {
          event.preventDefault();
        }

        this.element.setAttribute('aria-hidden', 'false');

        this._calculateMaxHeight();

        document.documentElement.classList.add('no-scroll'); // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
        // other browsers, this is the only way to achieve that
        //disableBodyScroll(true, '[data-scrollable]');

        Accessibility.trapFocus(this.element, this.element.id);
        
        document.querySelector('#shopify-section-header').style.zIndex = ''; // Ugly hack
        // We attach an event to the page overlay to close it

        this.pageOverlayElement.classList.add('is-visible');
        this.pageOverlayElement.addEventListener('click', this._closeListener);
        this.isOpen = true;
        this.onOpen(); // Call the callback to allow other code to hook their logic

        return false;
      }
    }, {
      key: "close",
      value: function close(event) {
        if (!this.isOpen) {
          return;
        }

        if (event) {
          event.preventDefault();
        }

        this.element.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll'); //disableBodyScroll(false, '[data-scrollable]');

        //Accessibility.removeTrapFocus(this.element, 'drawer');
        // www-2102 testing using the elements id in order to have separated 
        // trap focus for when multiple drawers are open, 
        Accessibility.removeTrapFocus(this.element, this.element.id);
        this.pageOverlayElement.classList.remove('is-visible');
        this.pageOverlayElement.removeEventListener('click', this._closeListener);
        this.isOpen = false;
        this.onClose(); // Call the callback to allow other code to hook their logic
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._openListener = this.open.bind(this);
        this._closeListener = this.close.bind(this);
        this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);
        this.delegateBody.on('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._openListener);
        this.delegateBody.on('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._closeListener);
        this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
        window.addEventListener('resize', this._calculateMaxHeightListener);
      }
      /**
       * Make sure that we force a max-height so that the drawer always stays on screen
       */

    }, {
      key: "_calculateMaxHeight",
      value: function _calculateMaxHeight() {
        this.element.style.maxHeight = window.innerHeight + 'px';
      }
    }, {
      key: "_handleKeyboard",
      value:
      /**
       * Handle a11y events
       */
      function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);

    return Drawer;
  }();

  /**
   * Simple plugin that handles the loading bar actions
   *
   * This plugin uses delegate events so it's independent of the sections.
   */
  var LoadingBar = /*#__PURE__*/function () {
    function LoadingBar() {
      _classCallCheck(this, LoadingBar);

      this.element = document.querySelector('.LoadingBar');
      document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
      document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));
      this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
    }

    _createClass(LoadingBar, [{
      key: "_onLoadingStart",
      value: function _onLoadingStart() {
        this.element.classList.add('is-visible');
        this.element.style.width = '40%';
      }
    }, {
      key: "_onLoadingEnd",
      value: function _onLoadingEnd() {
        this.element.style.width = '100%';
        this.element.classList.add('is-finished');
      }
    }, {
      key: "_onTransitionEnd",
      value: function _onTransitionEnd(event) {
        if (event.propertyName === 'width' && this.element.classList.contains('is-finished')) {
          this.element.classList.remove('is-visible');
          this.element.classList.remove('is-finished');
          this.element.style.width = '0';
        }
      }
    }]);

    return LoadingBar;
  }();

  var Modal = /*#__PURE__*/function () {
    function Modal() {
      _classCallCheck(this, Modal);

      this.domDelegate = new domDelegate.Delegate(document.body);
      this.activeModal = null; // Keep track of the active modal

      this.wasLocked = false;
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      this._attachListeners();

      this._checkOpenByHash();
    }

    _createClass(Modal, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this._closeListener = this._closeModal.bind(this);
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this.domDelegate.on('click', '[data-action="open-modal"]', this._openModalEvent.bind(this));
        this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this));
      }
    }, {
      key: "_openModalEvent",
      value: function _openModalEvent(event, target) {
        this._openModal(document.getElementById(target.getAttribute('aria-controls')));

        event.preventDefault();
        event.stopPropagation();
      }
    }, {
      key: "_openModal",
      value: function _openModal(modal) {
        var _this = this;

        if (this.activeModal || !modal) {
          return; // If there is already an open modal, we return as we only allows one modal at a time
        }

        this.activeModal = modal;
        this.domDelegate.on('keyup', this._handleKeyboardListener);

        if (document.documentElement.classList.contains('no-scroll')) {
          this.wasLocked = true;
        }

        fastdom.mutate(function () {
          Accessibility.clearTrapFocus(); // Needed as the modal can be open on top of a popover

          _this._onTransitionEndedListener = _this._onTransitionEnded.bind(_this);

          _this.activeModal.addEventListener('transitionend', _this._onTransitionEndedListener);

          _this.activeModal.setAttribute('aria-hidden', 'false');

          document.documentElement.classList.add('no-scroll'); // If the modal is not a fullscreen modal, then we also display the overlay

          if (!_this.activeModal.classList.contains('Modal--fullScreen')) {
            _this.pageOverlayElement.classList.add('is-visible');

            _this.pageOverlayElement.addEventListener('click', _this._closeListener);
          }
        });
      }
    }, {
      key: "_closeModal",
      value: function _closeModal() {
        var _this2 = this;

        if (!this.activeModal) {
          return; // If no modal are open, we return immediately
        }

        this.activeModal.removeEventListener('keyup', this._handleKeyboardListener);
        this.domDelegate.off('keyup');
        var closingModal = this.activeModal;
        fastdom.mutate(function () {
          // If the modal is of video type, we need to remove the iframe to stop the video
          if (closingModal.classList.contains('Modal--videoContent')) {
            _this2._resetVideoListener = _this2._resetVideo.bind(_this2);

            closingModal.addEventListener('transitionend', _this2._resetVideoListener);
          }

          Accessibility.removeTrapFocus(closingModal, 'modal');

          if (!closingModal.classList.contains('Modal--fullScreen')) {
            // Only remove the overlay if no other component has claimed it since this was scheduled
            if (_this2.activeModal === closingModal) {
              _this2.pageOverlayElement.classList.remove('is-visible');
              _this2.pageOverlayElement.removeEventListener('click', _this2._closeListener);
            }
          }

          closingModal.setAttribute('aria-hidden', 'true');

          if (_this2.activeModal === closingModal) {
            _this2.activeModal = null;
          }

          if (!_this2.wasLocked) {
            document.documentElement.classList.remove('no-scroll');
          }
        });
      }
    }, {
      key: "_onTransitionEnded",
      value: function _onTransitionEnded(event) {
        if (event.propertyName !== 'visibility') {
          return;
        }

        Accessibility.trapFocus(this.activeModal, 'modal'); // Trap the focus first (as this trigger reflows)

        this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener);
      }
    }, {
      key: "_resetVideo",
      value: function _resetVideo(event) {
        if (event.propertyName !== 'visibility') {
          return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
        }

        var iframe = event.target.querySelector('iframe');
        iframe.parentNode.innerHTML = "<iframe class=\"Image--lazyLoad\" data-src=".concat(iframe.getAttribute('data-src'), " frameborder=\"0\" allowfullscreen>");
        event.target.removeEventListener('transitionend', this._resetVideoListener);
      }
      /**
       * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
       */

    }, {
      key: "_checkOpenByHash",
      value: function _checkOpenByHash() {
        var hash = window.location.hash,
            modal = document.getElementById(hash.replace('#', ''));

        if (modal && modal.classList.contains('Modal')) {
          this._openModal(modal);
        }
      }
      /**
       * Handle a11y events
       */

    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (null !== this.activeModal && event.keyCode === 27) {
          this._closeModal();
        }
      }
    }]);

    return Modal;
  }();

  var Popover = /*#__PURE__*/function () {
    function Popover(element, options) {
      _classCallCheck(this, Popover);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator = options['activator'] || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));
      this.preferredPosition = options['preferredPosition'] || 'bottom';
      this.preferredAlignment = options['preferredAlignment'] || undefined;
      this.threshold = options['threshold'] || 20;
      this.isOpen = false;

      this.onValueChanged = options['onValueChanged'] || function () {};

      this.onOpen = options['onOpen'] || function () {};

      this.onClose = options['onClose'] || function () {};

      this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay']; // When true, _position caps the value list to the space the panel actually has

      this.fitToViewport = options['fitToViewport'] === undefined ? false : options['fitToViewport'];
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      this._attachListeners();
    }

    _createClass(Popover, [{
      key: "destroy",
      value: function destroy() {
        this.element.removeEventListener('keyup', this._handleKeyboardListener);
        this.delegateElement.off('click');
        this.activator.removeEventListener('click', this._toggleListener);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open() {
        var _this = this;

        // Note: the additional check on the aria-controls is used here so that a given activator can be used on different
        //       popovers and be modified dynamically in JavaScript
        if (this.isOpen || this.activator.getAttribute('aria-controls') !== this.element.id) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'false');
        this.activator.setAttribute('aria-expanded', 'true');
        disableBodyScroll(true, '[data-scrollable]');
        document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open

        if (Responsive.matchesBreakpoint('lap-and-up')) {
          document.body.addEventListener('click', this._clickOutsideListener);

          this._position();

          this.element.setAttribute('tabindex', '-1');
          this.element.addEventListener('transitionend', function () {
            _this.element.focus();
          }, {
            once: true
          });
        } else {
          this.element.removeAttribute('style');

          this._resetViewportFit();

          if (this.showOverlay) {
            this.pageOverlayElement.classList.add('is-visible');
            this.pageOverlayElement.addEventListener('click', this._closeListener);
          }
        }

        this.onOpen(this); // Call the callback to allow other code to hook their logic

        this.isOpen = true;
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'true');
        this.activator.setAttribute('aria-expanded', 'false');
        disableBodyScroll(false, '[data-scrollable]');
        document.documentElement.classList.remove('no-scroll');

        document.body.removeEventListener('click', this._clickOutsideListener);

        if (this.showOverlay) {
          this.pageOverlayElement.classList.remove('is-visible');
          this.pageOverlayElement.removeEventListener('click', this._closeListener);
        }

        this.element.removeAttribute('tabindex');

        this._resetViewportFit();

        this.activator.focus();
        this.onClose(this); // Call the callback to allow other code to hook their logic

        this.isOpen = false;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this._clickOutsideListener = this._clickOutside.bind(this);
        this._closeListener = this.close.bind(this);
        this._toggleListener = this.toggle.bind(this);
        this.element.addEventListener('keyup', this._handleKeyboardListener);
        this.activator.addEventListener('click', this._toggleListener);
        this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
        this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));

        if (this.element.hasAttribute('id')) {
          this.delegateElement.on('focusout', "#".concat(this.element.getAttribute('id')), this._onFocusOut.bind(this));
        }
      }
      /**
       * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
       * of the value change
       */

    }, {
      key: "_valueChanged",
      value: function _valueChanged(event) {
        Dom.getSiblings(event.target, '.is-selected').forEach(function (item) {
          return item.classList.remove('is-selected');
        });
        event.target.classList.add('is-selected'); // If there is a callback in option we call it with the value

        this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator);
        this.close();
      }
    }, {
      key: "_onFocusOut",
      value: function _onFocusOut(event) {
        if (!this.element.contains(event.relatedTarget) && event.relatedTarget !== this.activator) {
          this.close();
        }
      }
      /**
       * Callback that is called to decide if we should close the popover when a click is captured outside
       */

    }, {
      key: "_clickOutside",
      value: function _clickOutside(event) {
        if (!event.target.closest('.Popover') && !event.target.closest('.Modal') && event.target !== this.activator && !this.activator.contains(event.target)) {
          this.close();
        }
      }
      /**
       * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
       */

    }, {
      key: "_position",
      value: function _position() {
        var _this2 = this;

        var topPosition = 0,
            rightPosition = 0,
            position = '',
            alignment = '',
            headerHeight = 0,
            fitAvailableHeight = 0,
            threshold = this.threshold;
        fastdom.measure(function () {
          var headerElement = _this2.element.querySelector('.Popover__Header');
          headerHeight = headerElement ? headerElement.offsetHeight : 0;

          var windowHeight = window.innerHeight,
              activatorBoundingRect = _this2.activator.getBoundingClientRect(),
              halfHeight = windowHeight / 2;

          if (_this2.preferredPosition === 'bottom') {
            alignment = 'right';

            if (_this2.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
              position = 'bottom';
            } else {
              position = 'top';
            }
          } else if (_this2.preferredPosition === 'top') {
            alignment = 'right';

            if (_this2.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
              position = 'top';
            } else {
              position = 'bottom';
            }
          } else {
            position = 'left'; // Is there enough space to use the center alignment (which is preferred)?

            var halfElementHeight = _this2.element.clientHeight / 2;

            if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = 'center';
            } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = 'bottom';
            } else {
              alignment = 'top';
            }
          }

          if (_this2.preferredAlignment) {
            alignment = _this2.preferredAlignment;
          } // Always keep the panel below the activator, fitted to the space there, so it
          // covers neither the control that opened it nor the header above it


          if (_this2.fitToViewport) {
            position = 'bottom';
            fitAvailableHeight = windowHeight - activatorBoundingRect.bottom - threshold;
          }

          if (position === 'top') {
            topPosition = activatorBoundingRect.top - _this2.element.clientHeight - threshold;

            if (alignment === 'center') {
              rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.right;
            }
          } else if (position === 'bottom') {
            topPosition = activatorBoundingRect.bottom + threshold;

            if (alignment === 'center') {
              rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.right;
            }
          } else {
            rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;

            if (alignment === 'center') {
              topPosition = activatorBoundingRect.top - _this2.element.clientHeight / 2 + _this2.activator.clientHeight / 2;
            } else if (alignment === 'top') {
              topPosition = activatorBoundingRect.bottom - _this2.element.clientHeight;
            } else {
              topPosition = activatorBoundingRect.top;
            }
          }
        });
        fastdom.mutate(function () {
          ['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].map(function (item) {
            return _this2.element.classList.remove(item);
          });

          _this2.element.classList.add("Popover--position".concat(position.charAt(0).toUpperCase() + position.slice(1)));

          _this2.element.classList.add("Popover--align".concat(alignment.charAt(0).toUpperCase() + alignment.slice(1)));

          _this2.element.setAttribute('style', "top: ".concat(parseInt(topPosition), "px; right: ").concat(parseInt(rightPosition), "px;"));

          if (_this2.fitToViewport) {
            var valueList = _this2.element.querySelector('.Popover__ValueList');

            if (valueList) {
              valueList.style.maxHeight = "".concat(Math.max(0, Math.floor(fitAvailableHeight) - headerHeight), "px");
            }
          }
        });
      }
      /**
       * Clears the inline cap applied by _position so the stylesheet takes over again
       */

    }, {
      key: "_resetViewportFit",
      value: function _resetViewportFit() {
        if (!this.fitToViewport) {
          return;
        }

        var valueList = this.element.querySelector('.Popover__ValueList');

        if (valueList) {
          valueList.style.maxHeight = '';
        }
      }
      /**
       * Handle a11y events
       */

    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);

    return Popover;
  }();

  /**
   * This class will coordinate all the transitions from the website
   */
  var PageTransition = /*#__PURE__*/function () {
    function PageTransition() {
      _classCallCheck(this, PageTransition);

      this.domDelegate = new domDelegate.Delegate(document.body);
      this.pageTransition = document.querySelector('.PageTransition');

      this._attachListeners();
    }

    _createClass(PageTransition, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.domDelegate.on('click', 'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', this._onPageUnload.bind(this));
      }
      /**
       * This callback captures click and transition from one page to another by doing a transition
       */

    }, {
      key: "_onPageUnload",
      value: function _onPageUnload(event, target) {
        var _this = this;

        if (event.defaultPrevented || event.ctrlKey || event.metaKey || !window.theme.showPageTransition || !this.pageTransition) {
          return;
        }

        event.preventDefault(); // Prevent the click to happen

        if (window.theme.showPageTransition && this.pageTransition) {
          var doTransition = function doTransition(event) {
            // Animation is finished, we can transition
            if (event.propertyName === 'opacity') {
              _this.pageTransition.removeEventListener('transitionend', doTransition);

              window.location.href = target.href;
            }
          };

          this.pageTransition.addEventListener('transitionend', doTransition);
          this.pageTransition.style.visibility = 'visible';
          this.pageTransition.style.opacity = '1';
        }
      }
    }], [{
      key: "getInstance",
      value: function getInstance() {
        if (!this.instance) {
          this.instance = new PageTransition();
        }

        return this.instance;
      }
    }]);

    return PageTransition;
  }();

  var Image = /*#__PURE__*/function () {
    function Image() {
      _classCallCheck(this, Image);
    }

    _createClass(Image, null, [{
      key: "getSizedImageUrl",
      value:
      /**
       * Create a CDN URL (similar to the img_url filter in Liquid)
       */
      function getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }

        if (size === 'master') {
          return src.replace(/http(s)?:/, '');
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
          var prefix = src.split(match[0]);
          var suffix = match[0];
          return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
        } else {
          return null;
        }
      }
      /**
       * From a given set of desired sizes and a given image, filter out any unwanted sizes
       */

    }, {
      key: "getSupportedSizes",
      value: function getSupportedSizes(image, desiredSizes) {
        var supportedSizes = [],
            imageWidth = image['width'];
        desiredSizes.forEach(function (width) {
          if (imageWidth >= width) {
            supportedSizes.push(width);
          }
        });
        return supportedSizes;
      }
    }]);

    return Image;
  }();

  var ProductImageZoom = /*#__PURE__*/function () {
    function ProductImageZoom(element, slideshow, callbacks) {
      _classCallCheck(this, ProductImageZoom);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.body);
      this.slideshow = slideshow;
      this.callbacks = callbacks || {};

      this._attachListeners();
    }

    _createClass(ProductImageZoom, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off('click');
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this));
        this.delegateElement.on('click', '.Product__SlideItem--image', this._initPhotoSwipeFromImageClick.bind(this));
      }
      /**
       * To save performance, we only initialize PhotoSwipe when it's requested. All high resolution images
       * are also loaded only on demand. Also, please note that PhotoSwipe is always completely destroyed
       * whenever it is closed, so it stays super snappy
       */

    }, {
      key: "_initPhotoSwipe",
      value: function _initPhotoSwipe() {
        var images = [];
        this.slideshow.flickityInstance.cells.forEach(function (item) {
          if (item.element.classList.contains('Product__SlideItem--image')) {
            images.push(item.element.querySelector('img'));
          }
        });

        if (images.length === 0) {
          return;
        }

        // `data-image-media-position` only exists on image slides, so a selected
        // video or model slide parses to NaN, which PhotoSwipe cannot open at.
        var selectedPosition = parseInt(this.slideshow.flickityInstance.selectedElement.getAttribute('data-image-media-position'));

        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), isNaN(selectedPosition) ? 0 : selectedPosition);
      }
      /**
       * WWW-4067: open the viewer at a given image slide (mobile tap on the hero)
       */

    }, {
      key: "openFromSlide",
      value: function openFromSlide(slideElement) {
        if (!slideElement || !slideElement.classList.contains('Product__SlideItem--image')) {
          return;
        }

        var position = parseInt(slideElement.getAttribute('data-image-media-position')),
            images = Dom.nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img'));

        if (isNaN(position) || images.length === 0) {
          return;
        }

        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), position);
      }
      /**
       * On desktop we do not have the dedicated small icon, instead the zoom is triggered when clicking directly on the image
       */

    }, {
      key: "_initPhotoSwipeFromImageClick",
      value: function _initPhotoSwipeFromImageClick(event, target) {
        // Opening this way is only available on desktop
        if (Responsive.matchesBreakpoint('pocket')) {
          return;
        }

        var images = Dom.nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img'));

        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(target.getAttribute('data-image-media-position')));
      }
      /**
       * Take a list of images and create a PhotoSwipe array. This is called whenever the gallery is initialized.
       */

    }, {
      key: "_createPhotoSwipeItemsFromImages",
      value: function _createPhotoSwipeItemsFromImages(images) {
        return images.map(function (image) {
          var maxWidth = parseInt(image.getAttribute('data-max-width')),
              maxHeight = parseInt(image.getAttribute('data-max-height')),
              maxDimension = Responsive.matchesBreakpoint('phone') ? 1200 : 1800,
              // 1200 is max size for mobile and 1800 for larger devices
          reduceFactor = 1.0;

          if (maxWidth >= maxHeight) {
            reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
          } else {
            reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
          }

          var requestedWidth = Math.floor(maxWidth / reduceFactor);
          var requestedHeight = Math.floor(maxHeight / reduceFactor);
          return {
            msrc: image.currentSrc || image.src,
            // For browser that supports srcset, currentSrc is the currently used image
            w: requestedWidth,
            h: requestedHeight,
            initialZoomLevel: 0.65,
            src: Image.getSizedImageUrl(image.getAttribute('data-original-src'), requestedWidth + 'x' + requestedHeight)
          };
        });
      }
      /**
       * Take a list of nodes containing all images and create a PhotoSwipe array. This is called
       * whenever the gallery is initialized.
       */

    }, {
      key: "_createPhotoSwipeInstance",
      value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
        var _this = this;

        var photoswipeContainer = document.querySelector('.pswp');
        this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
          index: selectedImageIndex,
          showHideOpacity: true,
          showAnimationDuration: 500,
          loop: false,
          history: false,
          closeOnVerticalDrag: false,
          // WWW-4067: a zoomed photo can be dragged past its edge onto the next one
          allowPanToNext: !!(this.callbacks.isWww4067Active && this.callbacks.isWww4067Active()),
          pinchToClose: false,
          errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
          // WWW-4067 opens on the whole, uncropped photo. 'zoom' opens at the larger of each item's
          // `initialZoomLevel` and the fitted size, which crops a portrait photo on a phone.
          scaleMode: this.callbacks.isWww4067Active && this.callbacks.isWww4067Active() ? 'fit' : 'zoom',
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.6;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn(index) {
            var thumbnail = _this.element.querySelector(".Product__Slideshow .Carousel__Cell[data-image-media-position=\"".concat(parseInt(index), "\"] img"));

            // false makes PhotoSwipe fall back to its opacity transition
            if (!thumbnail) {
              return false;
            }

            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect(),
                style = window.getComputedStyle(thumbnail);

            if (style.objectFit !== 'cover' || !thumbnail.naturalWidth || !thumbnail.naturalHeight) {
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }

            // The WWW-4067 hero crops with `object-fit: cover`, so the box is smaller
            // than the photo PhotoSwipe animates to. Return the bounds of the whole
            // scaled photo, offset by `object-position`, or it snaps on open and close.
            var ratio = thumbnail.naturalWidth / thumbnail.naturalHeight,
                contentWidth = Math.max(rect.width, rect.height * ratio),
                contentHeight = contentWidth / ratio,
                position = style.objectPosition.split(' '),
                positionX = /%$/.test(position[0]) ? parseFloat(position[0]) / 100 : 0.5,
                positionY = /%$/.test(position[1]) ? parseFloat(position[1]) / 100 : 0.5;

            return {
              x: rect.left - (contentWidth - rect.width) * positionX,
              y: rect.top + pageYScroll - (contentHeight - rect.height) * positionY,
              w: contentWidth
            };
          }
        }); // We need to patch PhotoSwipe update size to solve iOS 15 issue

        var originalUpdateSize = this.photoSwipeInstance.updateSize,
            lastWidth = null;

        this.photoSwipeInstance.updateSize = function () {
          if (lastWidth === null || lastWidth !== window.innerWidth) {
            originalUpdateSize(this, arguments);
          }

          lastWidth = window.innerWidth;
        };

        this.photoSwipeInstance.listen('beforeChange', this._onSlideChanged.bind(this));
        this.photoSwipeInstance.listen('destroy', this._destroyPhotoSwipe.bind(this));
        this.photoSwipeInstance.listen('doubleTap', this._onDoubleTap.bind(this));
        this.photoSwipeInstance.listen('initialZoomIn', this._onInitialZoomIn.bind(this));
        this.photoSwipeInstance.listen('initialZoomOut', this._onInitialZoomOut.bind(this));
        // `close` fires just before PhotoSwipe reads the closing bounds, so the
        // carousel is in place in time even if `afterChange` has not fired.
        this.photoSwipeInstance.listen('afterChange', this._syncSlideshowToViewer.bind(this));
        this.photoSwipeInstance.listen('close', this._syncSlideshowToViewer.bind(this));
        this._pendingZoomResets = [];
        this.photoSwipeInstance.listen('beforeChange', this._captureLeavingZoom.bind(this));
        this.photoSwipeInstance.listen('afterChange', this._onZoomChangeSettled.bind(this));
        this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this._onSingleTap.bind(this));
        this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);
        this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev);
        this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next);

        if (this.callbacks.onOpen) {
          this.callbacks.onOpen();
        }

        this.photoSwipeInstance.init();
      }
      /**
       * Update the nav
       */

    }, {
      key: "_onSlideChanged",
      value: function _onSlideChanged() {
        if (this.photoSwipeInstance.getCurrentIndex() === 0) {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').setAttribute('disabled', 'disabled');
        } else {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').removeAttribute('disabled');
        }

        if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').setAttribute('disabled', 'disabled');
        } else {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').removeAttribute('disabled');
        }
      }
      /**
       * This event is a bit different and is triggered when the user click somewhere. We use it do allow to zoom in and
       * zoom out in the image on desktop and use for the UI
       */

    }, {
      key: "_onSingleTap",
      value: function _onSingleTap(event) {
        if (!event.detail || event.detail.pointerType === 'mouse') {
          if (event.target.classList.contains('pswp__img')) {
            this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
          }
        } else {
          if (event.target.classList.contains('pswp__button')) {
            return;
          }

          // WWW-4067 keeps the controls on screen; a stray tap beside an arrow would otherwise hide them
          if (this.callbacks.isWww4067Active && this.callbacks.isWww4067Active()) {
            return;
          }

          event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
        }
      }
    }, {
      key: "_onDoubleTap",
      value: function _onDoubleTap(point) {
        var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

        if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
          this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
        } else {
          this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
        }
      }
    }, {
      /**
       * Swiping inside the viewer does not move the page carousel, so PhotoSwipe
       * would animate the close towards an off-screen cell. Move the carousel to
       * the viewer's photo first; the shopper also lands back on that photo.
       */
      key: "_syncSlideshowToViewer",
      value: function _syncSlideshowToViewer() {
        var flickityInstance = this.slideshow && this.slideshow.flickityInstance;

        // Desktop stacks the slides with Flickity off, so every cell is already in place
        if (!this.photoSwipeInstance || !flickityInstance || !flickityInstance.isActive) {
          return;
        }

        var cell = this.element.querySelector(".Product__Slideshow .Carousel__Cell[data-image-media-position=\"".concat(parseInt(this.photoSwipeInstance.getCurrentIndex()), "\"]"));

        if (!cell) {
          return;
        }

        // The image-only counter is not the cell index once there is a video, so use the 1-based position over all media
        var cellIndex = parseInt(cell.getAttribute('data-media-position')) - 1;

        if (!isNaN(cellIndex) && cellIndex !== flickityInstance.selectedIndex) {
          this.slideshow.selectCell(cellIndex, false, false);
        }
      }
    }, {
      /**
       * WWW-4067: a zoomed photo stays zoomed while it slides out, then resets once off screen.
       * `beforeChange` fires with the index delta while the old photo still shows its zoom, before
       * PhotoSwipe resets it. It also fires with 0 on resize, which is skipped.
       */
      key: "_captureLeavingZoom",
      value: function _captureLeavingZoom(indexDiff) {
        this._zoomChangePending = false;
        this._leavingZoomLook = null;

        if (!indexDiff || !this.callbacks.isWww4067Active || !this.callbacks.isWww4067Active()) {
          return;
        }

        this._zoomChangePending = true;

        var item = this.photoSwipeInstance.items[this.photoSwipeInstance.getCurrentIndex() - indexDiff];

        if (item && item.container && this.photoSwipeInstance.getZoomLevel() !== item.initialZoomLevel) {
          this._leavingZoomLook = this._readZoomLook(item);
        }
      }
    }, {
      key: "_onZoomChangeSettled",
      value: function _onZoomChangeSettled() {
        if (!this._zoomChangePending) {
          return;
        }

        this._zoomChangePending = false;

        var _this = this,
            item = this.photoSwipeInstance.currItem,
            leaving = this._leavingZoomLook;

        // Coming back to a photo before its reset ran: PhotoSwipe treats it as unzoomed, so it is
        // re-centred below and the pending reset is dropped.
        this._pendingZoomResets = this._pendingZoomResets.filter(function (pending) {
          if (pending.item !== item) {
            return true;
          }

          clearTimeout(pending.timer);
          return false;
        });

        // PhotoSwipe has just reset the photo being left, but Prestige animates `.pswp__container`
        // (0.7s) where PhotoSwipe expects the change to be instant, so the reset would play on
        // screen. Keep the zoomed look until the slide has finished, then apply PhotoSwipe's reset.
        if (leaving) {
          var resetLook = this._readZoomLook(leaving.item),
              duration = parseFloat(window.getComputedStyle(this.photoSwipeInstance.container).transitionDuration) * 1000 || 0;

          this._applyZoomLook(leaving);
          this._leavingZoomLook = null;

          var pending = { item: leaving.item };

          pending.timer = setTimeout(function () {
            _this._applyZoomLook(resetLook);
            _this._pendingZoomResets.splice(_this._pendingZoomResets.indexOf(pending), 1);
          }, duration + 50);

          this._pendingZoomResets.push(pending);
        }

        // PhotoSwipe only positions a photo when it builds the slide, so place the incoming one
        // explicitly. `true` lets it swap between the fitted and full-resolution image to suit the
        // zoom; without it the transform is scaled for one image size while the other shows.
        if (item && item.initialPosition) {
          this.photoSwipeInstance.applyZoomPan(item.initialZoomLevel, item.initialPosition.x, item.initialPosition.y, true);
        }
      }
      /**
       * The image sizes are part of the look because a zoomed photo is drawn from a full-resolution
       * image, which PhotoSwipe swaps back to the fitted one when it resets the photo.
       */
    }, {
      key: "_readZoomLook",
      value: function _readZoomLook(item) {
        return {
          item: item,
          container: item.container,
          transform: item.container.style.transform,
          images: Dom.nodeListToArray(item.container.querySelectorAll('img')).map(function (image) {
            return { image: image, width: image.style.width, height: image.style.height };
          })
        };
      }
    }, {
      key: "_applyZoomLook",
      value: function _applyZoomLook(look) {
        look.container.style.transform = look.transform;
        look.images.forEach(function (saved) {
          saved.image.style.width = saved.width;
          saved.image.style.height = saved.height;
        });
      }
    }, {
      key: "_onInitialZoomIn",
      value: function _onInitialZoomIn() {
        document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
      }
    }, {
      key: "_onInitialZoomOut",
      value: function _onInitialZoomOut() {
        document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
      }
      /**
       * PhotoSwipe instance is automatically destroyed for us when it's closed. What we need to do is simply re-set
       * our in-memory instance to null and our own events
       */

    }, {
      key: "_destroyPhotoSwipe",
      value: function _destroyPhotoSwipe() {
        this.delegateRoot.off('pswpTap');
        this.photoSwipeInstance = null;

        (this._pendingZoomResets || []).forEach(function (pending) {
          clearTimeout(pending.timer);
        });
        this._pendingZoomResets = [];

        if (this.callbacks.onClose) {
          this.callbacks.onClose();
        }
      }
    }]);

    return ProductImageZoom;
  }();

  var ProductModel = /*#__PURE__*/function () {
    function ProductModel(element, stackProductImages) {
      _classCallCheck(this, ProductModel);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.documentElement);
      this.stackProductImages = stackProductImages;

      this._attachListeners();

      var stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
      document.head.appendChild(stylesheet);
      window.Shopify.loadFeatures([{
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this._setupModelViewerUI.bind(this)
      }, {
        name: 'shopify-xr',
        version: '1.0'
      }]);
    }

    _createClass(ProductModel, [{
      key: "destroy",
      value: function destroy() {}
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        var _this = this;

        this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_play', function () {
          _this.element.dispatchEvent(new CustomEvent('model:played', {
            bubbles: true
          }));
        });
        this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_pause', function () {
          _this.element.dispatchEvent(new CustomEvent('model:paused', {
            bubbles: true
          }));
        });
      }
    }, {
      key: "hasBeenSelected",
      value: function hasBeenSelected() {
        // As per guidelines, we only need to autoplay when it's not a touch device
        if (Responsive.matchesBreakpoint('supports-hover')) {
          this.modelUi.play();
        }
      }
    }, {
      key: "hasBeenDeselected",
      value: function hasBeenDeselected() {
        // In all cases, we just turn it off
        this.modelUi.pause();
      }
    }, {
      key: "_setupModelViewerUI",
      value: function _setupModelViewerUI() {
        this.modelElement = this.element.querySelector('model-viewer');
        this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement);
      }
    }]);

    return ProductModel;
  }();

  var ProductReviews = /*#__PURE__*/function () {
    function ProductReviews(container) {
      _classCallCheck(this, ProductReviews);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateElement.on('click', '.spr-summary-actions-newreview', this._onNewReviewClicked.bind(this)); // Extending Shopify Reviews is a bit manual, but let's do it!

      window.SPRCallbacks = {};
      window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this);
      window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this);
    }

    _createClass(ProductReviews, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off();
      }
    }, {
      key: "_updatePagination",
      value: function _updatePagination(event, target) {
        // Unfortunately, we have to use this ugly jQuery style stuff
        SPR.$(target).data('page', parseInt(target.getAttribute('data-page')) + 1);
      }
    }, {
      key: "_onFormSuccess",
      value: function _onFormSuccess() {
        var formSuccess = this.element.querySelector('.spr-form-message-success');
        window.scrollTo(0, formSuccess.offsetTop - 45);
      }
    }, {
      key: "_onReviewsLoad",
      value: function _onReviewsLoad() {
        // We want to move "spr-pagination-next" before the "new review" button in the "spr-summary-actions" div
        var sprSummaryActions = this.element.querySelector('.spr-summary-actions'),
            previousSprPaginationNext = sprSummaryActions.querySelector('.spr-pagination-next'),
            sprPaginationNext = this.element.querySelector('.spr-pagination .spr-pagination-next');

        if (previousSprPaginationNext) {
          previousSprPaginationNext.remove();
        }

        if (sprPaginationNext) {
          sprSummaryActions.insertBefore(sprPaginationNext, sprSummaryActions.firstChild);
        }
      }
    }, {
      key: "_onNewReviewClicked",
      value: function _onNewReviewClicked(event, target) {
        target.style.display = 'none';

        if (target.previousElementSibling) {
          target.previousElementSibling.style.display = 'none';
        }
      }
    }]);

    return ProductReviews;
  }();

  /**
   * This implementation allows to serialize a form
   */
  var Form = /*#__PURE__*/function () {
    function Form() {
      _classCallCheck(this, Form);
    }

    _createClass(Form, null, [{
      key: "serialize",
      value: function serialize(form) {
        function stringKey(key, value) {
          var beginBracket = key.lastIndexOf('[');

          if (beginBracket === -1) {
            var _hash = {};
            _hash[key] = value;
            return _hash;
          }

          var newKey = key.substr(0, beginBracket);
          var newValue = {};
          newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
          return stringKey(newKey, newValue);
        }

        var hash = {};

        for (var i = 0, len = form.elements.length; i < len; i++) {
          var formElement = form.elements[i];

          if (formElement.name === '' || formElement.disabled) {
            continue;
          }

          if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
            var stringKeys = stringKey(formElement.name, formElement.value);
            hash = Form.extend(hash, stringKeys);
          }
        }

        return hash;
      }
    }, {
      key: "extend",
      value: function extend() {
        var extended = {};
        var i = 0; // Merge the object into the extended object

        var merge = function merge(obj) {
          for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              // If property is an object, merge properties
              if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                extended[prop] = Form.extend(extended[prop], obj[prop]);
              } else {
                extended[prop] = obj[prop];
              }
            }
          }
        }; // Loop through each object and conduct a merge


        for (; i < arguments.length; i++) {
          merge(arguments[i]);
        }

        return extended;
      }
    }]);

    return Form;
  }();

  var Currency = /*#__PURE__*/function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
      key: "formatMoney",
      value:
      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }
    }]);

    return Currency;
  }();

  var VariantSelector = /*#__PURE__*/function () {
    function VariantSelector(element, parentProductVariants) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck(this, VariantSelector);

      this.element = element;
      this.parentProductVariants = parentProductVariants;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator = options['activator'] || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));

      this.onValueChangedCallback = options['onValueChanged'] || function () {};

      this.isOpen = false;
      this.pageOverlayElement = document.querySelector('.PageOverlay');
      this.variantChoiceList = Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__Choice'));
      this.variantCarousel = new Carousel(this.element.querySelector('.VariantSelector__Carousel'), {
        onSelect: this._variantChanged.bind(this),
        onClick: this._variantSelected.bind(this)
      });

      this._attachListeners();
    }

    _createClass(VariantSelector, [{
      key: "destroy",
      value: function destroy() {
        this.element.removeEventListener('keyup', this._handleKeyboardListener);
        this.delegateElement.off('click');
        this.activator.removeEventListener('click', this._toggleListener);
        this.variantCarousel.destroy();
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'false');
        this.activator.setAttribute('aria-expanded', 'true');
        Accessibility.trapFocus(this.element, 'variant-selector');
        document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open

        this.element.setAttribute('style', '');
        this.pageOverlayElement.classList.add('is-visible');
        this.pageOverlayElement.addEventListener('click', this._closeListener);
        this.isOpen = true;
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'true');
        this.activator.setAttribute('aria-expanded', 'false');
        Accessibility.removeTrapFocus(this.element, 'variant-selector');
        document.documentElement.classList.remove('no-scroll');
        this.pageOverlayElement.classList.remove('is-visible');
        this.pageOverlayElement.removeEventListener('click', this._closeListener);
        this.isOpen = false;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this._closeListener = this.close.bind(this);
        this._toggleListener = this.toggle.bind(this);
        this.element.addEventListener('keyup', this._handleKeyboardListener);
        this.activator.addEventListener('click', this._toggleListener);
        this.delegateElement.on('click', '[data-action="select-variant"]', this._onVariantSelect.bind(this));
        this.parentProductVariants.delegateElement.on('variant:changed', this._onVariantChanged.bind(this));
      }
      /**
       * Called when the variant is changed (but not yet selected)
       */

    }, {
      key: "_variantChanged",
      value: function _variantChanged(selectedIndex) {
        var activeChoice = this.variantChoiceList[selectedIndex];
        activeChoice.classList.add('is-selected');
        Dom.getSiblings(activeChoice, '.is-selected').forEach(function (item) {
          return item.classList.remove('is-selected');
        });
      }
      /**
       * Called when a variant is clicked or selected
       */

    }, {
      key: "_variantSelected",
      value: function _variantSelected(cellElement, cellIndex) {
        if (this.variantCarousel.getSelectedIndex() === cellIndex) {
          this.onValueChangedCallback(cellElement.getAttribute('data-option-value'), cellElement, this.activator);
          this.close();
        } else {
          this.variantCarousel.selectCell(cellIndex);
        }
      }
    }, {
      key: "_onVariantChanged",
      value: function _onVariantChanged(event) {
        var _this = this;

        var selectedVariant = event.detail.variant,
            imageWrapperElements = this.element.querySelectorAll('.VariantSelector__ImageWrapper'),
            found = false;
        Dom.nodeListToArray(imageWrapperElements).forEach(function (image) {
          var colorPosition = parseInt(image.parentElement.getAttribute('data-option-position')) - 1,
              combinationExcludedColor = '';
          selectedVariant.options.forEach(function (optionValue, index) {
            if (index !== colorPosition) {
              combinationExcludedColor += optionValue;
            }
          });

          if (image.getAttribute('data-variant-title') === combinationExcludedColor) {
            image.setAttribute('aria-hidden', 'false');
            found = true;
          } else {
            image.setAttribute('aria-hidden', 'true');
          }
        });

        if (!found) {
          imageWrapperElements.children[0].setAttribute('aria-hidden', 'false');
        }

        var foundColorIndex = 0;
        Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__ChoicePrice')).forEach(function (priceElement, index) {
          var colorPosition = parseInt(priceElement.getAttribute('data-color-position')) - 1;

          _this.parentProductVariants.productData['variants'].forEach(function (variant) {
            var matchOptionsExcludedColor = true;
            variant['options'].forEach(function (option, index) {
              if (index !== colorPosition) {
                if (variant['options'][index] !== selectedVariant['options'][index]) {
                  matchOptionsExcludedColor = false;
                }
              }
            });

            if (matchOptionsExcludedColor && variant['options'][colorPosition] === selectedVariant['options'][colorPosition]) {
              if (foundColorIndex++ === index) {
                priceElement.innerHTML = "<span class=\"Heading Text--subdued\">".concat(Currency.formatMoney(variant['price'], window.theme.moneyFormat), "</span>");
              }
            }
          });
        });
      }
      /**
       * Called when the button "choose this variant" is explicitly clicked
       */

    }, {
      key: "_onVariantSelect",
      value: function _onVariantSelect() {
        var selectedCell = this.variantCarousel.flickityInstance.selectedCell.element;
        this.onValueChangedCallback(selectedCell.getAttribute('data-option-value'), selectedCell, this.activator);
        this.close();
      }
      /**
       * Handle a11y events
       */

    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);

    return VariantSelector;
  }();

  /**
   * Handle the store availability management. The parameter is the div that will hold the content. The function
   * "updateWithVariant" must be called whenever the variant is changed.
   */
  var StoreAvailability = /*#__PURE__*/function () {
    function StoreAvailability(element, productTitle) {
      _classCallCheck(this, StoreAvailability);

      this.element = element;
      this.productTitle = productTitle;
      this.existingDrawers = {};
    }

    _createClass(StoreAvailability, [{
      key: "updateWithVariant",
      value: function updateWithVariant(variant) {
        if (!this.element) {
          return; // If the element to inject the store availability does not exist, we return immediately
        } // If the variant is null (for instance unavailable variant), we clear the container


        if (!variant) {
          this.element.textContent = '';
          return;
        } // If we have a new variant we render the section


        this._renderAvailabilitySection(variant['id']);
      }
    }, {
      key: "_renderAvailabilitySection",
      value: function _renderAvailabilitySection(id) {
        var _this = this;

        // First we clear the previous content
        this.element.innerHTML = ''; // If there is already an element with the given modal we remove it first

        var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));

        if (availabilityModal) {
          availabilityModal.remove();
        }

        if (this.existingDrawers["StoreAvailabilityModal-".concat(id)]) {
          this.existingDrawers["StoreAvailabilityModal-".concat(id)].destroy();
          delete this.existingDrawers["StoreAvailabilityModal-".concat(id)];
        }

        return fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(id, "?section_id=store-availability")).then(function (response) {
          return response.text().then(function (content) {
            _this.element.innerHTML = content;
            _this.element.innerHTML = _this.element.firstElementChild.innerHTML; // The product title is not rendered so we have to render it manually

            var productTitle = _this.element.querySelector('.store-availabilities-modal__product-title');

            if (productTitle) {
              productTitle.textContent = _this.productTitle;
            } // In order for our modal system to work we have to append the modal to the body instead

            var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
            if (availabilityModal) {
              document.body.appendChild(availabilityModal); // Create the drawer
            }

            _this.existingDrawers["StoreAvailabilityModal-".concat(id)] = new Drawer(availabilityModal);
          });
        });
      }
    }]);

    return StoreAvailability;
  }();

  var ProductVariants = /*#__PURE__*/function () {
    function ProductVariants(container, options) {
      var _this = this;

      _classCallCheck(this, ProductVariants);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = options;
      var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML || '[]');
      this.productData = jsonData['product'];
      this.variantsInventories = jsonData['inventories'] || {};
      this.variantsExtraData = jsonData['variants_extra_data'] || {};
      this.configurator = jsonData['configurator'];
      this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData['id'])); // We init value with the first selected variant
      this.productVariantsElement = this.element.querySelector('.ProductForm__Variants');

      // TODO add custom strikethrough
      this.productData['variants'].forEach(function (variant) {
        if (_this.variantsExtraData.hasOwnProperty(variant['id'])) {
          Object.assign(variant, _this.variantsExtraData[variant['id']]);
        }
        variant['productHandle'] = _this.productData.handle;
        variant['showConfigurator'] = (!(_this.configurator == null || _this.configurator === ''));
        if (variant['id'] === jsonData['selected_variant_id']) {
          _this.currentVariant = variant;
          _this.option1 = variant['option1'];
          _this.option2 = variant['option2'];
          _this.option3 = variant['option3'];
        }
      });
      this.storeAvailability = new StoreAvailability(this.element.querySelector('.ProductMeta__StoreAvailabilityContainer'), this.productData['title']);
      this.storeAvailability.updateWithVariant(this.currentVariant);

      this._updateAddToCartButton(this.currentVariant);

      this._updateVariantSaleBadge(this.currentVariant);

      this._attachListeners();

      this._createSelectors();
    }

    _createClass(ProductVariants, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off('click');
        this.delegateElement.off('change');

        this.formPopovers.forEach(function (popover) {
          return popover.destroy();
        });
        this.formVariantSelectors.forEach(function (selector) {
          return selector.destroy();
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
        this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
        this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
        this.delegateElement.on('change', '[name="quantity"]', this._validateQuantity.bind(this)); // Hook when a radio button change

        this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));

        this.delegateElement.on('input', '.GiftCardSlider[type="range"]', this._previewSliderValue.bind(this));
        this.delegateElement.on('change', '.GiftCardSlider[type="range"]', this._updateSliderValue.bind(this));
      }
      /**
       * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
       */

    }, {
      key: "_createSelectors",
      value: function _createSelectors() {
        var _this2 = this;

        // Create the instances for each selector
        this.formPopovers = [];
        this.formVariantSelectors = [];
        Dom.nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function (item) {
          var popover = new Popover(item, {
            preferredPosition: 'left',
            onValueChanged: _this2._onOptionChanged.bind(_this2)
          });

          _this2.formPopovers.push(popover);
        });
        Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector')).forEach(function (item) {
          var variantSelector = new VariantSelector(item, _this2, {
            onValueChanged: _this2._onOptionChanged.bind(_this2)
          });

          _this2.formVariantSelectors.push(variantSelector);
        });
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
       *
       * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
       * edit this code
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * This callback is called whenever the variant changes and allows to update data about the active variant
       */

    }, {
      key: "_onVariantChanged",
      value: function _onVariantChanged(previousVariant, newVariant) {
        // 1st: the prices
        this._updateProductPrices(newVariant, previousVariant);
        // 2nd: update inventory
        this._updateInventory(newVariant, previousVariant);
        // 3rd: update SKU
        this._updateSku(newVariant, previousVariant);
        // 4th: update the price measurement
        this._updateUnitPrice(newVariant, previousVariant);
        // 5th: the add to cart button
        this._updateAddToCartButton(newVariant, previousVariant);
        // 6th: update swatches
        this._updateProductForm(newVariant);
        // 7th: store availability
        this._updateStoreAvailabilityAccordion(newVariant);
        this.storeAvailability.updateWithVariant(newVariant);
        // 8th: variant-aware private sale badge
        this._updateVariantSaleBadge(newVariant);
        // Finally, we send an event so that other system could hook and do their own logic

        this.element.dispatchEvent(new CustomEvent('variant:changed', {
          bubbles: true,
          detail: {
            variant: newVariant,
            previousVariant: previousVariant
          }
        }));
      }
      /**
       * Update the prices (optionally showing compare at price)
       */

    }, {
      key: "_updateProductPrices",
      value: function _updateProductPrices(newVariant, previousVariant) {
        // Never use moneyWithCurrencyFormat here: it appends the code for every currency. The code is
        // added as a separate span, matching snippets/currency-code-suffix.liquid.
        var productMetaPrices = this.element.querySelector('.ProductMeta__PriceList'),
            currencyFormat = window.theme.moneyFormat;

        if (!productMetaPrices) {
          return;
        }

        if (!newVariant) {
          productMetaPrices.style.display = 'none';
        } else {
          if (previousVariant
            && previousVariant['price'] === newVariant['price']
            && previousVariant['compare_at_price'] === newVariant['compare_at_price']
            && previousVariant['custom_private_sale_price'] == newVariant['custom_private_sale_price']) {
            return; // The price didn't change so let's return to avoid changing the DOM for nothing
          }

          productMetaPrices.innerHTML = '';

          // We know we need to have a custom price if the previous variant had one or if this one does
          if (previousVariant['custom_private_sale_price'] !== undefined || newVariant['custom_private_sale_price'] !== undefined) {
            
            if (newVariant['custom_private_sale_price']) {
              productMetaPrices.innerHTML += "<span class=\"ProductItem__Price ProductItem__CustomStrikethroughPrice Price Price--compareAt d-none\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
              productMetaPrices.innerHTML += "<span class=\"ProductItem__Price ProductItem__CustomStrikethroughPrice Price Price--highlight d-none\">".concat(newVariant['custom_private_sale_price'], "</span>");
            } else {
              // We give the main price as the custom price so it can be shown to privatesale
              productMetaPrices.innerHTML += "<span class=\"ProductItem__Price ProductItem__CustomStrikethroughPrice Price Text--subdued u-h4 d-none\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
            }
          }

          if (newVariant['compare_at_price'] > newVariant['price']) {
            productMetaPrices.innerHTML += "<span class=\"ProductItem__Price ProductItem__DefaultPrice Price Price--compareAt\" data-money-convertible>".concat(Currency.formatMoney(newVariant['compare_at_price'], currencyFormat), "</span>");
            productMetaPrices.innerHTML += "<span class=\"ProductItem__Price ProductItem__DefaultPrice Price Price--highlight\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
          } else {
            productMetaPrices.innerHTML += "<span class=\"ProductItem__Price ProductItem__DefaultPrice Price\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
          }

          if (window.theme.currencyCodeEnabled && window.theme.currencyCodeDisplay) {
            productMetaPrices.innerHTML += " <span class=\"Price Price__CurrencyCode\">".concat(window.theme.currencyCodeDisplay, "</span>");
          }

          productMetaPrices.style.display = '';

          checkPrivateSale();
        }
      }
      /**
       * Variant-aware private sale badge. Sets data-on-sale on the badge wrapper
       * and toggles visibility while respecting the early-access gate handled by
       * checkPrivateSale().
       */

    }, {
      key: "_updateVariantSaleBadge",
      value: function _updateVariantSaleBadge(newVariant) {
        var badges = this.element.querySelectorAll('[data-variant-sale-badge]');
        if (!badges.length) {
          return;
        }
        var isOnSale = !!(newVariant && newVariant['on_sale']);
        badges.forEach(function (badge) {
          badge.setAttribute('data-on-sale', isOnSale ? 'true' : 'false');
        });
        // Re-apply the early-access gate; this will reveal or hide the wrapper
        // depending on the new data-on-sale value.
        checkPrivateSale();
      }
      /**
       * Update the inventory (if needed)
       */

    }, {
      key: "_updateInventory",
      value: function _updateInventory(newVariant) {
        if (!this.options['showInventoryQuantity']) {
          return;
        }

        var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
            variantInventory = newVariant ? this.variantsInventories[newVariant['id']] : null;
            
            console.log(variantInventory);

        if (!newVariant || null === variantInventory['inventory_management'] || variantInventory['inventory_showmessage'] == 'true' ) {
          productFormInventory.style.display = 'none';
        } else {
          productFormInventory.innerHTML = variantInventory['inventory_message'];
          productFormInventory.style.display = '';
        }
      }

      /**
       * Update the SKU
       */
    }, {
      key: "_updateSku",
      value: function _updateSku(newVariant) {
        if (!this.options['showSku'] || !newVariant) {
          return;
        }

        var productSkuNumber = this.element.querySelector('.ProductMeta__SkuNumber');

        if (productSkuNumber && newVariant['sku']) {
          productSkuNumber.innerText = newVariant['sku'];
        }
      }
      
      /**
       * Update Value Slider Value Displayed when someone is dragging the slider
       * This does not select or update the variant chosen.
       */
    }, {
      key: "_previewSliderValue",
      value: function _previewSliderValue(event) {

        if (!event.target || !event.target.value) {
          return;
        }

        var slider = event.target;
        var idx = event.target.value;
        var displayedSliderValue = this.element.querySelector(slider.dataset.target);
        var hidden = this.element.querySelector(slider.dataset.hidden);
        var values = slider.dataset.values.split('||');
        var i = Math.max(0, Math.min(values.length - 1, parseInt(idx, 10) || 0));
        var val = values[i];
        displayedSliderValue.textContent = val;
        hidden.value = val;
        slider.setAttribute('aria-valuenow', i);
        
      }
      /**
       * Update Value Slider Option
       */
    }, {
      key: "_updateSliderValue",
      value: function _updateSliderValue(event) {

        if (!event.target || !event.target.value) {
          return;
        }

        this._previewSliderValue(event);

        var slider = event.target;
        var hidden = this.element.querySelector(slider.dataset.hidden);
        // notify any listeners that the option changed (theme variant JS)
        hidden.dispatchEvent(new Event('change', { bubbles: true }));

      }

      /**
       * Show or hide the store availability accordion.
       */
    }, {
      key: "_updateStoreAvailabilityAccordion",
      value: function _updateStoreAvailabilityAccordion(newVariant) {
        if (!newVariant) {
          return;
        }

        var storeAvailabilityAccordion = this.element.querySelector('.accordion-item.store-availability');

        if (storeAvailabilityAccordion) {
          var isBeforeLaunch = newVariant['launch_date_seconds'] && newVariant['launch_date_seconds'] > Math.floor(Date.now() / 1000) ? true : false;
          if (newVariant['available'] && !isBeforeLaunch) {
            storeAvailabilityAccordion.classList.remove('d-none');
          } else {
            storeAvailabilityAccordion.classList.add('d-none');
          }
        }
      }

      /**
       * Update the unit price
       */
    }, {
      key: "_updateUnitPrice",
      value: function _updateUnitPrice(newVariant) {
        if (!newVariant) {
          return;
        }

        var unitPriceMeasurement = this.element.querySelector('.ProductMeta__UnitPriceMeasurement');

        if (!unitPriceMeasurement) {
          return;
        }

        if (!newVariant.hasOwnProperty('unit_price')) {
          unitPriceMeasurement.style.display = 'none';
          return;
        }

        unitPriceMeasurement.style.display = 'block';
        unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML = Currency.formatMoney(newVariant['unit_price'], window.theme.moneyFormat);
        unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant['unit_price_measurement']['reference_unit'];
        var unitPriceReferenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
        unitPriceReferenceValue.textContent = newVariant['unit_price_measurement']['reference_value'];
        unitPriceReferenceValue.style.display = newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline';
      }
      /**
       * Update the add to cart
       */
    }, {
      key: "_updateAddToCartButton",
      value: function _updateAddToCartButton(newVariant) {
        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
            buyButtons = this.element.querySelector('.ProductForm__BuyButtons '),
            preorderInfoText = this.element.querySelector('.preorder-info'),
            oosGiftCardLink = this.element.querySelector('.oos-gift-card-link'),
            shopifyPaymentButton = this.element.querySelector('.shopify-payment-button'),
            preorderProperty = this.element.querySelector('#preorder'),
            estShipDateProperty = this.element.querySelector('#est_ship_date'),
            finalSaleProperty = this.element.querySelector('#finalsale'),
            monogrammingButton = this.element.querySelector('.ProductForm__Monogramming');

        var eacValue = null;
        var storedEac = localStorage.getItem('eac');
        if (storedEac) {
          var parsed = JSON.parse(storedEac);
          if (Date.now() < parsed.expires) {
            var eacValue = parsed.value;
          } else {
            localStorage.removeItem('eac'); // expired
          }
        }
        var urlParams = new URL(window.location).searchParams;
        var earlyAccess = (newVariant['early_access_code'] != null && (urlParams.get('eac') == newVariant['early_access_code'] || eacValue == newVariant['early_access_code']))
        var isBeforeLaunch = newVariant['launch_date_seconds'] && newVariant['launch_date_seconds'] > Math.floor(Date.now() / 1000) ? true : false;
        var isBeforeBackInStock = newVariant['back_in_stock_date_seconds'] && newVariant['back_in_stock_date_seconds'] > Math.floor(Date.now() / 1000) ? true : false;
        preorderInfoText?.classList.add('d-none');

        if (urlParams.get('cuy') == 'ALPACINO') {
          earlyAccess = true;
          const monoTestLink = this.element.querySelector('#cuyana-mono-qa');
          if (monoTestLink) {
            monoTestLink.dataset.variantId = newVariant['id'];
          }
        }

        if (monogrammingButton) {
            monogrammingButton.dataset.variantId = newVariant['id'];
        }

        if (addToCartButton) {
          addToCartButton.classList.remove('d-none');
          buyButtons?.classList.remove('d-none');
          if (!newVariant) {
            addToCartButton.setAttribute('disabled', 'disabled');
            addToCartButton.removeAttribute('data-action');
            preorderProperty?.setAttribute('value', '');
            estShipDateProperty?.setAttribute('value', '');
            finalSaleProperty?.setAttribute('value', '');
            addToCartButton.classList.add('Button--secondary');
            addToCartButton.innerHTML = window.languages.productFormUnavailable;
          } else {
            if (newVariant['available'] && (!isBeforeLaunch || earlyAccess)) {
              addToCartButton.removeAttribute('disabled');
              addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
              addToCartButton.setAttribute('data-action', 'add-to-cart');
              if (newVariant['is_preorder']) {
                addToCartButton.innerHTML = "<span>".concat(window.languages.productFormPreorder, "</span>");
                preorderProperty?.setAttribute('value', 'true');
                estShipDateProperty?.setAttribute('value', newVariant['back_in_stock_date'] || '');

                if (monogrammingButton) {
                  //monogrammingButton.innerHTML = "<span>".concat(window.languages.productFormPreorderMono, "</span>");
                }
              } else {
                if (undefined === this.options['showPriceInButton'] || this.options['showPriceInButton']) {
                  addToCartButton.innerHTML = "\n            <span>".concat(window.languages.productFormAddToCart, "</span>\n            <span class=\"Button__SeparatorDot\"></span>\n            <span data-money-convertible>").concat(Currency.formatMoney(newVariant['price'], window.theme.moneyFormat), "</span>\n          ");
                } else {
                  addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
                }
                preorderProperty?.setAttribute('value', '');
                estShipDateProperty?.setAttribute('value', '');
                if (monogrammingButton) {
                  //monogrammingButton.innerHTML = "<span>".concat(window.languages.productFormMonogram, "</span>");
                }
              }

              if (newVariant["is_final_sale"]) {
                finalSaleProperty?.setAttribute('value', 'true');
              } else {
                finalSaleProperty?.setAttribute('value', '');
              }

              if (isBeforeBackInStock) {
                var instockDate = this.element.querySelector('.instock-date');
                instockDate.innerHTML = newVariant['back_in_stock_date'];
                preorderInfoText?.classList.remove('d-none');
              }
            } else {
              addToCartButton.setAttribute('disabled', 'disabled');
              addToCartButton.classList.add('d-none');
              addToCartButton.removeAttribute('data-action');
              preorderProperty?.setAttribute('value', '');
              estShipDateProperty?.setAttribute('value', '');
              finalSaleProperty?.setAttribute('value', '');
              addToCartButton.innerHTML = window.languages.productFormSoldOut;
              buyButtons?.classList.add('d-none');
            }
          }
        }

        //Waitlist
        var waitlistSection = this.element.querySelector('.ProductForm__WaitList');
        if (waitlistSection) {
          waitlistSection.classList.add('d-none');
          if (!newVariant || !newVariant['available'] || (isBeforeLaunch && !earlyAccess)) {
            waitlistSection.classList.remove('d-none');
          }
          var soldOutSunset = waitlistSection.querySelector('.ProductForm__SoldOutSunset');
          var waitlistInner = waitlistSection.querySelector('.ProductForm__WaitListInner');
          var exitDateSeconds = newVariant && newVariant['exit_date_seconds'] ? parseInt(newVariant['exit_date_seconds'], 10) : 0;
          var isSunsetted = exitDateSeconds > 0 && Math.floor(Date.now() / 1000) >= exitDateSeconds;
          var isReplenishable = !newVariant || newVariant['replenishable'] !== false;
          var showSoldOutCta = isSunsetted || !isReplenishable;
          if (soldOutSunset) {
            soldOutSunset.classList.toggle('d-none', !showSoldOutCta);
          }
          if (waitlistInner) {
            waitlistInner.classList.toggle('d-none', showSoldOutCta);
          }
        }

        // OOS Gift Card Link
        oosGiftCardLink?.classList.add('d-none');
        if (!newVariant || !newVariant['available']) {
          oosGiftCardLink?.classList.remove('d-none');
        }

        //Launch Message
        var launchMessage = this.element.querySelector('.availability-message');
        if (launchMessage) {
          launchMessage.classList.add('d-none');
          if (isBeforeLaunch && !earlyAccess) {
            var defaultMsgValue = launchMessage.getAttribute('data-default-msg');
            if (newVariant['launch_date_message']) {
              launchMessage.innerHTML = newVariant['launch_date_message'];
            } else {
              launchMessage.innerHTML = defaultMsgValue;
              launchMessage.querySelector('.date').innerHTML = newVariant['launch_date_formatted'];
            }
            launchMessage.classList.remove('d-none');
          } 
        }

        var showConfiguratorButton = false;
        var showMonogrammingButton = false;
        if (newVariant['available']) {
          if (newVariant['showConfigurator']) {
            showConfiguratorButton = true;
          }
          if (newVariant['monogramming']) {
            showMonogrammingButton = true;
          }
        }

        /* Update Monogramming Button */
        if (monogrammingButton) {
          if (showMonogrammingButton) {
            monogrammingButton.classList.remove('d-none');
          } else {
            monogrammingButton.classList.add('d-none');
          }
        }
        
        /* Update Configurator Button */
        var configuratorButton = this.element.querySelector('.ProductForm__Configurator');
        if (configuratorButton) {
          if (showConfiguratorButton) {
            configuratorButton.classList.remove('d-none');
          } else {
            configuratorButton.classList.add('d-none');
          }
        }

        if (this.options['showPaymentButton'] && shopifyPaymentButton) {
          if (!newVariant || !newVariant['available']) {
            shopifyPaymentButton.style.display = 'none';
          } else {
            shopifyPaymentButton.style.display = 'block';
          }
        }
      }
    }, {
      key: "_updateProductForm",
      value: function _updateProductForm(newVariant) {

        if (this.productVariantsElement && newVariant.options.length > 1 ) {
          var variant_id = newVariant['id'];
          var productHandle = newVariant['productHandle']
          var _this = this;

          const cuyParam = new URL(window.location).searchParams.get('cuy') === 'ALPACINO' ? '&cuy=ALPACINO' : '';
          const url = window.location.origin + '/products/' + productHandle + '?variant=' + variant_id + '&view=swatches' + cuyParam;
          fetch(url)
            .then(response => response.text())
            .then(html => {
              const tempElement = document.createElement('div');
              tempElement.innerHTML = html;
              const sectionHtml = tempElement.querySelector('.ProductForm__Variants');
              _this.productVariantsElement.innerHTML = sectionHtml.innerHTML;
            })
          .catch(error => {
            console.error('Failed to fetch product quickview modal content:', error);
          });
        } 
      }

      /**
       * ---------------------------------------------------------------------------------------------------
       * INTERNAL CODE THAT HANDLE VARIANT CHANGES
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * Whenever an option is changed, this code fetch the corresponding active variant
       */

    }, {
      key: "_onOptionChanged",
      value: function _onOptionChanged(newValue, target, activator) {
        // We change the value associated with the activator, and check if we have a color swatch
        if (activator) {
          this['option' + target.getAttribute('data-option-position')] = newValue;
          activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
        } else {
          this['option' + target.getAttribute('data-option-position')] = target.value;
          var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');

          if (selectedValue) {
            selectedValue.innerHTML = ' ' + target.value;
          }
        } // Finally, we get the new variant

        var previousVariant = this.currentVariant;
        this.currentVariant = this._getCurrentVariantFromOptions();

        if (this.currentVariant) {
          this._onVariantChanged(previousVariant, this.currentVariant);

          if (this.options['enableHistoryState']) {
            this._updateHistoryState(this.currentVariant);
          } // We need to modify the hidden select that contain the id attribute as well

          this.masterSelector.querySelector('[selected]').removeAttribute('selected');
          this.masterSelector.querySelector("[value=\"".concat(this.currentVariant['id'], "\"]")).setAttribute('selected', 'selected');
          this.masterSelector.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      }
      /**
       * Get the active variant based on the options
       */

    }, {
      key: "_getCurrentVariantFromOptions",
      value: function _getCurrentVariantFromOptions() {
        var _this3 = this;

        var found = false;
        this.productData['variants'].forEach(function (variant) {
          if (variant['option1'] === _this3.option1 && variant['option2'] === _this3.option2 && variant['option3'] === _this3.option3) {
            found = variant;
          }
        });
        return found || null;
      }
      /**
       * Update the history state for browsers that support it
       */

    }, {
      key: "_updateHistoryState",
      value: function _updateHistoryState(variant) {
        if (!history.replaceState) {
          return;
        }

        var currentParams = new URL(window.location).searchParams;
        currentParams.delete('variant');
        var newUrl = "".concat(window.location.protocol, "//")
          .concat(window.location.host)
          .concat(window.location.pathname)
          .concat("?variant=", variant.id);
        
        if (currentParams.size > 0) {
          newUrl = newUrl.concat("&", currentParams.toString());
        }
          
        window.history.replaceState({
          path: newUrl
        }, '', newUrl);
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
       * ---------------------------------------------------------------------------------------------------
       */

    }, {
      key: "_addToCart",
      value: function _addToCart(event) {
        var _this4 = this;

        if (this.options['useAjaxCart'] === undefined || !this.options['useAjaxCart']) {
          return; // When using a cart type of page, we just simply redirect to the cart page
        }

        event.preventDefault(); // Prevent form to be submitted

        var formElement = this.element.querySelector('form[action*="/cart/add"]');

        // If it's a giftcard form, check validity
        if (formElement.querySelector('.giftcardform') && !formElement.checkValidity()) {
          event.stopPropagation();
          formElement.classList.add('was-validated');
          return
        }

        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'); // First, we switch the status of the button

        addToCartButton.setAttribute('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

        var payload = Form.serialize(formElement);
        payload.properties._uuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);

        payload.properties._variant = this.currentVariant?.id;

        var accessoriesDiv = this.element.querySelector('#accessoriesContent');
        if (accessoriesDiv) {
          var accessories = accessoriesDiv.querySelectorAll('input.accessoriesSelector');
          var items = [];

          accessories.forEach(function(accessory) {
            if (accessory.checked) {
              var id = accessory.getAttribute('data-pid');
              var preorder = accessory.getAttribute('data-preorder');
              var finalsale = accessory.getAttribute('data-finalsale');
              var properties = {};
              var item = {
                id: id,
                quantity: 1
              };
              if (preorder == "true") {
                properties._is_preorder = true;
              }
              if (finalsale == "true") {
                properties.is_final_sale = true;
                properties._LPROP = 'no-returns';
              }
              if (Object.keys(properties).length !== 0) {
                item.properties = properties;
              }
              items.push(item);
            }
          });
          if (items.length > 0) {
            items.unshift(payload);
            payload = { items: items };
          }
        } 

        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(payload),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          var quantityElement = formElement.querySelector('[name="quantity"]');

          if (response.ok) {
            addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render

            _this4.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this4.currentVariant,
                quantity: quantityElement ? parseInt(quantityElement.value) : 1
              }
            }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              addToCartButton.removeAttribute('disabled');
              addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });
        event.preventDefault();
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * OTHER
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * When using the quantity selector, this can be used to decrease the quantity (be ensuring it won't be lower than 1)
       */

    }, {
      key: "_decreaseQuantity",
      value: function _decreaseQuantity(event, target) {
        target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
      }
      /**
       * When using the quantity selector, this can be used to increase the quantity
       */

    }, {
      key: "_increaseQuantity",
      value: function _increaseQuantity(event, target) {
        target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
      }
      /**
       * Make sure the quantity does not go below when manually changed
       */

    }, {
      key: "_validateQuantity",
      value: function _validateQuantity(event, target) {
        target.value = Math.max(parseInt(target.value) || 1, 1);
      }
    }]);

    return ProductVariants;
  }();

  var ProductVideo = /*#__PURE__*/function () {
    function ProductVideo(element, stackProductImages, enableVideoLooping) {
      _classCallCheck(this, ProductVideo);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.stackProductImages = stackProductImages;
      this.enableVideoLooping = enableVideoLooping;
      this.player = null;

      switch (this.element.getAttribute('data-media-type')) {
        case 'video':
          var stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
          document.head.appendChild(stylesheet);
          window.Shopify.loadFeatures([{
            name: 'video-ui',
            version: '1.0',
            onLoad: this._setupHtml5Video.bind(this)
          }]);
          break;

        case 'external_video':
          this._setupExternalVideo();

          break;
      }
    }

    _createClass(ProductVideo, [{
      key: "destroy",
      value: function destroy() {
        if (this.player) {
          this.player.destroy(); // Both Plyr and YouTube API use the same name
        }
      }
    }, {
      key: "hasBeenSelected",
      value: function hasBeenSelected() {
        // As per guidelines, we only need to autoplay when it's not a touch device
        if (Responsive.matchesBreakpoint('supports-hover')) {
          this.play();
        }
      }
    }, {
      key: "hasBeenDeselected",
      value: function hasBeenDeselected() {
        this.pause();
      }
    }, {
      key: "play",
      value: function play() {
        switch (this.element.getAttribute('data-media-type')) {
          case 'video':
            this.player.play();
            break;

          case 'external_video':
            this.player.playVideo();
            break;
        }
      }
    }, {
      key: "pause",
      value: function pause() {
        switch (this.element.getAttribute('data-media-type')) {
          case 'video':
            this.player.pause();
            break;

          case 'external_video':
            this.player.pauseVideo();
            break;
        }
      }
    }, {
      key: "_setupHtml5Video",
      value: function _setupHtml5Video() {
        var _this = this;

        this.player = new Shopify.Plyr(this.element.querySelector('video'), {
          controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],
          loop: {
            active: this.enableVideoLooping
          },
          hideControlsOnPause: true,
          clickToPlay: true,
          iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
          tooltips: {
            controls: false,
            seek: true
          }
        });
        this.player.on('play', function () {
          _this.element.dispatchEvent(new CustomEvent('video:played', {
            bubbles: true
          }));
        });
        this.player.on('pause', function () {
          _this.element.dispatchEvent(new CustomEvent('video:paused', {
            bubbles: true
          }));
        });
      }
    }, {
      key: "_setupExternalVideo",
      value: function _setupExternalVideo() {
        if (this.element.getAttribute('data-video-host') === 'youtube') {
          this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
        }
      }
    }, {
      key: "_setupYouTubePlayer",
      value: function _setupYouTubePlayer() {
        var _this2 = this;

        var playerLoadingInterval = setInterval(function () {
          if (window.YT !== undefined && window.YT.Player !== undefined) {
            _this2.player = new YT.Player(_this2.element.querySelector('iframe'), {
              videoId: _this2.element.getAttribute('data-video-id'),
              events: {
                onStateChange: function onStateChange(event) {
                  if (event.data === window.YT.PlayerState.PLAYING) {
                    _this2.element.dispatchEvent(new CustomEvent('video:played', {
                      bubbles: true
                    }));
                  } else if (event.data === YT.PlayerState.PAUSED) {
                    _this2.element.dispatchEvent(new CustomEvent('video:paused', {
                      bubbles: true
                    }));
                  }

                  if (event.data === window.YT.PlayerState.ENDED && _this2.enableVideoLooping) {
                    event.target.seekTo(0);
                  }
                }
              }
            });
            clearInterval(playerLoadingInterval);
          }
        }, 50);
      }
    }, {
      key: "_loadYouTubeScript",
      value: function _loadYouTubeScript() {
        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = '//www.youtube.com/iframe_api';
        });
      }
    }]);

    return ProductVideo;
  }();

  /**
   * This code has been heavily inspired by this: https://kitaitimakoto.gitlab.io/scrollspy-example/index.en.html#whatsthis
   */
  var ScrollSpy = /*#__PURE__*/function () {
    function ScrollSpy(container, elementsToSpy, observerOptions) {
      var _this = this;

      _classCallCheck(this, ScrollSpy);

      this.container = container;
      this.targets = [];
      this.targetIndices = {};
      this.indicesInViewPort = [];
      this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), observerOptions);
      elementsToSpy.forEach(function (elementToSpy, index) {
        _this.targets.push(elementToSpy);

        _this.targetIndices[elementToSpy.id] = index;

        _this.observer.observe(elementToSpy);
      });
    }

    _createClass(ScrollSpy, [{
      key: "destroy",
      value: function destroy() {
        this.observer.disconnect();
      }
      /**
       * Called whenever there is a change of visibility
       */

    }, {
      key: "_onIntersectionChange",
      value: function _onIntersectionChange(changes) {
        var oldTargetIndex = this.indicesInViewPort[0] || 0;

        for (var i = changes.length - 1; i >= 0; i--) {
          this._updateIndicesInViewPort(changes[i], oldTargetIndex);
        } // Firefox generates duplicates so make sure to remove

        this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });

        if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
          return;
        }

        var event = new CustomEvent('scrollspy:target:changed', {
          detail: {
            newTarget: this.targets[this.indicesInViewPort[0]],
            oldTarget: this.targets[oldTargetIndex]
          }
        });
        this.container.dispatchEvent(event);
      }
      /**
       * Update indices visible in the view port
       */

    }, {
      key: "_updateIndicesInViewPort",
      value: function _updateIndicesInViewPort(change, oldTargetIndex) {
        var index = this.targetIndices[change.target.id];

        if (change.intersectionRatio === 0) {
          var indexInViewPort = this.indicesInViewPort.indexOf(index);

          if (indexInViewPort !== -1) {
            this.indicesInViewPort.splice(indexInViewPort, 1);
          }
        } else {
          if (index < oldTargetIndex) {
            this.indicesInViewPort.unshift(index);
          } else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
            this.indicesInViewPort.push(index);
          } else {
            this.indicesInViewPort.push(index);
            this.indicesInViewPort.sort();
          }
        }
      }
    }]);

    return ScrollSpy;
  }();

  var SearchBar = /*#__PURE__*/function () {
    function SearchBar() {
      _classCallCheck(this, SearchBar);

      this.documentDelegate = new domDelegate.Delegate(document.body);
      this.searchElement = document.getElementById('Search');
      this.searchInputElement = this.searchElement.querySelector('[name="q"]');
      this.searchResultsElement = this.searchElement.querySelector('.Search__Results');
      this.queryMap = {};
      this.isOpen = false;
      this.pageOverlayElement = document.querySelector('.PageOverlay');
      this.srAnnouncements = document.querySelector('#srAnnouncements');

      this._attachListeners();
    }

    _createClass(SearchBar, [{
      key: "destroy",
      value: function destroy() {
        this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
        this.searchInputElement.removeEventListener('input', this._onInputListener);
        this.documentDelegate.off();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._preventSubmissionListener = this._preventSubmission.bind(this);
        this._onInputListener = this._debounce(this._onInput.bind(this), 250);
        this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
        this.searchInputElement.addEventListener('input', this._onInputListener);
        this.documentDelegate.on('click', '[data-action="toggle-search"]', this._toggleSearch.bind(this));
        this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
        this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
        this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
      }
      /**
       * Toggle the search
       */

    }, {
      key: "_toggleSearch",
      value: function _toggleSearch(event) {
        if (this.isOpen) {
          this._closeSearch(event);
          this.srAnnouncements.textContent = `The search bar has been closed.`;
        } else {
          this._openSearch(event);
          this.srAnnouncements.textContent = `The search bar is has been opened.`;
        }

        event.preventDefault();
      }
      /**
       * Open the search form and trap focus
       */

    }, {
      key: "_openSearch",
      value: function _openSearch() {
        var _this = this;

        this.searchElement.setAttribute('aria-hidden', 'false');
        this.searchInputElement.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');
        Accessibility.trapFocus(this.searchElement, 'search', this.searchElement.querySelector('[name="q"]'));

        var onFocusListener = function onFocusListener() {
          _this.searchInputElement.focus();

          _this.searchElement.removeEventListener('transitionend', onFocusListener);
        };

        this.searchElement.addEventListener('transitionend', onFocusListener);
        this.isOpen = true;
        this.pageOverlayElement.classList.add('is-visible');
        document.querySelector('#shopify-section-header').style.zIndex = 10;
      }
      /**
       * Close the search form and clear focus
       */

    }, {
      key: "_closeSearch",
      value: function _closeSearch() {
        var _this2 = this;

        if (!this.isOpen) {
          return;
        }

        this.searchElement.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        Accessibility.removeTrapFocus(this.searchElement, 'search');
        this.isOpen = false;

        var onTransitionEnd = function onTransitionEnd(event) {
          if (event.propertyName === 'visibility') {
            document.querySelector('#shopify-section-header').style.zIndex = '';

            _this2.pageOverlayElement.removeEventListener('transitionend', onTransitionEnd);
          }
        };

        this.pageOverlayElement.addEventListener('transitionend', onTransitionEnd);
        this.pageOverlayElement.classList.remove('is-visible');
      }
      /**
       * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
       * then we disable submission using enter key
       */

    }, {
      key: "_preventSubmission",
      value: function _preventSubmission(event) {
        if (event.keyCode === KEY_ENTER && window.theme.searchMode !== 'product') {
          event.preventDefault();
        }
      }
      /**
       * This is called when the user has stopped typing (after debounce delay)
       */

    }, {
      key: "_onInput",
      value: function _onInput(event) {
        var _this3 = this;

        if (event.keyCode === KEY_ENTER) {
          return;
        } // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
        // keep track of sent requests, and only use the results of the last one


        this.lastInputValue = event.target.value;

        if (this.lastInputValue === '') {
          this._resetSearch();

          return;
        }

        var queryOptions = {
          method: 'GET',
          credentials: 'same-origin'
        };
        var queries = [fetch("".concat(window.routes.searchUrl, "?section_id=cuyana-predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=product"), queryOptions)];

        if (window.theme.searchMode !== 'product') {
          queries.push(fetch("".concat(window.routes.searchUrl, "?section_id=cuyana-predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=").concat(window.theme.searchMode.replace('product,', '')), queryOptions));
        }

        this.queryMap[this.lastInputValue] = true;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        Promise.all(queries).then(function (responses) {
          // If we receive the result for a query that is not the last one, we simply do not process the result
          if (_this3.lastInputValue !== event.target.value) {
            return;
          }

          delete _this3.queryMap[event.target.value];
          Promise.all(responses.map(function (response) {
            return response.text();
          })).then(function (contents) {
            // If we have only one content then we only have product, otherwise we have products and articles
            if (window.theme.searchMode === 'product') {
              _this3.searchResultsElement.innerHTML = contents[0];
            } else {
              _this3.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\">".concat(contents[0], "</div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\">").concat(contents[1], "</div>\n            </div>");
            }

            _this3.searchResultsElement.setAttribute('aria-hidden', 'false');
            checkPrivateSale();
          });

          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      }
    }, {
      key: "_resetSearch",
      value: function _resetSearch() {
        if (window.theme.searchMode === 'product') {
          this.searchResultsElement.innerHTML = '';
        } else {
          this.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\"></div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\"></div>\n            </div>";
        }

        this.searchResultsElement.setAttribute('aria-hidden', 'true');
        document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
      }
      /**
       * Simple function that allows to debounce
       */

    }, {
      key: "_debounce",
      value: function _debounce(fn, delay) {
        var _this4 = this;

        var timer = null;
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(_this4, args);
          }, delay);
        };
      }
    }]);

    return SearchBar;
  }();
  
  var NavSearchBar = /*#__PURE__*/function () {
    function NavSearchBar() {
      _classCallCheck(this, NavSearchBar);

      this.searchElement = document.getElementById('NavSearch');
      if (!this.searchElement) {
        return;
      }

      this.documentDelegate = new domDelegate.Delegate(document.body);
      this.searchCloseElement = this.searchElement.querySelector('.Search__Close');
      this.searchInputElement = this.searchElement.querySelector('[name="q"]');
      this.searchResultsElement = this.searchElement.querySelector('.Search__Results');
      this.queryMap = {};
      this.isOpen = false;
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      this._attachListeners();
    }

    _createClass(NavSearchBar, [{
      key: "destroy",
      value: function destroy() {
        this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
        this.searchInputElement.removeEventListener('input', this._onInputListener);
        this.documentDelegate.off();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._preventSubmissionListener = this._preventSubmission.bind(this);
        this._onInputListener = this._debounce(this._onInput.bind(this), 250);
        this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
        this.searchInputElement.addEventListener('input', this._onInputListener);
        
        this.documentDelegate.on('click', '[data-action="clear-search"]', this._clearSearch.bind(this));

        //this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
      }
      /**
       * Toggle the search
       */

    }, {
      key: "_clearSearch",
      value: function _closeSearch() {
        var _this2 = this;

        this.searchInputElement.value = '';
        this._resetSearch(this);
        this.searchCloseElement.classList.add('d-none');
      }
      /**
       * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
       * then we disable submission using enter key
       */

    }, {
      key: "_preventSubmission",
      value: function _preventSubmission(event) {
        if (event.keyCode === KEY_ENTER && window.theme.searchMode !== 'product') {
          event.preventDefault();
        }
      }
      /**
       * This is called when the user has stopped typing (after debounce delay)
       */

    }, {
      key: "_onInput",
      value: function _onInput(event) {
        var _this3 = this;

        if (event.keyCode === KEY_ENTER) {
          return;
        } // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
        // keep track of sent requests, and only use the results of the last one


        this.lastInputValue = event.target.value;

        if (this.lastInputValue === '') {
          this._resetSearch();

          return;
        }

        var queryOptions = {
          method: 'GET',
          credentials: 'same-origin'
        };
        var queries = [fetch("".concat(window.routes.searchUrl, "?section_id=cuyana-predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=product"), queryOptions)];

        if (window.theme.searchMode !== 'product') {
          queries.push(fetch("".concat(window.routes.searchUrl, "?section_id=cuyana-predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=").concat(window.theme.searchMode.replace('product,', '')), queryOptions));
        }

        this.queryMap[this.lastInputValue] = true;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        Promise.all(queries).then(function (responses) {
          // If we receive the result for a query that is not the last one, we simply do not process the result
          if (_this3.lastInputValue !== event.target.value) {
            return;
          }

          delete _this3.queryMap[event.target.value];
          Promise.all(responses.map(function (response) {
            return response.text();
          })).then(function (contents) {
            // If we have only one content then we only have product, otherwise we have products and articles
            if (window.theme.searchMode === 'product') {
              _this3.searchResultsElement.innerHTML = contents[0];
            } else {
              _this3.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\">".concat(contents[0], "</div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\">").concat(contents[1], "</div>\n            </div>");
            }

            _this3.searchCloseElement.classList.remove('d-none');
            _this3.searchResultsElement.setAttribute('aria-hidden', 'false');
          });
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      }
    }, {
      key: "_resetSearch",
      value: function _resetSearch() {
        if (window.theme.searchMode === 'product') {
          this.searchResultsElement.innerHTML = '';
        } else {
          this.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\"></div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\"></div>\n            </div>";
        }

        this.searchResultsElement.setAttribute('aria-hidden', 'true');
        document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
      }
      /**
       * Simple function that allows to debounce
       */

    }, {
      key: "_debounce",
      value: function _debounce(fn, delay) {
        var _this4 = this;

        var timer = null;
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(_this4, args);
          }, delay);
        };
      }
    }]);

    return NavSearchBar;
  }();
  
  

  var CountrySelector = /*#__PURE__*/function () {
    function CountrySelector(countrySelect, provinceSelect) {
      _classCallCheck(this, CountrySelector);

      this.countrySelect = countrySelect;
      this.provinceSelect = provinceSelect;

      if (this.countrySelect && this.provinceSelect) {
        this._attachListeners();

        this._initSelectors();
      }
    }

    _createClass(CountrySelector, [{
      key: "destroy",
      value: function destroy() {
        if (this.countrySelect) {
          this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
        }
      }
    }, {
      key: "_initSelectors",
      value: function _initSelectors() {
        // Check first the default value of country
        var defaultCountry = this.countrySelect.getAttribute('data-default');

        if (defaultCountry) {
          for (var i = 0; i !== this.countrySelect.options.length; ++i) {
            if (this.countrySelect.options[i].text === defaultCountry) {
              this.countrySelect.selectedIndex = i;
              break;
            }
          }
        } else {
          this.countrySelect.selectedIndex = 0;
        }

        var event = new Event('change', {
          bubbles: true
        });
        this.countrySelect.dispatchEvent(event); // Then the province

        var defaultProvince = this.provinceSelect.getAttribute('data-default');

        if (defaultProvince) {
          for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
            if (this.provinceSelect.options[_i].text === defaultProvince) {
              this.provinceSelect.selectedIndex = _i;
              break;
            }
          }
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onCountryChangedListener = this._onCountryChanged.bind(this);
        this.countrySelect.addEventListener('change', this._onCountryChangedListener);
      }
    }, {
      key: "_onCountryChanged",
      value: function _onCountryChanged() {
        var _this = this;

        var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
            provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]'); // First remove all options

        this.provinceSelect.innerHTML = '';

        if (provinces.length === 0) {
          this.provinceSelect.parentNode.style.display = 'none';
          return;
        } // We need to build the provinces array


        provinces.forEach(function (data) {
          _this.provinceSelect.options.add(new Option(data[1], data[0]));
        });
        this.provinceSelect.parentNode.style.display = 'block';
      }
    }]);

    return CountrySelector;
  }();

  var ShippingEstimator = /*#__PURE__*/function () {
    function ShippingEstimator(element) {
      _classCallCheck(this, ShippingEstimator);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.countrySelector = new CountrySelector(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));

      this._attachListeners();
    }

    _createClass(ShippingEstimator, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
        this.countrySelector.destroy();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.ShippingEstimator__Submit', this._fetchRates.bind(this));
      }
    }, {
      key: "_fetchRates",
      value: function _fetchRates() {
        var _this = this;

        var country = this.element.querySelector('[name="country"]').value,
            province = this.element.querySelector('[name="province"]').value,
            zip = this.element.querySelector('[name="zip"]').value;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(zip, "&shipping_address[country]=").concat(country, "&shipping_address[province]=").concat(province), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.json().then(function (result) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));

            var resultsContainer = _this.element.querySelector('.ShippingEstimator__Results'),
                errorContainer = _this.element.querySelector('.ShippingEstimator__Error');

            if (response.ok) {
              var shippingRates = result['shipping_rates'];

              if (shippingRates.length === 0) {
                resultsContainer.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
              } else {
                var html = '';

                if (shippingRates.length === 1) {
                  html += "<p>".concat(window.languages.shippingEstimatorOneResult, "</p><ul>");
                } else {
                  html += "<p>".concat(window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length), "</p><ul>");
                }

                shippingRates.forEach(function (item) {
                  html += "<li>".concat(item['name'], ": ").concat(Currency.formatMoney(item['price'], window.theme.moneyFormat), "</li>");
                });
                html += '</ul>';
                resultsContainer.firstElementChild.innerHTML = html;
              }

              TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, {
                autoAlpha: 0,
                y: -15
              }, {
                autoAlpha: 1,
                y: 0,
                delay: 0.35
              });
              errorContainer.style.display = 'none';
              resultsContainer.style.display = 'block';
              Animation.slideDown(resultsContainer);
            } else {
              var errorHtml = '';
              Object.keys(result).forEach(function (key) {
                errorHtml += "<li class=\"Alert__ErrorItem\">".concat(key, " ").concat(result[key], "</li>");
              });
              errorContainer.innerHTML = "<ul class=\"Alert__ErrorList\">".concat(errorHtml, "</ul>");
              resultsContainer.style.display = 'none';
              errorContainer.style.display = 'block';
            }
          });
        });
      }
    }]);

    return ShippingEstimator;
  }();

  var AddressesSection = function AddressesSection() {
    var _this = this;

    _classCallCheck(this, AddressesSection);

    this.countrySelectors = [];
    Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(function (modal) {
      _this.countrySelectors.push(new CountrySelector(modal.querySelector('[name="address[country]"]'), modal.querySelector('[name="address[province]"]')));
    });
  };
  
  var AnnouncementSection = /*#__PURE__*/function () {
    function AnnouncementSection(container) {
      _classCallCheck(this, AnnouncementSection);

      this.element = container;
      const rotationDelaySeconds = parseFloat(this.element.dataset.rotationDelay);

      var announcements;
      var privateSaleActiveSet = false;
      var privateAnnouncements = this.element.querySelectorAll('.AnnouncementBar__Content.n4u');
      if (privateAnnouncements.length && checkPrivateSale(true)) {
        announcements = Array.from(this.element.querySelectorAll('.AnnouncementBar__Content')); // Convert to array
        announcements = announcements.filter(el => {
          if (!el.classList.contains('n4u')) {
            el.remove(); 
            return false; // exclude this element
          } else {
            el.classList.remove('n4u');
            if (!privateSaleActiveSet) {
              el.classList.add('active'); 
              privateSaleActiveSet = true;
            }
            return true; // keep this element
          }
        });
      } else {
        announcements = this.element.querySelectorAll('.AnnouncementBar__Content:not(.n4u)');
      }

      if (announcements.length > 1 && rotationDelaySeconds) {
        let currentIndex = 0;

        setInterval(() => {
            announcements[currentIndex].classList.remove('active');
            // Move to the next announcement or wrap around to the first announcement
            currentIndex = (currentIndex + 1) % announcements.length;
            announcements[currentIndex].classList.add('active');
        }, rotationDelaySeconds * 1000);
      }
    }

    _createClass(AnnouncementSection, [{
      key: "onUnload",
      value: function onUnload() {
        //if (this.localePopover) {
        //  this.localePopover.destroy();
        //}
      }
    }]);

    return AnnouncementSection;
  }();

  var ArticleList = /*#__PURE__*/function () {
    function ArticleList(container) {
      var _this = this;

      _classCallCheck(this, ArticleList);

      this.element = container;

      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        });
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
    }

    _createClass(ArticleList, [{
      key: "onUnload",
      value: function onUnload() {
        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this2 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this2.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 30
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);

    return ArticleList;
  }();

  var ArticleSection = /*#__PURE__*/function () {
    function ArticleSection(container) {
      var _this = this;

      _classCallCheck(this, ArticleSection);

      this.element = container;
      this.toolbarElement = this.element.querySelector('.ArticleToolbar');
      this.articleNavElement = this.element.querySelector('.ArticleNav');
      var articleImageElement = this.element.querySelector('.Article__Image');

      if (articleImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
        this.parallaxInstance = new Rellax('.Article__Image', {
          speed: -7,
          center: false,
          round: true
        });
      }

      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        });
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }

      this._attachListeners();
    }

    _createClass(ArticleSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.parallaxInstance) {
          this.parallaxInstance.destroy();
        }

        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }

        window.removeEventListener('scroll', this._onScrollListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onScrollListener = this._checkToolbarVisibility.bind(this);
        window.addEventListener('scroll', this._onScrollListener);
      }
    }, {
      key: "_checkToolbarVisibility",
      value: function _checkToolbarVisibility() {
        var _this2 = this;

        var lastYPosition = 0,
            headerHeight = 0,
            navBottom = 0,
            isFixedHeader = 0,
            header = document.querySelector('.Header');
        fastdom.measure(function () {
          lastYPosition = window.pageYOffset;
          headerHeight = header.offsetHeight;
          isFixedHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || 0);

          if (_this2.articleNavElement) {
            navBottom = _this2.articleNavElement.offsetTop + _this2.articleNavElement.clientHeight - headerHeight;
          }
        });
        fastdom.mutate(function () {
          _this2.toolbarElement.style.top = isFixedHeader ? headerHeight + 'px' : null;

          if (_this2.articleNavElement) {
            if (lastYPosition > 150 && _this2.articleNavElement && lastYPosition < navBottom) {
              _this2.toolbarElement.classList.add('is-visible');
            } else {
              _this2.toolbarElement.classList.remove('is-visible');
            }
          } else {
            if (lastYPosition > 150) {
              _this2.toolbarElement.classList.add('is-visible');
            } else {
              _this2.toolbarElement.classList.remove('is-visible');
            }
          }
        });
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this3 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this3.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 30
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);

    return ArticleSection;
  }();

  var CartSection = /*#__PURE__*/function () {
    function CartSection(container) {
      _classCallCheck(this, CartSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.documentDelegate = new domDelegate.Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '[]');
      this.itemCount = this.options['itemCount'];
      this.isCartNoteOpen = false;
      this.giftboxUpdateInProgress = false;
      this.srAnnouncements = document.querySelector('#srAnnouncements');

      this.productMonogramming = null;
      var monogrammingModal = document.querySelector('#monogrammingModal');
      if (monogrammingModal ) {
        this.productMonogramming = new ProductMonogrammingSection(monogrammingModal, true);
      }

      if (this.options['drawer']) {
        this.sidebarDrawer = new Drawer(this.element, {
          onClose: this._onDrawerClosed.bind(this)
        });
      }

      if (this.options['hasShippingEstimator']) {
        this.shippingEstimator = new ShippingEstimator(this.element.querySelector('.ShippingEstimator'));
      }

      this._removeOrphanedNonUUIDItems();
      this._removeOrphanedItems();

      this._attachListeners();
    }

    _createClass(CartSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.options['hasShippingEstimator']) {
          this.shippingEstimator.destroy();
        }

        this.delegateElement.off();
        document.removeEventListener('product:added', this._onProductAddedListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onProductAddedListener = this._onProductAdded.bind(this);
        this.delegateElement.on('change', '#cart-note', this._updateCartNote.bind(this));

        if (this.options['type'] !== 'page') {
          this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
          this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._updateItemQuantity.bind(this));
          this.delegateElement.on('change', '.CartItem__GiftBoxCheckbox', this._addGiftboxChecked.bind(this));
        } else {
          this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._reloadPageWithQuantity.bind(this));
        } // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page


        if (this.options['drawer']) {
          this.delegateElement.on('click', '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this));
        }

        this.delegateElement.on('click', '[data-bs-target="#monogrammingModal"]', this._openMonogramming.bind(this));
        this.delegateElement.on('click', '.removeProductMonograming', this._removeMonogramming.bind(this));

        document.addEventListener('product:added', this._onProductAddedListener); // We attach a listener at page level which allows to re-render the cart

        this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));
      }
    }, {
      key: "_updateCartNote",
      value: function _updateCartNote(event, target) {
        fetch("".concat(window.routes.cartUrl, "/update.js"), {
          body: JSON.stringify({
            note: target.value
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        });
      }
    }, {
      key: "_openMonogramming",
      value: function _openMonogramming(event) {
        if (this.sidebarDrawer) this.sidebarDrawer.close();
      }
    }, {
      key: "_removeMonogramming",
      value: function _removeMonogramming(event) {
        event.preventDefault();
        event.stopPropagation();

        var cartItemDiv = event.target.closest('.CartItem');
        if (cartItemDiv) {
          this.productMonogramming.parentItemUuid = cartItemDiv.getAttribute('data-item-uuid');
          this.productMonogramming.parentItemKey = cartItemDiv.getAttribute('data-item-key');
          this.productMonogramming.removeMonogrammingFromProduct();
        }
      }
    }, {
      key: "_toggleCartNote",
      value: function _toggleCartNote() {
        var _this = this;

        var noteContainer = this.element.querySelector('.Cart__OffscreenNoteContainer'),
            cartNote = this.element.querySelector('#cart-note');
        this.element.classList.toggle('has-note-open');
        this.element.querySelector('.Cart__NoteButton').innerHTML = cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote;
        noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
        this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';

        if (this.element.classList.contains('has-note-open')) {
          var transitionEndListener = function transitionEndListener() {
            _this.element.querySelector('#cart-note').focus();

            noteContainer.removeEventListener('transitionend', transitionEndListener);
          };

          noteContainer.addEventListener('transitionend', transitionEndListener);
        }
      }
    }, {
      key: "_removeOrphanedNonUUIDItems",
      value: async function _removeOrphanedNonUUIDItems() {
        const itemContainer = document.querySelector('.Cart__ItemList');
        if (itemContainer) {

          // Select elements where data-is-giftbox="true" and data-parent-uuid is not set
          const hiddenItems = Array.from(itemContainer.querySelectorAll('.CartItem.d-none[data-parent-uuid=""]'));

          let updates = {};

          hiddenItems.forEach(item => {
            let isGiftbox = item.dataset.isGiftbox;
            let lineGroup = item.dataset.lineGroup;
            let itemKey = item.dataset.itemKey;

            // Find the non-hidden parent item based on the line group
            const parentItem = itemContainer.querySelector(`.CartItem:not(.d-none)[data-line-group="${lineGroup}"]`);

            if (isGiftbox == "true" || (lineGroup != '' && !parentItem)) {
              updates[itemKey] = "0";
            }
          });

          document.dispatchEvent(new CustomEvent('theme:loading:start'));

          try {
            const response = await fetch(`${window.routes.cartUpdateUrl}.js`, {
              body: JSON.stringify({ updates }),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            });
  
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            this._rerenderCart();
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          } catch (error) {
            console.error('A request failed:', error);
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          }
        }
      }
    }, {
      key: "_removeOrphanedItems",
      value: async function _removeOrphanedItems() {
        const itemContainer = document.querySelector('.Cart__ItemList');
        if (itemContainer) {
          const hiddenItems = Array.from(itemContainer.querySelectorAll('.CartItem.d-none[data-parent-uuid]'));
          const _this = this;
          let removals = false;

          try {
            for (const card of hiddenItems) {
              const uuid = card.dataset.parentUuid;

              // Find the non-hidden parent item based on the line group
              const parentItem = itemContainer.querySelector(`.CartItem:not(.d-none)[data-item-uuid="${uuid}"]`);

              if (uuid != '' && !parentItem) {
                // No corresponding non-hidden parent item found, remove the line group item
                removals = true;
                await _this._updateCartItem(card.dataset.itemKey, null, 0);
              }
            }

            // Hard refresh after all removals
            if (removals) {
              window.location.reload(true);
            }
          } catch (error) {
            console.error('A request failed:', error);
          }
        }
      }
    }, {
      key: "_updateItemQuantity",
      value: async function _updateItemQuantity(event, target) {
        event.preventDefault();
        const item = target.closest('.CartItem');
        const lineGroup = item.dataset.lineGroup;
        const uuid = item.dataset.itemUuid;
        const productName = item.querySelector('.CartItem__Title a')?.textContent;

        const itemContainer = item.closest('.Cart__ItemList');
        const quantity = target.tagName === 'INPUT' ? parseInt(target.value) : target.dataset.quantity;

        let updates = {};
        let itemArray = [];

        if (uuid) {
          // Gather all of the linked items that need to be updated together (i.e. mono, giftbox)
          itemArray = Array.from(itemContainer.querySelectorAll(`.CartItem[data-parent-uuid="${uuid}"]`));
        }

        //updates[item.dataset.itemKey] = quantity;

        // ADD the parent item as the first item in the array
        itemArray.unshift(item);

        // Loop through each item in itemArray
        itemArray.forEach(item => {
          let itemKey = item.dataset.itemKey;
          // Convert the item key to string and assign the quantity value Q to the corresponding item key in the updates object
          updates[itemKey] = quantity;
        });

        if (!uuid) {
          // If no UUID, then clear any hidden items linked to this item based on the line-group
          let HiddenItemArray = Array.from(itemContainer.querySelectorAll(`.CartItem.d-none[data-line-group="${lineGroup}"]`));
  
          HiddenItemArray.forEach(hiddenItem => {
            let itemKey = hiddenItem.dataset.itemKey;
            updates[itemKey] = "0";
          });
        }

        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        try {
          const response = await fetch(`${window.routes.cartUpdateUrl}.js`, {
            body: JSON.stringify({ updates }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          this._rerenderCart();
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          if ( quantity == 0 ) {
            this.srAnnouncements.textContent = `The item ${productName} has been removed from your cart.`;
          } else {
            this.srAnnouncements.textContent = `The item ${productName} quantity has been updated to ${quantity}`;
          }

        } catch (error) {
          console.error('A request failed:', error);
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        }
      }
    }, {
      key: "_updateCartItem",
      value: function _updateCartItem(key, properties = null, quantity = null) {
        
        let payload = {
          id: key
        }

        if (properties !== null) {
          payload.properties = properties;
        }

        if (quantity !== null) {
          payload.quantity = quantity;
        }

        return fetch(`${window.routes.cartChangeUrl}.js`, {
          body: JSON.stringify(payload),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
      }
    }, {
      key: "_addGiftboxItem",
      value: function _addGiftboxItem(parent_item_key, id, quantity, properties) {
        return fetch(`${window.routes.cartAddUrl}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            quantity: quantity,
            parent_line_key: parent_item_key,
            properties: properties
          }),
        })
      }
    }, {
      key: "_addGiftboxChecked",
      value: async function _addGiftboxChecked(event, target) {
        
        if (this.giftboxUpdateInProgress){
          event.preventDefault();
          return;
        }

        let parentItem = target.closest('.CartItem');
        let lineGroup = parentItem.dataset.lineGroup;
        let uuid = parentItem.dataset.itemUuid;
        let parentItemProperties = JSON.parse(parentItem.dataset.lineProperties || '{}');
        const parentQuantity = parseInt(parentItem.querySelector('.QuantitySelector__CurrentQuantity').value) || 1;

        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        this.giftboxUpdateInProgress = true;

        // If the checkbox was checked, add the giftbox
        if (event.target.checked) {
          var addedText = target.getAttribute('data-added');
          event.target.parentElement.querySelector('label').innerText = addedText; //'Gift Box Added';

          document.dispatchEvent(new CustomEvent('theme:loading:start'));

          if (!lineGroup) {
            try {
              lineGroup = await _generateLineGroupID();
              // Merge the existing properties with the new ones
              parentItemProperties = {...parentItemProperties, ...{"_line_group": lineGroup}};

            } catch (error) {
              console.error('A request failed:', error);
              this.giftboxUpdateInProgress = false;
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              return;
            }
          }

          if (!uuid) {
            try {
              const currentDate = new Date();
              uuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
              parentItem.dataset.itemUuid = uuid;

              // Merge the existing properties with the new ones
              parentItemProperties = {...parentItemProperties, ...{"_uuid": uuid}};

            } catch (error) {
              console.error('A request failed:', error);
              this.giftboxUpdateInProgress = false;
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              return;
            }
          }

          try {
            // First add the giftbox to the cart
            let giftBoxUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
            const giftboxProperties = {
              "_is_giftbox": true,
              "_line_group": lineGroup,
              "_uuid": giftBoxUuid,
              "_parent_uuid": uuid,
              "_hidden": true,
              "is_final_sale": true,
              "_LPROP": "no-returns"
            };

            await this._addGiftboxItem(parentItem.dataset.itemKey, parentItem.dataset.giftboxId, parentQuantity, giftboxProperties);

            // Then update the parent item giftwrapped status
            await this._updateCartItem(
              parentItem.dataset.itemKey, 
              {...parentItemProperties, "_is_giftwrapped": true}, 
              parentQuantity
            );

          } catch (error) {
            console.error('A request failed:', error);
            this.giftboxUpdateInProgress = false;
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            return;
          }
        // If it was unchecked, remove the giftbox
        } else {
          var addText = target.getAttribute('data-add');
          event.target.parentElement.querySelector('label').innerText = addText;
          
          try {
            let ParentItemkey = parentItem.dataset.itemKey;

            // Get the Giftbox Item Key from DOM element
            const giftBoxElement = document.querySelector('.CartItem[data-is-giftbox="true"][data-parent-uuid="' + uuid + '"]');
            if (giftBoxElement) {
              const giftboxKey = giftBoxElement.dataset.itemKey;
              // Remove the Giftbox
              const updateCartResponse = await this._updateCartItem(giftboxKey, null, 0).then(response => {
                return response.json(); 
              });  
              // Get the new Changed key of the parent product
              if (updateCartResponse && updateCartResponse.items) {
                const matchingItem = updateCartResponse.items.find(item => item.properties._uuid === uuid);
                if (matchingItem) {
                  ParentItemkey = matchingItem.key;
                }
              }
            }

            // Update the parent item giftwrapped status
            parentItemProperties._is_giftwrapped = false;
            await this._updateCartItem(
              ParentItemkey, 
              parentItemProperties, 
              parentQuantity
            );

          } catch (error) {
            console.error('A request failed:', error);
            this.giftboxUpdateInProgress = false;
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            return;
          }
        }

        this.giftboxUpdateInProgress = false;
        this._rerenderCart();
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    }, {
      key: "_reloadPageWithQuantity",
      value: function _reloadPageWithQuantity(event, target) {
        window.location.href = "".concat(window.routes.cartChangeUrl, "?quantity=").concat(parseInt(target.value), "&line=").concat(target.getAttribute('data-line'));
      }
    }, {
      key: "_onProductAdded",
      value: function _onProductAdded(event) {
        var _this3 = this;

        this.itemCount += event.detail.quantity;

        this._rerenderCart().then(function () {
          if (_this3.sidebarDrawer) _this3.sidebarDrawer.open();
        });

        const productName = event?.detail?.variant?.name;
        this.srAnnouncements.textContent = `The item ${productName} has been added to your cart.`;
      }
    }, {
      key: "_onDrawerClosed",
      value: function _onDrawerClosed() {
        if (this.isCartNoteOpen) {
          this._toggleCartNote();
        }
      }
      /**
       * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
       * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
       * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
       * all the time and hence having easier logic.
       */

    }, {
      key: "_rerenderCart",
      value: function _rerenderCart(elementToAnimate) {
        var _this4 = this;

        // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
        return fetch("".concat(window.routes.cartUrl, "?section_id=").concat(this.options['drawer'] && window.theme.pageType !== 'cart' ? 'mini-cart' : 'main-cart', "&timestamp=").concat(Date.now()), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (content) {
          // If there is an element to animate, we animate it using a transition
          if (_this4.options['drawer'] && elementToAnimate) {
            var timelineLite = new TimelineLite({
              onComplete: function onComplete() {
                content.text().then(function (html) {
                  _this4._replaceContent(html);
                });
              }
            });
            timelineLite.to(elementToAnimate, 0.5, {
              height: 0,
              opacity: 0,
              ease: Cubic.easeOut
            }, 0);

            if (_this4.itemCount === 0) {
              timelineLite.to(_this4.element.querySelector('.Drawer__Footer'), 0.5, {
                y: '100%',
                transition: 'none',
                ease: Cubic.easeInOut
              }, 0);
            }
          } else {
            content.text().then(function (html) {
              _this4._replaceContent(html);
            });
          }
        });
      }
    }, {
      key: "_replaceContent",
      value: function _replaceContent(html) {
        var _this5 = this;

        var tempElement = document.createElement('div');
        tempElement.innerHTML = html;

        // WWW-3912: reduce the dynamic checkout wallets while the fetched
        // markup is still detached — custom elements only upgrade once
        // connected, so this is the last safe moment to edit wallet-configs.
        // Defined in cart-drawer.liquid.
        if (typeof window.cuyFilterCartWallets === 'function') {
          window.cuyFilterCartWallets(tempElement);
        }

        // Fetch can return a challenge/error page with no cart section —
        // bail out and keep the existing cart DOM rather than crash mid-render.
        var cartSectionElement = tempElement.querySelector('[data-section-type="cart"]');

        if (!cartSectionElement) {
          return;
        }

        // Update itemCount from response BEFORE DOM manipulation so the
        // empty-cart check below uses the real count, not a stale value.
        var cartResult = JSON.parse(cartSectionElement.getAttribute('data-section-settings') || '[]');
        this.itemCount = cartResult['itemCount'];

        var cartNodeParent = this.element.querySelector('.Cart') ? this.element.querySelector('.Cart').parentNode : null;

        if (this.options['drawer'] && window.theme.pageType !== 'cart') {
          var currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
          if (cartNodeParent) {
            cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
          }
          this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
        } else {
          // For dedicated page we replace the whole section if there is no more product
          if (this.itemCount === 0) {
            this.element.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
          } else {
            cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
            this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
          }
        }

        // Dynamic checkout buttons (Apple Pay, etc.) are injected via
        // content_for_additional_checkout_buttons; when their markup is
        // replaced via AJAX, Shopify's script needs to be told to re-scan
        // the DOM and render buttons into the new placeholder.
        if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
          Shopify.PaymentButton.init();
        } // We can also update the dot and the quantity


        var cartDot = Dom.nodeListToArray(document.querySelectorAll('.Header__CartDot')),
            cartQuantity = Dom.nodeListToArray(document.querySelectorAll('.Header__CartCount'));
        cartDot.forEach(function (item) {
          if (_this5.itemCount === 0) {
            item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
          } else {
            item.classList.add('is-visible');
          }
        });
        cartQuantity.forEach(function (item) {
          item.textContent = _this5.itemCount;
        });
      }
    }]);

    return CartSection;
  }();

  var CollectionListSection = /*#__PURE__*/function () {
    function CollectionListSection(container) {
      _classCallCheck(this, CollectionListSection);

      this.element = container;
      var collectionListElement = this.element.querySelector('[data-flickity-config]');

      if (collectionListElement) {
        this.carousel = new Carousel(collectionListElement);
      }
    }

    _createClass(CollectionListSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.carousel) {
          this.carousel.destroy();
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        if (this.carousel) {
          this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        if (this.carousel) {
          this.carousel.unpausePlayer();
        }
      }
    }]);

    return CollectionListSection;
  }();

  /**
   * This class allows to automatically scrolls within a div when this div does not fit into the visible space
   */
  var OverflowScroller = /*#__PURE__*/function () {
    function OverflowScroller(element) {
      _classCallCheck(this, OverflowScroller);

      if (!element) {
        return;
      }

      this.element = element;
      this.lastKnownY = window.scrollY;
      this.currentTop = 0;
      this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);

      this._attachListeners();
    }

    _createClass(OverflowScroller, [{
      key: "destroy",
      value: function destroy() {
        window.removeEventListener('scroll', this._checkPositionListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._checkPositionListener = this._checkPosition.bind(this);
        window.addEventListener('scroll', this._checkPositionListener);
      }
    }, {
      key: "_checkPosition",
      value: function _checkPosition() {
        var _this = this;

        fastdom.measure(function () {
          var bounds = _this.element.getBoundingClientRect(),
              maxTop = bounds.top + window.scrollY - _this.element.offsetTop + _this.initialTopOffset,
              minTop = _this.element.clientHeight - window.innerHeight;

          if (window.scrollY < _this.lastKnownY) {
            _this.currentTop -= window.scrollY - _this.lastKnownY;
          } else {
            _this.currentTop += _this.lastKnownY - window.scrollY;
          }

          _this.currentTop = Math.min(Math.max(_this.currentTop, -minTop), maxTop, _this.initialTopOffset);
          _this.lastKnownY = window.scrollY;
        });
        fastdom.mutate(function () {
          _this.element.style.top = "".concat(_this.currentTop, "px");
        });
      }
    }]);

    return OverflowScroller;
  }();

  // Must match the param name the price bucket Liquid checks in cuyana-collection, cuyana-variant-collection,
  // cuyana-search and cuyana-price-bucket-links.
  var PRICE_BUCKET_PARAM = 'filter.v.m.custom.price_bucket';

  var CollectionSection = /*#__PURE__*/function () {
    function CollectionSection(element) {
      _classCallCheck(this, CollectionSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.toolbarElement = this.element.querySelector('.CollectionToolbar');
      this.collectionInnerElement = this.element.querySelector('.CollectionInner__Products');
      this.settings = JSON.parse(this.element.getAttribute('data-section-settings') || '[]'); // Create the popover if available

      var sortPopoverElement = document.getElementById('collection-sort-popover');

      if (sortPopoverElement) {
        this.sortPopover = new Popover(sortPopoverElement, {
          onValueChanged: this._sortByChanged.bind(this),
          fitToViewport: true
        });
      } // Create the filter drawer if available

      this.clearFiltersElement = this.element.querySelector('.Clear_Active_Filters');

      var filterDrawerElement = document.getElementById('collection-filter-drawer');

      if (filterDrawerElement) {
        this.filterDrawer = new Drawer(filterDrawerElement);
      } // Create scroller of sidebar


      if (this.settings['filterPosition'] === 'sidebar') {
        this.filterInnerSidebarScroller = new OverflowScroller(this.element.querySelector('.CollectionInner__Sidebar'));
      } // Setup parallax on image (if any)

      const collectionLevel2Link = document.getElementById("collection-level2-links");
      const subCollections = document.getElementById("sub-collections");

      if (collectionLevel2Link && subCollections) {
        subCollections.innerHTML = collectionLevel2Link.innerHTML;
      }

      // Moved rather than copied: the pills are updated in place after each click.
      var priceBucketLinks = document.getElementById('price-bucket-links');
      var priceBucketSlot = this.element.querySelector('[data-price-bucket-links-slot]');

      if (priceBucketLinks && priceBucketSlot) {
        priceBucketSlot.appendChild(priceBucketLinks);
        priceBucketLinks.classList.remove('d-none');
      }

      var collectionImageElement = this.element.querySelector('.PageHeader__ImageWrapper');

      if (collectionImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
        this.parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
          speed: -7,
          center: false,
          round: true
        });
      } // Setup product item color swatch


      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      });

      this._setupAnimation();

      this._attachListeners();
    }

    _createClass(CollectionSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.sortPopover) {
          this.sortPopover.destroy();
        }

        if (this.filterDrawer) {
          this.filterDrawer.destroy();
        }

        if (this.filterInnerSidebarScroller) {
          this.filterInnerSidebarScroller.destroy();
        }

        if (this.parallaxInstance) {
          this.parallaxInstance.destroy();
        }

        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }
      }
    }, {
      key: "_setupAnimation",
      value: function _setupAnimation() {
        var _this = this;

        var forceLoadFromTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (!window.theme.showElementStaggering) {
          return;
        } // If there is already an observer set up, we remove it first


        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }

        if (forceLoadFromTop) {
          this.timeline.clear();
          this.timeline.staggerFromTo(this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem'), 0.25, {
            autoAlpha: 0,
            y: 25
          }, {
            autoAlpha: 1,
            y: 0
          }, 0.1);
        } else {
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), {
            threshold: 0.3
          });
          Dom.nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem')).forEach(function (item) {
            _this.intersectionObserver.observe(item);
          });
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this2 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this2.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.35, {
          autoAlpha: 0,
          y: 25
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.15);
      }
    }, {
      key: "_changeLayoutMode",
      value: function _changeLayoutMode(event, target) {
        var _this3 = this;

        var layoutType = target.getAttribute('data-grid-type'),
            newCount = parseInt(target.getAttribute('data-count')); // Otherwise we detect the mode, and change all classes

        var productList = this.collectionInnerElement.querySelector('.ProductList');

        if (productList) {
          var previousCount = parseInt(productList.getAttribute("data-".concat(layoutType, "-count")));

          if (previousCount === newCount) {
            return; // Nothing has changed so we just return to avoid reflow
          }

          productList.setAttribute("data-".concat(layoutType, "-count"), newCount);
          Dom.nodeListToArray(productList.querySelectorAll('.Grid__Cell')).forEach(function (item) {
            if (layoutType === 'mobile') {
              item.classList.remove("1/".concat(previousCount, "--phone")); // IE11 and lower does not support classList.replace

              item.classList.add("1/".concat(newCount, "--phone"));
            } else {
              var previousTabletCount = previousCount === 2 ? 2 : 3,
                  newTabletCount = newCount === 2 ? 2 : 3;

              if (_this3.settings['filterPosition'] === 'drawer') {
                item.classList.remove("1/".concat(previousCount, "--lap-and-up"));
                item.classList.add("1/".concat(newCount, "--lap-and-up"));
              } else {
                item.classList.remove("1/".concat(previousCount, "--desk"));
                item.classList.add("1/".concat(newCount, "--desk"));
              }

              item.classList.remove("1/".concat(previousTabletCount, "--tablet-and-up"));
              item.classList.add("1/".concat(newTabletCount, "--tablet-and-up"));
            }

            if (window.theme.showElementStaggering) {
              item.firstElementChild.style.visibility = 'hidden'; // Make it as hidden so we can re-trigger the animation
            }
          }); // Force lazy sizes to recalculate item sizes

          lazySizes.autoSizer.checkElems();
        }

        target.classList.add('is-active');
        Dom.getSiblings(target)[0].classList.remove('is-active');

        this._setupAnimation(); // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
        // is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript


        fetch("".concat(window.routes.cartUrl, "/update.js"), {
          body: JSON.stringify({
            attributes: _defineProperty({}, "collection_".concat(layoutType, "_items_per_row"), newCount)
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        });
      }
    }, {
      key: "_sortByChanged",
      value: function _sortByChanged(sortBy) {
        var currentUrl = new URL(location.href);
        currentUrl.searchParams.set('sort_by', sortBy);
        currentUrl.searchParams.delete('page');

        this._reloadProducts(currentUrl.toString());
      }
    }, {
      key: "_onFiltersCleared",
      value: function _onFiltersCleared(event) {
        // The drawer's Reset leaves the price bucket applied; it is cleared from the price bucket pills.
        var clearUrl = new URL(event.target.getAttribute('data-url'), window.location.origin);
        new URLSearchParams(window.location.search).getAll(PRICE_BUCKET_PARAM).forEach(function (value) {
          clearUrl.searchParams.append(PRICE_BUCKET_PARAM, value);
        });
        this._reloadProducts(clearUrl.pathname + clearUrl.search);
        this.clearFiltersElement?.classList.add('d-none');
      }
    }, {
      key: "_onPriceBucketClicked",
      value: function _onPriceBucketClicked(event, target) {
        event.preventDefault();
        var url = new URL(window.location.href);
        url.searchParams.delete(PRICE_BUCKET_PARAM);
        url.searchParams.delete('page');
        var value = target.getAttribute('data-value');
        if (value) {
          url.searchParams.append(PRICE_BUCKET_PARAM, value);
        }

        // _reloadProducts doesn't re-render the pills, so set the active one here.
        Array.from(target.parentNode.querySelectorAll('[data-price-bucket-link]')).forEach(function (link) {
          var isActive = link === target;
          link.classList.toggle('active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });

        this._reloadProducts(url.pathname + url.search);
      }
    }, {
      key: "_onFilterChanged",
      value: function _onFilterChanged(event) {
        var formData = new FormData(event.target.closest('form'));
        var searchParamsAsString = new URLSearchParams(formData).toString();
        var hasDrawerFilter = Array.from(formData.keys()).some(function (key) {
          return key.indexOf('filter.') === 0 && key !== PRICE_BUCKET_PARAM;
        });
        if (hasDrawerFilter) {
          this.clearFiltersElement?.classList.remove('d-none');
        } else {
          this.clearFiltersElement?.classList.add('d-none');
        }

        this._reloadProducts("".concat(window.location.pathname, "?").concat(searchParamsAsString));
      }
    }, {
      key: "_reloadProducts",
      value: function _reloadProducts(url) {
        var _this4 = this;

        if (this.abortController) {
          this.abortController.abort();
        }

        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        if (history.replaceState) {
          window.history.pushState({
            path: url
          }, '', url);
        }

        var currentUrl = new URL(window.location);
        currentUrl.searchParams.set('section_id', this.settings['sectionId']);

        try {
          this.abortController = new AbortController();
          fetch(currentUrl.toString(), {
            signal: this.abortController.signal
          }).then(function (response) {
            response.text().then(function (content) {
              var tempElement = document.createElement('div');
              tempElement.innerHTML = content;
              _this4.collectionInnerElement.innerHTML = tempElement.querySelector('.CollectionInner__Products').innerHTML;
              var toolbarFilter = tempElement.querySelector('.CollectionToolbar__Item--filter');

              if (toolbarFilter) {
                var newToolbarFilter = _this4.element.querySelector('.CollectionToolbar__Item--filter');

                newToolbarFilter.innerHTML = toolbarFilter.innerHTML;
                newToolbarFilter.className = toolbarFilter.className;
              } // We also replace the filters


              var collectionFiltersDrawer = _this4.element.querySelector('#collection-filters-drawer-form'),
                  collectionFiltersSidebar = _this4.element.querySelector('#collection-filters-sidebar-form');

              if (collectionFiltersDrawer) {
                var newDrawerContent = tempElement.querySelector('#collection-filters-drawer-form');
                Array.from(collectionFiltersDrawer.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
                  var newCollapsible = newDrawerContent.querySelector("[data-filter-index=\"".concat(collapsible.getAttribute('data-filter-index'), "\"]"));

                  if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
                    newCollapsible.style.overflow = 'visible';
                    newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true');
                    newCollapsible.lastElementChild.style.height = 'auto';
                    newCollapsible.lastElementChild.style.overflow = 'visible';
                  }
                });
                collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML;
              }

              if (collectionFiltersSidebar) {
                var newSidebarContent = tempElement.querySelector('#collection-filters-sidebar-form');
                Array.from(collectionFiltersSidebar.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
                  var newCollapsible = newSidebarContent.querySelector("[data-filter-index=\"".concat(collapsible.getAttribute('data-filter-index'), "\"]"));

                  if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
                    newCollapsible.style.overflow = 'visible';
                    newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true');
                    newCollapsible.lastElementChild.style.height = 'auto';
                    newCollapsible.lastElementChild.style.overflow = 'visible';
                  }
                });
                collectionFiltersSidebar.innerHTML = newSidebarContent.innerHTML;
              }

              checkPrivateSale();

              document.dispatchEvent(new CustomEvent('theme:loading:end'));

              _this4._setupAnimation(true); // We scroll to the top


              var elementOffset = _this4.element.querySelector('.CollectionMain').getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue('--header-height'));

              if (Responsive.matchesBreakpoint('lap-and-up') && _this4.toolbarElement && _this4.toolbarElement.clientHeight === 0) {
                elementOffset -= 50;
              }

              if (elementOffset < 0) {
                window.scrollBy({
                  top: elementOffset,
                  behavior: 'smooth'
                });
              }
            });
          });
        } catch (exception) {}
      }
    }, {
      key: "_handleScroll",
      value: function _handleScroll() {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1500 && !document.isLoadingMoreProducts) {
          
          var loadMoreLink = document.querySelector('#load-more-products')
          if (loadMoreLink) {
            // Enter loading state
            document.isLoadingMoreProducts = true;
            loadMoreLink.textContent = 'Loading ';
            var pagination = loadMoreLink.closest('.Pagination');
            if (pagination) {
              pagination.classList.add('is-loading');
            }
            // Make an AJAX request to the link URL.
            fetch(loadMoreLink.href)
              .then(response => response.text())
              .then(html => {
                // Parse the HTML.
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');

                // Grab the product list divs.
                var productListItems = doc.querySelector('.ProductList')?.children;

                // Append these divs to the existing product list.
                var productList = document.querySelector('.ProductList');
                if (productListItems) {
                  Array.from(productListItems).forEach(element => productList.appendChild(element));
                }

                // Check for private sale to update prices if needed
                checkPrivateSale();

                // Update the href of the load more link.
                var newLoadMoreLink = doc.querySelector('#load-more-products');
                if (newLoadMoreLink) {
                  loadMoreLink.href = newLoadMoreLink.href;
                } else {
                  const loadMoreBlock = loadMoreLink.closest('.Pagination');
                  loadMoreLink.remove();
                  loadMoreBlock.classList.add('m-5');
                  window.removeEventListener('scroll', this._handleScroll);
                }
              })
              .finally(() => {
                // Exit loading state
                if (pagination) {
                  pagination.classList.remove('is-loading');
                }
                document.isLoadingMoreProducts = false;
                loadMoreLink.textContent = 'Load More';
                document.dispatchEvent(new CustomEvent('collection:productsAppended'));
              });
          }
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._changeLayoutModeListener = this._changeLayoutMode.bind(this);
        this.delegateElement.on('click', '[data-action="change-layout-mode"]', this._changeLayoutModeListener);
        this.delegateElement.on('click', '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
        this.delegateElement.on('change', '[name^="filter."]', this._onFilterChanged.bind(this));
        this.delegateElement.on('click', '[data-price-bucket-link]', this._onPriceBucketClicked.bind(this));
        this.scrollListener = window.addEventListener('scroll', this._handleScroll.bind(this));
        document.isLoadingMoreProducts = false;
        window.addEventListener('popstate', function (event) {
          if (event.state.path) {
            window.location.href = event.state.path;
          }
        });
      }
    }]);

    return CollectionSection;
  }();

  var FaqSection = /*#__PURE__*/function () {
    function FaqSection(element) {
      _classCallCheck(this, FaqSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);

      this._attachListeners();
    }

    _createClass(FaqSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this._openItem(event.target);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(event) {
        this._closeItem(event.target);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.Faq__Question', this._toggleItem.bind(this));
        this.delegateElement.on('click', '.FaqSummary__Item', this._switchToCategory.bind(this));
      }
    }, {
      key: "_switchToCategory",
      value: function _switchToCategory(event, target) {
        target.classList.add('is-active');
        Dom.getSiblings(target, '.is-active').forEach(function (item) {
          item.classList.remove('is-active');
        });
      }
    }, {
      key: "_toggleItem",
      value: function _toggleItem(event, target) {
        var item = target.closest('.Faq__Item');

        if (item.getAttribute('aria-expanded') === 'true') {
          this._closeItem(item);
        } else {
          this._openItem(item);
        }
      }
    }, {
      key: "_openItem",
      value: function _openItem(item) {
        var answerWrapper = item.querySelector('.Faq__AnswerWrapper');
        item.setAttribute('aria-expanded', 'true');
        answerWrapper.setAttribute('aria-hidden', 'false');
        Animation.slideDown(answerWrapper, true);
        Dom.getSiblings(item, '[aria-expanded="true"]').forEach(function (siblingItem) {
          var siblingAnswerWrapper = siblingItem.querySelector('.Faq__AnswerWrapper');
          siblingItem.setAttribute('aria-expanded', 'false');
          siblingAnswerWrapper.setAttribute('aria-hidden', 'true');
          Animation.slideUp(siblingAnswerWrapper);
        });
      }
    }, {
      key: "_closeItem",
      value: function _closeItem(item) {
        var answerWrapper = item.querySelector('.Faq__AnswerWrapper');
        item.setAttribute('aria-expanded', 'false');
        answerWrapper.setAttribute('aria-hidden', 'true');
        Animation.slideUp(answerWrapper);
      }
    }]);

    return FaqSection;
  }();

  var FeaturedCollectionsSection = /*#__PURE__*/function () {
    function FeaturedCollectionsSection(container) {
      var _this = this;

      _classCallCheck(this, FeaturedCollectionsSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-settings') || '[]');
      this.carousels = [];
      Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      }); // Setup product item color swatch

      this._setupAnimation();

      this._attachListeners();
    }

    _createClass(FeaturedCollectionsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousels.forEach(function (item) {
          return item.destroy();
        });
        this.delegateElement.off('click');
        this.intersectionObserver.disconnect();
        this.timeline.kill();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        // We simply trigger a click on the element that controls this tab
        this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="toggle-tab"]', this._switchTab.bind(this));
      }
    }, {
      key: "_switchTab",
      value: function _switchTab(event, target) {
        var _this2 = this;

        // If the tab is already active, do nothing
        if (target.classList.contains('is-active')) {
          return;
        } // First, switch the current tab


        target.classList.add('is-active');
        Dom.getSiblings(target, '.is-active').forEach(function (item) {
          item.classList.remove('is-active');
        }); // Then, display the panel

        var tabPanelToShow = this.element.querySelector("#".concat(target.getAttribute('aria-controls')));
        this.timeline.eventCallback('onReverseComplete', function () {
          tabPanelToShow.setAttribute('aria-hidden', 'false');
          Dom.getSiblings(tabPanelToShow, '.TabPanel[aria-hidden="false"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'true');
          });

          if (Responsive.matchesBreakpoint('lap-and-up')) {
            _this2.carousels.forEach(function (carousel) {
              // There is a bug in Safari where it cannot detect the pseudo-element "::after" if the tab panel is hidden. As a consequence,
              // we manually activate it
              carousel.flickityInstance.activate();
              carousel.flickityInstance.resize(); // Ugly hack
            });
          }

          _this2.timeline.clear();

          _this2._setupAnimation();
        });

        if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
          this.timeline.reverse().timeScale(3);
        } else {
          this.timeline.reverse();
        }
      }
    }, {
      key: "_setupAnimation",
      value: function _setupAnimation() {
        var _this3 = this;

        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }

        this.timeline = new TimelineLite({
          delay: 0.5
        });

        if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
          Dom.nodeListToArray(this.element.querySelectorAll('.TabPanel[aria-hidden="false"] .ProductList .ProductItem')).forEach(function (item) {
            _this3.intersectionObserver.observe(item);
          });
        } else {
          var productList = this.element.querySelector('.TabPanel[aria-hidden="false"] .ProductList');

          if (productList) {
            this.timeline.fromTo(productList, 0.6, {
              autoAlpha: 0,
              y: 25
            }, {
              autoAlpha: 1,
              y: 0
            });
          }
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this4 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this4.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 25
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);

    return FeaturedCollectionsSection;
  }();

  var FeaturedProductSection = /*#__PURE__*/function () {
    function FeaturedProductSection(container) {
      _classCallCheck(this, FeaturedProductSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '[]');

      if (!this.options['usePlaceholder']) {
        this.productVariants = new ProductVariants(container, this.options);
      } // We have to re-order elements in the DOM


      var offscreenElement = this.element.querySelector('.Product__OffScreen');

      if (offscreenElement) {
        this.element.appendChild(offscreenElement);
      }

      this._attachListeners();
    }

    _createClass(FeaturedProductSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.productVariants) {
          this.productVariants.destroy();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('variant:changed', this._updateMainImage.bind(this));
      }
      /**
       * Update the main featured image
       */

    }, {
      key: "_updateMainImage",
      value: function _updateMainImage(event) {
        var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant;

        if (!variant || !variant['featured_image'] || previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
          return;
        } // Otherwise we are on the home page. It's a bit more complex as we have to rewrite some code normally written in Liquid


        var newImage = variant['featured_image'];
        var mainImageContainer = this.element.querySelector('.FeaturedProduct__Gallery .AspectRatio');
        mainImageContainer.style.cssText = "max-width: ".concat(newImage['width'], "px; --aspect-ratio: ").concat(newImage['width'] / newImage['height']);
        var newImageElement = document.createElement('img');
        newImageElement.classList.add('Image--lazyLoad');
        newImageElement.setAttribute('data-src', Image.getSizedImageUrl(newImage['src'], '1x1').replace('_1x1.', '_{width}x.'));
        newImageElement.setAttribute('data-widths', "[".concat(Image.getSupportedSizes(newImage, [200, 400, 600, 700, 800, 900, 1000]).join(','), "]"));
        newImageElement.setAttribute('data-sizes', 'auto');
        mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));
      }
    }]);

    return FeaturedProductSection;
  }();

  var BackgroundVideoSection = /*#__PURE__*/function () {
    function BackgroundVideoSection(container) {
      _classCallCheck(this, BackgroundVideoSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '[]');

      this._loadScript().then(this._setupPlayer.bind(this));
    }

    _createClass(BackgroundVideoSection, [{
      key: "_loadScript",
      value: function _loadScript() {
        var _this = this;

        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = _this.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
        });
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        if (this.player) {
          this.player.destroy(); // Both YouTube and Vimeo use the same function name
        }
      }
    }, {
      key: "_setupPlayer",
      value: function _setupPlayer() {
        var _this2 = this;

        var elementToInsert = this.element.querySelector('.ImageHero__VideoHolder');
        var playerLoadingInterval = setInterval(function () {
          if (_this2.options['videoType'] === 'youtube') {
            if (window.YT) {
              _this2.player = new YT.Player(elementToInsert, {
                videoId: _this2.options['videoId'],
                playerVars: {
                  showinfo: 0,
                  controls: 0,
                  fs: 0,
                  rel: 0,
                  height: '100%',
                  width: '100%',
                  iv_load_policy: 3,
                  html5: 1,
                  loop: 1,
                  playsinline: 1,
                  modestbranding: 1,
                  disablekb: 1,
                  origin: _this2.options['requestHost']
                },
                events: {
                  onReady: _this2._onYouTubeReady.bind(_this2),
                  onStateChange: _this2._onYouTubeStateChange.bind(_this2)
                }
              });
              clearInterval(playerLoadingInterval);
            }
          } else {
            if (window.Vimeo) {
              _this2.player = new Vimeo.Player(elementToInsert.parentNode, {
                id: _this2.options['videoId'],
                autoplay: true,
                autopause: false,
                muted: true,
                background: true,

                /*height: '100%',
                width: '100%',*/
                loop: true
              });
              clearInterval(playerLoadingInterval);
            }
          }
        }, 50);
      }
    }, {
      key: "_onYouTubeReady",
      value: function _onYouTubeReady(event) {
        this.player.mute();
        this.player.playVideo();
      }
    }, {
      key: "_onYouTubeStateChange",
      value: function _onYouTubeStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
          this.player.playVideo();
        }
      }
    }]);

    return BackgroundVideoSection;
  }();

  var GiftCardSection = /*#__PURE__*/function () {
    function GiftCardSection(container) {
      _classCallCheck(this, GiftCardSection);

      this.element = container;

      this._createQrCode();

      this._setupPrint();
    }

    _createClass(GiftCardSection, [{
      key: "_createQrCode",
      value: function _createQrCode() {
        var qrCodeElement = document.getElementById('QrCode');
        new QRCode(qrCodeElement, {
          text: qrCodeElement.getAttribute('data-identifier'),
          width: 190,
          height: 190
        });
      }
    }, {
      key: "_setupPrint",
      value: function _setupPrint() {
        var printElement = document.getElementById('PrintGiftCard');

        if (printElement) {
          printElement.addEventListener('click', function () {
            window.print();
          });
        }
      }
    }]);

    return GiftCardSection;
  }();

  var HeaderSection = /*#__PURE__*/function () {
    function HeaderSection(container) {
      var _this = this;

      _classCallCheck(this, HeaderSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '[]');
      this.lastScrollPosition = -1;
      this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      if (this.options['isSticky']) {
        Stickyfill.addOne(this.element.parentNode);
      } // Set up the search bar

      this.searchBar = new SearchBar();

      this._attachListeners();

      this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS

      var mainLogo = this.element.querySelector('.Header__LogoImage--primary');

      if (mainLogo && !mainLogo.complete) {
        mainLogo.addEventListener('load', function () {
          fastdom.measure(function () {
            document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
            document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
          });
        });
      } else {
        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
          document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
        });
      }

      window.addEventListener('pageshow', this._checkTransparentHeader.bind(this));

      this._setupLocalizationPopovers();
    }

    _createClass(HeaderSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.element.removeEventListener('mouseleave', this._closeNavigationListener);
        this.element.removeEventListener('mouseenter', this._focusNavigationListener);
        this.element.removeEventListener('focusin', this._focusNavigationListener);
        this.delegateElement.off();
        window.removeEventListener('scroll', this._checkTransparentHeaderListener);
        window.removeEventListener('resize', this._verifyNavigationOverlapListener);

        if (this._navigationResizeObserver) {
          this._navigationResizeObserver.disconnect();
        }

        if (this.options['isSticky']) {
          Stickyfill.removeOne(this.element.parentNode);
        }

        this.searchBar.destroy();
        this.localizationPopovers.forEach(function (localizationPopover) {
          localizationPopover.destroy();
        });
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this._checkTransparentHeader();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        var _this2 = this;

        var listItem = event.target.closest('.HorizontalList__Item');
        fastdom.mutate(function () {
          event.target.setAttribute('aria-hidden', 'false');

          if (listItem) {
            listItem.classList.add('is-expanded');
            Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
              item.classList.remove('is-expanded');
            });
          }

          _this2.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible

        });
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(event) {
        var listItem = event.target.closest('.HorizontalList__Item');
        fastdom.mutate(function () {
          event.target.setAttribute('aria-hidden', 'true');

          if (listItem) {
            listItem.classList.remove('is-expanded');
          }
        });

        this._checkTransparentHeader();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
        this._closeNavigationListener = this._closeNavigation.bind(this);
        this._focusNavigationListener = this._focusNavigation.bind(this);
        this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
        this.element.addEventListener('mouseleave', this._closeNavigationListener);
        this.delegateElement.on('mouseenter', '.Header__MainNav .HorizontalList__Item, [aria-haspopup]', this._openMenu.bind(this), true);
        this.delegateElement.on('keydown', '[aria-haspopup]', this._handleKeyboardMenu.bind(this), true);
        this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false);
        this.delegateElement.on('click', '[data-action="toggle-search"]', this._closeNavigationListener);
        this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
        this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);


        if (this.isTouch) {
          this.delegateElement.on('click', '.Header__MainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
        }

        if (this.options['hasTransparentHeader']) {
          this.element.addEventListener('mouseenter', this._focusNavigationListener);
          this.element.addEventListener('focusin', this._focusNavigationListener);
        }

        if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
          window.addEventListener('scroll', this._checkTransparentHeaderListener);
        }

        if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
          window.addEventListener('resize', this._verifyNavigationOverlapListener);

          // The overlap check above only re-runs on window resize. Nav items can appear after init
          // (A/B variations un-hiding a menu item, app embeds, font swaps), which wraps the links
          // without any resize. Re-run the check whenever the nav's own box changes size.
          var mainTopMenu = this.element.querySelector('.Header__MainNav');

          if (mainTopMenu && 'ResizeObserver' in window) {
            var _this3b = this;

            // Keyed on the visible items' widths, not on an in-flight flag: the check's own
            // logo-left <-> centered toggle resizes the nav and would otherwise re-trigger it.
            var lastNavSignature = null;
            var navSignature = function navSignature() {
              return Dom.nodeListToArray(mainTopMenu.querySelectorAll('.HorizontalList__Item')).filter(function (item) {
                return item.offsetParent !== null;
              }).map(function (item) {
                return item.offsetWidth;
              }).join(',');
            };

            this._navigationResizeObserver = new ResizeObserver(function () {
              var signature = navSignature();

              if (signature === lastNavSignature) {
                return;
              }

              lastNavSignature = signature;

              _this3b._verifyNavigationOverlap();
            });
            this._navigationResizeObserver.observe(mainTopMenu);
          }
        }
      }
    }, {
      key: "_setupLocalizationPopovers",
      value: function _setupLocalizationPopovers() {
        // Prestige is an extremely complex theme, especially in the header due to the various layouts that power different
        // features. One issue that arises with this is that we output the localization elements twice in the DOM (with the
        // same ID as we're doing a capture in Liquid), and then depending on the screen size one layout is choosen. We therefore
        // have to de-duplicate the ID here. This is honestly not the cleanest code on earth, but I prefer handling this here
        // rather than duplicating too much Liquid
        this.localizationPopovers = [];
        Dom.nodeListToArray(document.querySelectorAll('#header-locale-popover')).forEach(function (item, index) {
          item.id = "".concat(item.id, "-").concat(index);
        });
        Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-locale-popover"]')).forEach(function (item, index) {
          item.setAttribute('aria-controls', "".concat(item.getAttribute('aria-controls'), "-").concat(index));
        });
        Dom.nodeListToArray(document.querySelectorAll('#header-currency-popover')).forEach(function (item, index) {
          item.id = "".concat(item.id, "-").concat(index);
        });
        Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-currency-popover"]')).forEach(function (item, index) {
          item.setAttribute('aria-controls', "".concat(item.getAttribute('aria-controls'), "-").concat(index));
        });
        var localePopoverElement1 = document.getElementById('header-locale-popover-0');

        if (localePopoverElement1) {
          this.localizationPopovers.push(new Popover(localePopoverElement1, {
            preferredAlignment: 'center',
            preferredPosition: 'bottom',
            threshold: 12
          }));
        }

        var localePopoverElement2 = document.getElementById('header-locale-popover-1');

        if (localePopoverElement2) {
          this.localizationPopovers.push(new Popover(localePopoverElement2, {
            preferredAlignment: 'center',
            preferredPosition: 'bottom',
            threshold: 12
          }));
        }

        var currencyPopoverElement1 = document.getElementById('header-currency-popover-0');

        if (currencyPopoverElement1) {
          this.localizationPopovers.push(new Popover(currencyPopoverElement1, {
            preferredAlignment: 'center',
            preferredPosition: 'bottom',
            threshold: 12
          }));
        }

        var currencyPopoverElement2 = document.getElementById('header-currency-popover-1');

        if (currencyPopoverElement2) {
          this.localizationPopovers.push(new Popover(currencyPopoverElement2, {
            preferredAlignment: 'center',
            preferredPosition: 'bottom',
            threshold: 12
          }));
        }
      }
    }, {
      key: "_focusNavigation",
      value: function _focusNavigation() {
        var _this3 = this;

        fastdom.mutate(function () {
          if (!_this3.isTouch || Responsive.matchesBreakpoint('desk')) {
            _this3.element.classList.remove('Header--transparent');
          }
        });
      }
    }, {
      key: "_closeNavigation",
      value: function _closeNavigation() {
        var _this4 = this;
        this.pageOverlayElement.classList.remove('header-menu-open');

        fastdom.mutate(function () {
          Dom.nodeListToArray(_this4.element.querySelectorAll('.is-expanded')).forEach(function (item) {
            item.classList.remove('is-expanded');
          });
          Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
            item.setAttribute('aria-hidden', 'true');
          });
        });
        

        if (this.options['hasTransparentHeader']) {
          this._checkTransparentHeader();
        }
      }
    }, {
      key: "_openMenu",
      value: function _openMenu(event, target) {
        if (event.type === 'mouseenter' && target !== event.target) {
          return;
        }
        this.pageOverlayElement.classList.add('header-menu-open');

        fastdom.mutate(function () {
          target.classList.add('is-expanded');
          Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'false');
          });
          Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
            Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
              item.setAttribute('aria-hidden', 'true');
            });
          });
        });
      }
    }, {
      key: "_closeMenu",
      value: function _closeMenu(event, target) {
        if (event.type === 'mouseleave' && target !== event.target) {
          return;
        }

        // For focusout events, check if focus is moving within the same HorizontalList__Item
        if (event.type === 'focusout' && event.relatedTarget) {
          var parentListItem = target.closest('.HorizontalList__Item');
          var relatedParentListItem = event.relatedTarget.closest('.HorizontalList__Item');
          
          // Don't close if focus is staying within the same list item
          if (parentListItem && parentListItem === relatedParentListItem) {
            return;
          }
        }

        fastdom.mutate(function () {
          target.classList.remove('is-expanded');
          Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'true');
          });
        });
      }
    }, {
      key: "_handleKeyboardMenu",
      value: function _handleKeyboardMenu(event, target) {
        if (event.key === 'Enter') {
          if (target.classList.contains('is-expanded')) {
            // Menu is already open, allow default behavior (follow link)
            return;
          } else {
            // Menu is closed, open it and prevent link navigation
            event.preventDefault();
            event.stopPropagation();
            this._openMenu(event, target);
          }
        }
      }
    }, {
      key: "_adjustDropdownPosition",
      value: function _adjustDropdownPosition(event, target) {
        var nestedMenus = Dom.nodeListToArray(target.querySelectorAll('.DropdownMenu')),
            shouldOpenLeft = false;
        fastdom.measure(function () {
          var windowWidth = window.innerWidth,
              rightEdge = target.getBoundingClientRect().right;
          nestedMenus.forEach(function (item) {
            if (rightEdge + item.offsetWidth > windowWidth) {
              shouldOpenLeft = true;
            }
          });
        });
        fastdom.mutate(function () {
          if (shouldOpenLeft) {
            nestedMenus.forEach(function (item) {
              item.classList.add('DropdownMenu--reversed');
            });
          } else {
            nestedMenus.forEach(function (item) {
              item.classList.remove('DropdownMenu--reversed');
            });
          }
        });
      }
      /**
       * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
       * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
       * the sub-menu. If this link is clicked a second twice, then the menu is followed
       */

    }, {
      key: "_handleTouchMenu",
      value: function _handleTouchMenu(event, target) {
        if (!target.classList.contains('is-expanded')) {
          event.preventDefault();
        }
      }
    }, {
      key: "_verifyNavigationOverlap",
      value: function _verifyNavigationOverlap() {
        var _this5 = this;

        var isOverlapping = false,
            mainTopMenu = this.element.querySelector('.Header__MainNav');
        fastdom.measure(function () {
          // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
          if (mainTopMenu) {
            // Get the first element
            var firstNavElementHeight = Dom.outerHeightWithMargin(mainTopMenu.querySelector('.HorizontalList__Item')),
                mainNavHeight = mainTopMenu.scrollHeight;

            if (mainNavHeight > firstNavElementHeight) {
              isOverlapping = true;
            }
          }
        });
        this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center');
        this.element.classList.add("Header--".concat(this.options['navigationStyle']));
        this.element.clientWidth; // Forces a reflow

        fastdom.mutate(function () {
          if (isOverlapping) {
            _this5.element.classList.remove("Header--".concat(_this5.options['navigationStyle']));

            _this5.element.classList.add('Header--center'); // Check if still overlapping despite changing the mode


            if (mainTopMenu) {
              // Get the first element
              var itemTopSet = new Set();
              Array.from(mainTopMenu.querySelectorAll('.HorizontalList__Item')).forEach(function (item) {
                itemTopSet.add(item.getBoundingClientRect().top);
              });
              isOverlapping = itemTopSet.size > 1;
            }
          } else {
            _this5.element.classList.add("Header--".concat(_this5.options['navigationStyle']));

            _this5.element.classList.remove('Header--center');
          }

          var logo = _this5.element.querySelector('.Header__FlexItem--logo');

          logo.classList.toggle('Header__FlexItem--increaseSpace', isOverlapping);

          _this5.element.classList.add('Header--initialized');

          fastdom.measure(function () {
            document.documentElement.style.setProperty('--header-height', _this5.element.clientHeight + 'px');
          });
        });
      }
      /**
       * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
       * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
       * scroll listener)
       */

    }, {
      key: "_checkTransparentHeader",
      value: function _checkTransparentHeader() {
        var _this6 = this;

        if (!this.options['hasTransparentHeader']) {
          return;
        }

        var scrollThreshold = 10;
        fastdom.measure(function () {
          _this6.lastScrollPosition = window.pageYOffset;
        });
        fastdom.mutate(function () {
          if (_this6.lastScrollPosition <= scrollThreshold) {
            _this6.element.classList.add('Header--transparent');
          } else {
            _this6.element.classList.remove('Header--transparent');
          }
        });
      }
    }]);

    return HeaderSection;
  }();

  var FooterSection = /*#__PURE__*/function () {
    function FooterSection(container) {
      _classCallCheck(this, FooterSection);

      this.element = container;
      var localePopoverElement = document.getElementById('footer-locale-popover');

      if (localePopoverElement) {
        this.localePopover = new Popover(localePopoverElement, {
          preferredAlignment: 'center',
          preferredPosition: 'top',
          threshold: 12
        });
      }

      var currencyPopoverElement = document.getElementById('footer-currency-popover');

      if (currencyPopoverElement) {
        this.currencyPopover = new Popover(currencyPopoverElement, {
          preferredAlignment: 'center',
          preferredPosition: 'top',
          threshold: 12
        });
      }
    }

    _createClass(FooterSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.localePopover) {
          this.localePopover.destroy();
        }

        if (this.currencyPopover) {
          this.currencyPopover.destroy();
        }
      }
    }]);

    return FooterSection;
  }();

  var ImageWithTextBlockSection = /*#__PURE__*/function () {
    function ImageWithTextBlockSection(container) {
      _classCallCheck(this, ImageWithTextBlockSection);

      this.element = container;
    }

    _createClass(ImageWithTextBlockSection, [{
      key: "onUnload",
      value: function onUnload() {}
    }]);

    return ImageWithTextBlockSection;
  }();

  var LoginSection = /*#__PURE__*/function () {
    function LoginSection(container) {
      _classCallCheck(this, LoginSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.timelineLite = new TimelineLite();
      this.customerLoginForm = this.element.querySelector('#customer_login');
      this.recoverPasswordForm = this.element.querySelector('#recover_customer_password');
      this.delegateElement.on('click', '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
    }

    _createClass(LoginSection, [{
      key: "_showRecoverPassword",
      value: function _showRecoverPassword() {
        var isLoginActive = this.customerLoginForm.style.display === 'block';

        if (isLoginActive) {
          this.timelineLite.fromTo(this.customerLoginForm, 0.5, {
            autoAlpha: 1,
            display: 'block',
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            display: 'none'
          }).fromTo(this.recoverPasswordForm, 0.5, {
            autoAlpha: 0,
            display: 'none',
            y: 20
          }, {
            autoAlpha: 1,
            display: 'block',
            y: 0,
            delay: 0.25
          });
        } else {
          this.timelineLite.fromTo(this.recoverPasswordForm, 0.5, {
            autoAlpha: 1,
            display: 'block',
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            display: 'none'
          }).fromTo(this.customerLoginForm, 0.5, {
            autoAlpha: 0,
            display: 'none',
            y: 20
          }, {
            autoAlpha: 1,
            display: 'block',
            y: 0,
            delay: 0.25
          });
        }
      }
    }]);

    return LoginSection;
  }();

  var MapSection = /*#__PURE__*/function () {
    function MapSection(element) {
      _classCallCheck(this, MapSection);

      this.element = element;
      this.options = JSON.parse(element.getAttribute('data-section-settings'));

      if (this.options['apiKey'] && this.options['mapAddress']) {
        this._loadScript().then(this._initMap.bind(this));
      }
    }

    _createClass(MapSection, [{
      key: "_loadScript",
      value: function _loadScript() {
        var _this = this;

        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(_this.options['apiKey']);
        });
      }
    }, {
      key: "_initMap",
      value: function _initMap() {
        var _this2 = this;

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: this.options['mapAddress']
        }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            if (Shopify.designMode) ;
          } else {
            var mapOptions = {
              zoom: _this2.options['zoom'],
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };
            var map = new google.maps.Map(_this2.element.querySelector('.FeaturedMap__GMap'), mapOptions),
                center = map.getCenter();
            map.setCenter(center);
            var icon = {
              path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
              fillColor: _this2.options['markerColor'],
              fillOpacity: 1,
              anchor: new google.maps.Point(15, 55),
              strokeWeight: 0,
              scale: 0.6
            };
            new google.maps.Marker({
              map: map,
              position: map.getCenter(),
              icon: icon
            });
            var styledMapType = new google.maps.StyledMapType(JSON.parse(_this2.element.querySelector('[data-gmap-style]').innerHTML));
            map.mapTypes.set('styled_map', styledMapType);
            map.setMapTypeId('styled_map');
            google.maps.event.addDomListener(window, 'resize', function () {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
            });
          }
        });
      }
    }]);

    return MapSection;
  }();

  var NewsletterPopupSection = /*#__PURE__*/function () {
    function NewsletterPopupSection(element) {
      _classCallCheck(this, NewsletterPopupSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(element.getAttribute('data-section-settings') || '[]'); // If the popup has been already displayed, we do not display it

      try {
        if (window.location.hash === '#newsletter-popup' && window.theme.pageType !== null) {
          this._openPopup();
        } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
          setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000);
        }
      } catch (error) {// Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }

      this._attachListeners();
    }

    _createClass(NewsletterPopupSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this._openPopup();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this._closePopup();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
      }
    }, {
      key: "_openPopup",
      value: function _openPopup() {
        this.element.setAttribute('aria-hidden', 'false');
        localStorage.setItem('themePopup', 'true');
      }
    }, {
      key: "_closePopup",
      value: function _closePopup() {
        this.element.setAttribute('aria-hidden', 'true');
      }
    }]);

    return NewsletterPopupSection;
  }();

  var ProductRecommendationsSection = /*#__PURE__*/function () {
    function ProductRecommendationsSection(container) {
      _classCallCheck(this, ProductRecommendationsSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '[]');

      this._loadRecommendations().then(this._createSlideshow.bind(this));
    }

    _createClass(ProductRecommendationsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }, {
      key: "_loadRecommendations",
      value: function _loadRecommendations() {
        var _this = this;

        var url = "".concat(window.routes.productRecommendationsUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&product_id=").concat(this.options['productId'], "&limit=").concat(this.options['recommendationsCount'], "&intent=complementary");
        return fetch(url).then(function (response) {
          return response.text().then(function (content) {
            var container = document.createElement('div');
            container.innerHTML = content;
            var sourceEl = container.querySelector('.ProductRecommendations');
            var targetEl = _this.element.querySelector('.ProductRecommendations');
            if (sourceEl && targetEl) {
              targetEl.innerHTML = sourceEl.innerHTML;
            }
          });
        });
      }
    }, {
      key: "_createSlideshow",
      value: function _createSlideshow() {
        var flickityElement = this.element.querySelector('[data-flickity-config]');

        if (!flickityElement) {
          return;
        }

        this.carousel = new Carousel(flickityElement); // Setup product item color swatch
      }
    }]);

    return ProductRecommendationsSection;
  }();

  var WaitListSection = /*#__PURE__*/function () {
    function WaitListSection(container) {
      var _this = this;

      _classCallCheck(this, WaitListSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);

      this.joinWaitlistDiv = this.element.querySelector('#jwWrapper');
      this.joinWaitlistButton = this.element.querySelector('.join-waitlist #jwTrigger');
      this.joinWaitlistForm = this.element.querySelector('.join-waitlist #jwForm');

      this._attachListeners();
    }

    _createClass(WaitListSection, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off('click');
        this.delegateElement.off('keypress');
        this.delegateElement.off('variant:changed');
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.join-waitlist .btn-join-waitlist', this._joinWaitListShow.bind(this));
        this.delegateElement.on('keypress', '#jwForm .email-input input', this._joinWaitListInputKeyPress.bind(this));
        this.delegateElement.on('click', '#jwForm button', this._joinWaitListSubmit.bind(this));
        this.delegateElement.on('variant:changed', this._updateWaitListData.bind(this));
      }
      /**
       * Join Waitlist Update Variant ID
       */
    }, {
      key: "_updateWaitListData",
      value: function _updateWaitListData(event) {
        var variant = event.detail.variant;
        if (this.joinWaitlistDiv) {
          this.joinWaitlistDiv.setAttribute('data-variant-id', variant.id);
          this.joinWaitlistDiv.setAttribute('data-variant-name', variant.title || '');
          this.joinWaitlistDiv.setAttribute('data-variant-sku', variant.sku || '');

          var launchDateSeconds = variant['launch_date_seconds'];
          var isPreLaunch = launchDateSeconds && parseInt(launchDateSeconds) > Math.floor(Date.now() / 1000);
          this.joinWaitlistDiv.setAttribute('data-pre-launch', isPreLaunch ? 'true' : 'false');

          if (this.joinWaitlistButton) {
            var btn = this.joinWaitlistButton.querySelector('.btn-join-waitlist');
            if (btn) {
              btn.textContent = isPreLaunch ? window.languages.productFormEarlyAccess : window.languages.productFormWaitlist;
            }
            this.joinWaitlistButton.classList.add('active', 'show');
          }
          if (this.joinWaitlistForm) {
            this.joinWaitlistForm.classList.remove('active', 'show');
            this.joinWaitlistForm.querySelector('input[name="waitlistEmail"]').value = '';
          }

          const successMessage = this.element.querySelector('#jwSuccess');
          if (successMessage) {
            var successP = successMessage.querySelector('p');
            if (successP) {
              successP.textContent = isPreLaunch
                ? (successMessage.getAttribute('data-msg-prelaunch') || 'Thank you. You\'ll be notified when this product launches.')
                : (successMessage.getAttribute('data-msg-waitlist') || 'Thank you. You\'ve been added to the waitlist.');
            }
            successMessage.classList.remove('active', 'show');
          }

        }
      }
      /**
       * Join Waitlist Show Email input
       */
    }, {
      key: "_joinWaitListShow",
      value: function _joinWaitListShow(event) {
        if (this.joinWaitlistForm) {
          this.joinWaitlistForm.classList.add('active', 'show');
          this.joinWaitlistButton.classList.remove('active', 'show');
        }
      }
      /**
       * Join Waitlist Enter Key Capture
       */
    }, {
      key: "_joinWaitListInputKeyPress",
      value: function _joinWaitListInputKeyPress(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          this._joinWaitListSubmit(event);
        }
      }
      /**
       * Join Waitlist Submit to Klaviuo
       */
    }, {
      key: "_joinWaitListSubmit",
      value: function _joinWaitListSubmit(event) {
        event.preventDefault();

        const successMessage = this.element.querySelector('#jwSuccess');
        const joinWaitlistForm = this.joinWaitlistForm;

        const email = this.joinWaitlistForm.querySelector('input[name="waitlistEmail"]').value;
        const variantId = this.joinWaitlistDiv.getAttribute('data-variant-id');
        // WWW-3630: isPreLaunch is temporarily hardcoded to false at the request of the marketing team.
        // When true, submissions route to Klaviyo's /client/events/ endpoint as a "Pre-Launch Waitlist"
        // event instead of the standard /client/back-in-stock-subscriptions/ endpoint.
        // The Klaviyo flow for that event has not yet been configured, so firing it would result in
        // signups being lost. Restore the commented line below once the Klaviyo flow is ready.
        // const isPreLaunch = this.joinWaitlistDiv.getAttribute('data-pre-launch') === 'true';
        const isPreLaunch = false;
        const isPreLaunchSignup = this.joinWaitlistDiv.getAttribute('data-pre-launch') === 'true';
        const productId = this.joinWaitlistDiv.getAttribute('data-product-id');
        const productName = this.joinWaitlistDiv.getAttribute('data-product-name');
        const variantName = this.joinWaitlistDiv.getAttribute('data-variant-name');
        const variantSku = this.joinWaitlistDiv.getAttribute('data-variant-sku');

        if (!_validEmailAddress(email)) {
          joinWaitlistForm.querySelector('.invalid-feedback').classList.add('d-block');
          return;
        }

        // ── PRE-LAUNCH: fire a custom event to trigger your Pre-Launch Flow ──────
        const preLaunchPayload = {
          "data": {
            "type": "event",
            "attributes": {
              "metric": {
                "data": {
                  "type": "metric",
                  "attributes": {
                    "name": "Pre-Launch Waitlist"
                  }
                }
              },
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": email
                  }
                }
              },
              "properties": {
                "variant_id": variantId,
                "product_id": productId,
                "product_name": productName,
                "variant_name": variantName,
                "sku": variantSku,
              }
            }
          }
        };

        // ── BACK-IN-STOCK: existing payload (unchanged) ───────────────────────────
        const backInStockPayload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": email                  }
                }
              },
              "channels": ["EMAIL"],
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        };

        // ── MAIN LIST: existing payload (unchanged) ───────────────────────────────
        const mainListPayload = {
          "data": {
            "type": "subscription",
            "attributes": {
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": email,
                    "subscriptions": {
                      "email": {
                        "marketing": {
                          "consent": "SUBSCRIBED",
                          "consented_at": new Date().toISOString()
                        }
                      }
                    }
                  }
                }
              },
              "custom_source": isPreLaunchSignup ? "Pre-Launch Signup" : "Back In Stock Signup"
            },
            "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": KLAVIYO_LIST_ID
                }
              }
            }
          }
        };

        const headers = {
          "Content-Type": "application/json",
          "revision": "2025-04-15"
        };

        // ── First call: either pre-launch event or back-in-stock ──────────────────
        const firstCallUrl = isPreLaunch
          ? "https://a.klaviyo.com/client/events/?company_id=" + KLAVIYO_PUBLIC_KEY
          : "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + KLAVIYO_PUBLIC_KEY;

        const firstCallBody = isPreLaunch ? preLaunchPayload : backInStockPayload;

        fetch(firstCallUrl, { method: 'POST', headers, body: JSON.stringify(firstCallBody) })
          .then(response => {
            if (!response.ok) {
              throw new Error(isPreLaunch ? 'Error submitting pre-launch waitlist' : 'Error subscribing user to back in stock');
            }
            console.log(isPreLaunch ? 'Pre-launch event tracked' : 'User subscribed to back in stock');

            // ── Second call: main list subscription (always) ──────────────────────
            return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_PUBLIC_KEY, {
              method: 'POST',
              headers,
              body: JSON.stringify(mainListPayload)
            });
          })
          .then(response => {
            if (response.status === 202) {
              console.log('User subscribed to main list');
              successMessage.classList.add('active', 'show');
              joinWaitlistForm.classList.remove('active', 'show');
            } else {
              return response.json().then(result => { throw result; });
            }
          })
          .catch(error => {
            console.error('Error in subscription process: ', error);
          });
      }
    }]);

    return WaitListSection;
  }();
  
  var ProductGallery = /*#__PURE__*/function () {
    function ProductGallery(container, options) {

      _classCallCheck(this, ProductGallery);

      this.options = options;
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.productGalleryElement = this.element.querySelector('.Product__Gallery');
      this.viewInSpaceElement = this.element.querySelector('[data-shopify-xr]');

      this._initGallery();
      this._setupDeviceFeatures();
      this._attachListeners();
    }

    _createClass(ProductGallery, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
        this.delegateElement.off('keydown');

        if (this.productSlideshow) {
          this.productSlideshow.destroy();
        }

        if (this.options['enableImageZoom']) {
          this.imageZoomInstance.destroy();
        }

        if (this.carouselNavScrollSpy) {
          this.carouselNavScrollSpy.destroy();
        }

        if (this.productThumbnailsScroller) {
          this.productThumbnailsScroller.destroy();
        }

        this.delegateElement.off('variant:changed');
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "_initGallery",
      value: function _initGallery() {

        var _this = this;
        var productSlideshowElement = this.element.querySelector('.Product__Slideshow'); // If there is no image at all, there is nothing to init

        // Flickity emits `select` while the Carousel below is constructed, before `_setupWww4067` runs,
        // so references from the previous render must not survive into it
        this.www4067ThumbStrip = null;
        this.www4067ZoomHint = null;
        this.slideVideos = [];

        if (productSlideshowElement) {
          this.productSlideshow = new Carousel(productSlideshowElement, {
            onSelect: this._onImageChanged.bind(this),
            onSettle: this._onImageSettled.bind(this),
            // Flickity's `staticClick`: a tap that did not become a drag
            onClick: this._onSlideStaticClick.bind(this)
          }, {
            draggable: !Responsive.matchesBreakpoint('supports-hover')
          });
          this.mediaList = {}; // We keep track of a list of media element
  
          this.previouslySelectedMedia = null; // Keep track of the previously selected media
          // For each model and video, we register a media
  
          productSlideshowElement.querySelectorAll('[data-media-type="model"]').forEach(function (model) {
            _this.mediaList[model.getAttribute('data-media-id')] = new ProductModel(model, _this.options['stackProductImages']);
          });
          productSlideshowElement.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (video) {
            _this.mediaList[video.getAttribute('data-media-id')] = new ProductVideo(video, _this.options['stackProductImages'], _this.options['enableVideoLooping']);
          });
  
          if (this.options['stackProductImages']) {
            this.slideshowNavDots = this.element.querySelector('.Product__SlideshowNav--dots');
            this.slideshowNavDotsItems = this.slideshowNavDots ? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll('a')) : [];
          }
  
          if (this.options['showThumbnails']) {
            this.slideshowNavThumbnails = this.element.querySelector('.Product__SlideshowNav--thumbnails');
            this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? Dom.nodeListToArray(this.slideshowNavThumbnails.querySelectorAll('.Product__SlideshowNavImage')) : [];
          }
  
          this.slideshowImages = Dom.nodeListToArray(productSlideshowElement.querySelectorAll('.Carousel__Cell')); 

          // Setup the mobile nav
          this._setupSlideshowMobileNav();
        }

        // Re-run on every colour change, because `_updateGallery` replaces the gallery's markup
        this._setupWww4067(productSlideshowElement);
  
        if (this.options['enableImageZoom']) {
          // Its listeners are on `this.element`, which outlives a re-render, so each one would open another viewer
          if (this.imageZoomInstance) {
            this.imageZoomInstance.destroy();
          }

          this.imageZoomInstance = new ProductImageZoom(this.element, this.productSlideshow, {
            onOpen: this._pauseSlideVideos.bind(this),
            onClose: this._syncSlideVideoPlayback.bind(this, undefined),
            isWww4067Active: this._isWww4067Active.bind(this)
          });
        }

      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * WWW-4067 A/B test: mobile gallery with thumbnail strip and tap-to-expand.
       *
       * Everything below is inert unless `_isWww4067Active()`; control keeps the existing gallery behaviour.
       * ---------------------------------------------------------------------------------------------------
       */
    }, {
      key: "_setupWww4067",
      value: function _setupWww4067(productSlideshowElement) {
        var _this = this;

        this.www4067ThumbStrip = this.element.querySelector('.Product__SlideshowNav--thumbnails');
        this.www4067ZoomHint = this.element.querySelector('.Product__ZoomHint');

        // The gallery re-render (`?view=gallery`) always includes the button, whatever the template's zoom setting
        if (this.www4067ZoomHint && !this.options['enableImageZoom']) {
          this.www4067ZoomHint.parentNode.removeChild(this.www4067ZoomHint);
          this.www4067ZoomHint = null;
        }

        this.slideVideos = productSlideshowElement ? Dom.nodeListToArray(productSlideshowElement.querySelectorAll('.Product__SlideItem--video video')) : [];

        if (!this.www4067ThumbStrip) {
          return;
        }

        new domDelegate.Delegate(this.www4067ThumbStrip).on('click', '.Product__SlideshowNavImage', function (event, element) {
          if (!_this._isWww4067Active()) {
            return;
          }

          // Stop propagation too: the theme's body-level `[href^="#"]` handler would
          // otherwise scroll the page to the anchor on every thumbnail tap.
          event.preventDefault();
          event.stopPropagation();

          var cells = _this.productSlideshow.flickityInstance.cells,
              mediaId = element.getAttribute('data-media-id');

          for (var i = 0; i !== cells.length; ++i) {
            if (cells[i].element.getAttribute('data-media-id') === mediaId) {
              _this.productSlideshow.selectCell(i);
              break;
            }
          }
        });
      }
      /**
       * True when the treatment CSS is showing the strip or the (+) button and Flickity is running
       * (mobile). Reads the CSS rather than the body class so the stylesheet's breakpoint is the only one.
       */
    }, {
      key: "_isWww4067Active",
      value: function _isWww4067Active() {
        if (!this.productSlideshow || !this.productSlideshow.flickityInstance || !this.productSlideshow.flickityInstance.isActive) {
          return false;
        }

        return [this.www4067ThumbStrip, this.www4067ZoomHint].some(function (element) {
          return element && element.isConnected && window.getComputedStyle(element).display !== 'none';
        });
      }
    }, {
      key: "_onSlideStaticClick",
      value: function _onSlideStaticClick(cellElement) {
        if (this.imageZoomInstance && this._isWww4067Active()) {
          this.imageZoomInstance.openFromSlide(cellElement);
        }
      }
    }, {
      key: "_onSlideKeydown",
      value: function _onSlideKeydown(event, target) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        if (this.imageZoomInstance && this._isWww4067Active()) {
          event.preventDefault();
          this.imageZoomInstance.openFromSlide(target);
        }
      }
      /**
       * Mark the active thumbnail and centre it. Scrolls the strip itself rather than using
       * scrollIntoView, which would also scroll the page.
       */
    }, {
      key: "_syncThumbnailStrip",
      value: function _syncThumbnailStrip(mediaId) {
        var scroller = this.www4067ThumbStrip.querySelector('.Product__SlideshowNavScroller') || this.www4067ThumbStrip;

        Dom.nodeListToArray(this.www4067ThumbStrip.querySelectorAll('.Product__SlideshowNavImage')).forEach(function (thumbnail) {
          var isSelected = thumbnail.getAttribute('data-media-id') === mediaId;
          thumbnail.classList.toggle('is-selected', isSelected);

          if (isSelected && scroller.scrollWidth > scroller.clientWidth) {
            scroller.scrollTo({
              left: thumbnail.offsetLeft - (scroller.clientWidth - thumbnail.offsetWidth) / 2,
              behavior: 'smooth'
            });
          }
        });
      }
      /**
       * Play the selected slide's video and pause the others. Mobile control never autoplays on
       * select (`ProductVideo.hasBeenSelected` is hover-devices only), so this is treatment-only.
       */
    }, {
      key: "_syncSlideVideoPlayback",
      value: function _syncSlideVideoPlayback(activeCell) {
        if (!this.slideVideos || this.slideVideos.length === 0 || !this._isWww4067Active()) {
          return;
        }

        var selectedElement = activeCell || this.productSlideshow.flickityInstance.selectedElement,
            reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.slideVideos.forEach(function (video) {
          if (!reducedMotion && selectedElement && selectedElement.contains(video)) {
            // Plyr rewrites `loop` from the section's `enable_video_looping` setting, which is off,
            // and iOS only allows an inline autoplay when muted.
            video.muted = true;
            video.loop = true;
            video.playsInline = true;

            var playing = video.play();

            if (playing && playing.catch) {
              playing.catch(function () {}); // Rejected in Low Power Mode and some in-app browsers
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      }
      /**
       * PhotoSwipe draws over the page, so a playing video would keep running behind it
       */
    }, {
      key: "_pauseSlideVideos",
      value: function _pauseSlideVideos() {
        (this.slideVideos || []).forEach(function (video) {
          if (!video.paused) {
            video.pause();
          }
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {

        this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
        this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
        this.delegateElement.on('keydown', '.Product__SlideItem--image', this._onSlideKeydown.bind(this));
        this.delegateElement.on('scrollspy:target:changed', this._onScrollTargetChanged.bind(this));
        this.delegateElement.on('model:played', this._onMediaPlayed.bind(this));
        this.delegateElement.on('video:played', this._onMediaPlayed.bind(this));
        this.delegateElement.on('model:paused', this._onMediaPaused.bind(this));
        this.delegateElement.on('video:paused', this._onMediaPaused.bind(this));
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
        if (this.options['modalDisplay']) {
          if (this.options['showThumbnails']) {
            // Thumbnails
            this.delegateElement.on('click', '.Product__SlideshowNavImage', this._imageNavClicked.bind(this));
          } else {
            // Dots
            this.delegateElement.on('click', '.Product__SlideshowNavDot', this._imageNavClicked.bind(this));
          } 
        } else if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
          this.delegateElement.on('click', '.Product__SlideshowNavImage', this._switchToImage.bind(this));
        }
      }
    }, {
      key: "_setupSlideshowMobileNav",
      value: function _setupSlideshowMobileNav() {
        var _this2 = this;

        this.slideshowMobileNav = this.element.querySelector('.Product__SlideshowMobileNav');

        if (this.slideshowMobileNav) {
          var slideshowMobileNavDelegate = new domDelegate.Delegate(this.slideshowMobileNav); // Handle the dot
 
          slideshowMobileNavDelegate.on('click', '.dot', function (event, element) {
            _this2._slideWillChange();

            _this2.productSlideshow.selectCell(parseInt(element.getAttribute('data-index')));
          }); // Handle the buttons

          slideshowMobileNavDelegate.on('click', '.Product__SlideshowNavArrow', function (event, element) {
            _this2._slideWillChange();

            if (element.getAttribute('data-direction') === 'next') {
              _this2.productSlideshow.next();
            } else {
              _this2.productSlideshow.previous();
            }
          });
        }
      }
      /**
       * Update the main carousel image or replace with variant gallery
       */
    }, {
      key: "_updateSlideshowImage",
      value: function _updateSlideshowImage(event) {
        var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant;

        if (this.productGalleryElement && this.productGalleryElement.dataset.isVariantGallery) {
          this._updateGallery(event);

        } else {

          if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
            return;
          } // We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor

          this._slideWillChange();

          if (Responsive.matchesBreakpoint('pocket') || !this.options['stackProductImages']) {
            for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
              var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
                  mediaId = parseInt(cellElement.getAttribute('data-media-id'));

              if (mediaId === variant['featured_media']['id']) {
                this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
              }
            }
          } else {
            document.querySelector("[href=\"#Media".concat(variant['featured_media']['id'], "\"]")).click(); //document.getElementById(`Media${variant['featured_media']['id']}`).scrollIntoView({behavior: 'smooth'});
          }
        }
      }
      /**
       * This happens when a media is played
       */
    }, {
      key: "_onMediaPlayed",
      value: function _onMediaPlayed(event) {
        // ONLY Remove draggability if there is a video set to no play inline which would be playing in full screen on mobile devies.
        var videoElement = event.target.querySelector('video[autoplay]:not([playsinline])');
        if (videoElement) {
          this.productSlideshow.getFlickityInstance().options.draggable = false;
          this.productSlideshow.getFlickityInstance().unbindDrag(); // If there is a previously enabled media, we disable it
        }

        if (this.previouslySelectedMedia && this.previouslySelectedMedia !== event.target) {
          const mediaId = this.previouslySelectedMedia.getAttribute('data-media-id');
          if (mediaId) {
            const mediaItem = this.mediaList[mediaId];
            if (mediaItem) {
              mediaItem.hasBeenDeselected();
            }
          }
        } // If the slideshow is configured to stack images, the "select" method from the carousel is not called, so we
        // have to keep track of it here

        if (this.options['stackProductImages']) {
          this.previouslySelectedMedia = event.target;
        }
      }
      /**
       * This happens when a given media is paused
       */
    }, {
      key: "_onMediaPaused",
      value: function _onMediaPaused() {
        // Enable draggability
        this.productSlideshow.getFlickityInstance().options.draggable = !Responsive.matchesBreakpoint('supports-hover');
        this.productSlideshow.getFlickityInstance().bindDrag();
      }
      /**
       * This method is called when a media changed in the slideshow
       */
    }, {
      key: "_handleMedia",
      value: function _handleMedia(item) {
        // First, we need to turn off the previous media (if any)
        if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
          switch (this.previouslySelectedMedia.getAttribute('data-media-type')) {
            case 'video':
            case 'external_video':
            case 'model':
              this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
          } // If the previous media was a model, we need to adjust the "view in space" button to go back to initial value


          if (this.previouslySelectedMedia.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
            this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', this.viewInSpaceElement.getAttribute('data-shopify-model3d-default-id'));
          }
        } // Then, we have to handle the currently selected media

        switch (item.getAttribute('data-media-type')) {
          case 'video':
          case 'external_video':
          case 'model':
            this.mediaList[item.getAttribute('data-media-id')].hasBeenSelected();
            break;
        } // If the media is a model, we need to adjust the "view in space" button


        if (item.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
          this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', item.getAttribute('data-media-id'));
        } // We set the previously selected media to the currently new one, so that when it changes it can be properly accounted


        this.previouslySelectedMedia = item;
      }
      /**
       * Callback when the target changes
       */

    }, {
      key: "_onScrollTargetChanged",
      value: function _onScrollTargetChanged(event) {
        // The scrollspy emit also an "oldTarget", but when scrolling very fast with Firefox or Safari, it prevents the old to be removed, so we
        // manually iterate through all of them to remove it first
        if (this.options['stackProductImages']) {
          this.slideshowNavDotsItems.forEach(function (item) {
            return item.classList.remove('is-selected');
          });
          
          var i = parseInt(event.detail.newTarget.getAttribute('data-media-position'));
          this.slideshowNavDotsItems[ i - 1].classList.add('is-selected');

          if (this.options['showThumbnails']) {
            this.slideshowNavThumbnailsItems.forEach(function (item) {
              return item.classList.remove('is-selected');
            });
            this.slideshowNavThumbnailsItems[parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1].classList.add('is-selected');
          }
        }
      }
    }, {
      key: "_imageNavClicked",
      value: function _imageNavClicked(event, target) {
        event.preventDefault();
        event.stopPropagation();

        this._slideWillChange();
       
        const targetImageID = target.getAttribute('href');
        const targetImage = this.productGalleryElement.querySelector(targetImageID);
        const imageContainer = this.productGalleryElement.parentElement
        const scrollPosition = targetImage.offsetTop;

        // Scroll the modal content to the target image
        //this.productGalleryElement.parentElement.scrollTop = scrollPosition;
        const animationDuration = 500;
        const startTime = performance.now();

        // Define the function for smooth scrolling animation
        function smoothScrollAnimation(currentTime) {
          const elapsedTime = currentTime - startTime;
          const scrollY = scrollPosition - imageContainer.scrollTop;
          const nextScrollPosition = scrollY * (-Math.cos(elapsedTime / animationDuration * Math.PI) + 1) + imageContainer.scrollTop; 
          imageContainer.scrollTop = nextScrollPosition;

          if (elapsedTime < animationDuration) {
            requestAnimationFrame(smoothScrollAnimation);
          }
        }

        requestAnimationFrame(smoothScrollAnimation);
      }
    }, {
      key: "_switchToImage",
      value: function _switchToImage(event, target) {
        event.preventDefault();

        this._slideWillChange();

        for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
          var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
              mediaId = parseInt(cellElement.getAttribute('data-media-id'));

          if (mediaId === parseInt(target.getAttribute('data-media-id'))) {
            this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
          }
        }
      }
      /**
       * Update the image gallery on variant change
       */
    }, {
      key: "_updateGallery",
      value: function _updateGallery(event) {

        if (this.productGalleryElement) {
          var view = 'gallery';
          if (this.options['view']) {
            view = this.options['view'];
          }
          var _this = this;
          var variant = event.detail.variant; 
          const url = window.location.origin + '/products/' + variant.productHandle + '?variant=' + variant.id + '&view=' + view;
          fetch(url)
          .then(response => response.text())
          .then(html => {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = html;
            const sectionHtml = tempElement.querySelector('.Product__Gallery');
            _this.productGalleryElement.innerHTML = sectionHtml.innerHTML;
            _this._initGallery();
            _this._setupDeviceFeatures();
          })
          .catch(error => {
              console.error('Failed to fetch gallery:', error);
          });
        }
      }
    }, {
      key: "_onImageChanged",
      value: function _onImageChanged(event, cell) {
        // If cell is video or model, we hide the action list
        if (Responsive.matchesBreakpoint('pocket')) {
          var productGalleryActionListElement = this.element.querySelector('.Product__Gallery .Product__ActionList');

          if (productGalleryActionListElement) {
            if (cell.classList.contains('Product__SlideItem--image')) {
              productGalleryActionListElement.classList.remove('is-hidden');
            } else {
              productGalleryActionListElement.classList.add('is-hidden');
            }
          }
        } // If we have non-stacked with thumbnails, update it


        if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
          var mediaId = cell.getAttribute('data-media-id');
          this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
            if (thumbnail.getAttribute('data-media-id') === mediaId) {
              thumbnail.classList.add('is-selected');
            } else {
              thumbnail.classList.remove('is-selected');
            }
          });
        }

        if (this._isWww4067Active()) {
          if (this.www4067ThumbStrip) {
            this._syncThumbnailStrip(cell.getAttribute('data-media-id'));
          }

          // On select rather than settle, so the video swiped away from stops at once
          this._syncSlideVideoPlayback(cell);
        } // If we have the mobile navigation, we also update it


        if (this.slideshowMobileNav) {
          var selectedIndex = parseInt(cell.getAttribute('data-media-position')) - 1; // The -1 is to make it 0 indexed

          Dom.nodeListToArray(this.slideshowMobileNav.querySelectorAll('.dot')).forEach(function (item, index) {
            if (index === selectedIndex) {
              item.classList.add('is-selected');
            } else {
              item.classList.remove('is-selected');
            }
          });
        }
      }
    }, {
      key: "_onImageSettled",
      value: function _onImageSettled(index, cell) {
        this._handleMedia(cell);

        if (Responsive.matchesBreakpoint('lap-and-up')) {
          var slides = this.element.querySelectorAll('.Product__SlideItem:not(.is-selected)');
          slides.forEach(function (slide) {
            slide.classList.add('Product__SlideItem--hidden');
          });
        }
      }
    }, {
      key: "_slideWillChange",
      value: function _slideWillChange() {
        if (Responsive.matchesBreakpoint('lap-and-up')) {
          var slides = this.element.querySelectorAll('.Product__SlideItem');
          slides.forEach(function (slide) {
            slide.classList.remove('Product__SlideItem--hidden');
          });
        }
      }
      /**
       * Verify when the screen size changes to create additional stuff on non pocket mode
       */
    }, {
      key: "_setupDeviceFeatures",
      value: function _setupDeviceFeatures(event) {

        var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null;

        if (currentBreakpoint === previousBreakpoint) {
          return; // Nothing has changed, no specific setup to do
        }

        if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
          if (this.carouselNavScrollSpy) {
            this.carouselNavScrollSpy.destroy();
          }

          if (this.productThumbnailsScroller) {
            this.productThumbnailsScroller.destroy();
          }

        } else {
          // 1st: scrollspy for the dots and image
          if (this.slideshowImages && this.slideshowImages.length > 1) {
            var offsetTop = 0;

            if (this.options['showThumbnails'] && Responsive.matchesBreakpoint('desk')) {
              offsetTop = 250;
            }

            this.carouselNavScrollSpy = new ScrollSpy(this.element, this.slideshowImages, {
              rootMargin: "-".concat(offsetTop, "px 0px 0px 0px")
            });
          }

          if (this.options['showThumbnails'] && this.slideshowNavThumbnails) {
            this.productThumbnailsScroller = new OverflowScroller(this.slideshowNavThumbnails);
          }
        }
      }
    }]);

    return ProductGallery;
  }();

  var ProductHintingModal = /*#__PURE__*/function () {
    function ProductHintingModal(container) {

      _classCallCheck(this, ProductHintingModal);

      this.element = container;
      this.delegateParentElement = new domDelegate.Delegate(this.element);

      this.modal = this.element.querySelector('#productHintingModal');

      if (!this.modal) {
        return;
      }

      this.delegateElement = new domDelegate.Delegate(this.modal);

      this.maxChars = 255;

      this.hintPreview = this.modal.querySelector('.hint-preview');
      this.hintDisplay = this.modal.querySelector('.hint-display');
      this.sizePreference = this.modal.querySelector('.size-preference');
      this.modalDialog = this.modal.querySelector('.modal-dialog');
      this.hintForm = this.modal.querySelector('.hint-form form');
      this.hintLink = this.element.querySelector('.send-hint');
      this.hintImage = this.modal.querySelector('.hint-product .product-image img');

      this._attachListeners();

      /* Auto open Hinting modal if url parameter is present */
      var urlParams = new URLSearchParams(window.location.search);
      var showhint = urlParams.get('showhint');
      if (showhint) {
        var modalInstance = bootstrap.Modal.getInstance(this.modal);
        if (modalInstance) {
          modalInstance.show();
        }
      }
    }

    _createClass(ProductHintingModal, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
 
        const tooltipTriggerList = this.element.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

        this.modal.addEventListener('shown.bs.modal', this._initModal.bind(this));
        this.modal.addEventListener('hidden.bs.modal', this._resetModal.bind(this));

        this.hintForm.addEventListener('submit', this._submitHint.bind(this));

        this.delegateElement.on('input', '#hintMessage', this._input.bind(this));
        this.delegateElement.on('keypress', '#hintMessage', this._keyPress.bind(this));

        this.delegateElement.on('click', '.preview-link', this._previewHint.bind(this));
        this.delegateElement.on('click', '.preview-back', this._backToHint.bind(this));

        this.delegateParentElement.on('variant:changed', this._updateHintLink.bind(this));
      }
    }, {
      /**
       *  Clearing/setting of session storage variables on modal open
       */
      key: "_initModal",
      value: function _initModal(event) {

        this.sizePreference.innerHTML = '';
        this.hintForm.reset();

        this.plpImage = this.hintLink.getAttribute('data-image');
        this.hintImage.setAttribute('src', this.plpImage);
        
        this.variantId = this.hintLink.getAttribute('data-pid');

        this.canMonogram = this.hintLink.getAttribute('data-monogram');
        if (this.canMonogram == "true") {
          var monoNote = this.element.querySelector('.mono_note');
          if (monoNote) {
            monoNote.classList.remove('d-none');
          }
        }

        this.productName = this.element.querySelector('.ProductMeta__Title').innerHTML;
        var productNameElement = this.modal.querySelector('.hint-product .product-name');
        productNameElement.innerHTML = this.productName;

        var sizeAttributes = this.element.querySelector('.SizeSwatchList:not(.OptionLinks)');
        if (sizeAttributes && sizeAttributes.innerHTML.trim() !== '') { 
          var parentDiv = sizeAttributes.parentElement;
          var clonedSizeAttribute = parentDiv.cloneNode(true);
          this.sizePreference.innerHTML = '<span class="size non-input-label">Preferred Size</span>';
          this.sizePreference.appendChild(clonedSizeAttribute);
        }

        this.hintPreview.innerHTML = '';
        this.hintDisplay.classList.remove('preview');

        this.modalDialog.classList.remove('hint-sent');

        var preferedColorText = '';
        this.productColor = 'NA';
        var colorAttribute = this.element.querySelector('.ProductForm__SelectedValue');
        
        if (colorAttribute !== null) {
            this.productColor = colorAttribute.innerHTML;
            preferedColorText = 'Preferred Color: ' + this.productColor;
        }

        var preferedSizeText = '';
        this.productSize = 'NA';
        var sizeAttribute = this.element.querySelector('.SizeSwatch__Radio[checked]');

        if (sizeAttribute !== null) {
            this.productSize = sizeAttribute.getAttribute('value');
            preferedSizeText = 'Preferred Size: <span id="preferedSize">' + this.productSize + '</span>';
        }

        var productAttributesContainer = this.modal.querySelector('.hint-product .product-attributes');
        productAttributesContainer.innerHTML = preferedColorText + '<br/>' + preferedSizeText;
      }
    }, {
      /**
       *  Clearing DOM settings of modal for clean view if reopend
       */
      key: "_resetModal",
      value: function _resetModal(event) {
        this.sizePreference.innerHTML = '';
      }
    }, {
      /**
       *  Input
       */
      key: "_input",
      value: function _input(event) {
        this._updateMessageCounter(event.target);
        var value = event.target.value.trim().replace(/(?:\r\n|\r|\n)/g, '<br/>');
        this.hintPreview.innerHTML = value;
      }
    }, {
      /**
       *  Key Press
       */
      key: "_keyPress",
      value: function _keyPress(event) {
        var regex = /^[a-zA-Z0-9~!@#$%^&*()\-+='":;.,? ]+$/;
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key) && !(event.keyCode == KEY_ENTER || event.keyCode == KEY_BACKSPACE)) {
            event.preventDefault();
            return false;
        }
      }
    }, {
      /**
       *  Show the Hint
       */
      key: "_backToHint",
      value: function _backToHint(event) {
        event.preventDefault();
        event.stopPropagation();
        var hintDisplay = this.modal.querySelector('.hint-display');
        if (hintDisplay) {
          hintDisplay.classList.remove('preview');
        }
      }
    }, {
      /**
       *  Preview the Hint
       */
      key: "_previewHint",
      value: function _previewHint(event) {
        event.preventDefault();

        window.scrollTo(0, 0);

        var formValid = true;
        var yourEmail = this.modal.querySelector('input[name="yourEmail"]');
        var yourName = this.modal.querySelector('input[name="yourName"]');
        var name = this.modal.querySelector('input[name="recipientName"]');
        var email = this.modal.querySelector('input[name="recipientEmail"]');
        var hintMessage = this.modal.querySelector('textarea[name="hintMessage"]');

        if (!_validEmailAddress(yourEmail.value.trim())) {
            yourEmail.classList.add('is-invalid');
            yourEmail.nextElementSibling.textContent = 'Please enter a valid email.';
            formValid = false;
        }

        if (!yourName.value.trim()) {
            yourName.classList.add('is-invalid');
            yourName.nextElementSibling.textContent = 'Please fill out this field.';
            formValid = false;
        }

        if (!_validEmailAddress(email.value.trim())) {
            email.classList.add('is-invalid');
            email.nextElementSibling.textContent = 'Please enter a valid email.';
            formValid = false;
        }

        if (!name.value.trim()) {
          name.classList.add('is-invalid');
          name.nextElementSibling.textContent = 'Please fill out this field.';
          formValid = false;
        }

        if (!hintMessage.value.trim()) {
            hintMessage.classList.add('is-invalid');
            hintMessage.nextElementSibling.textContent = 'Please fill out this field.';
            formValid = false;
        }

        if (!formValid) {
            return;
        }

        var hintDisplay = this.modal.querySelector('.hint-display');
        hintDisplay.classList.add('preview');

      }
    }, {
      /**
       * Submit Hint
       */
      key: "_submitHint",
      value: function _submitHint(event) {
        event.preventDefault();
        var _this = this;
        var formValid = true;
        var btn = this.modal.querySelector('.btn-send-hint');
        var yourEmail = this.modal.querySelector('input[name="yourEmail"]').value.trim();
        var yourName = this.modal.querySelector('input[name="yourName"]').value.trim();
        var name = this.modal.querySelector('input[name="recipientName"]').value.trim();;
        var email = this.modal.querySelector('input[name="recipientEmail"]').value.trim();;
        var hintMessage = this.modal.querySelector('textarea[name="hintMessage"]').value.trim();
        const currentURL = window.location.href;

        if (!_validEmailAddress(yourEmail) || !_validEmailAddress(email)) {
            formValid = false;
        }

        if (!formValid) {
            return;
        }

        // Set up the request options
        var requestOptions = {
          method: 'POST',
          headers: { 
            accept: 'application/json',
            revision: '2025-04-15',
            "Content-Type": "application/json"
          }
        };

        var hintRecieverData = {
          "data": {
            "type": "event",
            "attributes": {
              "properties": {
                "Hint Sender Email": String(yourEmail),
                "Hint Sender Name": String(yourName),
                "Recipient Name": String(name),
                "Hint Recipient": String(email),
                "Hint Message": String(hintMessage),
                "Product": String(this.productName),
                "Product Color": String(this.productColor),
                "Product Size": String(this.productSize),
                "Product Url": String(currentURL),
                "Product Image Url": String(this.plpImage),
                "Variant ID": String(this.variantId)
              },
              "metric": {
                "data": {
                  "type": "metric",
                  "attributes": {
                    "name": "Received Hint"
                  }
                }
              },
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": String(email),
                  }
                }
              }
            }
          }
        };

        var hintSenderData = {
          "data": {
            "type": "event",
            "attributes": {
              "properties": {
                "Hint Sender Email": String(yourEmail),
                "Hint Sender Name": String(yourName),
                "Recipient Name": String(name),
                "Hint Recipient": String(email),
                "Hint Message": String(hintMessage),
                "Product": String(this.productName),
                "Product Color": String(this.productColor),
                "Product Size": String(this.productSize),
                "Product Url": String(currentURL),
                "Product Image Url": String(this.plpImage),
                "Variant ID": String(this.variantId)
              },
              "metric": {
                "data": {
                  "type": "metric",
                  "attributes": {
                    "name": "Sent Hint"
                  }
                }
              },
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": String(yourEmail)
                  }
                }
              }
            }
          }
        };

        var mainListData = {
          "data": {
            "type": "subscription",
            "attributes": {
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": yourEmail,
                    "subscriptions": {
                      "email": {
                        "marketing": {
                          "consent": "SUBSCRIBED",
                          "consented_at": new Date().toISOString()
                        }
                      }
                    }
                  }
                }
              },
              "custom_source": "Sent a Hint"
            },
            "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": KLAVIYO_LIST_ID
                }
              }
            }
          }
        };

        var mainListRequestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision": "2025-04-15"
          },
          body: JSON.stringify(mainListData),
          redirect: 'follow'
        };

        // Disable the submit button
        btn.disabled = true;

        requestOptions.body = JSON.stringify(hintRecieverData);
        fetch("https://a.klaviyo.com/client/events/?company_id="+KLAVIYO_PUBLIC_KEY, requestOptions)
          .then(response => {
            if (response.status !== 202) {
              console.log(response);
            }
            if (response.status === 202) {
              // Success
              var sentMsg = _this.modal.querySelector('.sent-confirmation .message');
              var messageData = sentMsg.getAttribute('data-msg');
              sentMsg.textContent = messageData.replace("{{ recipient }}", name);
              _this.modal.querySelector('.modal-dialog').classList.add('hint-sent');
              var animationElement = _this.modal.querySelector('.modal-dialog .sent-confirmation .animation');
              if (animationElement) {
                setTimeout(() => {
                  animationElement.classList.add('animate');
                }, 100);
              }
              btn.disabled = false;
              return null; // No JSON to parse, so we return null
            }
          })
          .catch(err => console.error(err));

        requestOptions.body = JSON.stringify(hintSenderData);
        // Make the AJAX call to Klaviyo for back in stock
        fetch("https://a.klaviyo.com/client/events/?company_id="+KLAVIYO_PUBLIC_KEY, requestOptions)
          .then(response => {
            if (response.status !== 202) {
              console.log(response);
            }
            if (response.status === 202) {
              // The user was successfully subscribed to back in stock, now subscribe to main list   
              return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_PUBLIC_KEY, mainListRequestOptions);
            } else {
              // There was an error subscribing the user to back in stock
              throw new Error('Error subscribing user to back in stock');
            }
          })
          .then(response => {
              if (response.status === 202) {
                  // Success
                  return null; // No JSON to parse, so we return null
              } else {
                // For all other statuses, we expect JSON
                return response.json().then(result => {
                    // If the response was an error, we throw it to be caught in the catch block
                    throw result;
                });
            }
          })
          .catch(error => {
            // There was an error making the requests
            console.error('Error subscribing user to main list: ', error);
          });
      }
    }, {
      /**
       *  Update PDP Send a Hint link to visible or not
       */
      key: "_updateHintLink",
      value: function _updateHintLink(event) {
        var previousVariant = event.detail.previousVariant; 
        var newVariant = event.detail.variant; 

        if (newVariant['available']) {
          this.hintLink.classList.remove('d-none');
        } else {
          this.hintLink.classList.add('d-none');
        }

        this.variantId = newVariant['id'];
        this.hintLink.setAttribute('data-pid', this.variantId);

        this.canMonogram = (newVariant['monogramming']) ? "true" : "false";
        this.hintLink.setAttribute('data-monogram', this.canMonogram);

        var preferedSize =  this.modal.querySelector('#preferedSize');
        if (preferedSize) {
          if (Array.isArray(previousVariant.options)) {
            var index = previousVariant.options.indexOf(preferedSize.innerHTML);
            this.productSize = newVariant.options[index];
          } else {
            this.productSize = newVariant.option1;
          }
          preferedSize.innerHTML = this.productSize;
        }

        if (newVariant['plp_image']) {
          this.hintLink.setAttribute('data-image', newVariant['plp_image']);
        }
      }
    }, {
      /**
       *  Update PDP Send a Hint link to visible or not
       */
      key: "_updateMessageCounter",
      value: function _updateMessageCounter(textBox, updateDisplay = true) {
        var chars = textBox.value.trim().replace(/(?:\r\n|\r|\n|<br\/>)/g, ' ').length;
        var charsLeft = this.maxChars - chars;

        if (updateDisplay) {
            textBox.closest('.message-input').setAttribute('data-count', charsLeft);
        }

        if (chars <= this.maxChars) {
            return true;
        } else {
            return false;
        }
      }
    }]);

    return ProductHintingModal;
  }();
  
  var StickyBottomButtons = /*#__PURE__*/function () {
    function StickyBottomButtons(container) {
      _classCallCheck(this, StickyBottomButtons);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);

      // Create Drawer
      if (!document.querySelector('#sticky-drawer')) {
        var stickyDrawer = document.createElement('div');
        stickyDrawer.id = 'sticky-drawer';

        document.querySelector('.ProductForm').appendChild(stickyDrawer);
      }
      this.drawer = document.querySelector('#sticky-drawer');

      var proofBannerSection = document.querySelector('.proofBanner .proof-wrapper');
      if (proofBannerSection) {
        this.drawer.style.bottom = '48px';
      }

      this._updateStickyDrawer();
      this._attachListeners();
    }

    _createClass(StickyBottomButtons, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
        this.io.destroy();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {

        this.delegateElement.on('variant:changed', this._updateStickyDrawer.bind(this));

        this.delegateElement.on('click', '#sticky-drawer button.btn-join-waitlist', this._scrollToWaitList.bind(this));

        window.addEventListener('scroll', this._onScrollResizeListener.bind(this));
        window.addEventListener('resize', this._onScrollResizeListener.bind(this));
      }
      /**
       * Show/Hide the sticky drawer based on location
       */
    }, {
      key: "_onScrollResizeListener",
      value: function _onScrollResizeListener(event) {
        event.preventDefault();

        var PpdCtaButtons = this.element.querySelector('.ProductForm__CTA');

        if (PpdCtaButtons && PpdCtaButtons?.getBoundingClientRect().bottom <= 100) {
          this.drawer.classList.add('active');
          document.body.classList.add('sticky-drawer-open');
        } else {
          this.drawer.classList.remove('active');
          document.body.classList.remove('sticky-drawer-open');
        }
      }
      /**
       * Scroll the window to the waitlist from
       */
    }, {
      key: "_scrollToWaitList",
      value: function _scrollToWaitList(event) {
        event.preventDefault();
        var scrollTo = document.querySelector('div.join-waitlist').getBoundingClientRect().top + window.scrollY - (window.innerHeight / 2);
        window.scrollTo({
            top: scrollTo,
            behavior: 'smooth'
        });
        document.querySelector('div.join-waitlist button.btn-join-waitlist').click();
      }
      /**
       * Clone the buttons to the new sticky drawer
       */
    }, {
      key: "_updateStickyDrawer",
      value: function _updateStickyDrawer(event) {
        this.drawer.innerHTML = '';

        var PdpButtonConfigurator = this.element.querySelector('button.ProductForm__Configurator');
        var PdpButtonBundlinator = this.element.querySelector('button.ProductForm__Bundlinator');
        var PdpButtonCuyDrawer = this.element.querySelector('button.ProductForm__CuyDrawer');
        var PdpButtonMonogramming = null; //this.element.querySelector('button.ProductForm__Monogramming');
        var pdpButtonAddToCart = this.element.querySelector('button.ProductForm__AddToCart');
        var pdpWaitList = this.element.querySelector('.ProductForm__WaitList');

        var showBuyButtons = true;
        if (pdpWaitList) {
          showBuyButtons = pdpWaitList.classList.contains('d-none')
        }

        var newRow = document.createElement('div');
        newRow.className = 'row no-gutters';
        
        if(showBuyButtons) {

          var newColumn = document.createElement('div');
          newColumn.className = 'col-12 sticky-atb-btn-wrap';

          // Clone Product Configurator Customize Button
          if (PdpButtonConfigurator) {
            var customizeColumn = newColumn; //.cloneNode();
            customizeColumn.appendChild(PdpButtonConfigurator.cloneNode(true));
            newRow.appendChild(customizeColumn);
          }

          // Clone Product Bundlinator Customize Button
          if (PdpButtonBundlinator) {
            var customizeColumn = newColumn; //.cloneNode();
            customizeColumn.appendChild(PdpButtonBundlinator.cloneNode(true));
            newRow.appendChild(customizeColumn);
          }

          // Clone Cuy Drawer Configurator (V3) Customize Button
          if (PdpButtonCuyDrawer) {
            var customizeColumn = newColumn; //.cloneNode();
            customizeColumn.appendChild(PdpButtonCuyDrawer.cloneNode(true));
            newRow.appendChild(customizeColumn);
          }

          // Clone Monograming Button
          if (PdpButtonMonogramming && (PdpButtonConfigurator && PdpButtonConfigurator.classList.contains('d-none'))) {
            var customizeColumn = newColumn; //.cloneNode();
            customizeColumn.appendChild(PdpButtonMonogramming.cloneNode(true));
            newRow.appendChild(customizeColumn);
          }
          // Clone ATB Button
          if (pdpButtonAddToCart) {
            var atbColumn = document.createElement('div');
            atbColumn.className = 'col-12 sticky-atb-btn-wrap';

            var atbBtn = pdpButtonAddToCart.cloneNode(true);
            if (pdpButtonAddToCart.classList.contains('d-none')) {
                atbColumn.classList.add('d-none');
                atbBtn.classList.remove('d-none');
            }

            atbColumn.appendChild(atbBtn);

            var preOrderElement = this.element.querySelector('.ProductForm__CTA .preorder-info ');
            if (preOrderElement) {
              var preOrderInfo = preOrderElement.cloneNode(true);
              atbColumn.appendChild(preOrderInfo);
            }
            newRow.appendChild(atbColumn);
          }
        }

        // Create Waitlist Button
        var joinWaitlistForm = this.element.querySelector('.ProductForm__WaitList');
        if (joinWaitlistForm) {
          var soldOutSunsetEl = joinWaitlistForm.querySelector('.ProductForm__SoldOutSunset');
          var isSunsettedSticky = soldOutSunsetEl && !soldOutSunsetEl.classList.contains('d-none');
          var waitListButton;
          if (isSunsettedSticky) {
            waitListButton = '<div class="col-12"><button class="btn btn-secondary w-100' + (joinWaitlistForm.classList.contains('d-none') ? ' d-none' : '') + '" disabled>Sold Out</button></div>';
          } else {
            var jwWrapper = this.element.querySelector('#jwWrapper');
            var stickyLabel = jwWrapper && jwWrapper.getAttribute('data-pre-launch') === 'true' ? window.languages.productFormEarlyAccess : window.languages.productFormWaitlist;
            waitListButton = '<div class="col-12"><button class="btn-join-waitlist btn btn-secondary w-100' + (joinWaitlistForm.classList.contains('d-none') ? ' d-none' : '') + '">' + stickyLabel + '</button></div>';
          }
          newRow.innerHTML += waitListButton;
        }

        this.drawer.appendChild(newRow);
        
      }
    }]);

    return StickyBottomButtons;
  }();

  var ProductSection = /*#__PURE__*/function () {
    function ProductSection(container) {
      var _this = this;

      _classCallCheck(this, ProductSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '[]');
      this.viewInSpaceElement = this.element.querySelector('[data-shopify-xr]');
      this.productVariants = new ProductVariants(container, this.options);
      this.waitlistSection =  new WaitListSection(container);
      this.productReviews = new ProductReviews(container);
      this.productSystems = new ProductSystemsSection(container);
      this.productHintingModal =  new ProductHintingModal(container); 
      this.stickyBottomButtons = new StickyBottomButtons(this.element);

      this.configuratorModal = document.querySelector('#productConfiguratorModal');
      this.bundlinatorModal = document.querySelector('#bundlinatorModal');
      this.cuyDrawerBody = document.querySelector('[data-section-type="cuy-drawer-configurator"] .cuy-drawer-body');

      this.monogrammingModal = document.querySelector('#monogrammingModal');
      if (this.monogrammingModal ) {
        this.productMonogramming = new ProductMonogrammingSection(this.monogrammingModal);
      }

      this.accessoriesDiv = this.element.querySelector('#accessoriesContent');
      this.productWrapperElement = this.element.querySelector('.Product__Wrapper');
      this.productInfoElement = this.element.querySelector('.Product__Info');
      this.productAsideElement = this.element.querySelector('.Product__Aside');
      this.productGalleryElement = this.element.querySelector('.Product__Gallery');
      this.quickNav = this.element.querySelector('.Product__QuickNav');

      if (this.productGalleryElement) {
        this.productGallery = new ProductGallery(this.element, this.options);
      }

      if (this.productInfoElement) {
        Stickyfill.addOne(this.productInfoElement); // We have to re-order elements in the DOM
      }
      
      var offscreenElement = this.element.querySelector('.Product__OffScreen');

      if (offscreenElement) {
        this.element.appendChild(offscreenElement);
      }

      if (this.productInfoElement) {
        this._setupDeviceFeatures();
      }

      this._attachListeners();

      this._autoOpenConfigurator();

      document.addEventListener('DOMContentLoaded', function() {
        var video = _this.element.querySelector('video');
        if (video) {
          // Autoplay can be rejected (iOS Low Power Mode, in-app browsers).
          video.play().catch(function() {});
        }
      });
    }

    _createClass(ProductSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
        this.productReviews.destroy();

        if (this.productVariants) {
          this.productVariants.destroy();
        }

        if (this.quickNav) {
          window.removeEventListener('scroll', this._checkQuickNavListener);
        }

        if (this.productInfoScroller) {
          this.productInfoScroller.destroy();
        }

        if (window.ResizeObserver && this.productInfoResizeObserver) {
          this.productInfoResizeObserver.disconnect();
        }

        Stickyfill.removeOne(this.productInfoElement);
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      /**
       *  When the PDP is reached via ?customize=1 (e.g. the Quick View
       *  "Customize" button), auto-open the configurator the visitor is
       *  assigned to. GrowthBook decides which of the three trigger buttons is
       *  shown by adding `d-none` to the other two asynchronously, so we wait
       *  until exactly one is visible, then click it (each button opens its own
       *  configurator variant). If GrowthBook never resolves to a single button
       *  (experiment absent) we fall back to the first visible one (V1 control).
       */
      key: "_autoOpenConfigurator",
      value: function _autoOpenConfigurator() {
        var params = new URLSearchParams(window.location.search);
        if (!params.get('customize')) {
          return;
        }

        var buyButtons = this.element.querySelector('.ProductForm__BuyButtons');
        if (!buyButtons) {
          return;
        }

        var candidates = Array.prototype.slice.call(buyButtons.querySelectorAll(
          '.ProductForm__Configurator, .ProductForm__Bundlinator, .ProductForm__CuyDrawer'
        ));
        if (!candidates.length) {
          return;
        }

        var done = false;
        var observer = null;
        var timeoutId = null;

        var visible = function visible() {
          return candidates.filter(function (btn) {
            return !btn.classList.contains('d-none');
          });
        };

        var open = function open(btn) {
          if (done || !btn) {
            return;
          }
          done = true;
          if (observer) {
            observer.disconnect();
          }
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          btn.click();
        };

        // GrowthBook may have already resolved to a single visible button.
        var current = visible();
        if (current.length === 1) {
          open(current[0]);
          return;
        }

        if (window.MutationObserver) {
          observer = new MutationObserver(function () {
            var v = visible();
            if (v.length === 1) {
              open(v[0]);
            }
          });
          candidates.forEach(function (btn) {
            observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
          });
        }

        // Ceiling: if GrowthBook never narrows to one, open the first visible
        // button (falls back to the V1 control) so the shopper still lands in a
        // configurator. If none are visible (e.g. sold out) do nothing, but
        // still tear down the observer so a later variant change can't trigger a
        // spurious auto-open long after page load.
        timeoutId = setTimeout(function () {
          if (done) {
            return;
          }
          done = true;
          if (observer) {
            observer.disconnect();
          }
          var fallback = visible()[0];
          if (fallback) {
            fallback.click();
          }
        }, 1000);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
        this._checkQuickNavListener = this._checkQuickNav.bind(this);
        this.delegateElement.on('click', '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this));
        
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);

        if (this.configuratorModal) {
          this.delegateElement.on('variant:changed', this._updateConfiguratorModal.bind(this));
        }

        if (this.bundlinatorModal) {
          this.delegateElement.on('variant:changed', this._updateBundlinatorModal.bind(this));
        }

        if (this.cuyDrawerBody) {
          this.delegateElement.on('variant:changed', this._updateCuyDrawerBody.bind(this));
        }

        if (this.monogrammingModal) {
          this.delegateElement.on('variant:changed', this._updateMonogrammingModal.bind(this));

          // www-2248 Systems project move mono to minicart A/B test
          // this is populate the monograming modal on initial page load.
          var event = { detail: {variant: this.productVariants.currentVariant }};
          this._updateMonogrammingModal(event);
        }

        if (this.quickNav) {
          window.addEventListener('scroll', this._checkQuickNavListener);
        }

        if(this.accessoriesDiv) {
          this.delegateElement.on('variant:changed', this._updateAccessoriesAccordion.bind(this));
        }
      }

      /**
       * Update the PDP accessories accordion on variant change
       */
    }, {
      key: "_updateAccessoriesAccordion",
      value: function _updateAccessoriesAccordion(event) {
        var variant = event.detail.variant; 
        const url = window.location.pathname + '?variant=' + variant.id + '&view=accessories';
        var accessoriesDiv = this.accessoriesDiv;
        if (accessoriesDiv) {
          fetch(url)
          .then(response => response.text())
          .then(html => {
              const tempElement = document.createElement('div');
              tempElement.innerHTML = html;
              const tempAccordionItem = tempElement.querySelector('.accordion-item.accessories');
              const accordionItem = document.querySelector('.accordion-item.accessories');
              if (tempAccordionItem.classList.contains('d-none')) {
                  accordionItem.classList.add('d-none');
              } else {
                  accordionItem.classList.remove('d-none');
              }
              accessoriesDiv.innerHTML = tempElement.querySelector('#accessoriesContent').innerHTML;
          })
          .catch(error => {
              console.error('Failed to fetch accessories content:', error);
          });
        }
      } 
      /**
       * Update Monograming Modal on PDP variant change
       */
    }, {
      key: "_updateMonogrammingModal",
      value: function _updateMonogrammingModal(event) {

        var variant = event.detail.variant; 
        this.productMonogramming._updateMonogrammingModal(variant)

      }
      /**
       * Update the Configurator Modal body on PDP variant change
       */
    }, {
      key: "_updateConfiguratorModal",
      value: function _updateConfiguratorModal(event) {
        var _this = this;
        // Ignore variant:changed events from inside the configurator modal (addon detail variant picks).
        if (event.target.closest('#productConfiguratorModal')) return;
        const modalBody = this.configuratorModal.querySelector('.modal-body');
        if (modalBody) {
            var variant = event.detail.variant;
            const url = window.location.pathname + '?variant=' + variant.id + '&view=configurator-modal';
            fetch(url)
            .then(response => response.text())
            .then(html => {
              const tempElement = document.createElement('div');
              tempElement.innerHTML = html;
              const sectionHtml = tempElement.querySelector('.shopify-section').innerHTML;
              modalBody.innerHTML = sectionHtml;
            })
            .catch(error => {
                console.error('Failed to fetch configurator modal content:', error);
            });
        }
      }
    }, {
      key: "_updateBundlinatorModal",
      value: function _updateBundlinatorModal(event) {
        // Ignore variant:changed events from inside the bundlinator modal (addon detail variant picks).
        if (event.target.closest('#bundlinatorModal')) return;
        var modalBody = this.bundlinatorModal.querySelector('.modal-body');
        if (modalBody) {
          var variant = event.detail.variant;
          var url = window.location.pathname + '?variant=' + variant.id + '&view=bundlinator-modal';
          fetch(url)
            .then(function(response) { return response.text(); })
            .then(function(html) {
              var tempElement = document.createElement('div');
              tempElement.innerHTML = html;
              var sectionHtml = tempElement.querySelector('.shopify-section');
              if (sectionHtml) { modalBody.innerHTML = sectionHtml.innerHTML; }
            })
            .catch(function(error) {
              console.error('Failed to fetch bundlinator modal content:', error);
            });
        }
      }
    }, {
      key: "_updateCuyDrawerBody",
      value: function _updateCuyDrawerBody(event) {
        var _this = this;
        // Ignore variant:changed events that originate from inside the cuy-drawer
        // addon detail panel — those are addon variant selections, not PDP variant changes.
        // Without this guard the cuy-drawer body would be re-fetched and re-rendered
        // whenever the user picks a size/color in an addon detail, wiping selected-card state.
        if (event.target.closest('[data-section-type="cuy-drawer-configurator"]')) return;
        if (this.cuyDrawerBody) {
          var variant = event.detail.variant;
          var url = window.location.pathname + '?variant=' + variant.id + '&view=cuy-drawer-modal';
          fetch(url)
            .then(function(response) { return response.text(); })
            .then(function(html) {
              var tempElement = document.createElement('div');
              tempElement.innerHTML = html;
              var sectionHtml = tempElement.querySelector('.shopify-section');
              if (sectionHtml) {
                _this.cuyDrawerBody.innerHTML = sectionHtml.innerHTML;
                // Notify the cuy-drawer section so it can re-init slider scroll/drag listeners,
                // which were lost when innerHTML wiped the original slider nodes.
                _this.cuyDrawerBody.dispatchEvent(new CustomEvent('cuy-drawer:body-rerendered', { bubbles: true }));
              }
            })
            .catch(function(error) {
              console.error('Failed to fetch cuy-drawer body content:', error);
            });
        }
      }
      /**
       * Check the quick nav
       */
    }, {
      key: "_checkQuickNav",
      value: function _checkQuickNav() {
        var _this3 = this;

        var showAsideQuickNav = false;
        fastdom.measure(function () {
          showAsideQuickNav = window.scrollY >= _this3.productAsideElement.offsetTop - _this3.productAsideElement.clientHeight;
        });
        fastdom.mutate(function () {
          if (showAsideQuickNav) {
            _this3.quickNav.classList.add('is-flipped');
          } else {
            _this3.quickNav.classList.remove('is-flipped');
          }
        });
      }
      /**
       * Toggle the social share icons
       */
    }, {
      key: "_toggleSocialShare",
      value: function _toggleSocialShare(event, target) {
        target.classList.toggle('is-active');
        target.classList.toggle('RoundButton--secondaryState');
        target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        target.nextElementSibling.setAttribute('aria-hidden', target.nextElementSibling.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }
    }, {
      key: "_setupDeviceFeatures",
      value: function _setupDeviceFeatures(event) {
        var _this4 = this;

        var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null;

        if (currentBreakpoint === previousBreakpoint) {
          return; // Nothing has changed, no specific setup to do
        }

        if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {

          if (this.productInfoScroller) {
            this.productInfoScroller.destroy();
          }

          if (this.productAsideElement) {
            this.productAsideElement.style.minHeight = null;
          } else {
            this.productWrapperElement.style.minHeight = null;
          }

          this.productInfoElement.parentNode.style.maxHeight = null;
        } else {

          var productInfoStyles = window.getComputedStyle(this.productInfoElement),
              productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
              productGalleryHeight = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0; // 2nd: making sure to set up enough space in aside part

          var calculateMinHeight = function calculateMinHeight() {
            if (_this4.productAsideElement) {
              _this4.productAsideElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - productInfoPadding - productGalleryHeight, "px");
              _this4.productInfoElement.closest('.Product__InfoWrapper').style.maxHeight = _this4.productAsideElement.offsetTop + _this4.productInfoElement.scrollHeight - productInfoPadding + 'px';
            } else {
              _this4.productWrapperElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop), "px");
            }
          };

          calculateMinHeight(); // This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
          // will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
          // but I feel it's already good to have a clean fix

          if (window.ResizeObserver) {
            this.productInfoResizeObserver = new ResizeObserver(function () {
              calculateMinHeight(); // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
            });
            this.productInfoResizeObserver.observe(this.productInfoElement);
          } // 3rd: let's handle the scroll for the product info

          this.productInfoScroller = new OverflowScroller(this.productInfoElement); // 4th: let's handle the scroll for the thumbnails

        }
      }
    },]);

    return ProductSection;
  }();

  var ProductQuickViewSection = /*#__PURE__*/function () {
    function ProductQuickViewSection(container) {

      _classCallCheck(this, ProductQuickViewSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '[]');
      this.modal = document.querySelector('#quickViewModal');

      this.options.modalDisplay = true;
      this.options.showThumbnails = true;

      this._attachListeners();
    }

    _createClass(ProductQuickViewSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.productVariants) {
          this.productVariants.destroy();
        }

        if (this.productGallery) {
          this.productGallery.onUnload();
        }

      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {

        this.modal.addEventListener('shown.bs.modal', this._initModal.bind(this));
        this.modal.addEventListener('hide.bs.modal', this._hideModal.bind(this));
        this.delegateElement.on('product:added', this._hideModal.bind(this));
        this.delegateElement.on('click', '[data-quickview-customize]', this._onCustomizeClick.bind(this));
      }
    }, {
      /**
       *  Deep-link to the PDP with the configurator auto-opening (respecting the
       *  visitor's GrowthBook-assigned variant via the ?customize=1 handler).
       */
      key: "_onCustomizeClick",
      value: function _onCustomizeClick(event, target) {
        event.preventDefault();

        var productUrl = target.getAttribute('data-product-url');
        if (!productUrl) {
          return;
        }

        var variantId = this.productVariants && this.productVariants.currentVariant
          ? this.productVariants.currentVariant.id
          : null;

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'cuyana_customize_btn_click',
            source: 'quickview'
          });
        }

        var url = variantId
          ? productUrl + '?variant=' + variantId + '&customize=1'
          : productUrl + '?customize=1';

        window.location.assign(url);
      }
    }, {
      /**
       *  Get the modal body for the product quickview is being opened for
       */
      key: "_initModal",
      value: function _initModal(event) {
        event.preventDefault();

        var target = event.relatedTarget;
        var variant_id = target.getAttribute('data-pid');
        this.productHandle = target.getAttribute('data-product');
        var _this = this;

        const url = window.location.origin + '/products/' + this.productHandle + '?variant=' + variant_id + '&view=quickview';
        fetch(url)
          .then(response => response.text())
          .then(html => {
            var modalBody = _this.modal.querySelector('.modal-body');
            const tempElement = document.createElement('div');
            tempElement.innerHTML = html;
            modalBody.innerHTML = tempElement.querySelector('.shopify-section').innerHTML;

            checkPrivateSale();

            // Destroy previous instances to prevent duplicate event listeners
            if (_this.productVariants) {
              _this.productVariants.destroy();
            }
            if (_this.waitlistSection) {
              _this.waitlistSection.destroy();
            }
            if (_this.productGallery) {
              _this.productGallery.onUnload();
            }

            _this.productVariants = new ProductVariants(modalBody, _this.options);
            _this.waitlistSection =  new WaitListSection(modalBody);
            _this.productGalleryElement = modalBody.querySelector('.Product__Gallery');

            if (_this.productGalleryElement) {
              _this.productGallery = new ProductGallery(modalBody, _this.options);
            }
        })
        .catch(error => {
          console.error('Failed to fetch product quickview modal content:', error);
        });
      }
    }, {
      /**
       *  Close the modal
       */
      key: "_hideModal",
      value: function _hideModal(event) {
        var modalInstance = bootstrap.Modal.getInstance(this.modal);
        if (modalInstance) {
          // If triggered by product:added event, close the modal
          // (user added product to cart, so dismiss the quickview)
          if (event && event.type === 'product:added') {
            modalInstance.hide();
          }
          var modalBody = this.modal.querySelector('.modal-body');
          modalBody.innerHTML = ''; // Clear immediately
        }
      }
    }]);

    return ProductQuickViewSection;
  }();

  var ProductConfiguratorSection = /*#__PURE__*/function () {
    function ProductConfiguratorSection(container) {
      var _this = this;

      _classCallCheck(this, ProductConfiguratorSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.modal = this.element.querySelector('#productConfiguratorModal');

      this.addOnProductSection = this.modal.querySelector('.prdsys-addon-product');

      const exclusionElement = this.element.querySelector('[data-cex-json]');
      if (exclusionElement && exclusionElement.innerHTML.trim() !== '') {
        this.exclusions = JSON.parse(exclusionElement.innerHTML);
      }

      /* Auto open configurator modal if url parameter is present. Skipped for the
         portable (off-PDP) instance, which has no product body until a launcher
         injects one — auto-opening it empty would crash _initModal. */
      var urlParams = new URLSearchParams(window.location.search);
      var showconfig = urlParams.get('showconfig');
      if (showconfig && !this.element.hasAttribute('data-configurator-portable')) {
        this.selectionsTemp = null;
        this.selectionsFinal = null;
        bootstrap.Modal.getOrCreateInstance(this.modal).show();
      }

      // Monogramming product data. The PDP instance fetches it eagerly on load
      // (unchanged). The portable (off-PDP) instance renders on every non-product
      // page, so it defers the fetch to the first modal open — avoiding two extra
      // product-JSON requests on every site-wide page view when no one opens it.
      _this.monogramVariants = false;
      if (!this.element.hasAttribute('data-configurator-portable')) {
        this._loadMonogramVariants();
      }

      this._attachListeners();
    }

    _createClass(ProductConfiguratorSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.productVariants) {
          this.productVariants.destroy();
        }
      }
    }, {
      /**
       *  Fetch the monogramming product data. Runs at most once per instance.
       */
      key: "_loadMonogramVariants",
      value: function _loadMonogramVariants() {
        if (this._monoRequested) return;
        this._monoRequested = true;
        var _this = this;
        var monogrammingDataUrl = window.location.origin + '/products/mono-service.json';
        fetch(monogrammingDataUrl)
          .then(response => response.text())
          .then(html => {
            var monogramProductA = html.trim() ? JSON.parse(html) : {};
            fetch(window.location.origin + '/products/mono-service-both-cases.json')
              .then(response => response.text())
              .then(html => {
                var monogramProductB = html.trim() ? JSON.parse(html) : {};
                _this.monogramVariants = [...monogramProductA?.product?.variants, ...monogramProductB?.product?.variants];
            })
        })
        .catch(error => {
          console.error('Failed to fetch monogramming product data for configurator:', error);
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        var _this = this;

        this.modal.addEventListener('shown.bs.modal', this._initModal.bind(this));
        this.modal.addEventListener('hidden.bs.modal', this._resetModal.bind(this));

        const optionGifting = this.modal.querySelector('.prdsys-option-gifting');
        if (optionGifting) {
          this.modal.querySelector("input[name='giftbox']").addEventListener('change', function(e) {
            _this._toggleGiftBoxSelection(e);
          });
          this.delegateElement.on('click', '.prdsys-option-gifting', this._showSection.bind(this, 'gifting', true));
          this.delegateElement.on('click', '.prdsys-gifting .prdsys-selection-select', this._toggleGiftBoxSelection.bind(this));
          this.delegateElement.on('click', '.prdsys-gifting-save', this._saveSelections.bind(this));
          this.delegateElement.on('click', '.prdsys-gifting-cancel', this._showSection.bind(this, 'options', false));
        }

        this.delegateElement.on('click', '.prdsys-option-addons', this._showSection.bind(this, 'addons', true));
        this.delegateElement.on('click', '.prd-sys-review', this._showSection.bind(this, 'review', false));
        this.delegateElement.on('click', '.addonItemCards .addonItemCard', this._getAddOnItemDetails.bind(this));
        this.delegateElement.on('click', '.prdsys-addon-details-cancel', this._addonDetailCancel.bind(this));
        this.delegateElement.on('click', '.prdsys-addon-details-remove', this._addOnItemDetailRemove.bind(this));
        this.delegateElement.on('click', '.prdsys-addon-details-add', this._addOnItemSave.bind(this));
        this.delegateElement.on('click', '#showMonogramming', this._toggleAddOnItemMonogramming.bind(this));
        this.delegateElement.on('click', '.prdsys-back-to-edit', this._showSection.bind(this, 'addons', false));
        this.delegateElement.on('click', '.prd-sys-add-to-bag', this._addItemsToCart.bind(this));
        this.delegateElement.on('click', '.cuyconfig-review-back', this._showSection.bind(this, 'addons', false));
        this.delegateElement.on('click', '.cuyconfig-header__back', this._onHeaderBack.bind(this));
        this.delegateElement.on('click', '.cuyconfig-review-remove', this._reviewItemRemove.bind(this));

        // Off-PDP (launcher) entry: colorway picker tiles
        this.delegateElement.on('click', '.variantItemCards .variantItemCard', this._selectVariant.bind(this));

        this.delegateElement.on('variant:changed', this._updateAddon.bind(this));

        // Only the portable (off-PDP) instance listens for launcher triggers. The PDP
        // instance has no data-configurator-portable attribute, so this never runs there.
        if (this.element.hasAttribute('data-configurator-portable')) {
          document.addEventListener('click', function(e) {
            var trigger = e.target.closest('[data-configurator-open]');
            if (!trigger) return;
            e.preventDefault();
            var handle = trigger.getAttribute('data-product-handle');
            var variantId = trigger.getAttribute('data-variant-id');
            if (handle) _this._openFromLauncher(handle, variantId);
          });
        }

      }
    }, {
      key: "_initModal",
      value: function _initModal(event) {

        document.body.classList.add('cuyconfig-open');

        // Ensure monogramming data is loaded (deferred for the portable instance;
        // already requested in the constructor on the PDP, so this is a no-op there).
        this._loadMonogramVariants();

        this.addOnProductSection = this.modal.querySelector('.prdsys-addon-product');

        // Bail if the modal opened without a product body injected (e.g. the portable
        // shell opened with no launcher) — there is no base product to configure.
        var baseProductEl = this.element.querySelector('[data-baseproduct-json]');
        if (!baseProductEl) {
          var emptyInstance = bootstrap.Modal.getInstance(this.modal);
          if (emptyInstance) emptyInstance.hide();
          return;
        }

        this.baseproduct = JSON.parse(baseProductEl.innerHTML || '{}');

        // Restore previous selections if the variant hasn't changed; otherwise start fresh
        if (this._savedState && this._savedState.variantId === this.baseproduct.id) {
          this.selectionsFinal = this._savedState.selectionsFinal.slice();
          // Refresh the base product entry with the latest data (price, etc.)
          this.selectionsFinal[0] = this.baseproduct;
        } else {
          this.selectionsTemp = null;
          this.selectionsFinal = [this.baseproduct];
          this._savedState = null;
        }

        const giftBoxSelection = this.modal.querySelector("input[name='giftbox']");
        if (giftBoxSelection){
          giftBoxSelection.checked = false;
        }

        const attentiveOverlay = document.getElementById('attentive_overlay');
        if (attentiveOverlay) {
          attentiveOverlay.classList.add('d-none');
        }

        // Populate the header product name from the base product (needed for the
        // portable shell, whose header renders empty; harmless on the PDP where the
        // value already matches).
        var headerName = this.modal.querySelector('.cuyconfig-header__name');
        if (headerName && this.baseproduct && this.baseproduct.name) {
          headerName.textContent = this.baseproduct.name;
        }

        // Launcher opens start on the colorway picker; the PDP always opens on add-ons.
        if (this._entryMode === 'variants') {
          var variantTiles = this.modal.querySelectorAll('.prdsys-variants .variantItemCard');
          if (variantTiles.length === 1) {
            // Only one in-stock colorway — skip the picker and go straight to add-ons.
            this._chooseVariantTile(variantTiles[0], event);
          } else {
            this._showSection('variants', true, event);
          }
        } else {
          this._showSection('addons', true, event);
        }
      }
    }, {
      key: "_resetModal",
      value: function _resetModal(event) {

        document.body.classList.remove('cuyconfig-open');

        // Clear launcher/entry state so the next open starts clean.
        this._launcherMode = false;
        this._entryMode = null;
        this.modal.classList.remove('cuyconfig-can-goback');

        // Persist selections so they survive a close/reopen on the same variant —
        // unless the user just completed an ATB, in which case we clear state so
        // the next open starts fresh.
        if (this._addedToCart) {
          this._savedState = null;
          this._addedToCart = false;
        } else {
          var selectionsToSave = this.selectionsTemp || this.selectionsFinal;
          if (this.baseproduct && selectionsToSave) {
            this._savedState = {
              variantId: this.baseproduct.id,
              selectionsFinal: selectionsToSave.slice()
            };
          }
        }

        const optionGifting = this.modal.querySelector('.prdsys-option-gifting');
        if (optionGifting) {
          optionGifting.querySelector('.option-info').innerHTML = '';
          optionGifting.classList.remove('selected');
        }

        const optionAddons = this.modal.querySelector('.prdsys-option-addons');
        if (optionAddons) {
          optionAddons.querySelector('.option-info').innerHTML = '';
          optionAddons.classList.remove('selected');
        }

        this._showSection('addons', false, event);

        const attentiveOverlay = document.getElementById('attentive_overlay');
        if (attentiveOverlay) {
          attentiveOverlay.classList.remove('d-none');
        }
      }
    }, {
      key: "_buildPayloadItems",
      value: function _buildPayloadItems(productLineGroupID, item, hasGiftbox) {
        var items = [];

          var productProperties = {...item.properties, "_line_group": productLineGroupID};
          const currentDate = new Date();
          let uuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);

          productProperties._uuid = uuid;

          if (hasGiftbox) {
            productProperties._is_giftwrapped = true;
          }

          productProperties._is_baseproduct = item.isBaseProduct;

          if (item.monogramming && item.monogramming.text) {
            var monoProperties = {
              "Monogram Details": item.monogramming.text,
              "Monogram Color": item.monogramming.color,
              "Monogram Size": item.monogramming.size,
              "is_final_sale": true,
              "_LPROP": "no-returns"
            };

            var productToAddToCart = {
              id: item.id,
              quantity: 1,
              properties: {...productProperties, ...monoProperties}
            };
            items.push(productToAddToCart);

            let monoProductUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
            var monoProductToAddToCart = {
              id: item.monogramming.pid,
              quantity: 1,
              properties: {
                "_hidden": true,
                "_uuid": monoProductUuid,
                "_parent_uuid": productProperties._uuid,
                "_is_monogram": true,
                "_line_group": productLineGroupID
              }
            };
            items.push(monoProductToAddToCart);

          } else {
            var productToAddToCart = {
              id: item.id,
              quantity: 1,
              properties: productProperties
            };
            items.push(productToAddToCart);
          }

          if (item.giftbox) {
            let giftboxUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
            var giftBoxProductToAddToCart = {
              id: item.giftbox.id,
              quantity: 1,
              properties: {
                "_hidden": true,
                "_uuid": giftboxUuid,
                "_parent_uuid": productProperties._uuid,
                "_is_giftbox": true,
                "_line_group": productLineGroupID
              }
            };
            items.push(giftBoxProductToAddToCart);
          }

        return items;
      }
    }, {
      key: "_buildPayload",
      value: async function _buildPayload(configuratorSelections) {
        var _this = this;
        var payload = { items: [] };
        var productLineGroupsUsed = [];

        const hasGiftbox = configuratorSelections.some((item) => {
          return item.giftbox;
        });

        var productLineGroupID = await _generateLineGroupID(productLineGroupsUsed);
        productLineGroupsUsed.push(productLineGroupID);

        const promises = configuratorSelections.map(async function(item) {
          var items = _this._buildPayloadItems(productLineGroupID, item, hasGiftbox);
          return items;
        });

        const items = await Promise.all(promises);
        payload.items = items.flat();

        return payload;
      }
    }, {
      key: "_addItemsToCart",
      value: function _addItemsToCart(event) {
        event.preventDefault();
        event.stopPropagation();

        var _this = this;
        var addToCartButton = event.target;

        var configuratorSelectionsFinal = this.selectionsFinal.slice().reverse();

        this._buildPayload(configuratorSelectionsFinal).then( function (payload) {
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(payload),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (response) {
            if (response.ok) {
              _this.element.dispatchEvent(new CustomEvent('product:added', {
                detail: {
                  quantity: configuratorSelectionsFinal.length,
                  source: 'configurator',
                  products: configuratorSelectionsFinal.map(function(item) {
                    return {
                      id: item.id,
                      sku: item.sku || '',
                      mpid: item.mpid,
                      name: item.name,
                      color: item.color,
                      size: item.size,
                      price: parseFloat(item.price.decimalValue),
                      isBaseProduct: item.isBaseProduct
                    };
                  })
                },
                bubbles: true
              }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
              }));
              checkPrivateSale();

              // Signal that ATB succeeded — _resetModal checks this to skip
              // re-persisting selections, so the next open starts fresh.
              _this._addedToCart = true;

              var modalInstance = bootstrap.Modal.getInstance(_this.modal);
              if (modalInstance) {
                modalInstance.hide();
              }
            } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
            }
          });
        });
      }
    }, {
      key: "_addOnItemRemove",
      value: function _addOnItemRemove(event) {
        event.preventDefault();
        event.stopPropagation();

        var addonItemCard = event.target.closest('div.addonItemCard');
        var productIdToRemove = addonItemCard.getAttribute('data-pid');

        this.selectionsTemp = this.selectionsTemp.filter(function(selection) {
          return selection.id !== productIdToRemove;
        });

        addonItemCard.classList.remove('selected');
        this._updateItemCount();
      }
    }, {
      key: "_addOnItemDetailRemove",
      value: function _addOnItemDetailRemove(event) {
        event.preventDefault();
        event.stopPropagation();

        // Get mpid from the Add button (sibling in the same button bar)
        var addButton = this.addOnProductSection.querySelector('.prdsys-addon-details-add');
        var mpid = addButton ? addButton.getAttribute('data-mpid') : null;

        if (mpid) {
          this.selectionsTemp = this.selectionsTemp.filter(function(selection) {
            return selection.mpid !== mpid;
          });

          // Remove the selected class from the matching card in the addon grid
          this.modal.querySelectorAll('.prdsys-addons .addonItemCard').forEach(function(card) {
            if (card.getAttribute('data-mpid') === mpid) {
              card.classList.remove('selected');
            }
          });

          this._updateItemCount();
        }

        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showSection('review', false, event);
        } else {
          this._showSection('addons', false, event);
        }
      }
    }, {
      key: "_reviewItemRemove",
      value: function _reviewItemRemove(event) {
        event.preventDefault();
        event.stopPropagation();

        var btn = event.target.closest('.cuyconfig-review-remove') || event.target;
        var mpid = btn.getAttribute('data-mpid');
        if (!mpid) return;

        // Remove from selections
        this.selectionsFinal = this.selectionsFinal.filter(function(s) { return s.mpid !== mpid; });
        this.selectionsTemp = this.selectionsFinal.slice();

        // Remove the row from the DOM
        var reviewItem = btn.closest('.cuyconfig-review-item');
        if (reviewItem) reviewItem.remove();

        // Deselect the matching card in the addons grid
        this.modal.querySelectorAll('.prdsys-addons .addonItemCard').forEach(function(card) {
          if (card.getAttribute('data-mpid') === mpid) {
            card.classList.remove('selected');
          }
        });

        // Recalculate and update the displayed total
        var USDollar = new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.theme && window.theme.currencyCode) || 'USD', maximumFractionDigits: 0 });
        var totalPrice = this.selectionsFinal.reduce(function(sum, item) {
          var price = item.price?.customSalePrice && parseFloat(item.price.customSalePrice) < parseFloat(item.price.decimalValue)
            ? parseFloat(item.price.customSalePrice)
            : parseFloat(item.price.decimalValue);
          if (item.monogramming && item.monogramming.cost) {
            price += parseFloat(item.monogramming.cost) + parseFloat(item.monogramming.upCharge);
          }
          if (item.isBaseProduct && item.giftbox && item.giftbox.id) {
            price += parseFloat(item.giftbox.price.decimalValue);
          }
          return sum + price;
        }, 0);
        var totalEl = this.modal.querySelector('.prdsys-summary .cuyconfig-review-total');
        if (totalEl) totalEl.innerHTML = USDollar.format(totalPrice);

        // Update mobile totals bar
        var totalCountEl = this.modal.querySelector('.cuyconfig-totals-count');
        var totalLabelEl = this.modal.querySelector('.cuyconfig-totals-label');
        var totalPriceEl = this.modal.querySelector('.cuyconfig-totals-price');
        if (totalCountEl) totalCountEl.textContent = this.selectionsFinal.length;
        if (totalLabelEl) totalLabelEl.textContent = this.selectionsFinal.length === 1 ? 'Item' : 'Items';
        if (totalPriceEl) totalPriceEl.textContent = USDollar.format(totalPrice);

        this._updateItemCount();
      }
    }, {
      key: "_addOnItemSave",
      value: function _addOnItemSave(event) {
        event.preventDefault();
        event.stopPropagation();

        var pid = event.target.getAttribute('data-pid');
        var mpid = event.target.getAttribute('data-mpid');
        var name = event.target.getAttribute('data-name');
        var color = event.target.getAttribute('data-color');
        var size = event.target.getAttribute('data-size');
        var preorder = event.target.getAttribute('data-preorder');
        var final_sale = event.target.getAttribute('data-finalsale');
        // Strip thousand-separator commas (e.g. "22,900.00" for PHP) before parseFloat
        var price = event.target.getAttribute('data-price').replace(/,/g, '').trim();
        var compare_at_price = event.target.getAttribute('data-compareat').replace(/,/g, '').trim();
        var custom_sale_price = event.target.getAttribute('data-customsale')?.replace(/,/g, '').trim();
        var image = event.target.getAttribute('data-image');
        var handle = event.target.getAttribute('data-handle');
        var stock_date = event.target.getAttribute('data-stockdate');

        var productToAdd = {
          id: pid,
          mpid: mpid,
          handle: handle,
          name: name,
          color: color,
          size: size,
          image: image,
          isBaseProduct: false,
          stockdate: stock_date,
          properties: {},
          price: {
              decimalValue: parseFloat(price).toFixed(2),
              value: parseFloat(price).toFixed(2),
              formatted: '$' + price
          }
        };

        if (custom_sale_price) {
          productToAdd.price["customSalePrice"] = parseFloat(custom_sale_price).toFixed(2);
        }

        if (compare_at_price) {
          productToAdd.properties["_compare_at_price"] = parseFloat(compare_at_price);
        }

        if (preorder === "true") {
          productToAdd.properties["_is_preorder"] = true;
          if (stock_date) productToAdd.properties["_est_ship_date"] = stock_date;
        }

        if (final_sale === "true") {
          productToAdd.properties["is_final_sale"] = true;
          productToAdd.properties["_LPROP"] = 'no-returns';
        }

        var configuratorSelectionsTemp = this.selectionsTemp;
        this.selectionsTemp = configuratorSelectionsTemp.filter(function(selection) {
          return selection.mpid !== mpid;
        });

        this.selectionsTemp.push(productToAdd);

        // Update the addon card image to reflect the selected colorway.
        // Prefer the PLP image (600×600 center crop) over the full-res variant image.
        var plpImage = event.target.getAttribute('data-plpimage');
        var cardImageSrc = plpImage || image;
        var addonCard = this.modal.querySelector('.prdsys-addons .addonItemCard[data-mpid="' + mpid + '"]');
        if (addonCard && cardImageSrc) {
          var cardImg = addonCard.querySelector('img');
          if (cardImg) cardImg.src = cardImageSrc;
        }

        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showSection('review', false, event);
        } else {
          this._showSection('addons', false, event);
        }

      }
    }, {
      key: "_addonDetailCancel",
      value: function _addonDetailCancel(event) {
        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showSection('review', false, event);
        } else {
          this._showSection('addons', false, event);
        }
      }
    }, {
      key: "_updateAddon",
      value: function _updateAddon(event) {
        var newVariant = event.detail.variant;
        this._updateAddOnSaveButton(newVariant);
        this._updateAddOnGallery(newVariant);

        if (newVariant && newVariant['custom_private_sale_price']) {
          checkPrivateSale();
        } else {
          const strikethroughPrices = this.element.querySelectorAll('.ProductItem__CustomStrikethroughPrice');
          if (strikethroughPrices.length) {
            strikethroughPrices.forEach(element => {
              element.classList.add('d-none');
            });
            const defaultPrices = this.element.querySelectorAll('.ProductItem__DefaultPrice');
            defaultPrices.forEach(element => {
              element.classList.remove('d-none');
            });
          }
        }
      }
    }, {
      key: "_updateAddOnGallery",
      value: function _updateAddOnGallery(newVariant) {
        if (!newVariant || !newVariant.featured_image) return;
        var img = this.addOnProductSection.querySelector('.cuyconfig-addon-image img');
        if (img) { img.src = newVariant.featured_image.src; }
      }
    }, {
      key: "_updateAddOnSaveButton",
      value: function _updateAddOnSaveButton(newVariant) {

        var saveButton = this.addOnProductSection.querySelector('.prdsys-addon-details-add');

        if (saveButton) {
          saveButton.classList.remove('d-none');
          if (!newVariant) {
            saveButton.setAttribute('disabled', 'disabled');
            saveButton.removeAttribute('data-pid');
            saveButton.innerHTML = window.languages.productFormUnavailable;
          } else {
            if (newVariant['available']) {
              saveButton.removeAttribute('disabled');
              if (saveButton.textContent.trim() !== 'Update') saveButton.innerHTML = 'Add';
              saveButton.setAttribute('data-pid', newVariant['id']);
              saveButton.setAttribute('data-price', (newVariant['price'] / 100).toFixed(2));
              if (newVariant['compare_at_price']) {
                saveButton.setAttribute('data-compareat', (newVariant['compare_at_price'] / 100).toFixed(2));
              } else {
                saveButton.setAttribute('data-compareat', '');
              }

              if (newVariant['custom_private_sale_price']) {
                saveButton.setAttribute('data-customsale', (newVariant['custom_private_sale_price'] / 100).toFixed(2));
              } else {
                saveButton.setAttribute('data-customsale', '');
              }

              if (newVariant['is_preorder']) {
                saveButton.innerHTML = window.languages.productFormPreorder;
                saveButton.setAttribute('data-preorder', 'true');
              } else {
                saveButton.setAttribute('data-preorder', '');
              }
              if (newVariant['is_final_sale']) {
                saveButton.setAttribute('data-finalsale', 'true');
              } else {
                saveButton.setAttribute('data-finalsale', '');
              }
              if (newVariant.hasOwnProperty('option1')) {
                saveButton.setAttribute('data-color', newVariant['option1']);
              }
              if (newVariant.hasOwnProperty('option2')) {
                saveButton.setAttribute('data-size', newVariant['option2']);
              } else {
                saveButton.setAttribute('data-size', '');
              }
              if (newVariant.hasOwnProperty('back_in_stock_date')) {
                saveButton.setAttribute('data-stockdate', newVariant['back_in_stock_date']);
              } else {
                saveButton.setAttribute('data-stockdate', '');
              }
              if (newVariant.hasOwnProperty('featured_image')) {
                if (newVariant['featured_image'].src) {
                  saveButton.setAttribute('data-image', newVariant['featured_image'].src);
                }
              }

              // Update the PLP card thumbnail from variants_extra_data, sized to 600×600 center crop.
              // Shopify image_url returns protocol-relative URLs (//cdn.shopify.com/...) so we
              // avoid new URL() and manipulate the query string directly instead.
              try {
                var productDataEl = this.addOnProductSection.querySelector('[data-product-json]');
                if (productDataEl) {
                  var productData = JSON.parse(productDataEl.textContent);
                  var variantExtra = productData.variants_extra_data && productData.variants_extra_data[newVariant['id']];
                  if (variantExtra && variantExtra.plp_image) {
                    var plpBase = variantExtra.plp_image.replace(/\?.*$/, '');
                    saveButton.setAttribute('data-plpimage', plpBase + '?width=600&height=600&crop=center');
                  }
                }
              } catch(e) {}
            } else {
              saveButton.setAttribute('disabled', 'disabled');
              saveButton.removeAttribute('data-pid');
              saveButton.setAttribute('data-preorder', '');
              saveButton.setAttribute('data-finalsale', '');
              saveButton.innerHTML = window.languages.productFormSoldOut;
            }
          }
        }
      }
    }, {
      key: "_getAddOnItemDetails",
      value: function _getAddOnItemDetails(event) {
        event.preventDefault();
        var addonItemCard = event.target.closest('.addonItemCard');
        var variant_id = addonItemCard.getAttribute('data-pid');
        var addonProductHandle = addonItemCard.getAttribute('data-product');
        var addonMpid = addonItemCard.getAttribute('data-mpid');
        var isAlreadySelected = this.selectionsTemp && this.selectionsTemp.some(function(s) { return s.mpid === addonMpid; });

        if (isAlreadySelected) {
          var existingSelection = this.selectionsTemp.find(function(s) { return s.mpid === addonMpid; });
          if (existingSelection && existingSelection.id) { variant_id = existingSelection.id; }
        }

        this._openAddonDetail(addonProductHandle, variant_id, addonMpid, isAlreadySelected, false);
      }
    }, {
      key: "_openAddonDetail",
      value: function _openAddonDetail(handle, variantId, mpid, isAlreadySelected, fromReview) {
        var _this = this;
        var url = window.location.origin + '/products/' + handle + '?variant=' + variantId + '&view=configurator-addon';
        fetch(url)
          .then(function(response) { return response.text(); })
          .then(function(html) {
            var tempElement = document.createElement('div');
            tempElement.innerHTML = html;

            if (_this.exclusions && _this.exclusions.length > 0) {
              _this.exclusions.forEach(function(item) {
                var baseProducts = item.baseProducts;
                var exclusions = item.exclusions;
                var exclusionKeys = Object.keys(exclusions);
                if (baseProducts.length === 0 || baseProducts.includes(_this.baseproduct.sku)) {
                  exclusionKeys.forEach(function(key) {
                    if (key === handle) {
                      exclusions[key].forEach(function(attr) {
                        var attrEl = tempElement.querySelector('.ProductForm__Option li[data-value="' + attr + '"]');
                        if (attrEl) attrEl.remove();
                      });
                    }
                  });
                }
              });
            }

            var sectionHtml = tempElement.querySelector('.shopify-section').innerHTML;
            _this.addOnProductSection.innerHTML = sectionHtml;
            checkPrivateSale();
            _this.productVariants = new ProductVariants(_this.addOnProductSection, {});

            // Show Remove + Update when item is already selected
            if (isAlreadySelected) {
              var cancelBtn = _this.addOnProductSection.querySelector('.prdsys-addon-details-cancel');
              var removeBtn = _this.addOnProductSection.querySelector('.prdsys-addon-details-remove');
              var addBtn = _this.addOnProductSection.querySelector('.prdsys-addon-details-add');
              if (cancelBtn) cancelBtn.classList.add('d-none');
              if (removeBtn) removeBtn.classList.remove('d-none');
              if (addBtn && !addBtn.disabled) addBtn.textContent = 'Update';
            }

            // Track where we came from so Cancel/Update can return to the right screen
            _this._detailFromReview = fromReview;

            // Hide whichever section we came from
            if (fromReview) {
              _this.modal.querySelector('.prdsys-summary').style.display = 'none';
            } else {
              _this.modal.querySelector('.prdsys-main').classList.add('d-none');
            }
            _this.addOnProductSection.classList.remove('d-none');
            _this.modal.classList.add('cuyconfig-detail-active');
          })
          .catch(function(error) {
            console.error('Failed to fetch configurator add-on detail:', error);
          });
      }
    }, {
      key: "_toggleAddOnItemMonogramming",
      value: function _toggleAddOnItemMonogramming(event) {

        var clickedElement = event.target;

        var productMonogramming = this.addOnProductSection.querySelector('.product-monogramming');
        productMonogramming.classList.toggle('show', clickedElement.checked);

        if (document.documentElement.clientWidth > 768) {
          var scrollWrapper = this.modal.querySelector('.scroll-wrapper');
          scrollWrapper.scrollTop = scrollWrapper.querySelector('.scroller').scrollHeight;

          if (productMonogramming.classList.contains('mobile-show')) {
              productMonogramming.classList.remove('mobile-show');
          }
        }

      }
    }, {
      key: "_toggleGiftBoxSelection",
      value: function _toggleGiftBoxSelection(event) {
        event.preventDefault();
        var giftboxCard = event.target.closest('.addonItemCard');
        if (!giftboxCard) return;
        var pid = giftboxCard.getAttribute('data-pid');
        var mpid = giftboxCard.getAttribute('data-mpid');
        var price = giftboxCard.getAttribute('data-price').replace(/^\s+|\s+$/g, '');

        if (!pid) {
            return;
        }

        var configuratorSelectionsTemp = this.selectionsTemp;

        if (configuratorSelectionsTemp.length > 0 && mpid === 'giftbox') {

            var giftboxInput = this.modal.querySelector("input[name='giftbox']");

            if (giftboxCard.classList.contains('selected')) {
                configuratorSelectionsTemp[0].giftbox = null;
                giftboxCard.classList.remove('selected');
                giftboxInput.checked = false;
            } else {
                var giftbox = {
                    id: pid,
                    mpid: mpid,
                    name: this.modal.querySelector('.gift-product-name').textContent,
                    color: '',
                    size: '',
                    price: {
                        decimalValue: parseFloat(price),
                        value: parseFloat(price),
                        formatted: '$' + price
                    }
                };
                configuratorSelectionsTemp[0].giftbox = giftbox;
                giftboxCard.classList.add('selected');
                giftboxInput.checked = true;
            }
        }

        this.selectionsTemp = configuratorSelectionsTemp;
      }
    }, {
      key: "_saveSelections",
      value: function _saveSelections(event) {
        event.preventDefault();

        this.selectionsFinal = this.selectionsTemp;
        this._showSection('addons', false, event);
      }
    }, {
      key: "_showSection",
      value: function _showSection(section = '', setTempStorage = false, event) {
        event.preventDefault();

        this.addOnProductSection.classList.add('d-none');
        this.modal.querySelector('.prdsys-main').classList.remove('d-none');
        this.modal.classList.remove('cuyconfig-detail-active');

        // Scroll the modal body back to the top on every section transition
        var modalBody = this.modal.querySelector('.modal-body');
        if (modalBody) modalBody.scrollTop = 0;

        if (setTempStorage) {
          this.selectionsTemp = (this.selectionsFinal) ? this.selectionsFinal : [];
        }

        // Configurator no longer uses the options step — hide it unconditionally
        const optionsSection = this.modal.querySelector('.prdsys-options');
        if (optionsSection) optionsSection.style.display = 'none';

        if (section === 'addons') {
          var configuratorSelectionsTemp = this.selectionsTemp;
          var addonCards = this.modal.querySelectorAll('.prdsys-addons .addonItemCard');
          addonCards.forEach(function(card) {
            card.classList.remove('selected');
            var mpid = card.dataset.mpid;
            configuratorSelectionsTemp.forEach(function(selection) {
              if (selection.mpid === mpid) {
                card.classList.add('selected');
              }
            });
          });

          this.modal.querySelector('.prdsys-addons').style.display = 'block';
        } else {
          this.modal.querySelector('.prdsys-addons').style.display = 'none';
        }

        if (section === 'variants') {
          var variantsSection = this.modal.querySelector('.prdsys-variants');
          variantsSection.style.display = 'block';
          // Mark the current colorway as selected (bold border). Reflects the
          // launcher's variant on open and the chosen colorway on return.
          var baseColor = this.baseproduct && this.baseproduct.color;
          variantsSection.querySelectorAll('.variantItemCard').forEach(function(tile) {
            tile.classList.toggle('selected', tile.getAttribute('data-color') === baseColor);
          });
        } else {
          var _pv = this.modal.querySelector('.prdsys-variants');
          if (_pv) _pv.style.display = 'none';
        }

        // In launcher mode, the add-ons step can go back to the colorway picker.
        if (this._launcherMode && section === 'addons') {
          this.modal.classList.add('cuyconfig-can-goback');
        } else {
          this.modal.classList.remove('cuyconfig-can-goback');
        }
        this._currentSection = section;

        if (section === 'gifting') {
          this.modal.querySelector('.prdsys-gifting').style.display = 'block';
        } else {
          const optionGifting = this.modal.querySelector('.prdsys-gifting');
          if (optionGifting) optionGifting.style.display = 'none';
        }

        if (section === 'review') {
          let USDollar = new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: (window.theme && window.theme.currencyCode) || 'USD',
              maximumFractionDigits: 0,
          });

          this.selectionsFinal = this.selectionsTemp;

          var productSelectionsContainer = this.modal.querySelector('.prdsys-summary .product-selections');
          productSelectionsContainer.innerHTML = '';
          var totalPrice = 0;

          this.selectionsFinal.forEach(function(item) {
            let reviewItemHtml = document.querySelector('#productConfiguratorModal div.reviewItemHtml .cuyconfig-review-item').cloneNode(true);
            let productImage = reviewItemHtml.querySelector('img');
            productImage.src = item.image;
            productImage.alt = item.name;
            productImage.title = item.name;

            var attributes = '';
            if (item.properties["is_final_sale"]) {
              attributes += '<p class="CartItem__FinalSale">Final Sale</p>';
            }

            if (item.properties["_is_preorder"]) {
              attributes += '<p class="CartItem__Preorder">Estimated to ship <span class="instock-date">' + item.stockdate + '</span></p>';
            }

            attributes += item.color ? '<p>' + item.color : '';
            if (item.size && item.size != 'One Size' && item.size != 'Null') {
              attributes += ', ' + item.size;
            }
            attributes += '</p>';

            var monogramming = '';
            monogramming = item.monogramming && item.monogramming.text ? 'Monogram: ' + item.monogramming.text : '';

            var itemPrice = item.price.decimalValue;
            var priceHtml = '';
            if (item.price?.customSalePrice && parseFloat(item.price.customSalePrice) < parseFloat(item.price.decimalValue)) {
              itemPrice = parseFloat(item.price.customSalePrice).toFixed(2);
              priceHtml += '<span class="ProductItem__Price ProductItem__CustomStrikethroughPrice Price Price--compareAt Text--subdued d-none">' + USDollar.format(item.price.decimalValue)+ '</span>';
              priceHtml += '<span class="ProductItem__Price ProductItem__CustomStrikethroughPrice Price d-none">' + USDollar.format(item.price.customSalePrice) + '</span>';
            } else {
              priceHtml += '<span class="ProductItem__Price ProductItem__CustomStrikethroughPrice Price d-none">' + USDollar.format(item.price.decimalValue) + '</span>';
            }
            priceHtml += '<span class="ProductItem__Price ProductItem__DefaultPrice Price">' + USDollar.format(item.price.decimalValue) + '</span>';

            totalPrice += parseFloat(itemPrice);

            reviewItemHtml.querySelector('.product-name').innerHTML = item.name;
            reviewItemHtml.querySelector('.product-price').innerHTML = priceHtml;
            reviewItemHtml.querySelector('.product-attributes').innerHTML = attributes;
            reviewItemHtml.querySelector('.product-monogramming').innerHTML = monogramming;

            if (item.isBaseProduct && item.giftbox && item.giftbox.id) {
              reviewItemHtml.querySelector('.product-giftoptions').innerHTML = 'Gift Box Added';
              totalPrice += parseFloat(item.giftbox.price.decimalValue);
            }

            if (item.monogramming && item.monogramming.cost) {
              totalPrice += parseFloat(item.monogramming.cost) + parseFloat(item.monogramming.upCharge);
            }

            // Show Edit + Remove action links for addon items only (base product has no actions)
            var removeBtn = reviewItemHtml.querySelector('.cuyconfig-review-remove');
            if (!item.isBaseProduct) {
              if (removeBtn) {
                removeBtn.classList.remove('d-none');
                removeBtn.setAttribute('data-mpid', item.mpid);
              }
            }

            productSelectionsContainer.appendChild(reviewItemHtml);
          });

          var reviewTotalEl = this.modal.querySelector('.prdsys-summary .cuyconfig-review-total');
          if (reviewTotalEl) reviewTotalEl.innerHTML = USDollar.format(totalPrice);

          // Update mobile totals bar
          var totalCountEl = this.modal.querySelector('.cuyconfig-totals-count');
          var totalLabelEl = this.modal.querySelector('.cuyconfig-totals-label');
          var totalPriceEl = this.modal.querySelector('.cuyconfig-totals-price');
          if (totalCountEl) totalCountEl.textContent = this.selectionsFinal.length;
          if (totalLabelEl) totalLabelEl.textContent = this.selectionsFinal.length === 1 ? 'Item' : 'Items';
          if (totalPriceEl) totalPriceEl.textContent = USDollar.format(totalPrice);

          this.modal.classList.add('cuyconfig-in-review');
          this.modal.querySelector('.prdsys-summary').style.display = 'block';

        } else {
          this.modal.classList.remove('cuyconfig-in-review');
          this.modal.querySelector('.prdsys-summary').style.display = 'none';
        }

        this._updateItemCount();
        checkPrivateSale();
      }
    }, {
      key: "_updateItemCount",
      value: function _updateItemCount() {
        var selections = this.selectionsTemp || this.selectionsFinal || [];
        var count = selections.length;
        var countEl = this.modal.querySelector('.cuyconfig-item-count');
        var labelEl = this.modal.querySelector('.cuyconfig-item-label');
        if (countEl) countEl.textContent = count;
        if (labelEl) labelEl.textContent = count === 1 ? 'Item' : 'Items';

        // Update header price with running total of base product + selected add-ons
        var totalPrice = selections.reduce(function(sum, item) {
          var price = (item.price && item.price.customSalePrice &&
                       parseFloat(item.price.customSalePrice) < parseFloat(item.price.decimalValue))
            ? parseFloat(item.price.customSalePrice)
            : parseFloat(item.price && item.price.decimalValue || 0);
          return sum + (isNaN(price) ? 0 : price);
        }, 0);
        var priceEl = this.modal.querySelector('.cuyconfig-header__price');
        if (priceEl) {
          priceEl.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.theme && window.theme.currencyCode) || 'USD', maximumFractionDigits: 0 }).format(totalPrice);
        }
      }
    }, {
      /**
       *  Route the header Back button by context (review, launcher add-ons, else).
       */
      key: "_onHeaderBack",
      value: function _onHeaderBack(event) {
        if (this.modal.classList.contains('cuyconfig-in-review')) {
          this._showSection('addons', false, event);
        } else if (this._launcherMode && this._currentSection === 'addons') {
          this._showSection('variants', false, event);
        } else {
          this._showSection('addons', false, event);
        }
      }
    }, {
      /**
       *  Colorway picker (launcher entry): re-render the modal body for the chosen
       *  variant so add-ons are color-matched, then move to the add-ons step.
       */
      key: "_selectVariant",
      value: function _selectVariant(event) {
        event.preventDefault();
        this._chooseVariantTile(event.target.closest('.variantItemCard'), event);
      }
    }, {
      /**
       *  Commit a colorway tile as the base product and move to the add-ons step.
       *  Re-fetches the body for the chosen variant (color-matched add-ons) unless it
       *  is already the base product.
       */
      key: "_chooseVariantTile",
      value: function _chooseVariantTile(tile, event) {
        if (!tile) return;
        var _this = this;
        var handle = tile.getAttribute('data-handle');
        var variantId = tile.getAttribute('data-variant-id');
        if (this.baseproduct && String(this.baseproduct.id) === String(variantId)) {
          this._showSection('addons', true, event);
          return;
        }
        this._fetchBody(handle, variantId, function() {
          _this._initBaseProduct();
          _this._showSection('addons', true, event);
        });
      }
    }, {
      /**
       *  Open the configurator for an arbitrary product from a non-PDP launcher.
       */
      key: "_openFromLauncher",
      value: function _openFromLauncher(handle, variantId) {
        var _this = this;
        this._launcherMode = true;
        this._entryMode = 'variants';
        this._launcherHandle = handle;
        this._fetchBody(handle, variantId || null, function() {
          // No in-stock colorways to choose — send the shopper to the product page
          // instead of opening an empty picker.
          var tiles = _this.modal.querySelectorAll('.prdsys-variants .variantItemCard');
          if (tiles.length === 0) {
            window.location.href = window.location.origin + '/products/' + handle;
            return;
          }
          bootstrap.Modal.getOrCreateInstance(_this.modal).show();
        });
      }
    }, {
      /**
       *  Fetch and inject the configurator modal body for a product/variant.
       */
      key: "_fetchBody",
      value: function _fetchBody(handle, variantId, done) {
        var _this = this;
        var url = window.location.origin + '/products/' + handle + '?view=configurator-modal' + (variantId ? '&variant=' + variantId : '');
        fetch(url)
          .then(function(response) { return response.text(); })
          .then(function(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var section = temp.querySelector('.shopify-section');
            var modalBody = _this.modal.querySelector('.modal-body');
            if (modalBody) modalBody.innerHTML = section ? section.innerHTML : html;
            _this.addOnProductSection = _this.modal.querySelector('.prdsys-addon-product');
            checkPrivateSale();
            if (done) done();
          })
          .catch(function(error) {
            console.error('Failed to fetch configurator modal body:', error);
          });
      }
    }, {
      /**
       *  Re-read the base product JSON (after a body re-render) and reset selections.
       */
      key: "_initBaseProduct",
      value: function _initBaseProduct() {
        var baseEl = this.element.querySelector('[data-baseproduct-json]');
        this.baseproduct = JSON.parse((baseEl && baseEl.innerHTML) || '{}');
        this.selectionsTemp = null;
        this.selectionsFinal = [this.baseproduct];
        this._savedState = null;
        var exEl = this.element.querySelector('[data-cex-json]');
        if (exEl && exEl.innerHTML.trim() !== '') {
          try { this.exclusions = JSON.parse(exEl.innerHTML); } catch (e) {}
        }
        var headerName = this.modal.querySelector('.cuyconfig-header__name');
        if (headerName && this.baseproduct.name) headerName.textContent = this.baseproduct.name;
      }
    }]);

    return ProductConfiguratorSection;
  }();

  var BundlinatorSection = /*#__PURE__*/function () {
    function BundlinatorSection(container) {
      var _this = this;

      _classCallCheck(this, BundlinatorSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.modal = this.element.querySelector('#bundlinatorModal');

      this.addOnProductSection = this.modal.querySelector('.prdsys-addon-product');

      const exclusionElement = this.element.querySelector('[data-cex-json]');
      if (exclusionElement && exclusionElement.innerHTML.trim() !== '') {
        this.exclusions = JSON.parse(exclusionElement.innerHTML);
      }

      /* Auto open configurator modal if url parameter is present */
      var urlParams = new URLSearchParams(window.location.search);
      var showconfig = urlParams.get('showbundlinator');
      if (showconfig) {
        this.selectionsTemp = null;
        this.selectionsFinal = null;
        bootstrap.Modal.getOrCreateInstance(this.modal).show();
      }

      // Get monograming product data
      _this.monogramVariants = false;
      const monogrammingDataUrl = window.location.origin + '/products/mono-service.json';
      fetch(monogrammingDataUrl)
        .then(response => response.text())
        .then(html => {
          var monogramProductA = html.trim() ? JSON.parse(html) : {};
          fetch(window.location.origin + '/products/mono-service-both-cases.json')
            .then(response => response.text())
            .then(html => {
              var monogramProductB = html.trim() ? JSON.parse(html) : {};
              _this.monogramVariants = [...monogramProductA?.product?.variants, ...monogramProductB?.product?.variants];
          })
      })
      .catch(error => {
        console.error('Failed to fetch monogramming product data for bundlinator:', error);
      });

      this._attachListeners();
    }

    _createClass(BundlinatorSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.productVariants) {
          this.productVariants.destroy();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        var _this = this;

        this.modal.addEventListener('shown.bs.modal', this._initModal.bind(this));
        this.modal.addEventListener('hidden.bs.modal', this._resetModal.bind(this));

        const optionGifting = this.modal.querySelector('.prdsys-option-gifting');
        if (optionGifting) {
          this.modal.querySelector("input[name='giftbox']").addEventListener('change', function(e) {
            _this._toggleGiftBoxSelection(e);
          });
          this.delegateElement.on('click', '.prdsys-option-gifting', this._showSection.bind(this, 'gifting', true));
          this.delegateElement.on('click', '.prdsys-gifting .prdsys-selection-select', this._toggleGiftBoxSelection.bind(this));
          this.delegateElement.on('click', '.prdsys-gifting-save', this._saveSelections.bind(this));
          this.delegateElement.on('click', '.prdsys-gifting-cancel', this._showSection.bind(this, 'options', false));
        }

        this.delegateElement.on('click', '.prdsys-option-addons', this._showSection.bind(this, 'addons', true));
        this.delegateElement.on('click', '.prd-sys-review', this._showSection.bind(this, 'review', false));
        this.delegateElement.on('click', '.addonItemCards .addonItemCard', this._getAddOnItemDetails.bind(this));
        this.delegateElement.on('click', '.prdsys-addon-details-cancel', this._addonDetailCancel.bind(this));
        this.delegateElement.on('click', '.prdsys-addon-details-remove', this._addOnItemDetailRemove.bind(this));
        this.delegateElement.on('click', '.prdsys-addon-details-add', this._addOnItemSave.bind(this));
        this.delegateElement.on('click', '#showMonogramming', this._toggleAddOnItemMonogramming.bind(this));
        this.delegateElement.on('click', '.prdsys-back-to-edit', this._showSection.bind(this, 'addons', false));
        this.delegateElement.on('click', '.prd-sys-add-to-bag', this._addItemsToCart.bind(this));
        this.delegateElement.on('click', '.bundlinator-review-back', this._showSection.bind(this, 'addons', false));
        this.delegateElement.on('click', '.bundlinator-header__back', this._showSection.bind(this, 'addons', false));
        this.delegateElement.on('click', '.bundlinator-review-remove', this._reviewItemRemove.bind(this));

        this.delegateElement.on('variant:changed', this._updateAddon.bind(this));

      }
    }, {
      key: "_initModal",
      value: function _initModal(event) {

        document.body.classList.add('bundlinator-open');

        this.addOnProductSection = this.modal.querySelector('.prdsys-addon-product');

        this.baseproduct = JSON.parse(this.element.querySelector('[data-baseproduct-json]').innerHTML || '{}');

        // Restore previous selections if the variant hasn't changed; otherwise start fresh
        if (this._savedState && this._savedState.variantId === this.baseproduct.id) {
          this.selectionsFinal = this._savedState.selectionsFinal.slice();
          // Refresh the base product entry with the latest data (price, etc.)
          this.selectionsFinal[0] = this.baseproduct;
        } else {
          this.selectionsTemp = null;
          this.selectionsFinal = [this.baseproduct];
          this._savedState = null;
        }

        const giftBoxSelection = this.modal.querySelector("input[name='giftbox']");
        if (giftBoxSelection){
          giftBoxSelection.checked = false;
        }

        const attentiveOverlay = document.getElementById('attentive_overlay');
        if (attentiveOverlay) {
          attentiveOverlay.classList.add('d-none');
        }

        this._showSection('addons', true, event);
      }
    }, {
      key: "_resetModal",
      value: function _resetModal(event) {

        document.body.classList.remove('bundlinator-open');

        // Persist selections so they survive a close/reopen on the same variant —
        // unless the user just completed an ATB, in which case we clear state so
        // the next open starts fresh.
        if (this._addedToCart) {
          this._savedState = null;
          this._addedToCart = false;
        } else {
          var selectionsToSave = this.selectionsTemp || this.selectionsFinal;
          if (this.baseproduct && selectionsToSave) {
            this._savedState = {
              variantId: this.baseproduct.id,
              selectionsFinal: selectionsToSave.slice()
            };
          }
        }

        const optionGifting = this.modal.querySelector('.prdsys-option-gifting');
        if (optionGifting) {
          optionGifting.querySelector('.option-info').innerHTML = '';
          optionGifting.classList.remove('selected');
        }

        const optionAddons = this.modal.querySelector('.prdsys-option-addons');
        if (optionAddons) {
          optionAddons.querySelector('.option-info').innerHTML = '';
          optionAddons.classList.remove('selected');
        }

        this._showSection('addons', false, event);

        const attentiveOverlay = document.getElementById('attentive_overlay');
        if (attentiveOverlay) {
          attentiveOverlay.classList.remove('d-none');
        }
      }
    }, {
      key: "_buildPayloadItems",
      value: function _buildPayloadItems(productLineGroupID, item, hasGiftbox) {
        var items = [];

          var productProperties = {...item.properties, "_line_group": productLineGroupID};
          const currentDate = new Date();
          let uuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);

          productProperties._uuid = uuid;

          if (hasGiftbox) {
            productProperties._is_giftwrapped = true;
          }

          productProperties._is_baseproduct = item.isBaseProduct;

          if (item.monogramming && item.monogramming.text) {
            var monoProperties = {
              "Monogram Details": item.monogramming.text,
              "Monogram Color": item.monogramming.color,
              "Monogram Size": item.monogramming.size,
              "is_final_sale": true,
              "_LPROP": "no-returns"
            };

            var productToAddToCart = {
              id: item.id,
              quantity: 1,
              properties: {...productProperties, ...monoProperties}
            };
            items.push(productToAddToCart);

            let monoProductUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
            var monoProductToAddToCart = {
              id: item.monogramming.pid,
              quantity: 1,
              properties: {
                "_hidden": true,
                "_uuid": monoProductUuid,
                "_parent_uuid": productProperties._uuid,
                "_is_monogram": true,
                "_line_group": productLineGroupID
              }
            };
            items.push(monoProductToAddToCart);

          } else {
            var productToAddToCart = {
              id: item.id,
              quantity: 1,
              properties: productProperties
            };
            items.push(productToAddToCart);
          }

          if (item.giftbox) {
            let giftboxUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
            var giftBoxProductToAddToCart = {
              id: item.giftbox.id,
              quantity: 1,
              properties: {
                "_hidden": true,
                "_uuid": giftboxUuid,
                "_parent_uuid": productProperties._uuid,
                "_is_giftbox": true,
                "_line_group": productLineGroupID
              }
            };
            items.push(giftBoxProductToAddToCart);
          }

        return items;
      }
    }, {
      key: "_buildPayload",
      value: async function _buildPayload(configuratorSelections) {
        var _this = this;
        var payload = { items: [] };
        var productLineGroupsUsed = [];

        const hasGiftbox = configuratorSelections.some((item) => {
          return item.giftbox;
        });

        var productLineGroupID = await _generateLineGroupID(productLineGroupsUsed);
        productLineGroupsUsed.push(productLineGroupID);

        const promises = configuratorSelections.map(async function(item) {
          var items = _this._buildPayloadItems(productLineGroupID, item, hasGiftbox);
          return items;
        });

        const items = await Promise.all(promises);
        payload.items = items.flat();

        return payload;
      }
    }, {
      key: "_addItemsToCart",
      value: function _addItemsToCart(event) {
        event.preventDefault();
        event.stopPropagation();

        var _this = this;
        var addToCartButton = event.target;

        var configuratorSelectionsFinal = this.selectionsFinal.slice().reverse();

        this._buildPayload(configuratorSelectionsFinal).then( function (payload) {
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(payload),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (response) {
            if (response.ok) {
              _this.element.dispatchEvent(new CustomEvent('product:added', {
                detail: {
                  quantity: configuratorSelectionsFinal.length,
                  source: 'bundlinator',
                  products: configuratorSelectionsFinal.map(function(item) {
                    return {
                      id: item.id,
                      sku: item.sku || '',
                      mpid: item.mpid,
                      name: item.name,
                      color: item.color,
                      size: item.size,
                      price: parseFloat(item.price.decimalValue),
                      isBaseProduct: item.isBaseProduct
                    };
                  })
                },
                bubbles: true
              }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
              }));
              checkPrivateSale();

              // Signal that ATB succeeded — _resetModal checks this to skip
              // re-persisting selections, so the next open starts fresh.
              _this._addedToCart = true;

              var modalInstance = bootstrap.Modal.getInstance(_this.modal);
              if (modalInstance) {
                modalInstance.hide();
              }
            } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
            }
          });
        });
      }
    }, {
      key: "_addOnItemRemove",
      value: function _addOnItemRemove(event) {
        event.preventDefault();
        event.stopPropagation();

        var addonItemCard = event.target.closest('div.addonItemCard');
        var productIdToRemove = addonItemCard.getAttribute('data-pid');

        this.selectionsTemp = this.selectionsTemp.filter(function(selection) {
          return selection.id !== productIdToRemove;
        });

        addonItemCard.classList.remove('selected');
        this._updateItemCount();
      }
    }, {
      key: "_addOnItemDetailRemove",
      value: function _addOnItemDetailRemove(event) {
        event.preventDefault();
        event.stopPropagation();

        // Get mpid from the Add button (sibling in the same button bar)
        var addButton = this.addOnProductSection.querySelector('.prdsys-addon-details-add');
        var mpid = addButton ? addButton.getAttribute('data-mpid') : null;

        if (mpid) {
          this.selectionsTemp = this.selectionsTemp.filter(function(selection) {
            return selection.mpid !== mpid;
          });

          // Remove the selected class from the matching card in the addon grid
          this.modal.querySelectorAll('.prdsys-addons .addonItemCard').forEach(function(card) {
            if (card.getAttribute('data-mpid') === mpid) {
              card.classList.remove('selected');
            }
          });

          this._updateItemCount();
        }

        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showSection('review', false, event);
        } else {
          this._showSection('addons', false, event);
        }
      }
    }, {
      key: "_reviewItemRemove",
      value: function _reviewItemRemove(event) {
        event.preventDefault();
        event.stopPropagation();

        var btn = event.target.closest('.bundlinator-review-remove') || event.target;
        var mpid = btn.getAttribute('data-mpid');
        if (!mpid) return;

        // Remove from selections
        this.selectionsFinal = this.selectionsFinal.filter(function(s) { return s.mpid !== mpid; });
        this.selectionsTemp = this.selectionsFinal.slice();

        // Remove the row from the DOM
        var reviewItem = btn.closest('.bundlinator-review-item');
        if (reviewItem) reviewItem.remove();

        // Deselect the matching card in the addons grid
        this.modal.querySelectorAll('.prdsys-addons .addonItemCard').forEach(function(card) {
          if (card.getAttribute('data-mpid') === mpid) {
            card.classList.remove('selected');
          }
        });

        // Recalculate and update the displayed total
        var USDollar = new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.theme && window.theme.currencyCode) || 'USD', maximumFractionDigits: 0 });
        var totalPrice = this.selectionsFinal.reduce(function(sum, item) {
          var price = item.price?.customSalePrice && parseFloat(item.price.customSalePrice) < parseFloat(item.price.decimalValue)
            ? parseFloat(item.price.customSalePrice)
            : parseFloat(item.price.decimalValue);
          if (item.monogramming && item.monogramming.cost) {
            price += parseFloat(item.monogramming.cost) + parseFloat(item.monogramming.upCharge);
          }
          if (item.isBaseProduct && item.giftbox && item.giftbox.id) {
            price += parseFloat(item.giftbox.price.decimalValue);
          }
          return sum + price;
        }, 0);
        var totalEl = this.modal.querySelector('.prdsys-summary .bundlinator-review-total');
        if (totalEl) totalEl.innerHTML = USDollar.format(totalPrice);

        // Update mobile totals bar
        var totalCountEl = this.modal.querySelector('.bundlinator-totals-count');
        var totalLabelEl = this.modal.querySelector('.bundlinator-totals-label');
        var totalPriceEl = this.modal.querySelector('.bundlinator-totals-price');
        if (totalCountEl) totalCountEl.textContent = this.selectionsFinal.length;
        if (totalLabelEl) totalLabelEl.textContent = this.selectionsFinal.length === 1 ? 'Item' : 'Items';
        if (totalPriceEl) totalPriceEl.textContent = USDollar.format(totalPrice);

        this._updateItemCount();
      }
    }, {
      key: "_addOnItemSave",
      value: function _addOnItemSave(event) {
        event.preventDefault();
        event.stopPropagation();

        var pid = event.target.getAttribute('data-pid');
        var mpid = event.target.getAttribute('data-mpid');
        var name = event.target.getAttribute('data-name');
        var color = event.target.getAttribute('data-color');
        var size = event.target.getAttribute('data-size');
        var preorder = event.target.getAttribute('data-preorder');
        var final_sale = event.target.getAttribute('data-finalsale');
        // Strip thousand-separator commas (e.g. "22,900.00" for PHP) before parseFloat
        var price = event.target.getAttribute('data-price').replace(/,/g, '').trim();
        var compare_at_price = event.target.getAttribute('data-compareat').replace(/,/g, '').trim();
        var custom_sale_price = event.target.getAttribute('data-customsale')?.replace(/,/g, '').trim();
        var image = event.target.getAttribute('data-image');
        var handle = event.target.getAttribute('data-handle');
        var stock_date = event.target.getAttribute('data-stockdate');

        var productToAdd = {
          id: pid,
          mpid: mpid,
          handle: handle,
          name: name,
          color: color,
          size: size,
          image: image,
          isBaseProduct: false,
          stockdate: stock_date,
          properties: {},
          price: {
              decimalValue: parseFloat(price).toFixed(2),
              value: parseFloat(price).toFixed(2),
              formatted: '$' + price
          }
        };

        if (custom_sale_price) {
          productToAdd.price["customSalePrice"] = parseFloat(custom_sale_price).toFixed(2);
        }

        if (compare_at_price) {
          productToAdd.properties["_compare_at_price"] = parseFloat(compare_at_price);
        }

        if (preorder === "true") {
          productToAdd.properties["_is_preorder"] = true;
          if (stock_date) productToAdd.properties["_est_ship_date"] = stock_date;
        }

        if (final_sale === "true") {
          productToAdd.properties["is_final_sale"] = true;
          productToAdd.properties["_LPROP"] = 'no-returns';
        }

        var configuratorSelectionsTemp = this.selectionsTemp;
        this.selectionsTemp = configuratorSelectionsTemp.filter(function(selection) {
          return selection.mpid !== mpid;
        });

        this.selectionsTemp.push(productToAdd);

        // Update the addon card image to reflect the selected colorway.
        // Prefer the PLP image (600×600 center crop) over the full-res variant image.
        var plpImage = event.target.getAttribute('data-plpimage');
        var cardImageSrc = plpImage || image;
        var addonCard = this.modal.querySelector('.prdsys-addons .addonItemCard[data-mpid="' + mpid + '"]');
        if (addonCard && cardImageSrc) {
          var cardImg = addonCard.querySelector('img');
          if (cardImg) cardImg.src = cardImageSrc;
        }

        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showSection('review', false, event);
        } else {
          this._showSection('addons', false, event);
        }

      }
    }, {
      key: "_addonDetailCancel",
      value: function _addonDetailCancel(event) {
        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showSection('review', false, event);
        } else {
          this._showSection('addons', false, event);
        }
      }
    }, {
      key: "_updateAddon",
      value: function _updateAddon(event) {
        var newVariant = event.detail.variant;
        this._updateAddOnSaveButton(newVariant);
        this._updateAddOnGallery(newVariant);

        if (newVariant && newVariant['custom_private_sale_price']) {
          checkPrivateSale();
        } else {
          const strikethroughPrices = this.element.querySelectorAll('.ProductItem__CustomStrikethroughPrice');
          if (strikethroughPrices.length) {
            strikethroughPrices.forEach(element => {
              element.classList.add('d-none');
            });
            const defaultPrices = this.element.querySelectorAll('.ProductItem__DefaultPrice');
            defaultPrices.forEach(element => {
              element.classList.remove('d-none');
            });
          }
        }
      }
    }, {
      key: "_updateAddOnGallery",
      value: function _updateAddOnGallery(newVariant) {
        if (!newVariant || !newVariant.featured_image) return;
        var img = this.addOnProductSection.querySelector('.bundlinator-addon-image img');
        if (img) { img.src = newVariant.featured_image.src; }
      }
    }, {
      key: "_updateAddOnSaveButton",
      value: function _updateAddOnSaveButton(newVariant) {

        var saveButton = this.addOnProductSection.querySelector('.prdsys-addon-details-add');

        if (saveButton) {
          saveButton.classList.remove('d-none');
          if (!newVariant) {
            saveButton.setAttribute('disabled', 'disabled');
            saveButton.removeAttribute('data-pid');
            saveButton.innerHTML = window.languages.productFormUnavailable;
          } else {
            if (newVariant['available']) {
              saveButton.removeAttribute('disabled');
              if (saveButton.textContent.trim() !== 'Update') saveButton.innerHTML = 'Add';
              saveButton.setAttribute('data-pid', newVariant['id']);
              saveButton.setAttribute('data-price', (newVariant['price'] / 100).toFixed(2));
              if (newVariant['compare_at_price']) {
                saveButton.setAttribute('data-compareat', (newVariant['compare_at_price'] / 100).toFixed(2));
              } else {
                saveButton.setAttribute('data-compareat', '');
              }

              if (newVariant['custom_private_sale_price']) {
                saveButton.setAttribute('data-customsale', (newVariant['custom_private_sale_price'] / 100).toFixed(2));
              } else {
                saveButton.setAttribute('data-customsale', '');
              }

              if (newVariant['is_preorder']) {
                saveButton.innerHTML = window.languages.productFormPreorder;
                saveButton.setAttribute('data-preorder', 'true');
              } else {
                saveButton.setAttribute('data-preorder', '');
              }
              if (newVariant['is_final_sale']) {
                saveButton.setAttribute('data-finalsale', 'true');
              } else {
                saveButton.setAttribute('data-finalsale', '');
              }
              if (newVariant.hasOwnProperty('option1')) {
                saveButton.setAttribute('data-color', newVariant['option1']);
              }
              if (newVariant.hasOwnProperty('option2')) {
                saveButton.setAttribute('data-size', newVariant['option2']);
              } else {
                saveButton.setAttribute('data-size', '');
              }
              if (newVariant.hasOwnProperty('back_in_stock_date')) {
                saveButton.setAttribute('data-stockdate', newVariant['back_in_stock_date']);
              } else {
                saveButton.setAttribute('data-stockdate', '');
              }
              if (newVariant.hasOwnProperty('featured_image')) {
                if (newVariant['featured_image'].src) {
                  saveButton.setAttribute('data-image', newVariant['featured_image'].src);
                }
              }

              // Update the PLP card thumbnail from variants_extra_data, sized to 600×600 center crop.
              // Shopify image_url returns protocol-relative URLs (//cdn.shopify.com/...) so we
              // avoid new URL() and manipulate the query string directly instead.
              try {
                var productDataEl = this.addOnProductSection.querySelector('[data-product-json]');
                if (productDataEl) {
                  var productData = JSON.parse(productDataEl.textContent);
                  var variantExtra = productData.variants_extra_data && productData.variants_extra_data[newVariant['id']];
                  if (variantExtra && variantExtra.plp_image) {
                    var plpBase = variantExtra.plp_image.replace(/\?.*$/, '');
                    saveButton.setAttribute('data-plpimage', plpBase + '?width=600&height=600&crop=center');
                  }
                }
              } catch(e) {}
            } else {
              saveButton.setAttribute('disabled', 'disabled');
              saveButton.removeAttribute('data-pid');
              saveButton.setAttribute('data-preorder', '');
              saveButton.setAttribute('data-finalsale', '');
              saveButton.innerHTML = window.languages.productFormSoldOut;
            }
          }
        }
      }
    }, {
      key: "_getAddOnItemDetails",
      value: function _getAddOnItemDetails(event) {
        event.preventDefault();
        var addonItemCard = event.target.closest('.addonItemCard');
        var variant_id = addonItemCard.getAttribute('data-pid');
        var addonProductHandle = addonItemCard.getAttribute('data-product');
        var addonMpid = addonItemCard.getAttribute('data-mpid');
        var isAlreadySelected = this.selectionsTemp && this.selectionsTemp.some(function(s) { return s.mpid === addonMpid; });

        if (isAlreadySelected) {
          var existingSelection = this.selectionsTemp.find(function(s) { return s.mpid === addonMpid; });
          if (existingSelection && existingSelection.id) { variant_id = existingSelection.id; }
        }

        this._openAddonDetail(addonProductHandle, variant_id, addonMpid, isAlreadySelected, false);
      }
    }, {
      key: "_openAddonDetail",
      value: function _openAddonDetail(handle, variantId, mpid, isAlreadySelected, fromReview) {
        var _this = this;
        var url = window.location.origin + '/products/' + handle + '?variant=' + variantId + '&view=bundlinator-addon';
        fetch(url)
          .then(function(response) { return response.text(); })
          .then(function(html) {
            var tempElement = document.createElement('div');
            tempElement.innerHTML = html;

            if (_this.exclusions && _this.exclusions.length > 0) {
              _this.exclusions.forEach(function(item) {
                var baseProducts = item.baseProducts;
                var exclusions = item.exclusions;
                var exclusionKeys = Object.keys(exclusions);
                if (baseProducts.length === 0 || baseProducts.includes(_this.baseproduct.sku)) {
                  exclusionKeys.forEach(function(key) {
                    if (key === handle) {
                      exclusions[key].forEach(function(attr) {
                        var attrEl = tempElement.querySelector('.ProductForm__Option li[data-value="' + attr + '"]');
                        if (attrEl) attrEl.remove();
                      });
                    }
                  });
                }
              });
            }

            var sectionHtml = tempElement.querySelector('.shopify-section').innerHTML;
            _this.addOnProductSection.innerHTML = sectionHtml;
            checkPrivateSale();
            _this.productVariants = new ProductVariants(_this.addOnProductSection, {});

            // Show Remove + Update when item is already selected
            if (isAlreadySelected) {
              var cancelBtn = _this.addOnProductSection.querySelector('.prdsys-addon-details-cancel');
              var removeBtn = _this.addOnProductSection.querySelector('.prdsys-addon-details-remove');
              var addBtn = _this.addOnProductSection.querySelector('.prdsys-addon-details-add');
              if (cancelBtn) cancelBtn.classList.add('d-none');
              if (removeBtn) removeBtn.classList.remove('d-none');
              if (addBtn && !addBtn.disabled) addBtn.textContent = 'Update';
            }

            // Track where we came from so Cancel/Update can return to the right screen
            _this._detailFromReview = fromReview;

            // Hide whichever section we came from
            if (fromReview) {
              _this.modal.querySelector('.prdsys-summary').style.display = 'none';
            } else {
              _this.modal.querySelector('.prdsys-main').classList.add('d-none');
            }
            _this.addOnProductSection.classList.remove('d-none');
            _this.modal.classList.add('bundlinator-detail-active');
          })
          .catch(function(error) {
            console.error('Failed to fetch bundlinator add-on detail:', error);
          });
      }
    }, {
      key: "_toggleAddOnItemMonogramming",
      value: function _toggleAddOnItemMonogramming(event) {

        var clickedElement = event.target;

        var productMonogramming = this.addOnProductSection.querySelector('.product-monogramming');
        productMonogramming.classList.toggle('show', clickedElement.checked);

        if (document.documentElement.clientWidth > 768) {
          var scrollWrapper = this.modal.querySelector('.scroll-wrapper');
          scrollWrapper.scrollTop = scrollWrapper.querySelector('.scroller').scrollHeight;

          if (productMonogramming.classList.contains('mobile-show')) {
              productMonogramming.classList.remove('mobile-show');
          }
        }

      }
    }, {
      key: "_toggleGiftBoxSelection",
      value: function _toggleGiftBoxSelection(event) {
        event.preventDefault();
        var giftboxCard = event.target.closest('.addonItemCard');
        if (!giftboxCard) return;
        var pid = giftboxCard.getAttribute('data-pid');
        var mpid = giftboxCard.getAttribute('data-mpid');
        var price = giftboxCard.getAttribute('data-price').replace(/^\s+|\s+$/g, '');

        if (!pid) {
            return;
        }

        var configuratorSelectionsTemp = this.selectionsTemp;

        if (configuratorSelectionsTemp.length > 0 && mpid === 'giftbox') {

            var giftboxInput = this.modal.querySelector("input[name='giftbox']");

            if (giftboxCard.classList.contains('selected')) {
                configuratorSelectionsTemp[0].giftbox = null;
                giftboxCard.classList.remove('selected');
                giftboxInput.checked = false;
            } else {
                var giftbox = {
                    id: pid,
                    mpid: mpid,
                    name: this.modal.querySelector('.gift-product-name').textContent,
                    color: '',
                    size: '',
                    price: {
                        decimalValue: parseFloat(price),
                        value: parseFloat(price),
                        formatted: '$' + price
                    }
                };
                configuratorSelectionsTemp[0].giftbox = giftbox;
                giftboxCard.classList.add('selected');
                giftboxInput.checked = true;
            }
        }

        this.selectionsTemp = configuratorSelectionsTemp;
      }
    }, {
      key: "_saveSelections",
      value: function _saveSelections(event) {
        event.preventDefault();

        this.selectionsFinal = this.selectionsTemp;
        this._showSection('addons', false, event);
      }
    }, {
      key: "_showSection",
      value: function _showSection(section = '', setTempStorage = false, event) {
        event.preventDefault();

        this.addOnProductSection.classList.add('d-none');
        this.modal.querySelector('.prdsys-main').classList.remove('d-none');
        this.modal.classList.remove('bundlinator-detail-active');

        // Scroll the modal body back to the top on every section transition
        var modalBody = this.modal.querySelector('.modal-body');
        if (modalBody) modalBody.scrollTop = 0;

        if (setTempStorage) {
          this.selectionsTemp = (this.selectionsFinal) ? this.selectionsFinal : [];
        }

        // Configurator no longer uses the options step — hide it unconditionally
        const optionsSection = this.modal.querySelector('.prdsys-options');
        if (optionsSection) optionsSection.style.display = 'none';

        if (section === 'addons') {
          var configuratorSelectionsTemp = this.selectionsTemp;
          var addonCards = this.modal.querySelectorAll('.prdsys-addons .addonItemCard');
          addonCards.forEach(function(card) {
            card.classList.remove('selected');
            var mpid = card.dataset.mpid;
            configuratorSelectionsTemp.forEach(function(selection) {
              if (selection.mpid === mpid) {
                card.classList.add('selected');
              }
            });
          });

          this.modal.querySelector('.prdsys-addons').style.display = 'block';
        } else {
          this.modal.querySelector('.prdsys-addons').style.display = 'none';
        }

        if (section === 'gifting') {
          this.modal.querySelector('.prdsys-gifting').style.display = 'block';
        } else {
          const optionGifting = this.modal.querySelector('.prdsys-gifting');
          if (optionGifting) optionGifting.style.display = 'none';
        }

        if (section === 'review') {
          let USDollar = new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: (window.theme && window.theme.currencyCode) || 'USD',
              maximumFractionDigits: 0,
          });

          this.selectionsFinal = this.selectionsTemp;

          var productSelectionsContainer = this.modal.querySelector('.prdsys-summary .product-selections');
          productSelectionsContainer.innerHTML = '';
          var totalPrice = 0;

          this.selectionsFinal.forEach(function(item) {
            let reviewItemHtml = document.querySelector('#bundlinatorModal div.reviewItemHtml .bundlinator-review-item').cloneNode(true);
            let productImage = reviewItemHtml.querySelector('img');
            productImage.src = item.image;
            productImage.alt = item.name;
            productImage.title = item.name;

            var attributes = '';
            if (item.properties["is_final_sale"]) {
              attributes += '<p class="CartItem__FinalSale">Final Sale</p>';
            }

            if (item.properties["_is_preorder"]) {
              attributes += '<p class="CartItem__Preorder">Estimated to ship <span class="instock-date">' + item.stockdate + '</span></p>';
            }

            attributes += item.color ? '<p>' + item.color : '';
            if (item.size && item.size != 'One Size' && item.size != 'Null') {
              attributes += ', ' + item.size;
            }
            attributes += '</p>';

            var monogramming = '';
            monogramming = item.monogramming && item.monogramming.text ? 'Monogram: ' + item.monogramming.text : '';

            var itemPrice = item.price.decimalValue;
            var priceHtml = '';
            if (item.price?.customSalePrice && parseFloat(item.price.customSalePrice) < parseFloat(item.price.decimalValue)) {
              itemPrice = parseFloat(item.price.customSalePrice).toFixed(2);
              priceHtml += '<span class="ProductItem__Price ProductItem__CustomStrikethroughPrice Price Price--compareAt Text--subdued d-none">' + USDollar.format(item.price.decimalValue)+ '</span>';
              priceHtml += '<span class="ProductItem__Price ProductItem__CustomStrikethroughPrice Price d-none">' + USDollar.format(item.price.customSalePrice) + '</span>';
            } else {
              priceHtml += '<span class="ProductItem__Price ProductItem__CustomStrikethroughPrice Price d-none">' + USDollar.format(item.price.decimalValue) + '</span>';
            }
            priceHtml += '<span class="ProductItem__Price ProductItem__DefaultPrice Price">' + USDollar.format(item.price.decimalValue) + '</span>';

            totalPrice += parseFloat(itemPrice);

            reviewItemHtml.querySelector('.product-name').innerHTML = item.name;
            reviewItemHtml.querySelector('.product-price').innerHTML = priceHtml;
            reviewItemHtml.querySelector('.product-attributes').innerHTML = attributes;
            reviewItemHtml.querySelector('.product-monogramming').innerHTML = monogramming;

            if (item.isBaseProduct && item.giftbox && item.giftbox.id) {
              reviewItemHtml.querySelector('.product-giftoptions').innerHTML = 'Gift Box Added';
              totalPrice += parseFloat(item.giftbox.price.decimalValue);
            }

            if (item.monogramming && item.monogramming.cost) {
              totalPrice += parseFloat(item.monogramming.cost) + parseFloat(item.monogramming.upCharge);
            }

            // Show Edit + Remove action links for addon items only (base product has no actions)
            var removeBtn = reviewItemHtml.querySelector('.bundlinator-review-remove');
            if (!item.isBaseProduct) {
              if (removeBtn) {
                removeBtn.classList.remove('d-none');
                removeBtn.setAttribute('data-mpid', item.mpid);
              }
            }

            productSelectionsContainer.appendChild(reviewItemHtml);
          });

          var reviewTotalEl = this.modal.querySelector('.prdsys-summary .bundlinator-review-total');
          if (reviewTotalEl) reviewTotalEl.innerHTML = USDollar.format(totalPrice);

          // Update mobile totals bar
          var totalCountEl = this.modal.querySelector('.bundlinator-totals-count');
          var totalLabelEl = this.modal.querySelector('.bundlinator-totals-label');
          var totalPriceEl = this.modal.querySelector('.bundlinator-totals-price');
          if (totalCountEl) totalCountEl.textContent = this.selectionsFinal.length;
          if (totalLabelEl) totalLabelEl.textContent = this.selectionsFinal.length === 1 ? 'Item' : 'Items';
          if (totalPriceEl) totalPriceEl.textContent = USDollar.format(totalPrice);

          this.modal.classList.add('bundlinator-in-review');
          this.modal.querySelector('.prdsys-summary').style.display = 'block';

        } else {
          this.modal.classList.remove('bundlinator-in-review');
          this.modal.querySelector('.prdsys-summary').style.display = 'none';
        }

        this._updateItemCount();
        checkPrivateSale();
      }
    }, {
      key: "_updateItemCount",
      value: function _updateItemCount() {
        var selections = this.selectionsTemp || this.selectionsFinal || [];
        var count = selections.length;
        var countEl = this.modal.querySelector('.bundlinator-item-count');
        var labelEl = this.modal.querySelector('.bundlinator-item-label');
        if (countEl) countEl.textContent = count;
        if (labelEl) labelEl.textContent = count === 1 ? 'Item' : 'Items';

        // Update header price with running total of base product + selected add-ons
        var totalPrice = selections.reduce(function(sum, item) {
          var price = (item.price && item.price.customSalePrice &&
                       parseFloat(item.price.customSalePrice) < parseFloat(item.price.decimalValue))
            ? parseFloat(item.price.customSalePrice)
            : parseFloat(item.price && item.price.decimalValue || 0);
          return sum + (isNaN(price) ? 0 : price);
        }, 0);
        var priceEl = this.modal.querySelector('.bundlinator-header__price');
        if (priceEl) {
          priceEl.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.theme && window.theme.currencyCode) || 'USD', maximumFractionDigits: 0 }).format(totalPrice);
        }
      }
    }]);

    return BundlinatorSection;
  }();

  // ============================================================
  //  Cuy Drawer Configurator (V3) — Bottom Sheet / Side Drawer
  // ============================================================
  var CuyDrawerConfiguratorSection = /*#__PURE__*/function() {
    function CuyDrawerConfiguratorSection(container) {
      var _this = this;
      _classCallCheck(this, CuyDrawerConfiguratorSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.panel = this.element.querySelector('.cuy-drawer-panel');
      this.backdrop = this.element.querySelector('.cuy-drawer-backdrop');

      this.selections = [];
      this._savedState = null;
      this._addedToCart = false;
      this._detailFromReview = false; // routes Cancel/Remove back to review vs addons
      this.exclusions = null;
      this.baseproduct = null;
      this.productVariants = null;
      this.addonDetailSection = null;
      this._toastTimer = null;
      this._scrollTitleIdx = -1;

      this._attachListeners();
    }

    _createClass(CuyDrawerConfiguratorSection, [{
      key: '_attachListeners',
      value: function _attachListeners() {
        var _this = this;

        // Open — button can live anywhere (PDP form or sticky drawer clone)
        document.addEventListener('click', function(e) {
          if (e.target.closest('[data-cuy-drawer-open]')) _this._open();
        });

        // Backdrop closes drawer
        this.backdrop.addEventListener('click', function() { _this._close(); });

        // --- Shared bottom-sheet drag physics (ported from Vaul: px/ms velocity-based
        //     dismiss, proportional backdrop fade, 25%-of-height distance fallback) ---
        var _sheetPanelEl = this.panel;
        var _sheetBackdrop = this.element.querySelector('.cuy-drawer-backdrop');
        var DISMISS_VELOCITY = 0.4; // px/ms — a flick this fast dismisses regardless of distance
        var CLOSE_FRACTION = 0.25;  // otherwise dismiss once dragged past 25% of sheet height

        // Follow the finger: translate the sheet and fade the backdrop proportionally.
        var renderDrag = function(delta) {
          delta = Math.max(0, delta);
          _sheetPanelEl.style.transform = 'translate3d(0,' + delta + 'px,0)';
          if (_sheetBackdrop) {
            var h = _sheetPanelEl.offsetHeight || 1;
            _sheetBackdrop.style.transition = 'none';
            _sheetBackdrop.style.opacity = String(Math.max(0, Math.min(1, 1 - delta / h)));
          }
        };
        // On release: fling down dismisses, fling up snaps back, otherwise distance
        // decides. Then hand the animation back to the panel's CSS transition.
        var releaseDrag = function(delta, velocity) {
          var h = _sheetPanelEl.offsetHeight || 1;
          var shouldClose = velocity > DISMISS_VELOCITY ? true
            : velocity < -DISMISS_VELOCITY ? false
            : Math.max(0, delta) > h * CLOSE_FRACTION;
          if (shouldClose) { _this._close(); }
          requestAnimationFrame(function() {
            _sheetPanelEl.style.transition = '';
            _sheetPanelEl.style.transform = '';
            if (_sheetBackdrop) { _sheetBackdrop.style.transition = ''; _sheetBackdrop.style.opacity = ''; }
          });
        };

        // Drag handle — swipe down to dismiss (mobile bottom sheet)
        var handle = this.element.querySelector('.cuy-drawer-handle');
        if (handle) {
          var dragStartY = 0;
          var dragLastY = 0;
          var dragLastT = 0;
          var dragVel = 0; // px/ms, exponentially smoothed; >0 = downward
          var dragging = false;

          var dragStart = function(y) {
            dragging = true;
            dragStartY = y;
            dragLastY = y;
            dragLastT = performance.now();
            dragVel = 0;
            _sheetPanelEl.style.transition = 'none';
          };
          var dragMove = function(y) {
            if (!dragging) return;
            var now = performance.now();
            var dt = now - dragLastT;
            if (dt > 0) { dragVel = dragVel * 0.7 + ((y - dragLastY) / dt) * 0.3; }
            dragLastY = y;
            dragLastT = now;
            renderDrag(y - dragStartY);
          };
          var dragEnd = function() {
            if (!dragging) return;
            dragging = false;
            releaseDrag(dragLastY - dragStartY, dragVel);
          };

          handle.addEventListener('touchstart', function(e) {
            dragStart(e.touches[0].clientY);
          }, { passive: true });
          handle.addEventListener('touchmove', function(e) {
            dragMove(e.touches[0].clientY);
          }, { passive: true });
          handle.addEventListener('touchend', dragEnd);
          handle.addEventListener('touchcancel', dragEnd);

          handle.addEventListener('mousedown', function(e) {
            dragStart(e.clientY);
            e.preventDefault();
          });
          document.addEventListener('mousemove', function(e) {
            if (dragging) dragMove(e.clientY);
          });
          document.addEventListener('mouseup', function() {
            if (dragging) dragEnd();
          });
        }

        // Pull-to-dismiss: on mobile, once the add-ons list is scrolled to the top,
        // continuing to swipe down drags the whole sheet (like the handle).
        var scrollBody = this.element.querySelector('.cuy-drawer-body');
        if (scrollBody) {
          var sheetPanel = this.panel;
          var pullStartY = 0;
          var pullStartX = 0;
          var pullAxis = null; // 'h' | 'v' once the gesture's dominant axis is locked
          var pullLastY = 0;
          var pullLastT = 0;
          var pullVel = 0; // px/ms, exponentially smoothed; >0 = downward
          var pulling = false;

          var pullScroller = null;

          var isMobile = function() {
            return window.matchMedia && window.matchMedia('(max-width: 991.98px)').matches;
          };
          // Find the actual vertical scroll container under the finger (whichever view
          // we're in), skipping horizontal-only scrollers like the gallery / card sliders.
          var getScroller = function(node) {
            var el = node;
            while (el && el !== sheetPanel) {
              if (el.scrollHeight > el.clientHeight + 1) {
                var oy = window.getComputedStyle(el).overflowY;
                if (oy === 'auto' || oy === 'scroll') return el;
              }
              el = el.parentElement;
            }
            return scrollBody;
          };

          scrollBody.addEventListener('touchstart', function(e) {
            if (e.touches.length !== 1) return;
            pullStartY = e.touches[0].clientY;
            pullStartX = e.touches[0].clientX;
            pullAxis = null;
            pullLastY = pullStartY;
            pullLastT = performance.now();
            pullVel = 0;
            pulling = false;
            pullScroller = getScroller(e.target);
          }, { passive: true });

          scrollBody.addEventListener('touchmove', function(e) {
            if (e.touches.length !== 1) return;
            var y = e.touches[0].clientY;

            if (!pulling) {
              // Lock the gesture to one axis so a mostly-horizontal swipe (e.g. the
              // add-on gallery filmstrip) is never hijacked by the sheet pull, even if
              // the finger drifts down a little as it moves across the screen.
              if (pullAxis === 'h') return; // horizontal — leave native scrolling alone
              var dx = e.touches[0].clientX - pullStartX;
              var dy = y - pullStartY;
              if (pullAxis === null) {
                if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return; // not enough to classify yet
                pullAxis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
                if (pullAxis === 'h') return;
              }
              // Vertical gesture. Engage the instant the finger moves DOWN while the list
              // is at the top — keyed on the per-frame direction, NOT the distance from
              // the gesture origin. (Cumulative distance meant that after scrolling up
              // first, the finger had to travel all the way back past the origin before
              // engaging — during which iOS rubber-banded a long way, then visibly popped
              // back when we froze. Per-frame direction hands off right at the top, with
              // no accumulated overscroll to snap.)
              var atTop = !pullScroller || pullScroller.scrollTop <= 0;
              var dyInc = y - pullLastY; // movement since the previous frame
              pullLastY = y;
              if (isMobile() && atTop && dyInc > 0) {
                pulling = true;
                pullStartY = y; // rebase so the sheet doesn't jump
                pullLastT = performance.now();
                pullVel = 0;    // ignore any prior scroll velocity in the dismiss decision
                // Freeze the list so the browser's scroll/overscroll can't run alongside
                // our transform — that contention janks Android and double-pulls iOS.
                if (pullScroller) { pullScroller.style.overflowY = 'hidden'; }
                sheetPanel.style.transition = 'none';
                e.preventDefault();
                return;
              }
              return; // not pulling — let native scrolling happen
            }

            var now = performance.now();
            var dt = now - pullLastT;
            if (dt > 0) { pullVel = pullVel * 0.7 + ((y - pullLastY) / dt) * 0.3; }
            pullLastY = y;
            pullLastT = now;
            e.preventDefault(); // own the gesture so the sheet moves but the list can't bounce
            renderDrag(y - pullStartY);
          }, { passive: false });

          var pullEnd = function() {
            if (!pulling) return;
            pulling = false;
            if (pullScroller) { pullScroller.style.overflowY = ''; } // unfreeze the list
            releaseDrag(pullLastY - pullStartY, pullVel);
          };
          scrollBody.addEventListener('touchend', pullEnd);
          scrollBody.addEventListener('touchcancel', pullEnd);
        }

        // Header close
        this.delegateElement.on('click', '.cuy-drawer-header__close', function() { _this._close(); });

        // Header back button — step back one view (no debounce; rapid taps are fine)
        this.delegateElement.on('click', '.cuy-drawer-header__back', function() {
          _this._stepBack();
        });

        // Browser Back BUTTON (Android, desktop) → route through the sheet's back ladder.
        // Only acts if we currently own a trapped entry (i.e. we're in a sub-view); at the
        // root there's no trap, so Back leaves the page normally.
        window.addEventListener('popstate', function() {
          if (_this._suppressNextPopstate) { _this._suppressNextPopstate = false; return; }
          if (!_this.element.classList.contains('cuy-drawer--open')) return; // closed → normal back
          if (!_this._historyTrapped) return; // at root → let Back leave the page
          _this._edgeBackPending = false; // a real system Back handled it — cancel the edge fallback
          _this._sheetBack(true); // gesture consumed our entry → step back within the sheet
        });

        // iOS Safari renders a system page-preview during a left-edge "back" swipe even
        // though we trap the history (the preview shows BEFORE popstate fires). Intercept
        // the edge swipe ourselves: cancel the system gesture so there's no previous-page
        // peek, and run the sheet's own Back on release. No finger-follow / painted views.
        (function() {
          var EDGE = 64, BACK_AT = 55; // how far from the left edge a back-swipe may start
          var sx = 0, sy = 0, dx = 0, dy = 0, fromEdge = false;
          _this.element.addEventListener('touchstart', function(e) {
            if (e.touches.length !== 1) { fromEdge = false; return; }
            sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; dy = 0;
            // Only intercept the edge swipe when there's somewhere to go back to within
            // the sheet (a sub-view). At the root, let iOS's own Back gesture run.
            var inSub = _this.element.classList.contains('cuy-drawer--detail-active') ||
                        _this.element.classList.contains('cuy-drawer--review');
            fromEdge = _this.element.classList.contains('cuy-drawer--open') && inSub && sx <= EDGE;
          }, { passive: true });
          _this.element.addEventListener('touchmove', function(e) {
            if (!fromEdge || e.touches.length !== 1) return;
            dx = e.touches[0].clientX - sx; dy = e.touches[0].clientY - sy;
            // Rightward + horizontal-dominant from the edge = a back gesture → suppress
            // the iOS system back and its page preview. (Vertical scrolls near the edge
            // keep dy dominant, so they're left alone.)
            if (dx > 0 && Math.abs(dx) > Math.abs(dy)) e.preventDefault();
          }, { passive: false });
          var edgeEnd = function() {
            if (!fromEdge) return;
            fromEdge = false;
            if (dx > BACK_AT && Math.abs(dx) > Math.abs(dy)) {
              // The platform's own Back may also fire (Android always does; an iOS version
              // might ignore our preventDefault). If it does, its popstate handles the step
              // and cancels this fallback. Only if NO popstate arrives (iOS suppressed the
              // gesture) do we drive the back ourselves — avoiding the double history.back()
              // that was corrupting the stack and dropping the trap on the next sub-view.
              _this._edgeBackPending = true;
              setTimeout(function() {
                if (!_this._edgeBackPending) return;
                _this._edgeBackPending = false;
                _this._sheetBack(false);
              }, 80); // short enough to feel instant, long enough to catch a same-swipe system popstate
            }
          };
          _this.element.addEventListener('touchend', edgeEnd);
          _this.element.addEventListener('touchcancel', edgeEnd);
        })();

        // Category tab switch
        this.delegateElement.on('click', '.cuy-drawer-tab', function(e) {
          var tab = e.target.closest('.cuy-drawer-tab');
          if (tab) _this._selectCategory(tab.dataset.category);
        });

        // Add-on card click → open detail panel (suppressed if a slider drag just ended)
        this.delegateElement.on('click', '.cuy-drawer-card', function(e) {
          var card = e.target.closest('.cuy-drawer-card');
          if (!card) return;
          // Desktop prev/next chevrons live inside the card — never act on them
          if (e.target.closest('.cuy-drawer-card__nav')) return;
          // Suppress click after a slider drag
          var slider = e.target.closest('.cuy-drawer-card__slider');
          if (slider && slider.dataset.suppressClick === '1') {
            slider.dataset.suppressClick = '0';
            return;
          }
          // Image area → quick add / remove
          if (e.target.closest('.cuy-drawer-card__imagewrapper')) {
            _this._quickAddAddon(card);
            return;
          }
          // Text area (name, price, desc, info icon) → open detail panel
          var isSelected = card.classList.contains('cuy-drawer-card--selected');
          _this._openAddonDetail(card.dataset.handle, card.dataset.pid, card.dataset.mpid, isSelected, false);
        });

        // Keyboard activation for the text area (role=button) — Enter / Space open detail panel
        this.delegateElement.on('keydown', '.cuy-drawer-card__textarea', function(e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          var card = e.target.closest('.cuy-drawer-card');
          if (!card) return;
          var isSelected = card.classList.contains('cuy-drawer-card--selected');
          _this._openAddonDetail(card.dataset.handle, card.dataset.pid, card.dataset.mpid, isSelected, false);
        });

        // Add-on card image sliders — scroll updates indicator; mouse drag for desktop
        this._initCardSliders();

        // Re-init sliders after MainProductSection re-renders the drawer body on PDP variant change
        // (innerHTML replace destroys the slider nodes our scroll/drag listeners are bound to).
        this.element.addEventListener('cuy-drawer:body-rerendered', this._initCardSliders.bind(this));

        // Detail panel — Add / Update
        this.delegateElement.on('click', '.prdsys-addon-details-add', this._addonDetailAdd.bind(this));

        // Detail panel — Cancel
        this.delegateElement.on('click', '.prdsys-addon-details-cancel', function(e) {
          e.preventDefault();
          _this._addonDetailCancel();
        });

        // Detail panel — Remove
        this.delegateElement.on('click', '.prdsys-addon-details-remove', this._addonDetailRemove.bind(this));

        // Variant changed inside injected detail panel
        this.delegateElement.on('variant:changed', this._updateAddon.bind(this));

        // Footer — in review, only the Add-to-Bag button commits; in the addons view,
        // clicking anywhere in the footer advances to Review (when an item is selected).
        this.delegateElement.on('click', '.cuy-drawer-footer', function(e) {
          if (_this.element.classList.contains('cuy-drawer--review')) {
            if (e.target.closest('.cuy-drawer-footer__atb')) _this._addItemsToCart(e);
            return;
          }
          var atbBtn = _this.element.querySelector('.cuy-drawer-footer__atb');
          if (atbBtn && atbBtn.disabled) return; // no add-ons selected → footer inert
          _this._showReview();
        });

        // Review — remove item
        this.delegateElement.on('click', '.cuy-drawer-review-remove', this._reviewItemRemove.bind(this));

        // Onboarding callout — close button
        this.delegateElement.on('click', '.cuy-drawer-onboard__close', this._hideOnboard.bind(this));

        // Dismiss on scroll or any touch/pointer into the addon grid
        var onboardBody = this.element.querySelector('.cuy-drawer-body');
        if (onboardBody) {
          onboardBody.addEventListener('scroll', this._hideOnboard.bind(this), { passive: true });
          onboardBody.addEventListener('pointerdown', this._hideOnboard.bind(this), { passive: true });
        }

        // Scroll-linked header title: as a category heading scrolls 60% of its own height
        // past the body top, the header title swaps to that category name.
        // Scroll events don't bubble so we attach directly to the body element.
        var scrollBody = this.element.querySelector('.cuy-drawer-body');
        if (scrollBody) {
          scrollBody.addEventListener('scroll', function() {
            // Only active on the add-ons view
            if (_this.element.classList.contains('cuy-drawer--detail-active') ||
                _this.element.classList.contains('cuy-drawer--review')) return;
            var headings = _this.element.querySelectorAll('.cuy-drawer-category-heading');
            if (!headings.length) return;
            var titleEl = _this.element.querySelector('.cuy-drawer-header__title');
            if (!titleEl) return;
            var gTop = scrollBody.getBoundingClientRect().top;
            var idx = -1;
            var name = null;
            headings.forEach(function(h, i) {
              var r = h.getBoundingClientRect();
              if (r.top - gTop < -r.height * 0.6) { idx = i; name = h.textContent; }
            });
            if (idx === _this._scrollTitleIdx) return;
            var up = idx > _this._scrollTitleIdx;
            _this._scrollTitleIdx = idx;
            titleEl.textContent = name || 'Select Add-ons';
            titleEl.classList.remove('is-title-up', 'is-title-down');
            void titleEl.offsetWidth; // force reflow to restart animation on rapid changes
            titleEl.classList.add(up ? 'is-title-up' : 'is-title-down');
          }, { passive: true });
        }

      }
    }, {
      key: '_showOnboard',
      value: function _showOnboard() {
        var el = this.element.querySelector('.cuy-drawer-onboard');
        if (!el || this._onboardShown) return;
        this._onboardShown = true;
        // Set title from the parsed base product name
        var titleEl = el.querySelector('.cuy-drawer-onboard__title');
        if (titleEl && this.baseproduct && this.baseproduct.name) {
          titleEl.textContent = 'Customize Your ' + this.baseproduct.name;
        }
        el.hidden = false;
        requestAnimationFrame(function() { requestAnimationFrame(function() { el.classList.add('is-visible'); }); });
      }
    }, {
      key: '_hideOnboard',
      value: function _hideOnboard() {
        var el = this.element.querySelector('.cuy-drawer-onboard');
        if (!el || el.hidden) return;
        el.classList.remove('is-visible');
        setTimeout(function() { el.hidden = true; }, 300);
      }
    }, {
      key: '_open',
      value: function _open() {
        this.element.classList.add('cuy-drawer--open');
        document.body.classList.add('cuy-drawer-open');
        this._initDrawer();
        // Show onboarding callout 550ms after the drawer finishes sliding in
        var _this = this;
        setTimeout(function() { _this._showOnboard(); }, 550);
        // No history trap at the root — Back from the add-ons view should leave the page
        // like normal. The trap is armed only when we enter a sub-view (detail / review),
        // via _trapForSubview().
      }
    }, {
      key: '_close',
      value: function _close() {
        this.element.classList.remove('cuy-drawer--open');
        document.body.classList.remove('cuy-drawer-open');
        this._saveState();
        this._showAddons(); // reset to addons (also releases any sub-view history trap)
      }
    }, {
      key: '_trapForSubview',
      value: function _trapForSubview() {
        // Keep exactly one trapped history entry while in a sub-view (detail/review) and
        // none at the root. Called after every view change, so Back is captured only when
        // there's somewhere within the sheet to go back to.
        var inSub = this.element.classList.contains('cuy-drawer--detail-active') ||
                    this.element.classList.contains('cuy-drawer--review');
        if (inSub && !this._historyTrapped) {
          try { history.pushState({ cuyDrawer: true }, ''); this._historyTrapped = true; } catch (e) {}
        } else if (!inSub && this._historyTrapped) {
          this._historyTrapped = false;
          this._suppressNextPopstate = true; // consuming our own entry — ignore the popstate it fires
          try { history.back(); } catch (e) { this._suppressNextPopstate = false; }
        }
      }
    }, {
      key: '_stepBack',
      value: function _stepBack() {
        // One level back through the sheet (the view methods re-sync the history trap).
        if (this.element.classList.contains('cuy-drawer--detail-active')) { this._addonDetailCancel(); return true; }
        if (this.element.classList.contains('cuy-drawer--review')) { this._exitReviewToAddons(); return true; }
        return false;
      }
    }, {
      key: '_sheetBack',
      value: function _sheetBack(fromPopstate) {
        // Debounced entry for the Back GESTURE (edge swipe / popstate). On the rare iOS
        // version where our preventDefault doesn't fully suppress the system gesture, both
        // the edge handler and popstate can fire — the debounce keeps it to one step.
        var now = (window.performance && performance.now) ? performance.now() : Date.now();
        if (this._lastBackAt && (now - this._lastBackAt) < 250) return false;
        this._lastBackAt = now;
        if (fromPopstate) this._historyTrapped = false; // the browser already consumed our entry
        return this._stepBack();
      }
    }, {
      key: '_initDrawer',
      value: function _initDrawer() {
        this.addonDetailSection = this.element.querySelector('.cuy-drawer-addon-detail');
        this.baseproduct = JSON.parse(this.element.querySelector('[data-cuy-drawer-baseproduct-json]').textContent || '{}');

        var cexEl = this.element.querySelector('[data-cex-json]');
        if (cexEl) {
          try { this.exclusions = JSON.parse(cexEl.textContent); } catch(e) { this.exclusions = null; }
        }

        if (this._savedState && this._savedState.variantId === this.baseproduct.id) {
          this.selections = this._savedState.selections.slice();
          this.selections[0] = this.baseproduct;
        } else {
          this.selections = [this.baseproduct];
          this._savedState = null;
        }

        this._syncCardStates();
        this._updateFooter();

        var body = this.element.querySelector('.cuy-drawer-body');
        if (body) body.scrollTop = 0;
      }
    }, {
      key: '_saveState',
      value: function _saveState() {
        if (this._addedToCart) {
          this._savedState = null;
          this._addedToCart = false;
        } else if (this.baseproduct) {
          this._savedState = {
            variantId: this.baseproduct.id,
            selections: this.selections.slice()
          };
        }
      }
    }, {
      key: '_initCardSliders',
      value: function _initCardSliders() {
        var sliders = this.element.querySelectorAll('.cuy-drawer-card__slider');
        sliders.forEach(function(slider) {
          var card = slider.closest('.cuy-drawer-card');
          var indicator = card ? card.querySelector('.cuy-drawer-card__indicator') : null;
          var track = card ? card.querySelector('.cuy-drawer-card__indicator-track') : null;
          var slideCount = track ? parseInt(track.dataset.slideCount, 10) || 1 : 1;
          var navPrev = card ? card.querySelector('.cuy-drawer-card__nav--prev') : null;
          var navNext = card ? card.querySelector('.cuy-drawer-card__nav--next') : null;

          var updateIndicator = function() {
            var w = slider.clientWidth || 1;
            var ratio = slider.scrollLeft / w;
            var index = Math.max(0, Math.min(slideCount - 1, Math.round(ratio)));
            slider.dataset.slideIndex = String(index);
            if (indicator) indicator.style.transform = 'translateX(' + (index * 100) + '%)';
            // Hide the chevron once you reach that end (desktop only)
            if (navPrev) navPrev.classList.toggle('cuy-drawer-card__nav--disabled', index <= 0);
            if (navNext) navNext.classList.toggle('cuy-drawer-card__nav--disabled', index >= slideCount - 1);
          };
          slider.addEventListener('scroll', updateIndicator, { passive: true });

          // Desktop chevrons — advance one slide; stop propagation so the card detail doesn't open
          var goToSlide = function(index) {
            index = Math.max(0, Math.min(slideCount - 1, index));
            slider.scrollTo({ left: index * (slider.clientWidth || 1), behavior: 'smooth' });
          };
          if (navPrev) navPrev.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation();
            goToSlide((parseInt(slider.dataset.slideIndex, 10) || 0) - 1);
          });
          if (navNext) navNext.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation();
            goToSlide((parseInt(slider.dataset.slideIndex, 10) || 0) + 1);
          });
          updateIndicator(); // set initial chevron state (prev hidden at slide 0)

          // Mouse drag for desktop (touch handled by native overflow scroll)
          var isDown = false;
          var startX = 0;
          var startScrollLeft = 0;
          var moved = 0;
          slider.addEventListener('mousedown', function(e) {
            isDown = true;
            moved = 0;
            startX = e.pageX;
            startScrollLeft = slider.scrollLeft;
            slider.classList.add('is-dragging');
            e.preventDefault();
          });
          var endDrag = function(e) {
            if (!isDown) return;
            isDown = false;
            slider.classList.remove('is-dragging');
            if (moved > 5) {
              slider.dataset.suppressClick = '1';
              // Snap to nearest slide
              var w = slider.clientWidth || 1;
              var target = Math.round(slider.scrollLeft / w) * w;
              slider.scrollTo({ left: target, behavior: 'smooth' });
            }
          };
          slider.addEventListener('mousemove', function(e) {
            if (!isDown) return;
            var dx = e.pageX - startX;
            moved = Math.max(moved, Math.abs(dx));
            slider.scrollLeft = startScrollLeft - dx;
          });
          slider.addEventListener('mouseup', endDrag);
          slider.addEventListener('mouseleave', endDrag);
        });
      }
    }, {
      key: '_syncCardStates',
      value: function _syncCardStates() {
        var _this = this;
        this.element.querySelectorAll('.cuy-drawer-card').forEach(function(card) {
          var mpid = card.dataset.mpid;
          var saved = _this.selections.find(function(s) { return !s.isBaseProduct && s.mpid === mpid; });
          card.classList.toggle('cuy-drawer-card--selected', !!saved);
        });
        this._updateCategoryCounts();
      }
    }, {
      key: '_updateCategoryCounts',
      value: function _updateCategoryCounts() {
        // Tally selected cards per category group, then write the superscript on each tab.
        var counts = {};
        this.element.querySelectorAll('.cuy-drawer-category-group').forEach(function(group) {
          counts[group.dataset.category] = group.querySelectorAll('.cuy-drawer-card--selected').length;
        });
        this.element.querySelectorAll('.cuy-drawer-tab').forEach(function(tab) {
          var sup = tab.querySelector('.cuy-drawer-tab__count');
          if (!sup) return;
          var count = counts[tab.dataset.category] || 0;
          if (count > 0) {
            sup.textContent = count;
            sup.classList.remove('d-none');
          } else {
            sup.textContent = '';
            sup.classList.add('d-none');
          }
        });
      }
    }, {
      key: '_selectCategory',
      value: function _selectCategory(category) {
        this.element.querySelectorAll('.cuy-drawer-tab').forEach(function(tab) {
          var active = tab.dataset.category === category;
          tab.classList.toggle('cuy-drawer-tab--active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.element.querySelectorAll('.cuy-drawer-category-group').forEach(function(group) {
          group.classList.toggle('d-none', group.dataset.category !== category);
        });
      }
    }, {
      key: '_exitReviewToAddons',
      value: function _exitReviewToAddons() {
        var _this = this;
        var panel = this.element.querySelector('.cuy-drawer-review');
        var isMobile = window.matchMedia && window.matchMedia('(max-width: 991.98px)').matches;
        // Desktop (or no panel / not in review): switch instantly, no slide-down
        if (!panel || !isMobile || !this.element.classList.contains('cuy-drawer--review')) {
          this._showAddons();
          return;
        }
        // Play the reverse (slide-down) animation, then complete the transition
        panel.classList.add('cuy-drawer-review--exiting');
        var done = false;
        var finish = function() {
          if (done) return;
          done = true;
          panel.removeEventListener('animationend', onEnd);
          panel.classList.remove('cuy-drawer-review--exiting');
          _this._showAddons();
        };
        var onEnd = function(e) { if (e.target === panel) finish(); };
        panel.addEventListener('animationend', onEnd);
        setTimeout(finish, 600); // fallback if animationend doesn't fire (must exceed the 0.5s exit animation)
      }
    }, {
      key: '_showAddons',
      value: function _showAddons() {
        if (this.addonDetailSection) this.addonDetailSection.classList.add('d-none');
        this.element.classList.remove('cuy-drawer--detail-active');
        this.element.classList.remove('cuy-drawer--review');
        var atbBtn = this.element.querySelector('.cuy-drawer-footer__atb');
        if (atbBtn) atbBtn.textContent = 'Review';
        var titleEl = this.element.querySelector('.cuy-drawer-header__title');
        if (titleEl) titleEl.textContent = 'Select Add-ons';
        this._scrollTitleIdx = -1;
        var body = this.element.querySelector('.cuy-drawer-body');
        if (body) body.scrollTop = 0;
        // Always re-sync card selected states from this.selections as the source of truth.
        // This handles add, update, and remove in a single reliable place.
        this._syncCardStates();
        this._trapForSubview(); // at the root now → release any sub-view history trap
      }
    }, {
      key: '_showReview',
      value: function _showReview() {
        var _this = this;
        var fmt = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: (window.theme && window.theme.currencyCode) || 'USD',
          maximumFractionDigits: 0
        });

        var list = this.element.querySelector('.cuy-drawer-review__list');
        var template = this.element.querySelector('.cuy-drawer-review-item-template .cuy-drawer-review-item');
        if (!list || !template) return;

        list.innerHTML = '';
        var totalPrice = 0;

        this.selections.forEach(function(item) {
          var row = template.cloneNode(true);
          var img = row.querySelector('img');
          if (img) { img.src = item.image; img.alt = item.name; }
          var nameEl = row.querySelector('.product-name');
          if (nameEl) nameEl.textContent = item.name;

          var itemPrice = item.price.customSalePrice && parseFloat(item.price.customSalePrice) < parseFloat(item.price.decimalValue)
            ? parseFloat(item.price.customSalePrice) : parseFloat(item.price.decimalValue);
          totalPrice += isNaN(itemPrice) ? 0 : itemPrice;

          var priceEl = row.querySelector('.product-price');
          if (priceEl) priceEl.textContent = fmt.format(itemPrice);

          var attrs = [];
          if (item.color) attrs.push(item.color);
          if (item.size && item.size !== 'One Size' && item.size !== 'Null' && item.size !== 'null') attrs.push(item.size);
          var attrEl = row.querySelector('.product-attributes');
          if (attrEl) attrEl.textContent = attrs.join(', ');

          // Helper text — reuse the add-on card's short description (add-ons only)
          var descEl = row.querySelector('.product-description');
          if (descEl && !item.isBaseProduct) {
            var cardDescEl = _this.element.querySelector('.cuy-drawer-card[data-mpid="' + item.mpid + '"] .cuy-drawer-card__description');
            var descText = cardDescEl ? cardDescEl.textContent.trim() : '';
            if (descText) {
              descEl.textContent = descText;
              descEl.classList.remove('d-none');
            }
          }

          var removeBtn = row.querySelector('.cuy-drawer-review-remove');
          if (removeBtn) {
            if (item.isBaseProduct) {
              removeBtn.classList.add('d-none');
            } else {
              row.dataset.mpid = item.mpid;
            }
          }

          list.appendChild(row);
        });

        // Update footer total + switch button to "Add to Bag"
        var countEl = this.element.querySelector('.cuy-drawer-total-count');
        var labelEl = this.element.querySelector('.cuy-drawer-total-label');
        var priceEl = this.element.querySelector('.cuy-drawer-footer__total-price');
        if (countEl) countEl.textContent = this.selections.length;
        if (labelEl) labelEl.textContent = this.selections.length === 1 ? 'Item' : 'Items';
        if (priceEl) priceEl.textContent = fmt.format(totalPrice);

        var atbBtn = this.element.querySelector('.cuy-drawer-footer__atb');
        if (atbBtn) atbBtn.textContent = 'Add to Bag';
        var titleEl = this.element.querySelector('.cuy-drawer-header__title');
        if (titleEl) titleEl.textContent = 'Customization Review';

        this.element.classList.remove('cuy-drawer--detail-active');
        this.element.classList.add('cuy-drawer--review');
        this._trapForSubview(); // entered a sub-view → arm the Back trap

        // Reset scroll to the top so the review always opens at the top, not wherever
        // the add-ons list was scrolled. Run immediately and again next frame so the
        // reset sticks after the layout reflow from showing the review panel.
        var body = this.element.querySelector('.cuy-drawer-body');
        if (body) {
          body.scrollTop = 0;
          requestAnimationFrame(function() { body.scrollTop = 0; });
        }
      }
    }, {
      key: '_reviewItemRemove',
      value: function _reviewItemRemove(event) {
        event.preventDefault();
        event.stopPropagation();
        var row = event.target.closest('.cuy-drawer-review-item');
        var mpid = row && row.dataset.mpid;
        if (!mpid) return;

        var removed = this.selections.find(function(s) { return s.mpid === mpid; });
        var removedName = removed ? removed.name : '';

        this.selections = this.selections.filter(function(s) { return s.mpid !== mpid; });
        row.remove();

        var card = this.element.querySelector('.cuy-drawer-card[data-mpid="' + mpid + '"]');
        if (card) card.classList.remove('cuy-drawer-card--selected');

        this._updateFooter();
        if (removedName) this._showToast(removedName + ' removed');

        // If no add-ons remain, go back to addons screen
        if (this.selections.length <= 1) this._exitReviewToAddons();
      }
    }, {
      key: '_quickAddAddon',
      value: function _quickAddAddon(card) {
        var mpid      = card.dataset.mpid;
        var pid       = card.dataset.pid;
        var handle    = card.dataset.handle;
        var name      = card.dataset.name;
        var color     = card.dataset.color;
        var size      = card.dataset.size;
        var price     = (card.dataset.price || '').replace(/,/g, '').trim();
        var compareat = (card.dataset.compareat || '').replace(/,/g, '').trim();
        var customsale = (card.dataset.customsale || '').replace(/,/g, '').trim();
        var image     = card.dataset.image;
        var plpImage  = card.dataset.plpimage;
        var stockdate = card.dataset.stockdate;
        var preorder  = card.dataset.preorder;
        var finalsale = card.dataset.finalsale;

        var alreadySelected = this.selections.some(function(s) { return s.mpid === mpid; });

        if (alreadySelected) {
          // Remove
          this.selections = this.selections.filter(function(s) { return s.mpid !== mpid; });
          this._syncCardStates();
          this._updateFooter();
          this._showToast(name + ' removed');
        } else {
          // Add with the default variant shown on the card
          this.selections = this.selections.filter(function(s) { return s.mpid !== mpid; });
          var priceNum = parseFloat(price || '0');
          var fmt = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: (window.theme && window.theme.currencyCode) || 'USD',
            currencyDisplay: (window.theme && window.theme.currencyCodeEnabled) ? 'code' : 'symbol'
          });
          var productToAdd = {
            id: pid, mpid: mpid, handle: handle, name: name,
            color: color, size: size, image: image, plpImage: plpImage,
            isBaseProduct: false, stockdate: stockdate,
            properties: {},
            price: {
              decimalValue: priceNum.toFixed(2),
              value: priceNum.toFixed(2),
              formatted: fmt.format(priceNum)
            }
          };
          if (customsale) productToAdd.price.customSalePrice = parseFloat(customsale || '0').toFixed(2);
          if (compareat) productToAdd.properties._compare_at_price = parseFloat(compareat);
          if (preorder === 'true') { productToAdd.properties._is_preorder = true; if (stockdate) productToAdd.properties._est_ship_date = stockdate; }
          if (finalsale === 'true') { productToAdd.properties.is_final_sale = true; productToAdd.properties._LPROP = 'no-returns'; }
          this.selections.push(productToAdd);
          this._syncCardStates();
          this._updateFooter();
          this._showToast(name + ' added');
        }
      }
    }, {
      key: '_openAddonDetail',
      value: function _openAddonDetail(handle, variantId, mpid, isAlreadySelected, fromReview) {
        var _this = this;
        this._detailFromReview = !!fromReview;
        var url = window.location.origin + '/products/' + handle + '?variant=' + variantId + '&view=cuy-drawer-addon';
        fetch(url)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;

            // Apply exclusions
            if (_this.exclusions && _this.exclusions.length > 0) {
              _this.exclusions.forEach(function(item) {
                var baseProducts = item.baseProducts;
                var exclusions = item.exclusions;
                Object.keys(exclusions).forEach(function(key) {
                  if (key === handle) {
                    var shouldApply = baseProducts.length === 0 || baseProducts.includes(_this.baseproduct.sku);
                    if (shouldApply) {
                      exclusions[key].forEach(function(attr) {
                        var attrEl = temp.querySelector('.ProductForm__Option li[data-value="' + attr + '"]');
                        if (attrEl) attrEl.remove();
                      });
                    }
                  }
                });
              });
            }

            var sectionEl = temp.querySelector('.shopify-section');
            if (!sectionEl) return;

            _this.addonDetailSection.innerHTML = sectionEl.innerHTML;
            checkPrivateSale();
            _this.productVariants = new ProductVariants(_this.addonDetailSection, {});

            var cancelBtn = _this.addonDetailSection.querySelector('.prdsys-addon-details-cancel');
            var removeBtn = _this.addonDetailSection.querySelector('.prdsys-addon-details-remove');
            var addBtn    = _this.addonDetailSection.querySelector('.prdsys-addon-details-add');

            if (isAlreadySelected) {
              if (cancelBtn) cancelBtn.classList.add('d-none');
              if (removeBtn) removeBtn.classList.remove('d-none');
              if (addBtn && !addBtn.disabled) addBtn.textContent = 'Update';
            }

            _this.addonDetailSection.classList.remove('d-none');
            _this.element.classList.add('cuy-drawer--detail-active');
            _this._trapForSubview(); // entered a sub-view → arm the Back trap

            // Enable click-and-drag scrolling on the gallery (desktop mouse users)
            _this._initGalleryDrag();

            var body = _this.element.querySelector('.cuy-drawer-body');
            if (body) body.scrollTop = 0;
          })
          .catch(function(err) { console.error('Cuy Drawer: failed to fetch addon detail:', err); });
      }
    }, {
      key: '_addonDetailCancel',
      value: function _addonDetailCancel() {
        if (this.addonDetailSection) this.addonDetailSection.classList.add('d-none');
        this.element.classList.remove('cuy-drawer--detail-active');
        var body = this.element.querySelector('.cuy-drawer-body');
        if (body) body.scrollTop = 0;
        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showReview();
        } else {
          this._showAddons();
        }
      }
    }, {
      key: '_addonDetailAdd',
      value: function _addonDetailAdd(event) {
        event.preventDefault();
        event.stopPropagation();

        var btn = event.target.closest('.prdsys-addon-details-add') || event.target;
        var pid       = btn.getAttribute('data-pid');
        var mpid      = btn.getAttribute('data-mpid');
        var name      = btn.getAttribute('data-name');
        var color     = btn.getAttribute('data-color');
        var size      = btn.getAttribute('data-size');
        var preorder  = btn.getAttribute('data-preorder');
        var finalsale = btn.getAttribute('data-finalsale');
        var price     = btn.getAttribute('data-price').replace(/,/g, '').trim();
        var compareat = btn.getAttribute('data-compareat').replace(/,/g, '').trim();
        var customsale = btn.getAttribute('data-customsale')?.replace(/,/g, '').trim();
        var image     = btn.getAttribute('data-image');
        var plpImage  = btn.getAttribute('data-plpimage');
        var handle    = btn.getAttribute('data-handle');
        var stockdate = btn.getAttribute('data-stockdate');

        var isNew = !this.selections.some(function(s) { return s.mpid === mpid; });
        this.selections = this.selections.filter(function(s) { return s.mpid !== mpid; });

        var priceNum = parseFloat(price || '0');
        var fmt = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: (window.theme && window.theme.currencyCode) || 'USD',
          currencyDisplay: (window.theme && window.theme.currencyCodeEnabled) ? 'code' : 'symbol'
        });
        var productToAdd = {
          id: pid, mpid: mpid, handle: handle, name: name,
          color: color, size: size, image: image, plpImage: plpImage,
          isBaseProduct: false, stockdate: stockdate,
          properties: {},
          price: {
            decimalValue: priceNum.toFixed(2),
            value: priceNum.toFixed(2),
            formatted: fmt.format(priceNum)
          }
        };
        if (customsale) productToAdd.price.customSalePrice = parseFloat(customsale || '0').toFixed(2);
        if (compareat) productToAdd.properties._compare_at_price = parseFloat(compareat);
        if (preorder === 'true') { productToAdd.properties._is_preorder = true; if (stockdate) productToAdd.properties._est_ship_date = stockdate; }
        if (finalsale === 'true') { productToAdd.properties.is_final_sale = true; productToAdd.properties._LPROP = 'no-returns'; }

        this.selections.push(productToAdd);

        this._updateFooter();
        this._showToast(name + ' ' + (isNew ? 'added' : 'updated'));

        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showReview();
        } else {
          this._addonDetailCancel();
        }
      }
    }, {
      key: '_addonDetailRemove',
      value: function _addonDetailRemove(event) {
        event.preventDefault();
        event.stopPropagation();

        var addBtn = this.addonDetailSection ? this.addonDetailSection.querySelector('.prdsys-addon-details-add') : null;
        var mpid = addBtn ? addBtn.getAttribute('data-mpid') : null;
        var name = addBtn ? addBtn.getAttribute('data-name') : '';

        if (mpid) {
          this.selections = this.selections.filter(function(s) { return s.mpid !== mpid; });
          var card = this.element.querySelector('.cuy-drawer-card[data-mpid="' + mpid + '"]');
          if (card) card.classList.remove('cuy-drawer-card--selected');
        }

        this._updateFooter();
        this._showToast(name + ' removed');

        if (this._detailFromReview) {
          this._detailFromReview = false;
          this._showReview();
        } else {
          this._addonDetailCancel();
        }
      }
    }, {
      key: '_updateAddon',
      value: function _updateAddon(event) {
        var newVariant = event.detail.variant;
        this._updateAddOnSaveButton(newVariant);
        this._updateAddOnGallery(newVariant);
        if (newVariant && newVariant.custom_private_sale_price) checkPrivateSale();
      }
    }, {
      key: '_initGalleryDrag',
      value: function _initGalleryDrag() {
        if (!this.addonDetailSection) return;
        var track = this.addonDetailSection.querySelector('.cuy-drawer-gallery-track');
        // Bind once per track element (track persists across variant rebuilds — only its
        // innerHTML changes — so a single bind survives swatch changes).
        if (!track || track.dataset.dragBound === '1') return;
        track.dataset.dragBound = '1';

        var isDown = false, startX = 0, startScrollLeft = 0;
        track.addEventListener('mousedown', function(e) {
          isDown = true;
          startX = e.pageX;
          startScrollLeft = track.scrollLeft;
          track.classList.add('is-dragging');
          e.preventDefault(); // avoid native image/text selection drag
        });
        track.addEventListener('mousemove', function(e) {
          if (!isDown) return;
          track.scrollLeft = startScrollLeft - (e.pageX - startX);
        });
        var end = function() {
          if (!isDown) return;
          isDown = false;
          track.classList.remove('is-dragging');
        };
        track.addEventListener('mouseup', end);
        track.addEventListener('mouseleave', end);
      }
    }, {
      key: '_updateAddOnGallery',
      value: function _updateAddOnGallery(newVariant) {
        if (!newVariant || !this.addonDetailSection) return;

        // Pull per-variant gallery list emitted by cuy-drawer-addon-details.liquid
        var galleriesEl = this.addonDetailSection.querySelector('[data-cuy-drawer-galleries]');
        var images = null;
        if (galleriesEl) {
          try {
            var galleries = JSON.parse(galleriesEl.textContent || '{}');
            images = galleries[newVariant.id] || galleries[String(newVariant.id)];
          } catch (e) { images = null; }
        }

        // Fallback to variant.featured_image when the variant has no gallery metafield
        if ((!images || !images.length) && newVariant.featured_image) {
          images = [{
            id: newVariant.featured_image.id,
            src: newVariant.featured_image.src,
            alt: newVariant.featured_image.alt || ''
          }];
        }
        if (!images || !images.length) return;

        var track = this.addonDetailSection.querySelector('.cuy-drawer-gallery-track');
        if (!track) return;

        // Rebuild the filmstrip slides for the selected variant and reset scroll to the start.
        track.innerHTML = images.map(function(img, i) {
          return '<div class="cuy-drawer-gallery-slide" data-index="' + i + '" data-image-id="' + img.id + '">' +
                 '<img src="' + img.src + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '" />' +
                 '</div>';
        }).join('');
        track.scrollLeft = 0;
      }
    }, {
      key: '_updateAddOnSaveButton',
      value: function _updateAddOnSaveButton(newVariant) {
        if (!this.addonDetailSection) return;
        var saveButton = this.addonDetailSection.querySelector('.prdsys-addon-details-add');
        if (!saveButton) return;

        saveButton.classList.remove('d-none');

        if (!newVariant) {
          saveButton.setAttribute('disabled', 'disabled');
          saveButton.removeAttribute('data-pid');
          saveButton.textContent = window.languages.productFormUnavailable;
          return;
        }

        if (newVariant.available) {
          saveButton.removeAttribute('disabled');
          if (saveButton.textContent.trim() !== 'Update') saveButton.textContent = 'Add';
          saveButton.setAttribute('data-pid', newVariant.id);
          saveButton.setAttribute('data-price', (newVariant.price / 100).toFixed(2));
          saveButton.setAttribute('data-compareat', newVariant.compare_at_price ? (newVariant.compare_at_price / 100).toFixed(2) : '');
          saveButton.setAttribute('data-customsale', newVariant.custom_private_sale_price ? (newVariant.custom_private_sale_price / 100).toFixed(2) : '');
          saveButton.setAttribute('data-preorder', newVariant.is_preorder ? 'true' : '');
          saveButton.setAttribute('data-finalsale', newVariant.is_final_sale ? 'true' : '');
          if (newVariant.hasOwnProperty('option1')) saveButton.setAttribute('data-color', newVariant.option1);
          if (newVariant.hasOwnProperty('option2')) saveButton.setAttribute('data-size', newVariant.option2 || '');
          if (newVariant.hasOwnProperty('back_in_stock_date')) saveButton.setAttribute('data-stockdate', newVariant.back_in_stock_date || '');
          if (newVariant.hasOwnProperty('featured_image') && newVariant.featured_image && newVariant.featured_image.src) {
            saveButton.setAttribute('data-image', newVariant.featured_image.src);
          }
          try {
            var productDataEl = this.addonDetailSection.querySelector('[data-product-json]');
            if (productDataEl) {
              var productData = JSON.parse(productDataEl.textContent);
              var variantExtra = productData.variants_extra_data && productData.variants_extra_data[newVariant.id];
              if (variantExtra && variantExtra.plp_image) {
                var plpBase = variantExtra.plp_image.replace(/\?.*$/, '');
                saveButton.setAttribute('data-plpimage', plpBase + '?width=600&height=600&crop=center');
              }
            }
          } catch(e) {}
        } else {
          saveButton.setAttribute('disabled', 'disabled');
          saveButton.removeAttribute('data-pid');
          saveButton.textContent = window.languages.productFormSoldOut;
        }
      }
    }, {
      key: '_updateFooter',
      value: function _updateFooter() {
        var fmt = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: (window.theme && window.theme.currencyCode) || 'USD',
          maximumFractionDigits: 0
        });
        var totalPrice = this.selections.reduce(function(sum, item) {
          var price = (item.price && item.price.customSalePrice &&
                       parseFloat(item.price.customSalePrice) < parseFloat(item.price.decimalValue))
            ? parseFloat(item.price.customSalePrice)
            : parseFloat(item.price && item.price.decimalValue || 0);
          return sum + (isNaN(price) ? 0 : price);
        }, 0);

        var count   = this.selections.length;
        var countEl = this.element.querySelector('.cuy-drawer-total-count');
        var labelEl = this.element.querySelector('.cuy-drawer-total-label');
        var priceEl = this.element.querySelector('.cuy-drawer-footer__total-price');
        if (countEl) countEl.textContent = count;
        if (labelEl) labelEl.textContent = count === 1 ? 'Item' : 'Items';
        if (priceEl) priceEl.textContent = fmt.format(totalPrice);

        // Disable the Finish/Review/Add-to-Bag button when no add-ons are selected
        // (selections always contains the base product, so we need at least one non-base entry).
        var hasAddons = this.selections.some(function(s) { return !s.isBaseProduct; });
        var atbBtn = this.element.querySelector('.cuy-drawer-footer__atb');
        if (atbBtn) {
          atbBtn.disabled = !hasAddons;
          atbBtn.classList.toggle('cuy-drawer-footer__atb--disabled', !hasAddons);
        }
        // Reveal the footer chevron + make the whole footer tappable only when reachable
        var footer = this.element.querySelector('.cuy-drawer-footer');
        if (footer) footer.classList.toggle('cuy-drawer-footer--has-selection', hasAddons);
      }
    }, {
      key: '_showToast',
      value: function _showToast(message) {
        var _this = this;
        var toast = this.element.querySelector('.cuy-drawer-toast');
        if (!toast) return;
        toast.textContent = message;
        toast.classList.add('cuy-drawer-toast--visible');
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(function() {
          toast.classList.remove('cuy-drawer-toast--visible');
        }, 2500);
      }
    }, {
      key: '_buildPayloadItems',
      value: function _buildPayloadItems(productLineGroupID, item) {
        var items = [];
        var productProperties = Object.assign({}, item.properties, { _line_group: productLineGroupID });
        var uuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
        productProperties._uuid = uuid;
        productProperties._is_baseproduct = item.isBaseProduct;
        if (item.monogramming && item.monogramming.text) {
          var monoProps = { 'Monogram Details': item.monogramming.text, 'Monogram Color': item.monogramming.color, 'Monogram Size': item.monogramming.size, is_final_sale: true, _LPROP: 'no-returns' };
          items.push({ id: item.id, quantity: 1, properties: Object.assign({}, productProperties, monoProps) });
          var monoUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
          items.push({ id: item.monogramming.pid, quantity: 1, properties: { _hidden: true, _uuid: monoUuid, _parent_uuid: uuid, _is_monogram: true, _line_group: productLineGroupID } });
        } else {
          items.push({ id: item.id, quantity: 1, properties: productProperties });
        }
        return items;
      }
    }, {
      key: '_buildPayload',
      value: async function _buildPayload(selections) {
        var _this = this;
        var payload = { items: [] };
        var productLineGroupsUsed = [];
        var productLineGroupID = await _generateLineGroupID(productLineGroupsUsed);
        productLineGroupsUsed.push(productLineGroupID);
        var items = await Promise.all(selections.map(async function(item) { return _this._buildPayloadItems(productLineGroupID, item); }));
        payload.items = items.flat();
        return payload;
      }
    }, {
      key: '_addItemsToCart',
      value: function _addItemsToCart(event) {
        event.preventDefault();
        event.stopPropagation();
        var _this = this;
        var atbBtn = event.target.closest('.cuy-drawer-footer__atb') || event.target;
        var selectionsToAdd = this.selections.slice().reverse();

        this._buildPayload(selectionsToAdd).then(function(payload) {
          fetch(window.routes.cartAddUrl + '.js', {
            body: JSON.stringify(payload),
            credentials: 'same-origin',
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          }).then(function(response) {
            if (response.ok) {
              _this.element.dispatchEvent(new CustomEvent('product:added', {
                detail: {
                  quantity: selectionsToAdd.length,
                  source: 'cuy-drawer',
                  products: selectionsToAdd.map(function(item) {
                    return { id: item.id, sku: item.sku || '', mpid: item.mpid, name: item.name, color: item.color, size: item.size, price: parseFloat(item.price.decimalValue), isBaseProduct: item.isBaseProduct };
                  })
                },
                bubbles: true
              }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              checkPrivateSale();
              _this._addedToCart = true;
              _this._close();
            } else {
              response.json().then(function(content) {
                var errEl = document.createElement('span');
                errEl.className = 'ProductForm__Error Alert Alert--error';
                errEl.innerHTML = content.description;
                atbBtn.insertAdjacentElement('afterend', errEl);
                setTimeout(function() { errEl.remove(); }, 2500);
              });
            }
          });
        });
      }
    }]);

    return CuyDrawerConfiguratorSection;
  }();

  /* ---------------------------------------------------------------------------
   * Preconfigured Sets (section: cuyana-preconfigured-sets)
   * Full-bleed set carousel. Tabs slide to a set's image; "Buy Set" adds every
   * variant in the set to the cart in a single /cart/add.js request.
   * ------------------------------------------------------------------------- */
  var CuyanaPreconfiguredSetsSection = /*#__PURE__*/function () {
    function CuyanaPreconfiguredSetsSection(container) {
      _classCallCheck(this, CuyanaPreconfiguredSetsSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.track = this.element.querySelector('[data-cuy-sets-track]');
      this.tabs = Array.prototype.slice.call(this.element.querySelectorAll('.CuyanaSets__tab'));
      this.panels = Array.prototype.slice.call(this.element.querySelectorAll('.CuyanaSets__panel'));
      this.activeIndex = 0;

      this.delegateElement.on('click', '[data-action="cuy-sets-select"]', this._onSelect.bind(this));
      this.delegateElement.on('click', '[data-action="cuy-sets-buy"]', this._onBuy.bind(this));
      this._setupSwipe();
      this._setupCardDrag();
    }

    _createClass(CuyanaPreconfiguredSetsSection, [{
      key: 'onUnload',
      value: function onUnload() {
        this.delegateElement.off();
      }
    }, {
      key: '_activate',
      value: function _activate(index) {
        var count = this.tabs.length;
        if (index < 0) index = 0;
        if (index > count - 1) index = count - 1;
        this.activeIndex = index;

        if (this.track) {
          this.track.style.transform = 'translateX(' + (-index * 100) + '%)';
        }
        this.tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === index);
        });

        // Reset the newly shown card row to the start so its first card is always
        // at the same 6px left offset, regardless of any prior drag-scroll.
        var activePanel = this.panels[index];
        if (activePanel) {
          var activeCards = activePanel.querySelector('.CuyanaSets__cards');
          if (activeCards) {
            activeCards.scrollLeft = 0;
          }
        }

        // Keep the active tab in view within the mobile horizontal scroll row.
        var activeTab = this.tabs[index];
        if (activeTab && activeTab.scrollIntoView) {
          activeTab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }
    }, {
      key: '_onSelect',
      value: function _onSelect(event, target) {
        var idx = parseInt(target.getAttribute('data-set-index'), 10);
        if (!isNaN(idx)) {
          this._activate(idx);
        }
      }
    }, {
      key: '_onBuy',
      value: function _onBuy(event, target) {
        event.preventDefault();
        var _this = this;

        if (target.hasAttribute('disabled')) {
          return;
        }
        var ids = (target.getAttribute('data-variant-ids') || '').split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean);
        if (!ids.length) {
          return;
        }

        var label = target.querySelector('.CuyanaSets__addLabel');
        var originalLabel = label ? label.textContent : '';
        var items = ids.map(function (id) {
          return { id: id, quantity: 1 };
        });

        target.setAttribute('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        fetch(window.routes.cartAddUrl + '.js', {
          body: JSON.stringify({ items: items }),
          credentials: 'same-origin',
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          target.removeAttribute('disabled');

          if (response.ok) {
            // product:added (bubbling, with quantity) re-renders and opens the cart drawer.
            _this.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: { quantity: items.length, source: 'cuyana-preconfigured-sets' }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            // The cart's product:added handler builds its screen-reader message from
            // detail.variant.name, which we don't have for a multi-variant set (it would
            // announce "The item undefined..."). dispatchEvent above ran synchronously, so
            // overwrite the shared live region here with a set-specific announcement.
            var srRegion = document.querySelector('#srAnnouncements');
            if (srRegion) {
              srRegion.textContent = 'Your Set has been added to the cart.';
            }

            if (label) {
              label.textContent = 'Added to bag';
              setTimeout(function () {
                label.textContent = originalLabel || 'Buy Set';
              }, 1600);
            }
          } else {
            response.json().then(function (content) {
              var errEl = document.createElement('span');
              errEl.className = 'ProductForm__Error Alert Alert--error';
              errEl.textContent = (content && content.description) || 'Could not add this set to your cart.';
              target.insertAdjacentElement('afterend', errEl);
              setTimeout(function () { errEl.remove(); }, 3000);
            }).catch(function () {});
          }
        }).catch(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          target.removeAttribute('disabled');
        });
      }
    }, {
      key: '_setupSwipe',
      value: function _setupSwipe() {
        var _this = this;
        var hero = this.element.querySelector('[data-cuy-sets-hero]');
        if (!hero) {
          return;
        }
        var startX = null;
        var startY = null;
        hero.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });
        hero.addEventListener('touchend', function (e) {
          if (startX === null) {
            return;
          }
          var t = e.changedTouches[0];
          var dx = t.clientX - startX;
          var dy = t.clientY - startY;
          startX = null;
          startY = null;
          // Ignore small moves and vertical scrolls.
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) {
            return;
          }
          _this._activate(_this.activeIndex + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    }, {
      key: '_setupCardDrag',
      value: function _setupCardDrag() {
        // Mouse drag-to-scroll for the horizontal card row (mobile / tablet).
        // Touch and pen use the native overflow scroll, so we gate to mouse.
        var rows = this.element.querySelectorAll('.CuyanaSets__cards');
        Array.prototype.forEach.call(rows, function (row) {
          var isDown = false;
          var moved = false;
          var startX = 0;
          var startScroll = 0;

          row.addEventListener('pointerdown', function (e) {
            if (e.pointerType && e.pointerType !== 'mouse') return;
            isDown = true;
            moved = false;
            startX = e.clientX;
            startScroll = row.scrollLeft;
          });
          row.addEventListener('pointermove', function (e) {
            if (!isDown) return;
            var dx = e.clientX - startX;
            // Only enter drag mode once the pointer actually moves; a plain click
            // never captures the pointer or gets flagged, so links navigate normally.
            if (!moved && Math.abs(dx) > 3) {
              moved = true;
              if (row.setPointerCapture) row.setPointerCapture(e.pointerId);
              row.classList.add('is-dragging');
            }
            if (moved) {
              row.scrollLeft = startScroll - dx;
            }
          });
          var end = function () {
            if (!isDown) return;
            isDown = false;
            row.classList.remove('is-dragging');
          };
          row.addEventListener('pointerup', end);
          row.addEventListener('pointercancel', end);
          // The tiles are links; suppress navigation when the pointer was dragged.
          row.addEventListener('click', function (e) {
            if (moved) {
              e.preventDefault();
              e.stopPropagation();
              moved = false;
            }
          }, true);
          // Suppress the browser's native image drag ghost while dragging.
          row.addEventListener('dragstart', function (e) { e.preventDefault(); });
        });
      }
    }]);

    return CuyanaPreconfiguredSetsSection;
  }();

  var ProductMonogrammingSection = /*#__PURE__*/function () {
    function ProductMonogrammingSection(container, init = false) {
      var _this = this;

      _classCallCheck(this, ProductMonogrammingSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);

      this.monoCost = 15.00; // This is just a default setting. The actual price comes from the mono-service variant.

      this.modal = document.querySelector('#monogrammingModal');

      this.goBackAndDelete = false;
      this.parentItemLineGroup = null
      this.parentItemUuid = null;
      this.parentItemKey = null;
      this.parentItemProperties = {};
      this.initialized = false;

      /* Auto open monogramming modal if url parameter is present */
      if (this.modal) {
        const urlHash = window.location.hash;
        if (urlHash.indexOf('monogram') !== -1) {
          window.history.replaceState(undefined, undefined, ' ');
          var modalInstance = bootstrap.Modal.getInstance(this.modal);
          if (modalInstance) {
            modalInstance.show();
          }
        }
      }

      // Get monograming product data
      _this.monogramVariants = false;
      const monogrammingDataUrl = window.location.origin + '/products/mono-service.json';
      fetch(monogrammingDataUrl)
        .then(response => response.text())
        .then(html => {
          var monogramProductA = html.trim() ? JSON.parse(html) : {};
          fetch(window.location.origin + '/products/mono-service-both-cases.json')
            .then(response => response.text())
            .then(html => {
              var monogramProductB = html.trim() ? JSON.parse(html) : {};
              _this.monogramVariants = [...monogramProductA?.product?.variants, ...monogramProductB?.product?.variants];
          })
      })
      .catch(error => {
        console.error('Failed to fetch monogramming product data for configurator:', error);
      });

      this._attachListeners(init);
    }

    _createClass(ProductMonogrammingSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners(init) {

        this.delegateElement.on('keydown', '.user-input .inputs', this._keyDown.bind(this));
        this.delegateElement.on('keypress', '.user-input .inputs', this._keyPress.bind(this));
        this.delegateElement.on('keyup', '.user-input .inputs', this._keyUp.bind(this));
        this.delegateElement.on('change', '.custom-control-input', this._change.bind(this));

        if (init && this.modal) {
          this.modal.addEventListener('shown.bs.modal', this._initModal.bind(this));
          this.modal.addEventListener('hide.bs.modal', this._hideModal.bind(this));

          this.delegateElement.on('click', '.monogramming-add-to-cart button', this._addItemsToCart.bind(this));
          this.delegateElement.on('click', '.monogramming-add-to-product button', this._addMonogrammingToProduct.bind(this));
          this.delegateElement.on('click', '.monogramming-update-product button', this._updateMonogrammingOnProduct.bind(this));
          this.delegateElement.on('click', '.monogramming-remove-from-product button', this.removeMonogrammingFromProduct.bind(this));
        }
      }
    }, {
      /**
       *  Clearing/setting of session storage variables on modal open
       */
      key: "_initModal",
      value: function _initModal(event) {
        var clickedItem = null;
        if (event?.delegateTarget?.dataset?.variantId) {
          clickedItem = event?.delegateTarget;
        } else if (event?.relatedTarget?.dataset?.variantId) {
          clickedItem = event?.relatedTarget;
        }

        // Check if PDP monograming button opend the modal.
        if (clickedItem.classList.contains('ProductForm__Monogramming')) {
          var productHandle = clickedItem.dataset.product;
          var variant = {id: clickedItem.dataset.variantId};
          this._updateMonogrammingModal(variant, productHandle, true);
          clickedItem = null;
        }

        if (clickedItem) {
          this.cartItemDiv = clickedItem.closest('.CartItem');
          if (this.cartItemDiv) {
            this.parentItemLineGroup = this.cartItemDiv.getAttribute('data-line-group');
            this.parentItemUuid = this.cartItemDiv.getAttribute('data-item-uuid');
            this.parentItemKey = this.cartItemDiv.getAttribute('data-item-key');

            var linePropertiesRaw = this.cartItemDiv.getAttribute('data-line-properties');
            try {
              this.parentItemProperties = linePropertiesRaw && linePropertiesRaw.trim() ? JSON.parse(linePropertiesRaw) : {};
            } catch (e) {
              this.parentItemProperties = {};
            }

            var quantityElement = this.cartItemDiv.querySelector('.QuantitySelector__CurrentQuantity');
            this.parentItemQty = quantityElement ? quantityElement.value : 1;

            // The markup renders every property as a string, and saving resends them all, so the
            // line's real properties and quantity come from the cart.
            var itemKey = this.parentItemKey;
            var _self = this;
            fetch("".concat(window.routes.cartUrl, ".js"), { credentials: 'same-origin' })
              .then(function (response) { return response.json(); })
              .then(function (cart) {
                var line = (cart.items || []).find(function (item) { return item.key === itemKey; });
                if (line && _self.parentItemKey === itemKey) {
                  _self.parentItemProperties = line.properties || {};
                  _self.parentItemQty = line.quantity;
                }
              })
              .catch(function () {});
          }

          var productHandle = clickedItem.dataset.product;
          var variant = {id: clickedItem.dataset.variantId};
          this._updateMonogrammingModal(variant, productHandle);
        } 
      }
    }, {
      /**
       *  Clearing DOM settings of modal for clean view if reopend
       */
      key: "_populateMongramValues",
      value: function _populateMongramValues() {
        
        if (this.cartItemDiv) {
          // Set monograming values from Line Item Properties (lip) if opening to edit.
          if (this.cartItemDiv.getAttribute('data-line-properties')) {

            var lipRaw = this.cartItemDiv.getAttribute('data-line-properties');
            var lip = {};
            try { lip = lipRaw.trim() ? JSON.parse(lipRaw) : {}; } catch (e) {}

            if (lip["Monogram Details"]) {
              var monogramDetail = lip["Monogram Details"];
              var monogramInputs = document.querySelectorAll('input[name="monogram[]"]');

              for (var i = 0; i < monogramDetail.length; i++) {
                if (i < monogramInputs.length) {
                  monogramInputs[i].value = monogramDetail.charAt(i);
                  if (i == monogramDetail.length - 1) {
                    monogramInputs[i].focus();
                  }
                }
              }
              // clear any remaining inputs
              for (var j = monogramDetail.length; j < monogramInputs.length; j++) {
                monogramInputs[j].value = '';
              }
              var monogramOverlayText = this.element.querySelector('.monogram-overlay svg text');
              monogramOverlayText.textContent = monogramDetail;
            }


            if (lip["Monogram Color"]) {
              var radioButtons = document.querySelectorAll('input[name="placements"]');
              radioButtons.forEach(function(radioButton) {
                  var colorLabel = radioButton.getAttribute('data-label');
                  if (colorLabel === lip["Monogram Color"]) {
                      radioButton.checked = true;
                  }
              });
            }

            if (lip["Monogram Placement"]) {
              var radioButtons = document.querySelectorAll('input[name="placements"]');
              radioButtons.forEach(function(radioButton) {
                  var placementLabel = radioButton.getAttribute('data-label');
                  if (placementLabel === lip["Monogram Placement"]) {
                      radioButton.checked = true;
                  }
              });
            }

            if (lip["Monogram Size"]) {

              var characterlimit = false;
              var radioButtons = document.querySelectorAll('input[name="sizes"]');
              radioButtons.forEach(function(radioButton) {
                  var sizeLabel = radioButton.getAttribute('data-label');
                  if (sizeLabel === lip["Monogram Size"]) {
                      radioButton.checked = true;
                      characterlimit = radioButton.getAttribute('data-characterlimit') ? JSON.parse(radioButton.getAttribute('data-characterlimit')) : false
                  }
              });
              
              
              if (characterlimit) {
                var userInputInputs = this.element.querySelectorAll('#monogramming .user-input .inputs');
                userInputInputs.forEach(function (input, i) {
                  input.classList.remove('d-none');
                  if (i >= characterlimit) {
                    input.value = '';
                    input.classList.add('d-none');
                  }
                });
    
                var monogramInputs = this.element.querySelectorAll("input[name='monogram[]']");
                var monogram = Array.from(monogramInputs).map(function (input) {
                  return input.value;
                }).filter(function (el) {
                  return el !== '';
                });
                if (monogramOverlayText) {
                  monogramOverlayText.textContent = monogram.join('');
                }
    
                var userInputElement = this.element.querySelector('.user-input');
                userInputElement.style.setProperty('--chars', characterlimit);
                var monogramOverlayElement = this.element.querySelector('.monogram-overlay');
                if (monogramOverlayElement) {
                  if (characterlimit < 4) {
                    monogramOverlayElement.classList.add('large');
                  } else {
                    monogramOverlayElement.classList.remove('large');
                  }
                }
    
                // Handle the single filed input on the monogramming optiong on Add-ons
                var inputField = document.querySelector(".product-data .monogrammingCopy input[name='monogram[]']");
                if (inputField) {
                  var trimmedString = inputField.value.substring(0, characterlimit);
                  inputField.setAttribute('maxlength', characterlimit);
                  inputField.value = trimmedString;
    
                  var selectedSize = this.element.querySelector('input[name="sizes"]:checked');
                  if (selectedSize) {
                    var sizeMessage = selectedSize.closest('.custom-radio').querySelector('.size-message-hidden').innerHTML;
                    this.element.querySelector('.monogrammingCopy .size-message').innerHTML = sizeMessage;
                  }
                }
              }
            }
          }
        }
      }
      
    }, {
      /**
       *  Clearing DOM settings of modal for clean view if reopend
       */
      key: "_hideModal",
      value: function _hideModal(event) {
        // Add the overlay class so the modal is overlayed to start it's next opening.
        this.modal.classList.add('overlaid');
      }
    }, {
      /**
       *  Get Monograming Data.
       */
      key: "_getMonogrammingData",
      value: function _getMonogrammingData(event) {

        var monoCost = this.monoCost;  // This is just a default setting actual price comes from the mono-service variant.
        var monogramInputs = this.element.querySelectorAll("input[name='monogram[]']");
        var monogram = Array.from(monogramInputs).map(function(input) {
          return input.value;
        }).filter(function(el) {
          return el !== '';
        });
      
        var monogrammingError = this.element.querySelector('.monogramming-error');
        monogrammingError.textContent = '';

        var monogramString = monogram.join('').toUpperCase();
        if (monogram.length === 0) {
          monogrammingError.textContent = this.element.querySelector('.user-input').getAttribute('data-error');
          return false;
        }

        if (!_validMonoCharacterCheck(monogramString)) {
          monogrammingError.textContent = this.element.querySelector('.user-input').getAttribute('data-error-letters');
          return false;
        }

        var skuPrefix = this.element.querySelector('.selections').getAttribute('data-type');

        var selectedPlacement = '';
        var selectedPlacementID = '';
        var upCharge = 0;
        var placementRadios = this.element.querySelectorAll('input[name="placements"]');
        if (placementRadios.length > 0) {
          var placements = Array.from(placementRadios).filter(function(radio) {
            return radio.checked;
          });
          if (placements.length == 0) {
            monogrammingError.style.display = 'block';
            monogrammingError.textContent = this.element.querySelector('.selections').getAttribute('data-error');
            return false;
          }

          selectedPlacement = placements[0].getAttribute('data-label');
          selectedPlacementID = placements[0].getAttribute('data-id');
          upCharge = Number(placements[0].getAttribute('data-additional-cost'));
          if (placements[0].getAttribute('data-prefix').trim() !== '') {
            skuPrefix = placements[0].getAttribute('data-prefix').trim();
          }
        }
      
        var sizeRadios = this.element.querySelectorAll('input[name="sizes"]:checked');
        if (sizeRadios.length == 0) {
          monogrammingError.textContent = this.element.querySelector('.selections').getAttribute('data-error');
          return false;
        }
        var selectedSizeID = sizeRadios[0].getAttribute('data-id').split(':')[0].trim();
        var selectedSize = sizeRadios[0].getAttribute('data-label');
      
        var colorRadios = this.element.querySelectorAll('input[name="colors"]:checked');
        if (colorRadios.length == 0) {
          monogrammingError.textContent = this.element.querySelector('.selections').getAttribute('data-error');
          return false;
        }
        var selectedColorID = colorRadios[0].getAttribute('data-id').split(':')[0].trim();
        var selectedColor = colorRadios[0].getAttribute('data-label');
        
        var monogramSKU =  skuPrefix + '-' + selectedColorID + '-' + selectedSizeID;
        // Find the Variant ID for the monogramming sku selected.
        var variantId = null;
        if (this.monogramVariants) {
          for (var i = 0; i < this.monogramVariants.length; i++) {
            var variant = this.monogramVariants[i];
            if (variant.sku === monogramSKU) {
              variantId = variant.id;
              monoCost = parseFloat(variant.price);
              break; 
            }
          }
        }

        var data = {
            pid: variantId,
            sku: monogramSKU,
            quantity: 1,
            text: monogram.join('').toUpperCase(),
            placement: selectedPlacement,
            placementId: selectedPlacementID,
            size: selectedSize,
            color: selectedColor,
            cost: monoCost,
            upCharge: upCharge
        };

        return data;
      }
    }, {
      /**
       *  Add monogramed product to the cart.
       */
      key: "_addItemsToCart",
      value: function _addItemsToCart(event) {
        event.preventDefault();
        event.stopPropagation();

        var monogramingData = this._getMonogrammingData();
        if (!monogramingData) {
          return false;
        }

        var _this = this;
        var addToCartButton = event.target;
        var productLineGroupsUsed = [];
        var payload = { items: [] };

        var monogramingData = this._getMonogrammingData();

        document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

        var formElement = document.querySelector('section[data-section-type="product"] form[action*="/cart/add"]');
        var productToAddToCart = Form.serialize(formElement);

        _generateLineGroupID(productLineGroupsUsed).then((productLineGroupID) => {
          const currentDate = new Date();
          let uuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
          productLineGroupsUsed.push(productLineGroupID);

          productToAddToCart.properties["Monogram Details"] = monogramingData.text;
          productToAddToCart.properties["Monogram Color"] = monogramingData.color;
          productToAddToCart.properties["Monogram Size"] = monogramingData.size;
          productToAddToCart.properties["_line_group"] = productLineGroupID;
          productToAddToCart.properties["is_final_sale"] = true;
          productToAddToCart.properties["_LPROP"] = "no-returns";
          productToAddToCart.properties["_uuid"] = uuid;

          if (monogramingData.placement) {
            productToAddToCart.properties["Monogram Placement"] = monogramingData.placement;
          }

          // Monogramming Product to cart
          let monoProductUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
          var monoProductToAddToCart = {
            id: monogramingData.pid,
            quantity: 1,
            properties: {
              "_hidden": true,
              "_uuid": monoProductUuid,
              "_parent_uuid": uuid,
              "_is_monogram": true,
              "_line_group": productLineGroupID
            }
          };
          
          // Add Product as first item
          payload.items.push(productToAddToCart)
          
          // Add mono as secondary item (addon)
          payload.items.push(monoProductToAddToCart);

        }).then( function () {
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(payload),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (response) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            if (response.ok) {
              _this.element.dispatchEvent(new CustomEvent('product:added', {
                detail: {
                  quantity: 1
                },
                bubbles: true
              }));
              var modalInstance = bootstrap.Modal.getInstance(_this.modal);
              if (modalInstance) {
                modalInstance.hide();
              }
            } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
            }
          });
        });
      }
    }, {
      /**
       *  Add monogramed product to the cart.
       */
      key: "_addMonogrammingToProduct",
      value: function _addMonogrammingToProduct(event) {
        event.preventDefault();
        event.stopPropagation();

        var monogramingData = this._getMonogrammingData();
        if (!monogramingData) {
          return false;
        }

        var _this = this;
        var addToCartButton = event.target;
        var productLineGroupsUsed = [];
        var payload = { items: [] };
        var existingProperties = {...this.parentItemProperties};
        var productToUpdate = {'id': this.parentItemKey, 'quantity': this.parentItemQty, 'properties': {...existingProperties, '_uuid': this.parentItemUuid }};

        document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

        _generateLineGroupID(productLineGroupsUsed).then((productLineGroupID) => {

          const currentDate = new Date();
          let uuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);

          if (_this.parentItemLineGroup) {
            productLineGroupID = _this.parentItemLineGroup;
          } else {
            productLineGroupsUsed.push(productLineGroupID);
            productToUpdate.properties["_line_group"] = productLineGroupID;
          }

          productToUpdate.properties["Monogram Details"] = monogramingData.text;
          productToUpdate.properties["Monogram Color"] = monogramingData.color;
          productToUpdate.properties["Monogram Size"] = monogramingData.size;
          productToUpdate.properties["is_final_sale"] = true;
          productToUpdate.properties["_LPROP"] = 'no-returns';

          if (monogramingData.placement) {
            productToUpdate.properties["Monogram Placement"] = monogramingData.placement;
          }

          // Monogramming Product to cart
          let monoProductUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
          var monoProductToAddToCart = {
            id: monogramingData.pid,
            quantity: _this.parentItemQty,
            parent_line_key: _this.parentItemKey,
            properties: {
              "_hidden": true,
              "_uuid": monoProductUuid,
              "_parent_uuid": _this.parentItemUuid,
              "_is_monogram": true,
              "_line_group": productLineGroupID
            }
          };
          
          // Add hidden Monogramming item to the payload
          payload.items.push(monoProductToAddToCart);

        }).then( function () {

          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(payload),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (response) {
            if (response.ok) {
              // Monogramming product was added to the cart, now update the parent product
              fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                body: JSON.stringify(productToUpdate),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                }
              }).then(function (response) {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                if (response.ok) {
                  _this.element.dispatchEvent(new CustomEvent('product:added', {
                    detail: {
                      quantity: 1
                    },
                    bubbles: true
                  }));

                  var modalInstance = bootstrap.Modal.getInstance(_this.modal);
                  if (modalInstance) {
                    modalInstance.hide();
                  }

                } else {
                  response.json().then(function (content) {
                    var errorMessageElement = document.createElement('span');
                    errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                    errorMessageElement.innerHTML = content['description'];
                    addToCartButton.removeAttribute('disabled');
                    addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                    setTimeout(function () {
                      errorMessageElement.remove();
                    }, 2500);
                  });
                }
              });

            } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
            }
          });
        });
      }
    }, {
      /**
       *  Remove monogramed product to the cart.
       */
      key: "removeMonogrammingFromProduct",
      value: function removeMonogrammingFromProduct(event) {
        event.preventDefault();
        event.stopPropagation();
  
        var _this = this;

        var existingProperties = {...this.parentItemProperties};
        delete existingProperties["Monogram Details"];
        delete existingProperties["Monogram Color"];
        delete existingProperties["Monogram Size"];
        delete existingProperties["Monogram Placement"];
        delete existingProperties["is_final_sale"];
        delete existingProperties["_LPROP"];
        var parentItemElement = document.querySelector('.CartItem[data-item-uuid="' + this.parentItemUuid + '"]');
        if (parentItemElement && parentItemElement.getAttribute('data-finalsale') === 'true') {
          existingProperties["is_final_sale"] = true;
          existingProperties["_LPROP"] = "no-returns";
        }
        var productToUpdate = {'id': this.parentItemKey, 'quantity': this.parentItemQty, 'properties': {...existingProperties, '_uuid': this.parentItemUuid }};
        productToUpdate.properties["_line_group"] = this.parentItemLineGroup;

        document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
        // Update the parent product
        fetch("".concat(window.routes.cartChangeUrl, ".js"), {
          body: JSON.stringify(productToUpdate),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          var monoItemElement = document.querySelector('.CartItem[data-is-giftbox="false"][data-parent-uuid="' + _this.parentItemUuid + '"]');
          if (response.ok && monoItemElement) {

            var monoItemKey = monoItemElement.getAttribute('data-item-key');
            var parentItemLineGroup = monoItemElement.getAttribute('data-line-group');
            var monoProductToUpdate = {'id': monoItemKey, 'quantity': 0};

            // Parent Prodcut Updated, now remove the Monogramming product was removed from the cart
            fetch("".concat(window.routes.cartChangeUrl, ".js"), {
              body: JSON.stringify(monoProductToUpdate),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
              }
            }).then(function (response2) {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              if (response2.ok) {
                _this.element.dispatchEvent(new CustomEvent('product:added', {
                  detail: {
                    quantity: 0
                  },
                  bubbles: true
                }));
                var modalInstance = bootstrap.Modal.getInstance(_this.modal);
                if (modalInstance) {
                  modalInstance.hide();
                }
              } else {
                response.json().then(function (content) {
                  var errorMessageElement = document.createElement('span');
                  errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                  errorMessageElement.innerHTML = content['description'];
                  //TODO: figure out where to display error in minicart
                  /*
                    addToCartButton.removeAttribute('disabled');
                    addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                    setTimeout(function () {
                      errorMessageElement.remove();
                    }, 2500);
                  */
                });
              }
            });

          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              addToCartButton.removeAttribute('disabled');
              addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });

      }
    }, {
      /**
       *  Add monogramed product to the cart.
       */
      key: "_updateMonogrammingOnProduct",
      value: function _updateMonogrammingOnProduct(event) {
        event.preventDefault();
        event.stopPropagation();

        var monogramingData = this._getMonogrammingData();
        if (!monogramingData) {
          return false;
        }

        document.dispatchEvent(new CustomEvent('theme:loading:start')); 

        var _this = this;
        var productLineGroupID = this.parentItemLineGroup;
        var addToCartButton = event.target;
        var payload = { items: [] };

        var monoItemElement = document.querySelector('.CartItem[data-is-giftbox="false"][data-parent-uuid="' + this.parentItemUuid + '"]');
        if (!monoItemElement) {
          return false;
        } 

        var monoItemKey = monoItemElement.getAttribute('data-item-key');

        var monoProductToRemove = {'id': monoItemKey, 'quantity': 0};

        var existingProperties = {...this.parentItemProperties};
        var productToUpdate = {
          'id': this.parentItemKey,
          'properties': {
            ...existingProperties,
            "_uuid": this.parentItemUuid,
            "_line_group": productLineGroupID,
            "Monogram Details": monogramingData.text,
            "Monogram Color": monogramingData.color,
            "Monogram Size": monogramingData.size,
            "is_final_sale": true,
            "_LPROP": "no-returns"
          }
        };

        if (monogramingData.placement) {
          productToUpdate.properties["Monogram Placement"] = monogramingData.placement;
        }

        let monoProductUuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);
        var monoProductToAddToCart = {
          id: monogramingData.pid,
          quantity: this.parentItemQty,
          parent_line_key: _this.parentItemKey,
          properties: {
            "_hidden": true,
            "_uuid": monoProductUuid,
            "_parent_uuid": _this.parentItemUuid,
            "_is_monogram": true,
            "_line_group": productLineGroupID
          }
        };
          
          // Add hidden Monogramming item to the payload
        payload.items.push(monoProductToAddToCart);

        // Add new monogramming product
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(payload),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          if (response.ok) {
            // Remove OLD monogramming product by updating it's QTY to 0
            fetch("".concat(window.routes.cartChangeUrl, ".js"), {
              body: JSON.stringify(monoProductToRemove),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
              }

            }).then(function (response) {
              if (response.ok) {
                // Monogramming product was added to the cart, now update the parent product
                fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                  body: JSON.stringify(productToUpdate),
                  credentials: 'same-origin',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                  }
                }).then(function (response) {
                  document.dispatchEvent(new CustomEvent('theme:loading:end'));
                  if (response.ok) {
                    _this.element.dispatchEvent(new CustomEvent('product:added', {
                      detail: {
                        quantity: 1
                      },
                      bubbles: true
                    }));
                    var modalInstance = bootstrap.Modal.getInstance(_this.modal);
                    if (modalInstance) {
                      modalInstance.hide();
                    }
                  } else {
                    response.json().then(function (content) {
                      var errorMessageElement = document.createElement('span');
                      errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                      errorMessageElement.innerHTML = content['description'];
                      addToCartButton.removeAttribute('disabled');
                      addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                      setTimeout(function () {
                        errorMessageElement.remove();
                      }, 2500);
                    });
                  }
                });
              } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
              }
            });
          }
        });
      }
    }, {
      /**
       *  _change
       */
      key: "_change",
      value: function _change(event) {
        var target = event.target;

        if (target.classList.contains('custom-control-input')) {

          var group = target.getAttribute('data-group');
          var placements = target.getAttribute('data-placements') ? JSON.parse(target.getAttribute('data-placements')) : false;
          var sizes = target.getAttribute('data-sizes') ? JSON.parse(target.getAttribute('data-sizes')) : false;
          var colors = target.getAttribute('data-colors') ? JSON.parse(target.getAttribute('data-colors')) : false;
          var characterlimit = target.getAttribute('data-characterlimit') ? JSON.parse(target.getAttribute('data-characterlimit')) : false;
          var monogramOverlayText = this.element.querySelector('.monogram-overlay svg text');

          this.element.querySelector('.monogramming-error').textContent = '';
          
          if (group === 'placements') {
            var additionalCharge = target.getAttribute('data-additional-cost') ? target.getAttribute('data-additional-cost') : 0;
            var upCharge = Number(additionalCharge);
            var monoCost = this.monoCost + upCharge;
            const buttonMonoPrice = this.element.querySelector('.MonogrammingModal__MonoPrice')
            const addMonoButton = buttonMonoPrice.closest('.btn-primary');
            buttonMonoPrice.innerHTML = ' +$' + monoCost;
            addMonoButton.setAttribute('aria-label', `Add monogramming to this product for an additional ${monoCost}`);
          }

          if (group === 'colors') {
            var label = target.closest('.custom-radio').querySelector('label').textContent.trim().replace(/\s+/g, '-').toLowerCase();
            this.element.querySelector('.monogram-overlay').setAttribute('data-style', label);
          }

          if (group === 'sizes') {
            var monogramInputs = this.element.querySelectorAll("input[name='monogram[]']");
            var monogram = Array.from(monogramInputs).map(function (input) {
                return input.value;
              }).filter(function (el) {
                return el !== '';
              });

            if (monogramOverlayText) {
              monogramOverlayText.textContent = monogram.join('');
            }

            const index = target.getAttribute('data-index');
            const fallBackImageID = 'monogram_image_1'; 
            const desiredImageID  = 'monogram_image_' + index;
            const desiredImage = document.querySelector('[id="' + desiredImageID + '"]');
            const currentVisibleImage = document.querySelector('[id^="monogram_image_"]:not(.d-none)');
            if (desiredImage && currentVisibleImage && desiredImage !== currentVisibleImage) {
              currentVisibleImage.classList.add('d-none');
              desiredImage.classList.remove('d-none');
            } else if (!desiredImage && currentVisibleImage && currentVisibleImage.id !== fallBackImageID) {
              currentVisibleImage.classList.add('d-none');
              const fallBackImage = document.querySelector('[id="' + fallBackImageID + '"]');
              fallBackImage.classList.remove('d-none');
            }
          }

          if (placements) {
            var placementInputs = this.element.querySelectorAll('.selection.placements .custom-control-input');
            placementInputs.forEach(function (input) {
              if (placements.indexOf(input.getAttribute('data-id')) > -1) {
                input.closest('.custom-radio').classList.remove(group + '-hide');
              } else {
                input.checked = false;
                input.closest('.custom-radio').classList.add(group + '-hide');
              }
            });
          }

          if (sizes) {
            var sizeInputs = this.element.querySelectorAll('.selection.sizes .custom-control-input');
            sizeInputs.forEach(function (input) {
              if (sizes.indexOf(input.getAttribute('data-id')) > -1) {
                input.closest('.custom-radio').classList.remove(group + '-hide');
              } else {
                input.checked = false;
                input.closest('.custom-radio').classList.add(group + '-hide');
              }
            });
          }
      
          if (colors) {
            var colorInputs = this.element.querySelectorAll('.selection.colors .custom-control-input');
            colorInputs.forEach(function (input) {
              if (colors.indexOf(input.getAttribute('data-id')) > -1) {
                input.closest('.custom-radio').classList.remove(group + '-hide');
              } else {
                input.checked = false;
                input.closest('.custom-radio').classList.add(group + '-hide');
              }
            });
          }

          if (characterlimit) {
            var userInputInputs = this.element.querySelectorAll('#monogramming .user-input .inputs');
            userInputInputs.forEach(function (input, i) {
              input.classList.remove('d-none');
              if (i >= characterlimit) {
                input.value = '';
                input.classList.add('d-none');
              }
            });

            var monogramInputs = this.element.querySelectorAll("input[name='monogram[]']");
            var monogram = Array.from(monogramInputs).map(function (input) {
              return input.value;
            }).filter(function (el) {
              return el !== '';
            });
            if (monogramOverlayText) {
              monogramOverlayText.textContent = monogram.join('');
            }

            var userInputElement = this.element.querySelector('.user-input');
            userInputElement.style.setProperty('--chars', characterlimit);
            var monogramOverlayElement = this.element.querySelector('.monogram-overlay');
            if (monogramOverlayElement) {
              if (characterlimit < 4) {
                monogramOverlayElement.classList.add('large');
              } else {
                monogramOverlayElement.classList.remove('large');
              }
            }

            // Handle the single filed input on the monogramming optiong on Add-ons
            var inputField = document.querySelector(".product-data .monogrammingCopy input[name='monogram[]']");
            if (inputField) {
              var trimmedString = inputField.value.substring(0, characterlimit);
              inputField.setAttribute('maxlength', characterlimit);
              inputField.value = trimmedString;

              var selectedSize = this.element.querySelector('input[name="sizes"]:checked');
              if (selectedSize) {
                var sizeMessage = selectedSize.closest('.custom-radio').querySelector('.size-message-hidden').innerHTML;
                this.element.querySelector('.monogrammingCopy .size-message').innerHTML = sizeMessage;
              }
            }
          }
        }
      }
    }, {
      /**
       *  _keyUp
       */
      key: "_keyUp",
      value: function _keyUp(event) {
        var target = event.target;
        //var parentDiv = target.parentElement;
        //var configuratorAddonInput = target.getAttribute('data-addon') === 'true'; 
        var monogramOverlayText = this.element.querySelector('.monogram-overlay svg text');

        if (this.goBackAndDelete) {
            var prevInput = target.previousElementSibling;
            if (prevInput && prevInput.classList.contains('inputs')) {
              prevInput.focus();
              prevInput.value = '';
            }
            this.goBackAndDelete = false;

            if (monogramOverlayText) {
              var textContent = monogramOverlayText.textContent;
              if (textContent.length > 0) {
                  var newTextContent = textContent.slice(0, -1);
                  monogramOverlayText.textContent = newTextContent;
              }
            }
            return false;
        }

        if (target.value.length === target.maxLength && !(event.keyCode === 9 || event.keyCode === 16)) {
            var nextInput = target.nextElementSibling;
            if (nextInput && nextInput.classList.contains('inputs')) {
              nextInput.focus();
            } else {
              target.blur();
            }
        }

        var monogramInputs = this.element.querySelectorAll("input[name='monogram[]']");
        var monogram = Array.from(monogramInputs).map(function(input) {
            return input.value;
        });

        monogram = monogram.filter(function(el) {
            return el !== '';
        });

        // Do not update the SVG when the event.target is the mono input for a Configurator Add-on
        if (monogramOverlayText) {
          monogramOverlayText.textContent = monogram.join('');
        }
      }
    }, {
      /**
       *  _keyPress
       */
      key: "_keyPress",
      value: function _keyPress(event) {
        var key = event.key;
        if (!_validMonoCharacterCheck(key)) {
            event.preventDefault();
            this.element.querySelector('.monogramming-error').textContent = this.element.querySelector('.user-input').getAttribute('data-error-letters');
            return false;
        }
      }
    }, {
      /**
       *  _keyDown
       */
      key: "_keyDown",
      value: function _keyDown(event) {
        var target = event.target;
        var cursorPosition = target.selectionStart;
        if ((event.key === 'Delete' || event.key === 'Backspace') && cursorPosition === 0) {
            //flag to trigger delete of previous input
            this.goBackAndDelete = true;
        }
      }
    }, {
      key: "_updateMonogrammingModal",
      value: function _updateMonogrammingModal(variant, productHandle, hideCartOptions = false) {

        var _this = this;
        const monogrammingModal = this.modal;
        if (!this.modal) {
          return;
        }
        var url = window.location.pathname + '?variant=' + variant.id + '&view=monogramming-modal';
        if (productHandle) {
           url = '/products/' + productHandle + '?variant=' + variant.id + '&view=monogramming-modal';
        }
        // Enable modal overlay to prevent user from clicking any buttons until modal is populated
        monogrammingModal.classList.add('opening');
        fetch(url)
        .then(response => response.text())
        .then(html => {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = html;
            const monogrammingHTML = tempElement.querySelector('#monogramming');
            if (monogrammingHTML) {
              monogrammingModal.querySelector('#monogramming').innerHTML = monogrammingHTML.innerHTML;
              _this.monoCost = Number(monogrammingHTML.getAttribute('data-monogrammingcost') || _this.monoCost); 
            }
          }).then(function(){
            if (_this.parentItemUuid) {
              var monoItemElement = document.querySelector('.CartItem[data-is-giftbox="false"][data-parent-uuid="' + _this.parentItemUuid + '"]');
              if (monoItemElement) {
                //We are editing
                monogrammingModal.querySelector('.monogramming-add-to-product').classList.add('d-none');
                monogrammingModal.querySelector('.monograming-edit').classList.remove('d-none');
              } else {
                monogrammingModal.querySelector('.monogramming-add-to-product').classList.remove('d-none');
                monogrammingModal.querySelector('.monograming-edit').classList.add('d-none');
              }
            }
            // Hide Options for Updating item in Cart because the user came from the PDP
            if (hideCartOptions) {
                monogrammingModal.querySelector('.monogramming-add-to-product').classList.add('d-none');
                monogrammingModal.querySelector('.monograming-edit').classList.add('d-none');
            }
        }).then(function(){
            var monoInputs = monogrammingModal.querySelector('.inputs');
            if (monoInputs && !hideCartOptions) {
              monogrammingModal.querySelector('.monogramming-add-to-cart').classList.add('d-none');
              monoInputs.focus();
              _this._populateMongramValues();
            }
            checkPrivateSale();
            // Remove modal overlay if the modal is being shown
            if (monogrammingModal.classList.contains('show')) {
              monogrammingModal.classList.remove('overlaid');
            }
        })
        .catch(error => {
            console.error('Failed to fetch monogramming modal content:', error);
        });

      }
    }]);

    return ProductMonogrammingSection;
  }();

  var ProductSystemsSection = /*#__PURE__*/function () {
    function ProductSystemsSection(container) {
      var _this = this;

      _classCallCheck(this, ProductSystemsSection);

      var sidebarDrawer = document.querySelector('#sidebar-product-systems'); 
      if (!sidebarDrawer) {
        return;
      }

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.productGallery = null;

      this.productSystems = this.element.querySelector('.product-systems');
      this.systemsItems = this.element.querySelector('.systems-items');

      const exclusionElement = this.element.querySelector('[data-systems-exclusions-json]');
      if (exclusionElement && exclusionElement.innerHTML.trim() !== '') {
        this.exclusions = JSON.parse(exclusionElement.innerHTML);
      } 

      this.sidebarDelegateElement = new domDelegate.Delegate(sidebarDrawer);
      this.sidebarContent = sidebarDrawer.querySelector('.Drawer__Main');

      this.sidebarDrawer = new Drawer(sidebarDrawer, {
        onClose: this._onDrawerClosed.bind(this)
      });

      const baseProductDataElement = this.element.querySelector('[data-base-systems-product-json]');
      if (baseProductDataElement && baseProductDataElement.innerHTML.trim() !== '') {
        this.baseproduct = JSON.parse(baseProductDataElement.innerHTML);
      }

      this._attachListeners();
    }

    _createClass(ProductSystemsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.productVariants) {
          this.productVariants.destroy();
        }

        if (this.productGallery) {
          this.productGallery.destroy();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.showControl', this._showMoreLess.bind(this));
        this.delegateElement.on('click', '.addonItemCard', this._openSidebar.bind(this));
        this.delegateElement.on('variant:changed', this._updateSystemsProducts.bind(this));
        
        this.sidebarDelegateElement.on('variant:changed', this._updateSidebarAddon.bind(this));
        this.sidebarDelegateElement.on('click', 'button.prdsys-addon-atb', this._addItemsToCart.bind(this));
      }
    }, {
      /**
       *  Add Product System item to the cart.
       */
      key: "_addItemsToCart",
      value: async function _addItemsToCart(event) {
        event.preventDefault();
        event.stopPropagation();

        var _this = this;
        var addToCartButton = event.target;

        var pid = event.target.getAttribute('data-pid');
        var mpid = event.target.getAttribute('data-mpid');
        var name = event.target.getAttribute('data-name');
        var color = event.target.getAttribute('data-color');
        var size = event.target.getAttribute('data-size');
        var preorder = event.target.getAttribute('data-preorder');
        var final_sale = event.target.getAttribute('data-finalsale');
        var price = event.target.getAttribute('data-price').replace(/^\s+|\s+$/g, '');
        var compare_at_price = event.target.getAttribute('data-compareat').replace(/^\s+|\s+$/g, '');
        var image = event.target.getAttribute('data-image');
        var stock_date = event.target.getAttribute('data-stockdate');

        var productLineGroupID = await _generateLineGroupID();

        const currentDate = new Date();
        let uuid = 'CUY' + Date.now() + Math.floor(Math.random() * 1000);

        var payload = { items: [] };
        
        // Add Product
        var productToAddToCart = {
          id: pid,
          quantity: 1,
          properties: {
            "_line_group": productLineGroupID,
            "_uuid": uuid
          }
        };

        if (compare_at_price) {
          productToAddToCart.properties["_compare_at_price"] = parseFloat(compare_at_price);
        }

        payload.items.push(productToAddToCart);

        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(payload),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          if (response.ok) {
            _this.element.dispatchEvent(new CustomEvent('product:added', {
              detail: {
                quantity: 1
              },
              bubbles: true
            }));
            // When the page is loaded from the cache, we have to reload the cart content
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));
            
            _this.sidebarDrawer.close();
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              addToCartButton.removeAttribute('disabled');
              addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });
        
      }
    }, {
      /**
       *  Get Add-On Item Details via Ajax Call
       */
      key: "_getAddOnItemDetails",
      value: function _getAddOnItemDetails() {
        return new Promise((resolve, reject) => {

          var _this = this;
          const url = window.location.origin + '/products/' + this.sidebardAddonProductHandle + '?variant=' + this.sidebarVariantID + '&view=systems-addon';
  
          fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                return response.text();
            })
            .then(html => {
                const tempElement = document.createElement('div');
                tempElement.innerHTML = html;

                if (_this.exclusions && _this.exclusions.length > 0) {
                  _this.exclusions.forEach(item => {
                    const { baseProducts, exclusions } = item;
                    const exclusionKeys = Object.keys(exclusions);

                    if (baseProducts.length === 0 || baseProducts.includes(_this.baseproduct.sku)) {
                      exclusionKeys.forEach(key => {
                        if (key === _this.sidebardAddonProductHandle) {
                          // Exclude Invalid Add-on Attributes based on Base Product and Add-on chosen.
                          exclusions[key].forEach(attr => {
                            const attributeElement = tempElement.querySelector('.ProductForm__Option li[data-value="' + attr + '"]');
                            if (attributeElement) {
                              attributeElement.remove();
                            }
                          });
                        }
                      });
                    }
                  });
                }

              const sectionHtml = tempElement.querySelector('.shopify-section')?.innerHTML;

              if (sectionHtml) {
                _this.sidebarContent.innerHTML = sectionHtml;
                _this.productVariants = new ProductVariants(_this.sidebarContent, {});
                checkPrivateSale();
              } else {
                console.error('Error: No .shopify-section element found in the fetched content.');
              }

              resolve(); // Call resolve when the promise is completed successfully
            })
            .catch(error => {
                console.error('Failed to fetch configurator add-on modal content:', error);
                reject(error); // Call reject in case of an error
            });
            
        });
      }
    }, {
      /**
       * Opens the drawer
       */
      key: "_openSidebar",
      value: async function _openSidebar(event) {
        event.preventDefault();
        event.stopPropagation();

        var addonItemCard = event.target.closest('.addonItemCard');
        this.sidebarVariantID = addonItemCard.getAttribute('data-pid');
        this.sidebardAddonProductHandle = addonItemCard.getAttribute('data-product');

        await this._getAddOnItemDetails();

        var productGalleryElement = this.sidebarContent.querySelector('.Product__Gallery');

        if (productGalleryElement) {
          var options = 
          {
            "enableImageZoom": false,
            "enableVideoLooping": false,
            "modalDisplay": false,
            "stackProductImages": false,
            "showThumbnails": false,
            "view": "systems-addon-gallery"
          }
          this.productGallery = new ProductGallery(this.sidebarContent, options);
        }

        this.sidebarDrawer.open();
      }
    }, {
      key: "_onDrawerClosed",
      value: function _onDrawerClosed() {

        if (this.productGallery) {
          this.productGallery.onUnload();
        }

        if (this.productVariants) {
          this.productVariants.destroy();
        }

      }

    }, {
      /**
       *  Update Add-On Item Displayed on Variant Change
       */
      key: "_updateSidebarAddon",
      value: async function _updateSidebarAddon(event) {
        event.preventDefault();
        event.stopPropagation();

        var newVariant = event.detail.variant; 
        this.sidebarVariantID = newVariant['id'];
        this._updateSidebarAddonATB(newVariant);
      }
    }, {
      /**
       *  Update Add-On Item Save Button
       */
      key: "_updateSidebarAddonATB",
      value: function _updateSidebarAddonATB(newVariant) {

        var saveButton = this.sidebarContent.querySelector('button.prdsys-addon-atb');

        if (saveButton) {
          saveButton.classList.remove('d-none');
          if (!newVariant) {
            saveButton.setAttribute('disabled', 'disabled');
            saveButton.removeAttribute('data-pid');
            saveButton.innerHTML = window.languages.productFormUnavailable;
          } else {
            if (newVariant['available']) {
              saveButton.removeAttribute('disabled');
              saveButton.innerHTML = window.languages.productFromAddToSet;
              saveButton.setAttribute('data-pid', newVariant['id']);
              saveButton.setAttribute('data-price', (newVariant['price'] / 100).toFixed(2));
              if (newVariant['compare_at_price']) {
                saveButton.setAttribute('data-compareat', (newVariant['compare_at_price'] / 100).toFixed(2));
              } else {
                saveButton.setAttribute('data-compareat', '');
              }
              if (newVariant['is_preorder']) {
                saveButton.innerHTML = window.languages.productFormPreorder;
                saveButton.setAttribute('data-preorder', 'true');
              } else {
                saveButton.setAttribute('data-preorder', '');
              }
              if (newVariant['is_final_sale']) {
                saveButton.setAttribute('data-finalsale', 'true');
              } else {
                saveButton.setAttribute('data-finalsale', '');
              }
              if (newVariant.hasOwnProperty('option1')) {
                saveButton.setAttribute('data-color', newVariant['option1']);
              } 
              if (newVariant.hasOwnProperty('option2')) {
                saveButton.setAttribute('data-size', newVariant['option2']);
              } else {
                saveButton.setAttribute('data-size', '');
              }
              if (newVariant.hasOwnProperty('back_in_stock_date')) {
                saveButton.setAttribute('data-stockdate', newVariant['back_in_stock_date']);
              } else {
                saveButton.setAttribute('data-stockdate', '');
              }
              if (newVariant.hasOwnProperty('featured_image')) {
                if (newVariant['featured_image'].src) {
                  saveButton.setAttribute('data-image', newVariant['featured_image'].src);
                }
              }
            } else {
              saveButton.setAttribute('disabled', 'disabled');
              saveButton.removeAttribute('data-pid');
              saveButton.setAttribute('data-preorder', '');
              saveButton.setAttribute('data-finalsale', '');
              saveButton.innerHTML = window.languages.productFormSoldOut;
            }
          }
        }
      }
    }, {
      /**
       * Update Systems Products on PDP Variant Change
       */
      key: "_updateSystemsProducts",
      value: function _updateSystemsProducts(event) {
        var _this = this;

        if (this.productSystems) {

          var variant = event.detail.variant;
          const url = window.location.origin + '/products/' + variant.productHandle + '?variant=' + variant.id + '&view=systems';

          fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                return response.text();
            })
            .then(html => {
              const tempElement = document.createElement('div');
              tempElement.innerHTML = html;

              const sectionHtml = tempElement.querySelector('.systems-items')?.innerHTML;

              if (sectionHtml) {
                _this.systemsItems.innerHTML = sectionHtml;
              } else {
                console.error('Error: No .shopify-section element found in the fetched content.');
              }

            })
            .catch(error => {
                console.error('Failed to fetch configurator add-on modal content:', error);
            });
        }
      }
    }, {
      /**
       * Show More or Less products in desktop view
       */
      key: "_showMoreLess",
      value: function _showMoreLess(event) {
        if (this.productSystems) {
          this.productSystems.classList.toggle('showMore');
        }
      }
    }]);

    return ProductSystemsSection;
  }();
  
  
  var RecentlyViewedProductsSection = /*#__PURE__*/function () {
    function RecentlyViewedProductsSection(container) {
      _classCallCheck(this, RecentlyViewedProductsSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '[]'); // Setup product item color swatch

      this._fetchProducts();
    }

    _createClass(RecentlyViewedProductsSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.carousel) {
          this.carousel.destroy();
        }
      }
      /**
       * In order to get the products to display, we hit the search template with the given IDS
       */

    }, {
      key: "_fetchProducts",
      value: function _fetchProducts() {
        var _this = this;

        var queryString = this._getSearchQueryString();

        if (queryString === '') {
          return;
        } // If we have a non empty query string we do a search query


        fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&type=product&q=").concat(queryString), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            var tempElement = document.createElement('div');
            tempElement.innerHTML = content; // Set the content

            _this.element.innerHTML = tempElement.querySelector('.Section').innerHTML; // Show the section

            _this.element.parentNode.style.display = 'block'; // And finally let's create the carousel !

            _this.carousel = new Carousel(_this.element.querySelector('[data-flickity-config]'));

            checkPrivateSale();
          });
        });
      }
    }, {
      key: "_getSearchQueryString",
      value: function _getSearchQueryString() {
        var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); // If we are on a product template, we make sure to remove the main product from the related product

        if (items.includes(this.options['productId'])) {
          items.splice(items.indexOf(this.options['productId']), 1);
        }

        return items.map(function (item) {
          return 'id:' + item;
        }).join(' OR ');
      }
    }]);

    return RecentlyViewedProductsSection;
  }();

  /**
   * This code is extracted from Slate
   */

  var SectionContainer = /*#__PURE__*/function () {
    function SectionContainer() {
      _classCallCheck(this, SectionContainer);

      this.constructors = [];
      this.instances = [];

      this._attachListeners();
    }

    _createClass(SectionContainer, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
        document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
        document.addEventListener('shopify:section:select', this._onSelect.bind(this));
        document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
        document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
        document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
      }
    }, {
      key: "register",
      value: function register(type, constructor) {
        var _this = this;

        this.constructors[type] = constructor;
        Dom.nodeListToArray(document.querySelectorAll("[data-section-type=".concat(type, "]"))).forEach(function (container) {
          _this._createInstance(container, constructor);
        });
      }
      /**
       * Return an object from an array of objects that matches the provided key and value
       */

    }, {
      key: "_findInstance",
      value: function _findInstance(array, key, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return array[i];
          }
        }
      }
      /**
       * Remove an object from an array of objects by matching the provided key and value
       */

    }, {
      key: "_removeInstance",
      value: function _removeInstance(array, key, value) {
        var i = array.length;

        while (i--) {
          if (array[i][key] === value) {
            array.splice(i, 1);
            break;
          }
        }

        return array;
      }
    }, {
      key: "_onSectionLoad",
      value: function _onSectionLoad(event) {
        var container = event.target.querySelector('[data-section-id]');

        if (container) {
          this._createInstance(container);
        }
      }
    }, {
      key: "_onSectionUnload",
      value: function _onSectionUnload(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (!instance) {
          return;
        }

        if (typeof instance.onUnload === 'function') {
          instance.onUnload(event);
        }

        this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
      }
    }, {
      key: "_onSelect",
      value: function _onSelect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
          instance.onSelect(event);
        }
      }
    }, {
      key: "_onDeselect",
      value: function _onDeselect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
          instance.onDeselect(event);
        }
      }
    }, {
      key: "_onReorder",
      value: function _onReorder(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
          instance.onReorder(event);
        }
      }
    }, {
      key: "_onBlockSelect",
      value: function _onBlockSelect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
          instance.onBlockSelect(event);
        }
      }
    }, {
      key: "_onBlockDeselect",
      value: function _onBlockDeselect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
          instance.onBlockDeselect(event);
        }
      }
    }, {
      key: "_createInstance",
      value: function _createInstance(container, constructor) {
        var id = container.getAttribute('data-section-id'),
            type = container.getAttribute('data-section-type');
        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
          return;
        }

        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      }
    }]);

    return SectionContainer;
  }();

  var ShopNowSection = /*#__PURE__*/function () {
    function ShopNowSection(container) {
      _classCallCheck(this, ShopNowSection);

      this.element = container;
      this.carousel = new Carousel(this.element.querySelector('[data-flickity-config]')); // Setup product item color swatch
    }

    _createClass(ShopNowSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }]);

    return ShopNowSection;
  }();

  var ShopTheLookSection = /*#__PURE__*/function () {
    function ShopTheLookSection(container) {
      _classCallCheck(this, ShopTheLookSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.usePocketMode = Responsive.matchesBreakpoint('pocket');
      this.pocketActivatorButton = this.element.querySelector('[data-action="open-look"]');

      this._createOuterCarousel();

      this._createPocketPopovers();

      this._attachListeners();
    }

    _createClass(ShopTheLookSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.outerCarousel.destroy();
        this.innerCarousels.forEach(function (item) {
          item.forEach(function (innerItem) {
            return innerItem.destroy();
          });
        });
        this.popovers.forEach(function (item) {
          return item.destroy();
        });
        this.delegateElement.off();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.outerCarousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
      }
      /**
       * Attach all the listeners
       */

    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.ShopTheLook__Dot', this._onDotClicked.bind(this));
      }
      /**
       * There is one mobile and tablet popover per look, so we pre-create them
       */

    }, {
      key: "_createPocketPopovers",
      value: function _createPocketPopovers() {
        var _this = this;

        this.popovers = [];
        Dom.nodeListToArray(this.element.querySelectorAll('.Popover')).forEach(function (popover) {
          _this.popovers.push(new Popover(popover, {
            activator: _this.pocketActivatorButton,
            showOverlay: false,
            onOpen: _this._openPocketZoom.bind(_this),
            onClose: _this._closePocketZoom.bind(_this)
          }));
        });
      }
      /**
       * The outer carousel is the carousel that holds the main one (all the looks). Internally, it also creates
       * a sub-carousel for each inner carousel
       */

    }, {
      key: "_createOuterCarousel",
      value: function _createOuterCarousel() {
        var _this2 = this;

        this.outerCarousel = new Carousel(this.element.querySelector('.ShopTheLook'), {
          onSelect: this._onLookChanged.bind(this)
        });
        this.innerCarousels = new Array(this.outerCarousel.flickityInstance.cells.length);

        for (var i = 0; i !== this.innerCarousels.length; ++i) {
          this.innerCarousels[i] = [];
        } // We need to create ALL the carousels (both in desktop and mobile). Fortunately Flickity is quite fast, but
        // we have no other choices if we want to have proper animations everywhere.


        Dom.nodeListToArray(this.element.querySelectorAll('.ShopTheLook__ProductList')).forEach(function (item) {
          var lookIndex = parseInt(item.getAttribute('data-look-index'));

          _this2.innerCarousels[lookIndex].push(new Carousel(item, {
            onSelect: _this2._onProductChanged.bind(_this2)
          })); // By default, Flickity will append the carousel, hence making the "ViewButton" before the carousel. We need to manipulate it to move it after


          item.insertBefore(item.querySelector('.flickity-viewport'), item.querySelector('.ShopTheLook__ViewButton'));
        });
        this.outerCarousel.resize(); // Needed in case the products are taller than the image
      }
      /**
       * This function is called whenever the main look has changed, so that we can modify the popover activator
       */

    }, {
      key: "_onLookChanged",
      value: function _onLookChanged(selectedIndex, selectedCell) {
        // Then, we update the mobile button so that it opens the correct block
        this.pocketActivatorButton.setAttribute('aria-controls', "".concat(selectedCell.getAttribute('id'), "-popover"));
      }
      /**
       * This function is called whenever a product is changed in the list for a given look. This allows to focus the main dot
       */

    }, {
      key: "_onProductChanged",
      value: function _onProductChanged(selectedIndex, selectedCell) {
        var lookItem = this.outerCarousel.getSelectedCell(),
            activeDot = null;
        Dom.nodeListToArray(lookItem.querySelectorAll('.ShopTheLook__Dot')).forEach(function (dot, index) {
          dot.classList.remove('is-active'); // IE11 and lower does not support "toggle" with second parameter :(

          if (index === selectedIndex) {
            dot.classList.add('is-active');
            activeDot = dot;
          }
        }); // Update the link to the product (if using the desktop view)

        lookItem.querySelector('.ShopTheLook__ViewButton').setAttribute('href', selectedCell.getAttribute('data-product-url')); // We trigger an event so that when the dot change we can recalculate the position

        lookItem.dispatchEvent(new CustomEvent('product:changed', {
          detail: {
            dot: activeDot
          }
        }));
      }
      /**
       * This function is called whenever you explicitly click on a dot.
       *
       * On mobile and tablet, this must open the appropriate popver
       */

    }, {
      key: "_onDotClicked",
      value: function _onDotClicked(event, target) {
        var shouldAnimateCarousel = false,
            hasOnePopoverOpen = false,
            lookIndex = this.outerCarousel.getSelectedIndex();
        this.popovers.forEach(function (item) {
          if (item.isOpen) {
            hasOnePopoverOpen = true;
            shouldAnimateCarousel = true;
          }
        }); // Each inner carousel has a mobile AND desktop version, so we change both

        this.innerCarousels[lookIndex].forEach(function (innerCarousel) {
          innerCarousel.selectCell(parseInt(target.getAttribute('data-product-index')) - 1, false, shouldAnimateCarousel);
        });

        if (this.usePocketMode && !hasOnePopoverOpen) {
          this.popovers[lookIndex].open();
        }
      }
      /**
       * This is called when, on mobile, the popover is open. We must open the image in full resolution
       */

    }, {
      key: "_openPocketZoom",
      value: function _openPocketZoom(popover) {
        var _this3 = this;

        this._calculateImageTransform(popover);

        fastdom.mutate(function () {
          // We need to animate the header to avoid a slightly ugly effect if image overlap the header
          document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(-100%); transition: transform 0.3s ease-in-out;';

          _this3.outerCarousel.flickityInstance.unbindDrag(); // Prevent changing the active slide


          _this3.outerCarousel.flickityInstance.element.classList.add('is-zoomed');

          _this3.outerCarousel.getSelectedCell().classList.add('is-expanded');
        });
      }
      /**
       * When the mobile zoom is open, and whenever the active dot changes, we need to potentially re-calculate the transform
       */

    }, {
      key: "_calculateImageTransform",
      value: function _calculateImageTransform(openPopover) {
        var _this4 = this;

        var selectedCell = this.outerCarousel.getSelectedCell();
        fastdom.measure(function () {
          // We first need to compute the initial transform and scale factor
          var scale = window.innerWidth / (selectedCell.offsetWidth - parseInt(window.getComputedStyle(selectedCell).paddingLeft) * 2),
              heightAfterScale = Math.round(selectedCell.offsetHeight * scale),
              // Height of the selected cell once the scale transform is applied
          hiddenImageHeight = Math.round(Math.max(heightAfterScale - (window.innerHeight - openPopover.element.offsetHeight), 0)),
              // Part of image that is below popover
          visibleImageHeight = heightAfterScale - hiddenImageHeight,
              // Part of the image that is visible in the viewport
          minTranslateY = Math.round(-(selectedCell.getBoundingClientRect().top - (heightAfterScale - selectedCell.offsetHeight) / 2)),
              // The minimum translate Y transform allowed so that image is visible
          maxTranslateY = Math.round(minTranslateY - hiddenImageHeight); // The maximum translate Y transform allowed so that image is visible

          _this4._calculateTransformForDotListener = function (event) {
            var dotTopPosition = Math.round((event.detail.dot.offsetTop + event.detail.dot.offsetHeight / 2) * scale),
                offsetToMove = Math.round(dotTopPosition - visibleImageHeight / 2),
                translateY = Math.min(Math.max(minTranslateY - offsetToMove, maxTranslateY), minTranslateY);
            fastdom.mutate(function () {
              _this4.outerCarousel.flickityInstance.viewport.style.transform = "translate3d(0, ".concat(Math.round(translateY), "px, 0) scale(").concat(scale, ")");
            });
          }; // We manually generate an event the first time to trigger the positioning


          selectedCell.addEventListener('product:changed', _this4._calculateTransformForDotListener);
          selectedCell.dispatchEvent(new CustomEvent('product:changed', {
            detail: {
              dot: selectedCell.querySelector('.ShopTheLook__Dot.is-active')
            }
          }));
        });
      }
      /**
       * Close the mobile zoom (which close the popover and remove any transform
       */

    }, {
      key: "_closePocketZoom",
      value: function _closePocketZoom() {
        var _this5 = this;

        var selectedCell = this.outerCarousel.getSelectedCell();
        selectedCell.removeEventListener('product:changed', this._calculateTransformForDotListener);
        fastdom.mutate(function () {
          document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;';

          _this5.outerCarousel.flickityInstance.bindDrag();

          _this5.outerCarousel.flickityInstance.element.classList.remove('is-zoomed');

          _this5.outerCarousel.flickityInstance.viewport.style.transform = null;
          selectedCell.classList.remove('is-expanded');
        });
      }
    }]);

    return ShopTheLookSection;
  }();

  var SidebarMenuSection = /*#__PURE__*/function () {
    function SidebarMenuSection(container) {
      _classCallCheck(this, SidebarMenuSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.sidebarDrawer = new Drawer(container);

      this.searchBar = new NavSearchBar();

      this._attachListeners();
    }

    _createClass(SidebarMenuSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.sidebarDrawer.destroy();
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this.sidebarDrawer.open();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this.sidebarDrawer.close();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
      }
    }]);

    return SidebarMenuSection;
  }();

  var SlideshowSection = /*#__PURE__*/function () {
    function SlideshowSection(container) {
      _classCallCheck(this, SlideshowSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.slideshow = new Carousel(this.element.querySelector('[data-flickity-config]'), {
        onSelect: this._onSlideChanged.bind(this)
      });
      this.selectedSlide = null;
      this.shouldAnimate = true;
      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      });

      if (this.slideshow.flickityInstance.cells.length > 0) {
        this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, true);
      }

      this._attachListeners();
    }

    _createClass(SlideshowSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.slideshow.destroy();
        this.timeline.kill();
        this.delegateElement.off();
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.stopPlayer();
        }

        this.shouldAnimate = !event.detail.load;
        this.slideshow.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        this.shouldAnimate = true;

        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.playPlayer();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
        this.delegateElement.on('mouseenter', '.Button', this._pauseSlideshow.bind(this), true);
        this.delegateElement.on('mouseleave', '.Button', this._resumeSlideshow.bind(this), true);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "_pauseSlideshow",
      value: function _pauseSlideshow() {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.pausePlayer();
        }
      }
    }, {
      key: "_resumeSlideshow",
      value: function _resumeSlideshow() {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.unpausePlayer();
        }
      }
    }, {
      key: "_onSlideChanged",
      value: function _onSlideChanged(index, element) {
        this._transitionToSlide(element);
      }
    }, {
      key: "_transitionToSlide",
      value: function _transitionToSlide(slide) {
        var _this = this;

        this.timeline.clear(); // First, we check if there is a previous slide selected, if that's the case

        if (this.selectedSlide) {
          this._slideLeave(this.selectedSlide);

          this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0);
        } // We get the next slide (if any) to preload it


        this._lazyLoadNextImage();

        this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 0
        }, {
          autoAlpha: 1,
          ease: Cubic.easeInOut
        }, 'enter'); // The image may take 1s or more to load depending on the network, so we make sure to pause the player, and restart it once it has transitioned

        if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'playing') {
          this.slideshow.flickityInstance.pausePlayer();
        }

        Dom.nodeListToArray(slide.querySelectorAll('.Slideshow__Image')).forEach(function (image) {
          if (image.classList.contains('Image--lazyLoading') || image.classList.contains('Image--lazyLoad')) {
            image.addEventListener('lazyloaded', _this._slideEnter.bind(_this, slide));
          } else {
            _this._slideEnter(slide);
          }
        });
        this.selectedSlide = slide;
      }
    }, {
      key: "_slideLeave",
      value: function _slideLeave(slide) {
        var content = slide.querySelector('.SectionHeader'),
            buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');
        this.timeline.fromTo(slide, this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 1
        }, {
          autoAlpha: 0,
          ease: Cubic.easeInOut,
          delay: this.shouldAnimate ? 0.35 : 0
        });

        if (content) {
          this.timeline.fromTo(content, this.shouldAnimate ? 0.4 : 0, {
            autoAlpha: 1,
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            ease: Cubic.easeIn
          }, 0);
        }

        if (buttonWrapper) {
          this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.4 : 0, {
            autoAlpha: 1,
            y: 0
          }, {
            autoAlpha: 0,
            y: 10,
            ease: Cubic.easeIn
          }, 0);
        }
      }
    }, {
      key: "_slideEnter",
      value: function _slideEnter(slide) {
        var images = slide.querySelectorAll('.Slideshow__Image'),
            content = slide.querySelector('.SectionHeader'),
            buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');

        if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'paused') {
          this.slideshow.flickityInstance.unpausePlayer();
        }

        if (window.CSS && window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')) {
          if (window.theme.showImageZooming) {
            this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
              opacity: 0,
              scale: 1.2
            }, {
              opacity: 1,
              scale: 1,
              ease: Quad.easeOut
            }, 'enter');
          } else {
            this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
              opacity: 0
            }, {
              opacity: 1,
              ease: Quad.easeOut
            }, 'enter');
          }
        }

        if (content) {
          this.timeline.fromTo(content, this.shouldAnimate ? 0.8 : 0, {
            autoAlpha: 0,
            y: 30
          }, {
            autoAlpha: 1,
            y: 0,
            delay: this.shouldAnimate ? 0.8 : 0,
            ease: Cubic.easeOut
          }, 'enter');
        }

        if (buttonWrapper) {
          this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.8 : 0, {
            autoAlpha: 0,
            y: 20
          }, {
            autoAlpha: 1,
            y: 0,
            delay: this.shouldAnimate ? 0.8 : 0,
            ease: Cubic.easeOut
          }, 'enter');
        }
      }
    }, {
      key: "_lazyLoadNextImage",
      value: function _lazyLoadNextImage() {
        var currentIndex = this.slideshow.flickityInstance.selectedIndex,
            breakpoint = Responsive.getCurrentBreakpoint();

        if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
          var nextCellElement = this.slideshow.flickityInstance.cells[currentIndex + 1].element,
              imageContainers = Dom.nodeListToArray(nextCellElement.querySelectorAll('.Slideshow__ImageContainer')),
              imageToReveal = null;

          if (breakpoint === 'phone') {
            imageToReveal = imageContainers[0];
          } else {
            imageToReveal = imageContainers[1];
          }

          if (window.lazySizes && imageToReveal && imageToReveal.classList.contains('Image--lazyLoad')) {
            lazySizes.loader.unveil(imageToReveal.firstElementChild);
          }
        }
      }
    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged(event) {
        if (event.detail.previousBreakpoint === 'phone' && event.detail.currentBreakpoint !== 'phone' || event.detail.previousBreakpoint !== 'phone' && event.detail.currentBreakpoint === 'phone') {
          this.selectedSlide = null;

          this._transitionToSlide(this.slideshow.flickityInstance.selectedElement);
        }
      }
    }]);

    return SlideshowSection;
  }();

  var CuyanaProductFeaturesSection = /*#__PURE__*/function () {
    function CuyanaProductFeaturesSection(container) {
      _classCallCheck(this, CuyanaProductFeaturesSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);

      var features = this.element.querySelectorAll('.feature-progress-bar');
      if (features) {
        this.numberOfFeatures = features.length;
      }

      this.progressBarTimer = null;
      this.activeFeatureProgressBar = 0;
      this.previousFeatureProgressBar = 0;
      this.numberOfSecondsBetweenImages = window.theme.productFeaturesSlideDelay;

      this.touchstartX = 0;
      this.touchstartY = 0;
      this.touchendX = 0;
      this.touchendY = 0;

      var _this = this;

      var paginationTotal = this.element.querySelector('#pagination-total');
      paginationTotal.textContent = this.numberOfFeatures;

      document.documentElement.style.setProperty('--feature-pb-timer', this.numberOfSecondsBetweenImages +'s');

      //hide the pagination and progress bars when there is only 1 feature 
      if (this.numberOfFeatures <= 1){
        var progressUnits = this.element.querySelectorAll('.progress-unit');
        progressUnits.forEach(function(unit) {
          unit.style.display = 'none';
        });
      } else {
        // Click Event Listeners
        this.delegateElement.on('click', '#pagination-back', this._paginationBack.bind(this));
        this.delegateElement.on('click', '#pagination-next', this._paginationNext.bind(this));
        this.delegateElement.on('click', '#pagination-pause', this._paginationPlayPause.bind(this));

        //Area to implement swipe listeners on
        const gestureZone = this.element.querySelector('#product-feature-image-wrapper');
        if (gestureZone != null) {
            gestureZone.addEventListener('touchstart', function(event) {
              _this.touchstartX = event.changedTouches[0].screenX;
              _this.touchstartY = event.changedTouches[0].screenY;
            }, false);

            gestureZone.addEventListener('touchend', function(event) {
              _this.touchendX = event.changedTouches[0].screenX;
              _this.touchendY = event.changedTouches[0].screenY;
              _this._handleGesture();
            }, false);
        } 

        //kick off the progress bar
        var featureActive = this.element.querySelector('#feature_0');
        if (featureActive){
          featureActive.classList.add('active');
        }
        var progressBarActive = this.element.querySelector('#progress_bar_0');
        if (progressBarActive){
          progressBarActive.classList.add('active');
        }

        this.progressBarTimer = setInterval(this._processProgressBar.bind(this), this.numberOfSecondsBetweenImages * 1000);
      }
    }

    _createClass(CuyanaProductFeaturesSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off('click');
          this.progressBarTimer.destroy();
        }
      }, {
        key: "_handleGesture",
        value: function _handleGesture() {
          //Swipe events on feature image allow user to skip ahead or back.
          if (this.touchendX < this.touchstartX) {
            //Swiped left
            this._paginationNext()
          }
          if (this.touchendX > this.touchstartX) {
            //Swiped right
            this._paginationBack()
          }
        }
      }, {
        key: "_paginationBack",
        value: function _paginationBack() {
          if (this.activeFeatureProgressBar != 0) {
            clearInterval(this.progressBarTimer);
            this.previousFeatureProgressBar = this.activeFeatureProgressBar;
            this.activeFeatureProgressBar = this.activeFeatureProgressBar - 1 ;

            this._setActiveProgressBar();
            this.progressBarTimer = setInterval(this._processProgressBar.bind(this), this.numberOfSecondsBetweenImages * 1000);
          }
        }
      }, {
        key: "_paginationPlayPause",
        value: function _paginationPlayPause() {

          var buttonWrapper = this.element.querySelector('#pagination-pause');
          var buttonPause = buttonWrapper.querySelector('#pagination-pause .icon-pause');
          var buttonPlay = buttonWrapper.querySelector('#pagination-pause .icon-play-button');
          
          if (buttonPlay && buttonPlay.classList.contains('d-none')) {
            // Pause button has been cliked.  Play button is currenlty hidden
            clearInterval(this.progressBarTimer);
            
            buttonPlay.classList.remove('d-none');
            buttonPause.classList.add('d-none');
            buttonWrapper.setAttribute("aria-label", "Play Slides");

            var activeIndex = this.activeFeatureProgressBar;
            var barUnfillActive = this.element.querySelector('#bar_unfill_' + activeIndex);
            barUnfillActive.classList.add('completed');

          } else if (buttonPause && buttonPause.classList.contains('d-none')) {
            // Play button has been clicked.  Pause button is currenlty hidden
            buttonPause.classList.remove('d-none');
            buttonPlay.classList.add('d-none');
            buttonWrapper.setAttribute("aria-label", "Pause Slides");

            this._paginationNext()
          }
        }
      }, {
        key: "_paginationNext",
        value: function _paginationNext() {
          if (this.activeFeatureProgressBar != this.numberOfFeatures-1) {
            clearInterval(this.progressBarTimer);
            this.previousFeatureProgressBar = this.activeFeatureProgressBar;
            this.activeFeatureProgressBar = this.activeFeatureProgressBar + 1 ;

            this._setActiveProgressBar();
            this.progressBarTimer = setInterval(this._processProgressBar.bind(this), this.numberOfSecondsBetweenImages * 1000);
          }
        }
      }, {
        //transition to the next image by swapping which is active
        key: "_transitionImage",
        value: function _transitionImage() {

          var previousImage = this.element.querySelector('#feature_image_' + this.previousFeatureProgressBar);
          var nextImage = this.element.querySelector('#feature_image_' + this.activeFeatureProgressBar);

          if (previousImage) {
            previousImage.classList.remove('active');
          }

          if (nextImage) {
            nextImage.classList.add('active');
          }
        }
      }, {
        //increment the active progress bar, when complete changes active bar and image.
        key: "_processProgressBar",
        value: function _processProgressBar() {

          this.previousFeatureProgressBar = this.activeFeatureProgressBar;
          this.activeFeatureProgressBar++;

          if (this.activeFeatureProgressBar > this.numberOfFeatures - 1){
              this.activeFeatureProgressBar = 0; //start over with the 1st feature
          }

          this._setActiveProgressBar();
        }
      }, {
        key: "_setActiveProgressBar",
        value: function _setActiveProgressBar() {
          // Load new feature image
          this._transitionImage();

          var oldIndex = this.previousFeatureProgressBar;
          var activeIndex = this.activeFeatureProgressBar;

          var barUnfillOld = this.element.querySelector('#bar_unfill_' + oldIndex);
          var barUnfillActive = this.element.querySelector('#bar_unfill_' + activeIndex);
          var paginationBack = this.element.querySelector('#pagination-back');
          var paginationNext = this.element.querySelector('#pagination-next');
          var paginationCount = this.element.querySelector('#pagination-count');
          var progressBarOld = this.element.querySelector('#progress_bar_' + oldIndex);
          var progressBarActive = this.element.querySelector('#progress_bar_' + activeIndex);
          var featureOld = this.element.querySelector('#feature_' + oldIndex);
          var featureActive = this.element.querySelector('#feature_' + activeIndex);
          var imagePlaceholders = this.element.querySelectorAll('.feature-image');
      
          if (activeIndex != 0 && activeIndex > oldIndex) {
              barUnfillOld.classList.add('completed');
              paginationBack.classList.remove('inactive');
      
              if (activeIndex + 1 === this.numberOfFeatures) {
                  paginationNext.classList.add('inactive');
              }
          } else if (activeIndex === 0) {
              paginationNext.classList.remove('inactive');
              paginationBack.classList.add('inactive');
      
              for (var i = 0; i < this.numberOfFeatures; i++) {
                  this.element.querySelector('#bar_unfill_' + i).classList.remove('completed');
              }
          } else if (activeIndex < oldIndex) {
              barUnfillOld.classList.remove('completed');
              barUnfillActive.classList.remove('completed');
              paginationNext.classList.remove('inactive');
          }
      
          paginationCount.textContent = activeIndex + 1;
          progressBarOld.classList.remove('active');
          featureOld.classList.remove('active');
          progressBarActive.classList.add('active');
          featureActive.classList.add('active');

          imagePlaceholders[1].style.maxHeight = imagePlaceholders[0].offsetHeight + 'px';
        }
      }
    ]);

    return CuyanaProductFeaturesSection;
  }();

  var CuyanaSliderSection = /*#__PURE__*/function () {
    function CuyanaSliderSection(container) {
      _classCallCheck(this, CuyanaSliderSection);

      this.element = container;
      this.currentWidth = window.screen.width;

      this.progressCount = this.element.querySelector('.progress-count');

      this.Carousel = this.element.querySelector('[data-flickity-config]');
      this.config = JSON.parse(this.Carousel.getAttribute('data-flickity-config') || '[]');

      if (this.config['breakpoints'] !== undefined) {
        this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }

      this._build();

      window.addEventListener('resize', this.onResize.bind(this));
      window.addEventListener('load', this.onResize.bind(this));

      // Use Mutation Observer to call resize to solve cut off images
      const observer = new MutationObserver(() => {
        if (this.flickityInstance) {
          this.flickityInstance.resize();
          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    _createClass(CuyanaSliderSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.flickityInstance.destroy();
      }
    }, {
      key: "onResize",
      value: function onResize(event) {
        if (window.screen.width !== this.currentWidth)  {
          this.currentWidth = window.screen.width;
          this.flickityInstance.resize();
        }
      }
    /**
     * Verify if the breakpoint has changed, and optionally update the carousel
     */
    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged() {
        // The breakpoint may have changed, so we delete the carousel and rebuild it
        this.flickityInstance.destroy();
        this._build();
      }
    }, {
      key: "_build",
      value: function _build() {
        var _this = this;
        /*
        // apply desktop settings
        if ( matchMedia('screen and (min-width: 768px)').matches ) {
          this.config = { ...this.config, ...this.config.desktop};
        } else {
          delete this.config.desktop;
        }
        */
        this.flickityInstance = new Flickity(this.Carousel, this.config);

        this.flickityInstance.on('staticClick', function(event, pointer, cellElement, cellIndex) {

          if (typeof cellIndex === 'number') {
            // Fully visible slides keep their links, so tiles in a multi-slide row stay clickable.
            if (isFullyVisible(cellElement, _this.flickityInstance.viewport)) return;
            const link = cellElement.querySelector('a');
            if (link) {
              // Temporarily prevent link click
              link.addEventListener('click', preventLink, { once: true });
            }
            _this.flickityInstance.select(cellIndex);
          }

          // 1px tolerance absorbs sub-pixel slide widths (e.g. 100% / 4.3).
          function isFullyVisible(cellElement, viewport) {
            const cell = cellElement.getBoundingClientRect();
            const view = viewport.getBoundingClientRect();
            return cell.left >= view.left - 1 && cell.right <= view.right + 1;
          }

          function preventLink(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        });

        if (_this.progressCount) {
          this.flickityInstance.on('select', function (index) {
            _this.selectedIndex = _this.flickityInstance.selectedIndex;
            _this.progressCount.textContent = _this.selectedIndex + 1;
          });
        }
      }
    }]);

    return CuyanaSliderSection;
  }();

  var TestimonialsSection = /*#__PURE__*/function () {
    function TestimonialsSection(container) {
      _classCallCheck(this, TestimonialsSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.navItems = Dom.nodeListToArray(this.element.querySelectorAll('.TestimonialNav__Item'));
      this.carousel = new Carousel(this.element.querySelector('.TestimonialList'), {
        onSelect: this._testimonialChanged.bind(this)
      });

      this._attachListeners();
    }

    _createClass(TestimonialsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
        this.delegateElement.off('click');
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        this.carousel.unpausePlayer();
      }
    }, {
      key: "_testimonialClicked",
      value: function _testimonialClicked(event, target) {
        this.carousel.pausePlayer();
        this.carousel.selectCell(parseInt(target.getAttribute('data-index')));
        this.carousel.unpausePlayer();
      }
    }, {
      key: "_testimonialChanged",
      value: function _testimonialChanged(newIndex) {
        this.navItems.forEach(function (item, index) {
          item.classList.remove('is-selected'); // IE11 and lower does not support classList.toggle

          if (newIndex === index) {
            item.classList.add('is-selected');
          }
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.TestimonialNav__Item', this._testimonialClicked.bind(this));
      }
    }]);

    return TestimonialsSection;
  }();

  var TimelineSection = /*#__PURE__*/function () {
    function TimelineSection(container) {
      _classCallCheck(this, TimelineSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.items = Dom.nodeListToArray(this.element.querySelectorAll('.Timeline__Item'));
      this.navItems = Dom.nodeListToArray(this.element.querySelectorAll('.Timeline__NavItem'));

      this._attachListeners();
    }

    _createClass(TimelineSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.navItems[parseInt(event.target.getAttribute('data-index'))].click(); // Simulate a click on the given nav item
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.Timeline__NavItem', this._clickOnNavItem.bind(this));
      }
    }, {
      key: "_clickOnNavItem",
      value: function _clickOnNavItem(event, target) {
        var newItem = this.items[parseInt(target.getAttribute('data-index'))];

        if (newItem.classList.contains('is-selected')) {
          return;
        }

        var isContentLarger = false,
            navWrapper = target.parentNode,
            scrollableOffset = 0;
        fastdom.measure(function () {
          var scrollableWidth = navWrapper.scrollWidth,
              visibleWidth = navWrapper.offsetWidth;
          isContentLarger = visibleWidth < scrollableWidth;

          if (isContentLarger) {
            var beginBound = target.offsetLeft,
                endBound = beginBound + target.offsetWidth,
                closerToLeft = beginBound <= visibleWidth - endBound;
            var itemToUse = null;

            if (closerToLeft) {
              // If closer to left, we try to make the previous item visible (if possible)
              itemToUse = target.previousElementSibling || target;
            } else {
              // If closer to right, we try to make the next item visible (if possible)
              itemToUse = target.nextElementSibling || target;
            }

            var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
                itemEndBound = itemBeginBound + itemToUse.offsetWidth;

            if (itemEndBound > visibleWidth) {
              // Element is not visible from the right, so we must move by a given amount so that endBound is within viewable screen
              scrollableOffset = itemEndBound - visibleWidth;
            } else if (itemBeginBound < 0) {
              // Element is not visible from the left, so we simply use the opposite of the negative offset
              scrollableOffset = itemBeginBound;
            }
          }
        });
        fastdom.mutate(function () {
          if (isContentLarger) {
            navWrapper.scrollBy({
              behavior: 'smooth',
              left: scrollableOffset
            });
          } // First we set the class on the selected item and remove it on siblings


          target.classList.add('is-selected');
          Dom.getSiblings(target, '.is-selected').forEach(function (item) {
            item.classList.remove('is-selected');
          }); // Then we slide to the appropriate element

          newItem.classList.add('is-selected');
          Dom.getSiblings(newItem, '.is-selected').forEach(function (item) {
            item.classList.remove('is-selected');
          });
        });
      }
    }]);

    return TimelineSection;
  }();

  var PriceRange = /*#__PURE__*/function (_HTMLElement) {
    _inherits(PriceRange, _HTMLElement);

    var _super = _createSuper(PriceRange);

    function PriceRange() {
      _classCallCheck(this, PriceRange);

      return _super.apply(this, arguments);
    }

    _createClass(PriceRange, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;

        this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
        this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
        this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
        this.textInputHigherBound = this.querySelector('.price-range__input:last-child input'); // Select whole text on focus for text field to improve user experience

        this.textInputLowerBound.addEventListener('focus', function () {
          return _this.textInputLowerBound.select();
        });
        this.textInputHigherBound.addEventListener('focus', function () {
          return _this.textInputHigherBound.select();
        }); // Keep in sync the range with the text input fields

        this.textInputLowerBound.addEventListener('change', function (event) {
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
          _this.rangeLowerBound.value = event.target.value;

          _this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
        });
        this.textInputHigherBound.addEventListener('change', function (event) {
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
          _this.rangeHigherBound.value = event.target.value;

          _this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
        });
        this.rangeLowerBound.addEventListener('change', function (event) {
          _this.textInputLowerBound.value = event.target.value;

          _this.textInputLowerBound.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        });
        this.rangeHigherBound.addEventListener('change', function (event) {
          _this.textInputHigherBound.value = event.target.value;

          _this.textInputHigherBound.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }); // We also have to bound the two range sliders

        this.rangeLowerBound.addEventListener('input', function (event) {
          event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

          event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputLowerBound.value = event.target.value;
        });
        this.rangeHigherBound.addEventListener('input', function (event) {
          event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

          event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputHigherBound.value = event.target.value;
        });
      }
    }]);

    return PriceRange;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define('price-range', PriceRange);

  var ProductRecommendations = /*#__PURE__*/function (_HTMLElement) {
    _inherits(ProductRecommendations, _HTMLElement);

    var _super = _createSuper(ProductRecommendations);

    function ProductRecommendations() {
      var _this;

      _classCallCheck(this, ProductRecommendations);

      _this = _super.call(this);
      _this._isLoaded = false;
      return _this;
    }

    _createClass(ProductRecommendations, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this._loadRecommendations();
      }
    }, {
      key: "_loadRecommendations",
      value: function _loadRecommendations() {
        var _this2 = this;

        if (this._isLoaded) {
          return;
        }

        this._isLoaded = true;
        var section = this.closest('.shopify-section'),
            intent = this.getAttribute('intent') || 'related',
            url = "".concat(Shopify.routes.root, "recommendations/products?product_id=").concat(this.getAttribute('product'), "&limit=").concat(this.getAttribute('limit') || 4, "&section_id=").concat(this.getAttribute('section-id'), "&intent=").concat(intent);
        fetch(url).then(function (response) {
          response.text().then(function (text) {
            var tempDiv = new DOMParser().parseFromString(text, 'text/html'),
                productRecommendationsElement = tempDiv.querySelector('product-recommendations');

            if (productRecommendationsElement.childElementCount > 0) {
              _this2.replaceChildren.apply(_this2, _toConsumableArray(document.importNode(productRecommendationsElement, true).childNodes));
              
              // Check for private sale on page load
              checkPrivateSale();

            } else {
              if (intent === 'related') {
                section.remove();
              } else {
                _this2.remove();
              }
            }
          });
        });
      }
    }]);

    return ProductRecommendations;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  if (!window.customElements.get('product-recommendations')) {
    window.customElements.define('product-recommendations', ProductRecommendations);
  }

  (function () {
    // First, we register all plugins that are used for all pages
    new Collapsible();
    new Modal();
    new Responsive();

    if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
      new LoadingBar();
    }

    var sections = new SectionContainer();
    sections.register('header', HeaderSection);
    sections.register('newheader', HeaderSection);
    sections.register('footer', FooterSection);
    sections.register('sidebar-menu', SidebarMenuSection);
    sections.register('cart', CartSection);
    sections.register('newsletter-popup', NewsletterPopupSection); // Sections used on index
    sections.register('announcement-bar', AnnouncementSection);
    sections.register('slideshow', SlideshowSection);
    sections.register('cuyana-slider', CuyanaSliderSection);
    sections.register('cuyana-product-features', CuyanaProductFeaturesSection);
    sections.register('collection-list', CollectionListSection);
    sections.register('article-list', ArticleList);
    sections.register('featured-product', FeaturedProductSection);
    sections.register('image-with-text-block', ImageWithTextBlockSection);
    sections.register('timeline', TimelineSection);
    sections.register('map', MapSection);
    sections.register('featured-collections', FeaturedCollectionsSection);
    sections.register('shop-the-look', ShopTheLookSection);
    sections.register('testimonials', TestimonialsSection);
    sections.register('background-video', BackgroundVideoSection); // Sections used on product page

    sections.register('product', ProductSection);
    sections.register('product-quickview', ProductQuickViewSection);
    sections.register('product-configurator', ProductConfiguratorSection);
    sections.register('bundlinator', BundlinatorSection);
    sections.register('cuy-drawer-configurator', CuyDrawerConfiguratorSection);
    sections.register('cuyana-preconfigured-sets', CuyanaPreconfiguredSetsSection);

    sections.register('product-recommendations', ProductRecommendationsSection); // Sections used on collection page

    sections.register('collection', CollectionSection); // Sections used on blog page

    sections.register('article-list', ArticleList); // Sections used on article page

    sections.register('article', ArticleSection); // Sections used on content pages

    sections.register('faq', FaqSection); // Sections used on login page

    sections.register('login', LoginSection); // Sections used on addresses page

    sections.register('addresses', AddressesSection); // Sections used on gift card page

    sections.register('gift-card', GiftCardSection); // Sections used on different pages

    sections.register('recently-viewed-products', RecentlyViewedProductsSection);
    sections.register('shop-now', ShopNowSection);

    /* Add sectons to the Shopify object */
    if (window.Shopify.theme) {
      window.Shopify.theme.sections = sections;
    }

    /* Get and store the early access code so it may apply to multiple products */
    var urlParams = new URL(window.location).searchParams;
    var eacValue = urlParams.get('eac');

    if (eacValue) {
      var eacData = {
        value: eacValue,
        expires: Date.now() + 24 * 60 * 60 * 1000 // 24 hours from now
      };
      localStorage.setItem('eac', JSON.stringify(eacData));
    }

    /**
     * ----------------------------------------------------------------------------
     * FLICKITY
     *
     * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
     * event.preventDefault to be called on dynamically added listeners, which is
     * what Flickity is using.
     *
     * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
     * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
     * and that we are using here as a temporary workaround, that should be removed
     * once the bug is fixed on iOS
     * ----------------------------------------------------------------------------
     */

    Flickity.defaults.dragThreshold = 7;

    (function () {
      var touchingCarousel = false,
          touchStartCoords;
      document.body.addEventListener('touchstart', function (e) {
        if (e.target.closest('.flickity-slider')) {
          touchingCarousel = true;
        } else {
          touchingCarousel = false;
          return;
        }

        touchStartCoords = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      });
      document.body.addEventListener('touchmove', function (e) {
        if (!(touchingCarousel && e.cancelable)) {
          return;
        }

        var moveVector = {
          x: e.touches[0].pageX - touchStartCoords.x,
          y: e.touches[0].pageY - touchStartCoords.y
        };
        if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) e.preventDefault();
      }, {
        passive: false
      });
    })();
    /**
     * ----------------------------------------------------------------------------
     * FLICKITY 2
     *
     * Starting from iOS 15, Safari on iOS automatically starts to expand/collapse
     * the bottom bar as soon as you do even a minor diagonal movement. This is causing
     * a performance issue on iOS15 as it does a lot of reflow. We therefore have to
     * patch Flickity to make sure they re-size the carousel only when the width is
     * changed, by ignoring the height
     * ----------------------------------------------------------------------------
     */


    (function () {
      if (window.Flickity) {
        var originalResizeMethod = window.Flickity.prototype.resize,
            lastWidth = window.innerWidth;

        window.Flickity.prototype.resize = function () {
          if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
            return;
          }

          lastWidth = window.innerWidth;
          originalResizeMethod.apply(this, arguments); // Call original method
        };
      }
    })();

    /**
     * ----------------------------------------------------------------------------
     * RTE
     * ----------------------------------------------------------------------------
     */
    (function () {
      // We wrap each RTE table by a specific class to allow wrapping
      Dom.nodeListToArray(document.querySelectorAll('.Rte table')).forEach(function (table) {
        table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>';
      });
      Dom.nodeListToArray(document.querySelectorAll('.Rte iframe')).forEach(function (iframe) {
        // We scope the wrapping only for YouTube and Vimeo
        if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
          iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
          // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

          iframe.src = iframe.src;
        }
      });
    })();


    /**
     * ----------------------------------------------------------------------------
     * UTILS
     * ----------------------------------------------------------------------------
     */
    (function () {
      var documentDelegate = new domDelegate.Delegate(document.body),
          announcementBar = document.querySelector('.AnnouncementBar');
      documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {
        var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');

        // Bootstrap toggles point href at their target; scrolling to a fixed modal jumps the page to the top.
        if (selector === '#' || selector === '#main' || selector === '#collection-products' || target.hasAttribute('data-bs-toggle')) {
          return;
        }

        var element = document.querySelector(selector),
            offset = parseInt(target.getAttribute('data-offset') || 0);

        if (announcementBar) {
          offset -= announcementBar.clientHeight;
        }

        if (target.hasAttribute('data-focus-on-click')) {
          var prevScrollY = window.pageYOffset;
          element.focus({
            preventScroll: true
          }); // hack to fix scroll jump after focus

          if (window.pageYOffset !== prevScrollY) {
            window.scrollTo(window.pageXOffset, prevScrollY);
          }

          element.focus();
        }

        window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - offset
        });
        event.preventDefault();
      });
    })();
    
    (function () {
      // WWW-4071: --layout-width is the layout width without the scrollbar. Full-bleed
      // rules in theme.css size from it instead of 100vw. Set on <html> (not <body>) so
      // it reaches elements rendered outside the page container, and measured from
      // documentElement.clientWidth, not innerWidth, which includes the scrollbar.
      var root = document.documentElement;
      var setLayoutWidth = function () {
        root.style.setProperty('--layout-width', root.clientWidth + 'px');
      };
      setLayoutWidth();
      if (typeof ResizeObserver === 'function') {
        // Fires when the scrollbar appears or disappears (e.g. the no-scroll lock)
        // and on resize.
        new ResizeObserver(setLayoutWidth).observe(root);
      } else {
        window.addEventListener('resize', setLayoutWidth);
      }
    })();

    (function () {
      var windowWidth = window.innerWidth;
      var headerSection = document.getElementById('shopify-section-header');

      window.addEventListener('resize', function () {
        var newWidth = -1;
        fastdom.measure(function () {
          newWidth = window.innerWidth;
        });
        fastdom.mutate(function () {
          if (newWidth === windowWidth) {
            return;
          }

          windowWidth = newWidth;
          document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');

          if (headerSection) {
            document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
          }
        });
      });
    })();

    // Check for private sale on page load
    checkPrivateSale();

    (function () {
      function handleFirstTab(event) {
        if (event.keyCode === 9) {
          document.body.classList.add('is-tabbing');
          window.removeEventListener('keydown', handleFirstTab);
        }
      }

      window.addEventListener('keydown', handleFirstTab);
    })();

    /**
     * ----------------------------------------------------------------------------
     * WISHLIST ALERT HANDLING
     *
     * ----------------------------------------------------------------------------
     */
    // Callback function to be executed when mutations occur
    function handleMutations(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.addedNodes.length > 0) {
          const addedToasts = Array.from(mutation.addedNodes).filter(
            (node) => node.classList && node.classList.contains('wishlist-whale-toast')
          );

          if (addedToasts.length > 0) {
            addedToasts.forEach((newToast) => {
              newToast.classList.add('new-toast');
              // Set the toast element to remove itself after 5 seconds
              setTimeout(() => {
                newToast.remove();
              }, 5000);
            });

            // Hide any previous toast messages that are currently visible
            const staleToasts = document.querySelectorAll('.wishlist-whale-toast:not(.new-toast)');
            staleToasts.forEach((toast) => {
              toast.classList.add('d-none');
            });

            addedToasts.forEach((newToast) => {
              newToast.classList.remove('new-toast');
            });
          }
        }
      }
    }

    // Get a reference to the <body> element
    const body = document.body;

    // Create a MutationObserver and observe the <body> element
    const observer = new MutationObserver(handleMutations);
    observer.observe(body, { childList: true });


    /**
     * ----------------------------------------------------------------------------
     * VIDEO LAZY LOADING & VIEWPORT-AWARE PLAYBACK
     *
     * Uses IntersectionObserver to:
     * - Only play videos when visible in viewport
     * - Pause videos when they leave viewport (saves resources)
     * - Respects prefers-reduced-motion preference
     * ----------------------------------------------------------------------------
     */
    (function() {
      // Check if user prefers reduced motion
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        // If user prefers reduced motion, pause autoplay videos initially
        // but keep them visible so users can manually play if desired
        document.querySelectorAll('video[autoplay]').forEach(function(video) {
          video.pause();
        });
        // Don't set up IntersectionObserver auto-play for reduced motion users
        return;
      }

      // IntersectionObserver for viewport-aware video playback
      if ('IntersectionObserver' in window) {
        // Track observed videos to prevent duplicate observations
        const observedVideos = new WeakSet();

        const videoObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            const video = entry.target;
            if (entry.isIntersecting) {
              // Video is visible - play it. hls.js-driven videos start via an
              // explicit play() and never carry the autoplay attribute, so
              // data-autoplay (cleared on bail/slow-connection) counts too.
              if (video.paused && (video.hasAttribute('autoplay') || video.hasAttribute('data-autoplay'))) {
                // Sources activated after parse leave the element stuck in
                // NETWORK_NO_SOURCE; play() only re-runs resource selection
                // from NETWORK_EMPTY, so re-arm with load() (below-fold video
                // blocks defer loading until they scroll into view).
                if (video.networkState === 3) {
                  // Videos hidden at load (the unused half of a mobile/desktop
                  // pair) skip source activation entirely - activate mp4-only
                  // ones on demand so a rotate/resize across the breakpoint
                  // can't strand them. hls-bound videos are left alone
                  // (activating their sources starts a competing download)
                  // and slow connections keep the poster.
                  var mp4Only = !video.querySelector('source[type="application/x-mpegURL"]');
                  var slowNow = document.documentElement.classList.contains('slow-connection');
                  if (mp4Only && !slowNow && !video.querySelector('source[src]')) {
                    video.querySelectorAll('source[data-src]').forEach(function(source) {
                      source.src = source.getAttribute('data-src');
                    });
                  }
                  if (video.querySelector('source[src]')) {
                    video.load();
                  }
                }
                video.play().catch(function() {
                  // Autoplay was prevented - this is expected and fine
                });
              }
            } else {
              // Video is not visible - pause it to save resources, unless the
              // block opted out via data-pause-offscreen="false" (bc-video toggle).
              if (!video.paused && video.getAttribute('data-pause-offscreen') !== 'false') {
                video.pause();
              }
            }
          });
        }, {
          rootMargin: '50px 0px', // Start loading slightly before video enters viewport
          threshold: 0.1 // Trigger when 10% of video is visible
        });

        // Handle video errors - show fallback image on failure
        function handleVideoError(video) {
          var fallback = video.querySelector('img.video-fallback') || video.nextElementSibling;
          if (fallback && fallback.tagName === 'IMG') {
            // The fallback img sits inside the <video> (only rendered by
            // browsers without video support) - hiding the video would hide
            // it too, so move it out before revealing it.
            if (fallback.parentNode === video) {
              video.parentNode.insertBefore(fallback, video.nextSibling);
              // Absolute inset against the figure's aspect-ratio box: in-flow
              // percentage height can't resolve (parent height derives from
              // content) and renders the poster at natural size, misaligned.
              fallback.style.position = 'absolute';
              fallback.style.top = '0';
              fallback.style.left = '0';
              fallback.style.width = '100%';
              fallback.style.height = '100%';
              fallback.style.objectFit = 'cover';
            }
            fallback.style.display = 'block';
          }
          // visibility (not display): the figure is a flex item sized by its
          // content - display:none collapses it to 0x0 and the absolutely
          // positioned fallback has no box to fill
          video.style.visibility = 'hidden';
        }

        function addVideoErrorHandler(video) {
          video.addEventListener('error', function() {
            handleVideoError(video);
          });
          // Also listen for source errors
          video.querySelectorAll('source').forEach(function(source) {
            source.addEventListener('error', function() {
              // Only hide video if all sources have failed
              var sources = video.querySelectorAll('source');
              var lastSource = sources[sources.length - 1];
              if (source === lastSource) {
                handleVideoError(video);
              }
            });
          });
        }

        // Initialize video observation and error handling
        function initVideoObserver(video) {
          if (!observedVideos.has(video)) {
            videoObserver.observe(video);
            addVideoErrorHandler(video);
            observedVideos.add(video);
          }
        }

        // Observe all videos with the js-video-lazy class
        document.querySelectorAll('video.js-video-lazy, video[autoplay]').forEach(function(video) {
          initVideoObserver(video);
        });

        // Also observe dynamically added videos
        const videoMutationObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) {
                if (node.tagName === 'VIDEO' && (node.classList.contains('js-video-lazy') || node.hasAttribute('autoplay'))) {
                  initVideoObserver(node);
                }
                // Also check for videos inside added containers
                node.querySelectorAll && node.querySelectorAll('video.js-video-lazy, video[autoplay]').forEach(function(video) {
                  initVideoObserver(video);
                });
              }
            });
          });
        });

        videoMutationObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      /**
       * Enable loop after first play for videos using hls.js
       * This is only needed for hls.js browsers - Safari can use native loop with HLS
       */
      function enableLoopAfterFirstPlay(video) {
        video.addEventListener('ended', function onFirstPlayEnded() {
          video.loop = true;
          video.currentTime = 0;
          video.play().catch(function() {
            // Autoplay after ended was prevented - this is fine
          });
        }, { once: true });
      }

      /**
       * HLS.js integration for browsers without native HLS support (Chrome, Firefox, Android)
       * Enables adaptive bitrate streaming for better mobile performance
       */
      var hlsLoadingState = { loading: false, loaded: false };
      var hlsInstances = [];

      // Single global cleanup handler for all HLS instances
      window.addEventListener('beforeunload', function() {
        hlsInstances.forEach(function(hls) {
          if (hls) hls.destroy();
        });
        hlsInstances = [];
      }, { once: true });

      function initHlsVideo(video, hlsSource) {
        // If already loaded, attach immediately
        if (hlsLoadingState.loaded) {
          attachHls(video, hlsSource);
          return;
        }

        // Mark video as pending while script loads
        video.setAttribute('data-hls-pending', hlsSource);

        // If already loading, just wait for it
        if (hlsLoadingState.loading) {
          return;
        }

        // Load hls.js from self-hosted asset
        hlsLoadingState.loading = true;
        var script = document.createElement('script');
        script.src = window.theme.hlsJsUrl;
        script.onload = function() {
          hlsLoadingState.loading = false;
          hlsLoadingState.loaded = true;
          // Process all pending videos
          document.querySelectorAll('video[data-hls-pending]').forEach(function(v) {
            var src = v.getAttribute('data-hls-pending');
            v.removeAttribute('data-hls-pending');
            attachHls(v, src);
          });
        };
        script.onerror = function() {
          hlsLoadingState.loading = false;
          console.error('Failed to load hls.js - videos will use fallback sources');
          // Remove pending attributes so videos can fall back to MP4
          document.querySelectorAll('video[data-hls-pending]').forEach(function(v) {
            v.removeAttribute('data-hls-pending');
            // hls.js-bound videos skip source activation entirely, so activate
            // and start native playback (browser picks a playable source) here
            startNativeFallback(v);
          });
        };
        document.head.appendChild(script);
      }

      /**
       * Background quality upgrade for looping videos.
       *
       * Loops replay from the buffer, and hls.js never upgrades already-
       * buffered ranges - so segments fetched at low quality while ABR was
       * depressed by page-load contention replay pixelated on every loop.
       * In-band fixes (currentLevel/nextLevel flushes) visibly pause playback,
       * so instead: once initial buffering finishes, silently download a clean
       * copy at the connection's target quality into a second, detached video
       * element (zero impact on the playing video), then swap the elements at
       * a loop seam once the copy is fully buffered.
       *
       * The target comes from navigator.connection.downlink because ABR's own
       * estimate freezes at whatever it measured during contention - nothing
       * downloads once the loop is buffered, so it never recovers on its own.
       */
      function scheduleLoopQualityUpgrade(video, hls, hlsSource) {
        hls.once(Hls.Events.BUFFER_EOS, function() {
          if (video._bailed || video._upgradeScheduled) return;
          if (typeof video._minBufferedLevel !== 'number') return;

          var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
          var downlinkMbps = (conn && typeof conn.downlink === 'number' && conn.downlink > 0) ? conn.downlink : 0;
          var targetIdx = hls.loadLevel;
          if (downlinkMbps) {
            hls.levels.forEach(function(level, i) {
              if (level.bitrate <= downlinkMbps * 1000000) targetIdx = Math.max(targetIdx, i);
            });
          }
          if (targetIdx <= video._minBufferedLevel) return;
          video._upgradeScheduled = true;

          // Buffer the clean copy on a detached element - invisible until ready
          // Deep clone so the upgraded element carries the <source> children
          // and inline fallback img - every recovery path (fatal-error native
          // fallback, bfcache reattach, handleVideoError) depends on them.
          // Keep data-autoplay: the viewport observer needs it to resume the
          // swapped-in element after it pauses offscreen.
          var upgraded = video.cloneNode(true);
          upgraded.removeAttribute('data-enable-loop-after-first-play');
          upgraded.removeAttribute('data-hls-pending');
          upgraded.muted = true;
          upgraded.loop = true;

          var hlsB = new Hls({
            autoStartLoad: false,
            capLevelToPlayerSize: false // detached element measures 0x0
          });
          hlsB.loadSource(hlsSource);
          hlsB.attachMedia(upgraded);
          hlsB.on(Hls.Events.MANIFEST_PARSED, function() {
            hlsB.currentLevel = targetIdx; // pin every fragment to the target
            hlsB.startLoad(0);
          });
          hlsB.on(Hls.Events.ERROR, function(event, data) {
            if (data.fatal) {
              hlsB.destroy();
              video.removeEventListener('timeupdate', onTimeUpdate);
            }
          });
          hlsInstances.push(hlsB);
          upgraded._hlsInstance = hlsB;

          var upgradeReady = false;
          hlsB.once(Hls.Events.BUFFER_EOS, function() {
            upgradeReady = true;
          });

          // Swap at a loop seam: native loop fires no events, so detect the
          // wrap via timeupdate (currentTime jumping backwards)
          var lastTime = 0;
          function onTimeUpdate() {
            var t = video.currentTime;
            var wrapped = t < lastTime;
            lastTime = t;
            if (video._bailed) {
              video.removeEventListener('timeupdate', onTimeUpdate);
              hlsB.destroy();
              return;
            }
            if (!wrapped || !upgradeReady) return;
            video.removeEventListener('timeupdate', onTimeUpdate);

            // Overlay the upgraded copy on the playing video, start it in
            // sync, and only remove the original once the copy is rendering
            upgraded.style.position = 'absolute';
            upgraded.style.top = '0';
            upgraded.style.left = '0';
            upgraded.style.width = '100%';
            upgraded.style.height = '100%';
            video.parentNode.insertBefore(upgraded, video.nextSibling);
            upgraded.currentTime = video.currentTime;
            upgraded.play().then(function() {
              video.remove();
              hls.destroy();
              video._hlsInstance = null;
              upgraded.style.position = '';
              upgraded.style.top = '';
              upgraded.style.left = '';
              upgraded.style.width = '';
              upgraded.style.height = '';
            }).catch(function() {
              // Playback refused - keep the original looping
              upgraded.remove();
              hlsB.destroy();
            });
          }
          video.addEventListener('timeupdate', onTimeUpdate);
        });
      }

      // Activate native fallback sources (skipping the m3u8 the browser may not
      // play) and start playback - used when hls.js can't load or fatally errors
      function startNativeFallback(video) {
        if (video._bailed) return;
        // The element-level src (hls.js's dead blob) outranks <source>
        // children in resource selection - without clearing it, load()
        // re-selects the blob, errors again, and the mp4 never plays.
        if (video.src && video.src.indexOf('blob:') === 0) {
          video.removeAttribute('src');
        }
        video.querySelectorAll('source[data-src]').forEach(function(source) {
          source.src = source.getAttribute('data-src');
        });
        video.load();
        video.play().catch(function() {});
      }

      // bfcache restores (back/forward navigation) kill MediaSource blobs and
      // pause natively-sourced videos. Reattach the streams (the dead blob src
      // errors on any load) and resume visible videos, honoring an explicit
      // user pause via the ADA button.
      window.addEventListener('pageshow', function(event) {
        if (!event.persisted) return;
        document.querySelectorAll('video.js-video-lazy').forEach(function(video) {
          var pauseBtn = video.parentNode && video.parentNode.querySelector('.js-video-pause');
          var userPaused = pauseBtn && pauseBtn.classList.contains('is-paused');
          if (video.src && video.src.indexOf('blob:') === 0) {
            // The quality-upgrade clone has no <source> children, so the
            // manifest URL is carried on data-hls-manifest (set by attachHls
            // and inherited by the clone).
            var hlsSourceEl = video.querySelector('source[type="application/x-mpegURL"]');
            var manifestUrl = video.getAttribute('data-hls-manifest') ||
              (hlsSourceEl && (hlsSourceEl.getAttribute('data-src') || hlsSourceEl.getAttribute('src')));
            if (video._hlsInstance) {
              video._hlsInstance.destroy();
              video._hlsInstance = null;
            }
            video.removeAttribute('src');
            video.style.display = '';
            video.style.visibility = '';
            var fallback = video.parentNode.querySelector('img.video-fallback');
            if (fallback) fallback.style.display = 'none';
            if (userPaused) return;
            if (manifestUrl) {
              attachHls(video, manifestUrl);
            } else {
              startNativeFallback(video);
            }
          } else if (!userPaused && video.paused &&
              (video.hasAttribute('autoplay') || video.hasAttribute('data-autoplay'))) {
            var rect = video.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < window.innerHeight) {
              if (video.networkState === 3 && video.querySelector('source[src]')) {
                video.load();
              }
              video.play().catch(function() {});
            }
          }
        });
      });

      // Self-heal: a dying MediaSource (bfcache teardown) can fire its error
      // event after the recovery path has already reattached a fresh stream,
      // re-hiding a video that then plays invisibly behind the fallback
      // poster. Whenever a video actually produces frames, force it visible.
      // Capture phase - media events don't bubble.
      document.addEventListener('playing', function(event) {
        var video = event.target;
        if (!video || video.tagName !== 'VIDEO') return;
        if (video.style.visibility === 'hidden' || video.style.display === 'none') {
          video.style.visibility = '';
          video.style.display = '';
          var fallback = video.parentNode && video.parentNode.querySelector('img.video-fallback');
          if (fallback) fallback.style.display = 'none';
        }
      }, true);

      // Background tabs pause media without a matching resume event - when
      // the tab becomes visible again, restart visible autoplay videos.
      // Dead-blob and user-pause cases are excluded (pageshow and the ADA
      // button own those).
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState !== 'visible') return;
        document.querySelectorAll('video.js-video-lazy').forEach(function(video) {
          if (!video.paused) return;
          if (video.src && video.src.indexOf('blob:') === 0 && !video._hlsInstance) return;
          if (!video.hasAttribute('autoplay') && !video.hasAttribute('data-autoplay')) return;
          var pauseBtn = video.parentNode && video.parentNode.querySelector('.js-video-pause');
          if (pauseBtn && pauseBtn.classList.contains('is-paused')) return;
          var rect = video.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            if (video.networkState === 3 && video.querySelector('source[src]')) {
              video.load();
            }
            video.play().catch(function() {});
          }
        });
      });

      function attachHls(video, hlsSource) {
        if (typeof Hls === 'undefined') {
          console.warn('hls.js not loaded, falling back to native sources');
          startNativeFallback(video);
          return;
        }
        if (video._hlsInstance || video._bailed) {
          return;
        }
        if (Hls.isSupported()) {
          // Pick the starting rendition from the connection's measured downlink
          // instead of hls.js's lowest-first default, which played the first
          // segments at 480p on every connection (visibly pixelated on desktop).
          // Connections under 3 Mbps never reach this code (slow-connection gate
          // shows a static poster). Chrome caps connection.downlink reporting at
          // 10 Mbps -> 720p start, with ABR stepping up to 1080p from segment 2.
          // Note: startLevel -1 doesn't work here - hls.js 1.5 always downloads
          // the first segment at the lowest level as a bandwidth probe, which is
          // the pixelated start we're avoiding.
          // Browsers without the Network Information API (Firefox) report 0
          // and start at the lowest rendition, same as the old startLevel: 0.
          var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
          var downlinkMbps = (conn && typeof conn.downlink === 'number' && conn.downlink > 0) ? conn.downlink : 0;
          var hlsConfig = {
            autoStartLoad: false, // Wait for the manifest so we can pick the start level explicitly
            capLevelToPlayerSize: true // Cap quality to video element size
          };
          if (downlinkMbps) {
            hlsConfig.abrEwmaDefaultEstimate = downlinkMbps * 1000000;
          }
          var hls = new Hls(hlsConfig);

          // Recovery paths (bfcache reattach) need the manifest URL even on
          // elements without <source> children, like the quality-upgrade clone
          video.setAttribute('data-hls-manifest', hlsSource);

          hls.loadSource(hlsSource);
          hls.attachMedia(video);

          // Track the lowest-quality segment that made it into the buffer, so
          // scheduleLoopQualityUpgrade knows whether a background upgrade is
          // worthwhile
          hls.on(Hls.Events.FRAG_BUFFERED, function(event, data) {
            if (data.frag.type !== 'main') return;
            if (video._minBufferedLevel === undefined || data.frag.level < video._minBufferedLevel) {
              video._minBufferedLevel = data.frag.level;
            }
          });

          hls.on(Hls.Events.MANIFEST_PARSED, function(event, data) {
            // Highest rendition whose peak bitrate fits the measured downlink
            // (data.levels is sorted by bitrate ascending)
            var bandwidth = downlinkMbps * 1000000;
            var startIdx = 0;
            data.levels.forEach(function(level, i) {
              if (level.bitrate <= bandwidth) startIdx = i;
            });
            hls.startLevel = startIdx;
            hls.startLoad();
            video.play().catch(function(err) {
              console.warn('Video autoplay prevented:', err);
            });
          });
          hls.on(Hls.Events.ERROR, function(event, data) {
            if (data.fatal) {
              console.error('Fatal HLS error:', data.type, data.details);
              // Cleanup and let browser fall back to native source elements
              hls.destroy();
              video._hlsInstance = null;
              // Remove HLS source so browser uses MP4/WebM fallback
              var hlsSourceEl = video.querySelector('source[type="application/x-mpegURL"]');
              if (hlsSourceEl) {
                hlsSourceEl.remove();
              }
              startNativeFallback(video);
            }
          });
          // Store hls instance for cleanup
          video._hlsInstance = hls;
          hlsInstances.push(hls);
          scheduleLoopQualityUpgrade(video, hls, hlsSource);
        } else {
          // No MSE support - activate native sources so the MP4 fallback plays
          startNativeFallback(video);
        }
      }

      // Check for slow connection - use the class set by early inline script for consistency
      // The inline script in the _bc-video block runs first and sets html.slow-connection
      // This ensures both CSS and JS use the same threshold (< 3 Mbps)
      var isSlowConnection = document.documentElement.classList.contains('slow-connection');

      // True only for Safari/iOS, where the native HLS pipeline is the one we want.
      // Chrome 142+ also reports HLS support via its built-in player, but we keep
      // hls.js there for controlled startup quality, so UA-sniff Safari explicitly.
      // (iOS Chrome/Firefox are WebKit underneath and match this regex - correct.)
      function shouldUseNativeHls(video) {
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        return isSafari && video.canPlayType('application/vnd.apple.mpegurl') !== '';
      }

      // prefersReducedMotion already declared at top of IIFE

      // Activate deferred video sources only for visible videos (prevents loading both desktop & mobile)
      document.querySelectorAll('video.js-video-deferred').forEach(function(video) {
        // Skip videos hidden by CSS (e.g., mobile video on desktop or vice versa)
        if (video.offsetParent === null) {
          return;
        }

        // On slow connections or reduced motion preference, keep the static poster.
        // Re-check downlink here: the parse-time gate (html.slow-connection) reads a
        // single early sample, and the browser's estimate may have changed since.
        // Without a configured slow poster the video's own poster frame is kept -
        // previously these videos downloaded invisibly (.slow-connection CSS hides
        // the video element) while showing nothing.
        var slowPoster = video.getAttribute('data-slow-connection-poster');
        var connNow = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
        var slowNow = connNow && typeof connNow.downlink === 'number' && connNow.downlink > 0 && connNow.downlink < 3;
        var shouldSkipVideo = isSlowConnection || slowNow || prefersReducedMotion;
        if (shouldSkipVideo) {
          if (slowPoster) video.poster = slowPoster;
          video.removeAttribute('data-autoplay');
          video.removeAttribute('data-enable-loop-after-first-play');
          // Hide pause button when showing static poster
          var figure = video.closest('figure');
          var pauseBtn = figure.querySelector('.js-video-pause');
          if (pauseBtn) pauseBtn.style.display = 'none';
          // Fade out the black placeholder to reveal the poster
          figure.classList.add('video-ready');
          // Don't activate sources - keep video as static poster
          return;
        }

        // Activate sources only when this video won't be driven by hls.js.
        // Setting src on a <source> while the video is NETWORK_EMPTY already
        // triggers native resource selection - and Chrome 142+ ships a built-in
        // HLS player - which starts a competing download that hls.js immediately
        // discards. attachHls reads the manifest URL from data-src and plays the
        // video itself once the manifest is parsed; the fallback paths copy
        // data-src to src before calling load().
        var deferredHlsSource = video.querySelector('source[type="application/x-mpegURL"]');
        if (!deferredHlsSource || shouldUseNativeHls(video)) {
          video.querySelectorAll('source[data-src]').forEach(function(source) {
            source.src = source.getAttribute('data-src');
          });
          if (video.hasAttribute('data-autoplay')) {
            video.autoplay = true;
            // Only force-load videos near the viewport. Below-fold videos
            // (video blocks) are played on demand by the viewport observer -
            // play() loads on demand - otherwise every video on the page
            // downloads and decodes simultaneously at DOMContentLoaded.
            var activateRect = video.getBoundingClientRect();
            if (activateRect.bottom > -100 && activateRect.top < window.innerHeight + 100) {
              video.load();
            }
          }
        }

        // Show/hide buffering spinner and placeholder
        var figure = video.closest('figure');
        if (figure) {
          var spinnerTimeout = null;

          function showSpinner() {
            // Delay spinner to avoid flash on fast connections
            spinnerTimeout = setTimeout(function() {
              figure.classList.add('is-buffering');
            }, 150);
          }

          function hideSpinner() {
            clearTimeout(spinnerTimeout);
            figure.classList.remove('is-buffering');
          }

          function markVideoReady() {
            hideSpinner();
            figure.classList.add('video-ready');
          }

          // Give up on streaming if playback keeps stalling - e.g. the connection
          // passed the slow gate (or degraded after page load) but can't sustain
          // even the lowest rendition. Swap to the static poster instead of
          // letting the video freeze and rebuffer forever.
          var stallCount = 0;
          var stallStartedAt = null;
          var longStallTimer = null;
          function bailToPoster() {
            if (video._bailed) return;
            video._bailed = true;
            clearTimeout(longStallTimer);
            clearInterval(firstFrameTimer);
            video.removeAttribute('data-hls-pending');
            if (video._hlsInstance) {
              video._hlsInstance.destroy();
              video._hlsInstance = null;
            }
            video.pause();
            var bailPoster = video.getAttribute('data-slow-connection-poster');
            if (bailPoster) video.poster = bailPoster;
            // Strip sources so no more bytes are fetched; load() shows the poster
            video.removeAttribute('autoplay');
            video.removeAttribute('data-autoplay');
            video.querySelectorAll('source').forEach(function(source) {
              source.remove();
            });
            video.removeAttribute('src');
            video.load();
            var bailPauseBtn = figure.querySelector('.js-video-pause');
            if (bailPauseBtn) bailPauseBtn.style.display = 'none';
            markVideoReady();
            if (typeof posthog !== 'undefined') {
              var bailConn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
              posthog.capture('video_banner_bailout', {
                stall_count: stallCount,
                connection_type: bailConn ? bailConn.effectiveType : 'unknown',
                downlink_mbps: bailConn ? bailConn.downlink : null
              });
            }
          }
          function watchForChronicStalling() {
            video.addEventListener('waiting', function() {
              stallStartedAt = performance.now();
              clearTimeout(longStallTimer);
              longStallTimer = setTimeout(bailToPoster, 3500);
            });
            video.addEventListener('playing', function() {
              clearTimeout(longStallTimer);
              // Only count real stalls; loop restarts and seeks on a healthy
              // connection recover in well under half a second
              if (stallStartedAt && performance.now() - stallStartedAt > 500) {
                stallCount++;
                if (stallCount >= 2) bailToPoster();
              }
              stallStartedAt = null;
            });
          }

          // Wait for video to actually be playing smoothly before revealing
          // Use timeupdate to ensure we have real playback, not just buffering
          var hasRevealed = false;
          function checkAndReveal() {
            if (hasRevealed) return;
            // Wait until video has played at least 0.1s to avoid stutter
            if (video.currentTime > 0.1 && !video.paused) {
              hasRevealed = true;
              clearInterval(firstFrameTimer);
              markVideoReady();
              video.removeEventListener('timeupdate', checkAndReveal);
              // Only show buffering spinner for mid-playback rebuffering,
              // not during initial load (the CSS animation delay handles that)
              video.addEventListener('waiting', showSpinner);
              // Chronic-stall bail is for streams: short progressive MP4s
              // (video blocks) recover on their own, and bfcache restores
              // evict media buffers - the resume rebuffer reads as a stall
              // and the closure-held counters survive restores, so repeated
              // back-navigations falsely bailed healthy tiles.
              if (video.querySelector('source[type="application/x-mpegURL"]')) {
                watchForChronicStalling();
              }
            }
          }

          // If the first frame hasn't arrived within 8s of the video being on
          // screen, the connection can't really support video - settle on the
          // poster instead of leaving the user staring at a spinner. The clock
          // only runs while the video is in the viewport and the page is
          // foregrounded: WebKit defers offscreen autoplay, so a below-fold
          // video legitimately has no frames until scrolled into view.
          var visibleSince = null;
          var firstFrameTimer = setInterval(function() {
            if (hasRevealed) { clearInterval(firstFrameTimer); return; }
            if (document.hidden) { visibleSince = null; return; }
            var rect = video.getBoundingClientRect();
            if (rect.bottom <= 0 || rect.top >= window.innerHeight) { visibleSince = null; return; }
            if (visibleSince === null) { visibleSince = performance.now(); return; }
            if (performance.now() - visibleSince >= 8000) {
              clearInterval(firstFrameTimer);
              bailToPoster();
            }
          }, 1000);

          video.addEventListener('timeupdate', checkAndReveal);
          video.addEventListener('canplay', hideSpinner);
          video.addEventListener('loadeddata', hideSpinner);
          video.addEventListener('error', markVideoReady); // Hide placeholder even on error
        }
      });

      // Initialize videos with HLS support
      document.querySelectorAll('video[data-enable-loop-after-first-play]').forEach(function(video) {
        // Skip videos hidden by CSS
        if (video.offsetParent === null) {
          return;
        }

        var hlsSourceEl = video.querySelector('source[type="application/x-mpegURL"]');
        var hlsSourceUrl = hlsSourceEl && (hlsSourceEl.getAttribute('src') || hlsSourceEl.getAttribute('data-src'));

        if (hlsSourceUrl && !shouldUseNativeHls(video)) {
          // Browser needs hls.js (Chrome, Firefox, Android)
          initHlsVideo(video, hlsSourceUrl);
          // Only need JS loop workaround for hls.js browsers
          enableLoopAfterFirstPlay(video);
        } else {
          // Safari/iOS native HLS or mobile MP4 fallback - native loop works
          video.loop = true;
        }
      });

      // Pause button functionality for ADA compliance
      document.querySelectorAll('.js-video-pause').forEach(function(btn) {
        var figure = btn.closest('figure');
        if (!figure || !figure.querySelector('video')) return;

        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation(); // Prevent triggering parent link
          // Resolve at click time - the background quality upgrade can swap
          // the video element out from under us
          var video = figure.querySelector('video');
          if (!video) return;
          if (video.paused) {
            video.play();
            btn.classList.remove('is-paused');
            btn.setAttribute('aria-label', 'Pause video');
          } else {
            video.pause();
            btn.classList.add('is-paused');
            btn.setAttribute('aria-label', 'Play video');
          }
        });
      });

      // Tap-to-unmute functionality (bc-video "Enable audio" toggle).
      // Videos with audio still autoplay muted (browser policy); this button
      // unmutes on a user gesture and toggles back to muted.
      document.querySelectorAll('.js-video-unmute').forEach(function(btn) {
        var figure = btn.closest('figure');
        if (!figure || !figure.querySelector('video')) return;

        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation(); // Don't trigger a parent link
          var video = figure.querySelector('video');
          if (!video) return;

          if (video.muted) {
            // Silence any other unmuted video first so audio never overlaps
            document.querySelectorAll('.js-video-unmute.is-unmuted').forEach(function(otherBtn) {
              if (otherBtn === btn) return;
              var otherFig = otherBtn.closest('figure');
              var otherVideo = otherFig && otherFig.querySelector('video');
              if (otherVideo) otherVideo.muted = true;
              otherBtn.classList.remove('is-unmuted');
              otherBtn.setAttribute('aria-pressed', 'false');
              otherBtn.setAttribute('aria-label', 'Unmute video');
            });

            video.muted = false;
            // A muted autoplay video can be paused off-screen; make sure sound
            // is actually audible when the user asks for it.
            if (video.paused) video.play().catch(function() {});
            btn.classList.add('is-unmuted');
            btn.setAttribute('aria-pressed', 'true');
            btn.setAttribute('aria-label', 'Mute video');
          } else {
            video.muted = true;
            btn.classList.remove('is-unmuted');
            btn.setAttribute('aria-pressed', 'false');
            btn.setAttribute('aria-label', 'Unmute video');
          }
        });
      });
    })();


    /**
     * ----------------------------------------------------------------------------
     * ANIMATION
     *
     * Important: this has to be at the very end of the file
     * ----------------------------------------------------------------------------
     */
    if (window.theme.showPageTransition) {
      PageTransition.getInstance();
    }
  })();
})));

